I18n.translations || (I18n.translations = {});
I18n.translations["de"] = {
  "about": {
    "h1": "Einfach inserieren und verwalten",
    "h2": "Von Eigentümer für Eigentümer",
    "h3": "Konkurrenzloser Service – rund um die Uhr",
    "h4": "Europaweit inserieren und vermieten",
    "h5": "Sicherheit",
    "h6": "Attraktive Konditionen",
    "link_13": "Eine genaue Beschreibung des",
    "link_23": "Casapilot-Geschäftsmodells",
    "link_33": "können Sie als PDF herunterladen.",
    "p1": "In wenigen Schritten zum fertigen Inserat – das ist unser Anspruch. Ein übersichtliches Design und viele praktische Features, wie bspw. die Inseratvoransicht, die Ihren Anforderungen als Vermieter entsprechen, machen für Sie die Benutzung von Casapilot intuitiv und angenehm.",
    "p2": "Wir sind – genau wie Sie – Eigentümer einer Ferienimmobilie, die wir seit einigen Jahren selbst vermieten. Bei der Vermietung über Onlineportale und Makler mussten wir oft feststellen: externe Vermittler sind teuer und wenig flexibel. Das hat uns gestört und darum haben wir Casapilot ins Leben gerufen. Wir versprechen Ihnen günstige Konditionen, eine hohe Flexibilität und einen konkurrenzlosen Service.",
    "p3": "Wir stehen Ihnen mit Rat und Tat zur Seite und das 24 Stunden am Tag und 365 Tage im Jahr. Damit Sie europaweit Kunden gewinnen können, übernehmen wir für Sie sogar die Übersetzung der Beschreibungstexte Ihrer Immobilie in alle relevanten Fremdsprachen. Daneben kümmern wir uns auch um die Formalitäten, wie Werbung, Buchung, Versicherungsabschluss und Bezahlung und wir versorgen Ihre Kunden mit allen nötigen Informationen zu Ihrer Unterkunft.",
    "p4": "Wir denken europaweit und wollen dass Sie europaweit Mieter gewinnen. Darum ist Casapilot von Beginn an fünfsprachig ausgerichtet: Englisch, Deutsch, Französich, Spanisch und Niederländisch.",
    "p5": "Alle Buchungen laufen über eine sichere, verschlüsselte Website und über einen zertifizierten Zahlungsanbieter. Bei jeder Buchung erhalten Sie die Zahlung direkt nach Anreise der Kunden. Mögliche Sachschäden durch Ihre Mieter sind über die Haftpflichtversicherung mit abgedeckt, die Ihre Mieter bei einer Buchung auf Casapilot automatisch abschließen.",
    "p6": "Das Inserieren ist für Sie gänzlich kostenlos. Eine Vermittlunsprovision wird nur dann fällig, wenn Sie eine verbindliche Buchung erhalten. In dem Moment in dem Sie Ihren Mietpreis festlegen, wird die anteilige Provisionshöhe automatisch berechnet. So sehen Sie auf einen Blick Ihren Netto-Vermietpreis und auch den Brutto-Vermietpreis, für den Ihr Objekt Ihren Mietern angeboten wird."
  },
  "about_us": {
    "claim": "Casapilot macht die Vermietung Ihrer Ferienimmobilie einfach und profitabel.",
    "headline_html": "Mehr vermieten. <br/> Mehr verdienen. <br/> Mit Casapilot.",
    "page_title": "Mehr vermieten. Mehr verdienen. Mit Casapilot."
  },
  "accommodation_reviews": {
    "area": "Umgebung",
    "cleanliness": "Sauberkeit",
    "comfort": "Komfort",
    "hide": "Weniger anzeigen",
    "load_more_reviews": "Weitere Bewertungen laden…",
    "review_translated": "Bewertung übersetzt",
    "reviews": {
      "one": "Bewertung",
      "other": "Bewertungen"
    },
    "show_more": "Mehr anzeigen",
    "show_original": "Original anzeigen",
    "show_translation": "Übersetzung anzeigen",
    "value": "Preis/Leistung"
  },
  "accommodations": {
    "errors": {
      "minstay": "Für diese Unterkunft müssen Sie eine Aufenthaltsdauer auswählen, die durch %{minstay} teilbar ist. Bitte versuchen Sie es erneut."
    },
    "seo": {
      "in": "in",
      "kind": {
        "apartment": "Apartment ",
        "bed_and_breakfast": "B&B Zimmer ",
        "holiday_home": "Ferienwohnung "
      }
    }
  },
  "activemodel": {
    "errors": {
      "template": {
        "body": "Bitte überprüfen Sie die folgenden Felder:",
        "header": {
          "one": "Konnte %{model} nicht speichern: ein Fehler.",
          "other": "Konnte %{model} nicht speichern: %{count} Fehler."
        }
      }
    }
  },
  "activerecord": {
    "abbr_day_names": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "abbr_day_names_string": {
      "friday": "Fri",
      "monday": "Mon",
      "saturday": "Sat",
      "sunday": "Sun",
      "thursday": "Thu",
      "tuesday": "Tue",
      "wednesday": "Wed"
    },
    "abbr_month_names": [
      null,
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "attributes": {
      "accommodation": {
        "amenities": "Ausstattung",
        "area": "Fläche (m²)",
        "bond": "Kaution",
        "bond_refund": "Kautionserstattung",
        "created_at": "Angelegt am",
        "description": "Beschreibung",
        "description_short": "Kurzbeschreibung",
        "fee": "Provision (in %)",
        "filter_partition": {
          "all": "Show all accomodations",
          "any_missing": "missing translation",
          "de_missing": "missing German translation",
          "en_missing": "missing English translation",
          "es_missing": "missing spanish translation",
          "fr_missing": "missing French translation ",
          "nl_missing": "missing Dutch translation"
        },
        "filter_partition_all": "Alle Unterkünfte anzeigen",
        "filter_partition_any_missing": "mit fehlender Übersetzung",
        "filter_partition_de_missing": "ohne deutsche Übersetzung",
        "filter_partition_en_missing": "ohne englische Übersetzung",
        "filter_partition_es_missing": "ohne spanische Übersetzung",
        "filter_partition_fr_missing": "ohne französische Übersetzung",
        "filter_partition_nl_missing": "ohne niederländische Übersetzung",
        "id": "ID",
        "kind": "Art",
        "max_persons": "Personen (max.)",
        "number_of_baths": "Bäder",
        "number_of_bunk_beds": "Etagenbetten",
        "number_of_daybeds": "Schlafcouchen",
        "number_of_king_size_beds": "Doppelbetten",
        "number_of_rooms": "Schlafzimmer",
        "number_of_similar": "Anzahl gleichartiger Unterkünfte",
        "number_of_single_beds": "Einzelbetten",
        "photos": "Fotos",
        "property_id": "Objekt",
        "title": "Bezeichnung",
        "updated_at": "Aktualisiert am",
        "user_rating": "Basisbewertung"
      },
      "amenity": {
        "apartment": "Apartment",
        "bed_and_breakfast": "Bed & Breakfast",
        "category": "Kategorie",
        "created_at": "Angelegt am",
        "holiday_home": "Ferienhaus",
        "id": "ID",
        "name": "Identifier",
        "updated_at": "Aktualisiert am"
      },
      "attraction": {
        "category": "Kategorie",
        "created_at": "Angelegt am",
        "id": "ID",
        "name": "Identifier",
        "updated_at": "Aktualisiert am"
      },
      "attraction_distance": {
        "created_at": "Angelegt am",
        "distance": "Entfernung",
        "id": "ID",
        "updated_at": "Aktualisiert am"
      },
      "block": {
        "accommodation": "Ferienwohnung/Zimmer",
        "beginning": "Gesperrt von",
        "created_at": "Angelegt am",
        "ending": "Gesperrt bis",
        "id": "ID",
        "updated_at": "Aktualisiert am"
      },
      "cost": {
        "created_at": "Angelegt am",
        "id": "ID",
        "inclusive": "inklusive",
        "mandatory": "Verpflichtende Kosten",
        "name": "Identifier",
        "per_animal": "pro Tier",
        "per_box": "pro Box",
        "per_consumption": "nach Verbrauch und Marktpreis",
        "per_cubic_meter": "pro m³",
        "per_day": "pro Tag",
        "per_day_and_person": "pro Tag je Person",
        "per_day_and_piece": "pro Tag je Stück",
        "per_hour": "pro Stunde",
        "per_kwh": "pro kWh",
        "per_liter": "pro Liter",
        "per_midweek": "pro Wochenmitte",
        "per_night": "pro Nacht",
        "per_night_and_animal": "pro Nacht und Tier",
        "per_night_and_person": "pro Nacht je Person",
        "per_package": "pro Paket",
        "per_person": "pro Person",
        "per_piece": "pro Stück",
        "per_set": "pro Set",
        "per_stay": "pro Aufenthalt",
        "per_week": "pro Woche",
        "per_weekend": "pro Wochenende",
        "updated_at": "Aktualisiert am"
      },
      "extra": {
        "breakfast": "Frühstück",
        "bring": "Selbst mitbringen",
        "created_at": "Angelegt am",
        "dish_towels": "Geschirrtücher",
        "id": "ID",
        "included": "Inklusive",
        "kind": "Art",
        "linen": "Bettwäsche",
        "on_request": "auf Anfrage",
        "optional": "Optional",
        "payable": "Buchbar",
        "price": "Preis",
        "towels": "Handtücher",
        "updated_at": "Aktualisiert am"
      },
      "inquiry_form": {
        "day_of_arrival": "Tag der Ankunft",
        "day_of_departure": "Tag der Abreise",
        "email": "E-Mail",
        "inquiry": "Anfrage",
        "message": "Nachricht",
        "name": "Name",
        "object_id": "Object ID",
        "phone": "Telefon",
        "updated_at": "Actualizado el"
      },
      "limitation": {
        "allowed": "Gestattet",
        "bring_with": "Selbst mitbringen",
        "can_be_rented": "Mieten möglich",
        "created_at": "Angelegt am",
        "forbidden": "Nicht gestattet",
        "id": "ID",
        "must_be_rented": "Mietverpflichtung",
        "name": "Identifier",
        "onrequest": "Auf Anfrage",
        "updated_at": "Aktualisiert am"
      },
      "price": {
        "accommodation": "Ferienwohnung/Zimmer",
        "beginning": "Gültig von",
        "created_at": "Angelegt am",
        "default_price": "Standardpreis",
        "ending": "Gültig bis",
        "friday": "Freitag",
        "friday_abbr": "Fr",
        "id": "ID",
        "monday": "Montag",
        "monday_abbr": "Mo",
        "payment_type": "Zahlungsweise",
        "price": "Preis",
        "rotation_day": "Bettenwechsel",
        "saturday": "Samstag",
        "saturday_abbr": "Sa",
        "sunday": "Sonntag",
        "sunday_abbr": "So",
        "thursday": "Donnerstag",
        "thursday_abbr": "Do",
        "tuesday": "Dienstag",
        "tuesday_abbr": "Di",
        "updated_at": "Aktualisiert am",
        "wednesday": "Mittwoch",
        "wednesday_abbr": "Mi"
      },
      "property": {
        "country": "Land",
        "created_at": "Angelegt am",
        "description": "Beschreibung",
        "description_short": "Kurzbeschreibung",
        "filter_partition_all": "Alle Unterkünfte anzeigen",
        "filter_partition_any_missing": "mit fehlender Übersetzung",
        "filter_partition_de_missing": "ohne deutsche Übersetzung",
        "filter_partition_en_missing": "ohne englische Übersetzung",
        "filter_partition_es_missing": "ohne spanische Übersetzung",
        "filter_partition_fr_missing": "ohne französische Übersetzung",
        "filter_partition_nl_missing": "ohne niederländische Übersetzung",
        "id": "ID",
        "internal_memo": "Interner Vermerk",
        "locality": "Ort",
        "postal_code": "Postleitzahl",
        "rating": "Sterne-Kategorie",
        "region": "Region",
        "street": "Straße",
        "title": "Name des Objekts",
        "top_object": "Top Objekt",
        "travel_region_id": "Ferienregion",
        "updated_at": "Aktualisiert am"
      },
      "property_photo": {
        "created_at": "Angelegt am",
        "description": "Beschreibung",
        "file": "Bild",
        "id": "ID",
        "updated_at": "Aktualisiert am"
      },
      "travel_booking": {
        "accommodation": "Unterkunft",
        "amount_total": "Rechnungsbetrag",
        "cancel_ins_amount": "Reiserücktrittsvericherung",
        "casualty_ins_amount": "Haftpflichtversicherung",
        "created_at": "Buchung erstellt",
        "id": "ID",
        "number_of_adults": "Erwachsene",
        "number_of_children": "Kinder",
        "number_of_infants": "Kleinkinder",
        "number_of_pets": "Haustiere",
        "ref_code": "Rechnungsnummer",
        "renter": "Mieter",
        "state": "Status",
        "travel_ins_amount": "Umfassende Reiseversicherung",
        "travel_range": "Reisezeitraum"
      },
      "travel_region": {
        "country_code": "Land",
        "created_at": "Angelegt am",
        "custom_geocode": "Manueller Kartenausschnitt",
        "id": "ID",
        "name": "Name in Landessprache",
        "updated_at": "Aktualisiert am"
      },
      "user": {
        "additional_emails": "Zusätzliche E-Mails",
        "additional_emails_csv": "Zusätzliche E-Mails (getrennt durch Kommata)",
        "admin": "Administrator",
        "agent": "Telefonagent",
        "agent_lead": "Agenturleitung",
        "api_user": "API Benutzer",
        "authentication_token": "Auth Token",
        "avatar": "Ihr Foto",
        "birthday": "Geburtstag",
        "cellphone": "Mobiltelefon",
        "city": "Ort",
        "country": "Land",
        "created_at": "Registiert am",
        "current_password": "Aktuelles Passwort",
        "description": "Beschreibung",
        "email": "E-Mail",
        "first_name": "Vorname",
        "host": "Vermieter",
        "id": "ID",
        "invoice_city": "Ort (Kontaktdaten)",
        "invoice_company": "Firma (Kontaktdaten)",
        "invoice_country": "Land (Kontaktdaten)",
        "invoice_mobile_phone": "Mobiltelefon (Kontaktdaten)",
        "invoice_name": "Name (Kontaktdaten)",
        "invoice_phone": "Telefon (Kontaktdaten)",
        "invoice_postal_code": "Postleitzahl (Kontaktdaten)",
        "invoice_street": "Straße (Kontaktdaten)",
        "key_hand_over_city": "Stadt (Adresse der Schlüsselübergabe)",
        "key_hand_over_country": "Land (Adresse der Schlüsselübergabe)",
        "key_hand_over_name": "Name (Adresse der Schlüsselübergabe)",
        "key_hand_over_postal_code": "Postleitzahl (Adresse der Schlüsselübergabe)",
        "key_hand_over_street": "Straße (Adresse der Schlüsselübergabe)",
        "last_name": "Nachname",
        "last_sign_in_at": "Zuletzt eingeloggt am",
        "mother_tongue": "Muttersprache",
        "name": "Name",
        "newsletter": "Newsletter abonnieren",
        "password": "Passwort",
        "password_confirmation": "Passwort wiederholen",
        "phone": "Telefon",
        "postal_code": "PLZ",
        "remember_me": "Angemeldet bleiben",
        "remove_avatar": "Foto entfernen",
        "renter": "Mieter",
        "salutation": "Anrede",
        "street_nr": "Straße / Hausnummer",
        "terms_of_service": "Allgemeine Geschäftsbedingungen",
        "translator": "Übersetzer",
        "updated_at": "Aktualisiert am",
        "vat_rate": "Mehrwertsteuersatz"
      }
    },
    "day_names": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "day_names_string": {
      "friday": "Friday",
      "monday": "Monday",
      "saturday": "Saturday",
      "sunday": "Sunday",
      "thursday": "Thursday",
      "tuesday": "Tuesday",
      "wednesday": "Wednesday"
    },
    "errors": {
      "full_messages": {
        "format": "%{attribute}%{message}"
      },
      "messages": {
        "accepted": "müssen akzeptiert werden",
        "blank": "muss ausgefüllt werden",
        "confirmation": "stimmt nicht mit der Bestätigung überein",
        "empty": "muss ausgefüllt werden",
        "equal_to": "muss genau %{count} sein",
        "even": "muss gerade sein",
        "exclusion": "ist nicht verfügbar",
        "greater_than": "muss größer als %{count} sein",
        "greater_than_or_equal_to": "muss größer oder gleich %{count} sein",
        "inclusion": "ist kein gültiger Wert",
        "invalid": "ist nicht gültig",
        "less_than": "muss kleiner als %{count} sein",
        "less_than_or_equal_to": "muss kleiner oder gleich %{count} sein",
        "not_a_number": "ist keine Zahl",
        "not_an_integer": "muss ganzzahlig sein",
        "odd": "muss ungerade sein",
        "record_invalid": "Gültigkeitsprüfung ist fehlgeschlagen: %{errors}",
        "restrict_dependent_destroy": {
          "has_many": "Cannot delete record because dependent %{record} exist",
          "has_one": "Cannot delete record because a dependent %{record} exists"
        },
        "taken": "ist bereits vergeben",
        "too_long": "ist zu lang (nicht mehr als %{count} Zeichen)",
        "too_short": "ist zu kurz (nicht weniger als %{count} Zeichen)",
        "wrong_length": "hat die falsche Länge (muss genau %{count} Zeichen haben)"
      },
      "models": {
        "amenity": {
          "attributes": {
            "name": {
              "invalid": "darf nur Buchstaben enthalten"
            }
          }
        },
        "attraction": {
          "attributes": {
            "name": {
              "invalid": "darf nur Buchstaben enthalten"
            }
          }
        },
        "block": {
          "attributes": {
            "ending": {
              "range_too_short": "muss mindestens eine Tag nach Beginn des Zeitraums sein"
            }
          }
        },
        "cost": {
          "attributes": {
            "name": {
              "invalid": "darf nur Buchstaben enthalten"
            }
          }
        },
        "extra": {
          "attributes": {
            "kind": {
              "invalid": "darf nur Buchstaben enthalten"
            }
          }
        },
        "limitation": {
          "attributes": {
            "name": {
              "invalid": "darf nur Buchstaben enthalten"
            }
          }
        },
        "price": {
          "attributes": {
            "base": {
              "lump_price_exists": "Es existiert bereits ein Standard-Preis für den Zeitraum",
              "nested_season": "Das Überlappen von Saisonzeiträumen ist nicht möglich. Bitte legen Sie die einzelnen Saisonpreise aufeinanderfolgend an, so dass die Zeiträume sich nicht überschneiden.",
              "nightly_price_exists": "Es existiert bereits ein Preis für einen der Tage",
              "no_night_selected": "Bitte wählen Sie mindestens einen Wochentag aus",
              "not_linked_up": "Bei Standard-Preisen müssen die Wochentage zusammenhängend sein"
            },
            "ending": {
              "range_too_short": "muss mindestens eine Tag nach Beginn des Gültigkeitszeitraums sein"
            }
          },
          "not_blank": "ist nicht leer"
        },
        "travel_region": {
          "attributes": {
            "name": {
              "invalid": "darf nur Buchstaben enthalten"
            }
          }
        }
      },
      "template": {
        "body": "Bitte überprüfen Sie die folgenden Felder:",
        "header": {
          "one": "Konnte %{model} nicht speichern: ein Fehler.",
          "other": "Konnte %{model} nicht speichern: %{count} Fehler."
        }
      }
    },
    "models": {
      "accommodation": "Ferienwohnung/Zimmer",
      "amenity": "Ausstattungsmerkmal",
      "attraction": "Attraktion",
      "attraction_distance": "Entfernung zu Attraktionen",
      "block": "Blockierer Zeitraum",
      "cost": "Zusatzkosten",
      "extra": "Optionale Ausstattungsmerkmale",
      "limitation": "Einschränkungen/Besonderheiten",
      "price": "Preis",
      "property": "Objekt",
      "property_photo": "Foto",
      "travel_booking": "Buchung",
      "travel_region": "Region",
      "user": "Benutzer"
    },
    "month_names": [
      null,
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "options": {
      "accommodation": {
        "bond_refund": {
          "instantly": "sofort bei Abreise",
          "one_week": "eine Woche nach Abreise",
          "two_weeks": "zwei Wochen nach Abreise"
        },
        "kind": {
          "apartment": "Apartment",
          "bed_and_breakfast": "Bed & Breakfast",
          "holiday_home": "Ferienhaus"
        }
      },
      "amenity": {
        "category": {
          "business": "Business",
          "domestic": "Haushaltsgeräte",
          "exclusive": "Wellness und Freizeit",
          "exterior": "Außerhalb",
          "general": "Allgemeine",
          "location": "Standort",
          "multimedia": "Multimedia",
          "orientation": "Ausrichtung",
          "other": "Ausstattung für Personen mit eingeschränkter Mobilität",
          "view": "Ausblick"
        }
      },
      "attraction": {
        "category": {
          "activities": "Aktivitäten",
          "other": "Sonstiges",
          "places": "Orte"
        }
      },
      "extra": {
        "extra_type": {
          "bring": "Selbst mitbringen",
          "included": "Inklusive",
          "on_request": "auf Anfrage",
          "payable": "Muss gemietet werden"
        },
        "unit": {
          "per_night": "pro Nacht",
          "per_night_and_person": "pro Nacht/Person",
          "per_person": "pro Person",
          "per_piece": "pro Stück",
          "per_set": "pro Set",
          "per_stay": "pro Aufenthalt"
        }
      },
      "limitation": {
        "name": {
          "allowed": "Gestattet",
          "forbidden": "Nicht gestattet",
          "onrequest": "Auf Anfrage"
        }
      },
      "price": {
        "payment_type": {
          "lump": "pauschal",
          "nightly": "pro Nacht"
        },
        "rotation_day": {
          "friday": "Freitag",
          "monday": "Montag",
          "saturday": "Samstag",
          "sunday": "Sonntag",
          "thursday": "Donnerstag",
          "tuesday": "Dienstag",
          "wednesday": "Mittwoch"
        }
      },
      "travel_region": {
        "country_code": {
          "AD": "Andorra",
          "AE": "United Arab Emirates",
          "AF": "Afghanistan",
          "AG": "Antigua and Barbuda",
          "AI": "Anguilla",
          "AL": "Albania",
          "AM": "Armenia",
          "AN": "Netherlands Antilles",
          "AO": "Angola",
          "AP": "Asia/Pacific Region",
          "AQ": "Antarctica",
          "AR": "Argentina",
          "AS": "American Samoa",
          "AT": "Österreich",
          "AU": "Australia",
          "AW": "Aruba",
          "AX": "Aland Islands",
          "AZ": "Azerbaijan",
          "BA": "Bosnia and Herzegovina",
          "BB": "Barbados",
          "BD": "Bangladesh",
          "BE": "Belgien",
          "BF": "Burkina Faso",
          "BG": "Bulgaria",
          "BH": "Bahrain",
          "BI": "Burundi",
          "BJ": "Benin",
          "BL": "Saint Bartelemey",
          "BM": "Bermuda",
          "BN": "Brunei Darussalam",
          "BO": "Bolivia",
          "BR": "Brazil",
          "BS": "Bahamas",
          "BT": "Bhutan",
          "BV": "Bouvet Island",
          "BW": "Botswana",
          "BY": "Belarus",
          "BZ": "Belize",
          "CA": "Canada",
          "CC": "Cocos (Keeling) Islands",
          "CD": "Congo, The Democratic Republic of the",
          "CF": "Central African Republic",
          "CG": "Congo",
          "CH": "Schweiz",
          "CI": "Cote d'Ivoire",
          "CK": "Cook Islands",
          "CL": "Chile",
          "CM": "Cameroon",
          "CN": "China",
          "CO": "Colombia",
          "CR": "Costa Rica",
          "CU": "Cuba",
          "CV": "Cape Verde",
          "CX": "Christmas Island",
          "CY": "Cyprus",
          "CZ": "Czech Republic",
          "DE": "Deutschland",
          "DJ": "Djibouti",
          "DK": "Dänemark",
          "DM": "Dominica",
          "DO": "Dominican Republic",
          "DZ": "Algeria",
          "EC": "Ecuador",
          "EE": "Estonia",
          "EG": "Egypt",
          "EH": "Western Sahara",
          "ER": "Eritrea",
          "ES": "Spanien",
          "ET": "Ethiopia",
          "EU": "Europe",
          "FI": "Finnland",
          "FJ": "Fiji",
          "FK": "Falkland Islands (Malvinas)",
          "FM": "Micronesia, Federated States of",
          "FO": "Faroe Islands",
          "FR": "Frankreich",
          "FX": "France, Metropolitan",
          "GA": "Gabon",
          "GB": "Großbritannien",
          "GD": "Grenada",
          "GE": "Georgia",
          "GF": "French Guiana",
          "GG": "Guernsey",
          "GH": "Ghana",
          "GI": "Gibraltar",
          "GL": "Greenland",
          "GM": "Gambia",
          "GN": "Guinea",
          "GP": "Guadeloupe",
          "GQ": "Equatorial Guinea",
          "GR": "Griechenland",
          "GS": "South Georgia and the South Sandwich Islands",
          "GT": "Guatemala",
          "GU": "Guam",
          "GW": "Guinea-Bissau",
          "GY": "Guyana",
          "HK": "Hong Kong",
          "HM": "Heard Island and McDonald Islands",
          "HN": "Honduras",
          "HR": "Kroatien",
          "HT": "Haiti",
          "HU": "Ungarn",
          "ID": "Indonesia",
          "IE": "Ireland",
          "IL": "Israel",
          "IM": "Isle of Man",
          "IN": "India",
          "IO": "British Indian Ocean Territory",
          "IQ": "Iraq",
          "IR": "Iran, Islamic Republic of",
          "IS": "Island",
          "IT": "Italien",
          "JE": "Jersey",
          "JM": "Jamaica",
          "JO": "Jordan",
          "JP": "Japan",
          "KE": "Kenya",
          "KG": "Kyrgyzstan",
          "KH": "Cambodia",
          "KI": "Kiribati",
          "KM": "Comoros",
          "KN": "Saint Kitts and Nevis",
          "KP": "Korea, Democratic People's Republic of",
          "KR": "Korea, Republic of",
          "KW": "Kuwait",
          "KY": "Cayman Islands",
          "KZ": "Kazakhstan",
          "LA": "Lao People's Democratic Republic",
          "LB": "Lebanon",
          "LC": "Saint Lucia",
          "LI": "Liechtenstein",
          "LK": "Sri Lanka",
          "LR": "Liberia",
          "LS": "Lesotho",
          "LT": "Lithuania",
          "LU": "Luxemburg",
          "LV": "Latvia",
          "LY": "Libyan Arab Jamahiriya",
          "MA": "Morocco",
          "MC": "Monaco",
          "MD": "Moldova, Republic of",
          "ME": "Montenegro",
          "MF": "Saint Martin",
          "MG": "Madagascar",
          "MH": "Marshall Islands",
          "MK": "Macedonia",
          "ML": "Mali",
          "MM": "Myanmar",
          "MN": "Mongolia",
          "MO": "Macao",
          "MP": "Northern Mariana Islands",
          "MQ": "Martinique",
          "MR": "Mauritania",
          "MS": "Montserrat",
          "MT": "Malta",
          "MU": "Mauritius",
          "MV": "Maldives",
          "MW": "Malawi",
          "MX": "Mexico",
          "MY": "Malaysia",
          "MZ": "Mozambique",
          "NA": "Namibia",
          "NC": "New Caledonia",
          "NE": "Niger",
          "NF": "Norfolk Island",
          "NG": "Nigeria",
          "NI": "Nicaragua",
          "NL": "Niederlande",
          "NO": "Norwegen",
          "NP": "Nepal",
          "NR": "Nauru",
          "NU": "Niue",
          "NZ": "New Zealand",
          "OM": "Oman",
          "PA": "Panama",
          "PE": "Peru",
          "PF": "French Polynesia",
          "PG": "Papua New Guinea",
          "PH": "Philippines",
          "PK": "Pakistan",
          "PL": "Polen",
          "PM": "Saint Pierre and Miquelon",
          "PN": "Pitcairn",
          "PR": "Puerto Rico",
          "PS": "Palestinian Territory",
          "PT": "Portugal",
          "PW": "Palau",
          "PY": "Paraguay",
          "QA": "Qatar",
          "RE": "Reunion",
          "RO": "Romania",
          "RS": "Serbia",
          "RU": "Russian Federation",
          "RW": "Rwanda",
          "SA": "Saudi Arabia",
          "SB": "Solomon Islands",
          "SC": "Seychelles",
          "SD": "Sudan",
          "SE": "Schweden",
          "SG": "Singapore",
          "SH": "Saint Helena",
          "SI": "Slovenia",
          "SJ": "Svalbard and Jan Mayen",
          "SK": "Slovakia",
          "SL": "Sierra Leone",
          "SM": "San Marino",
          "SN": "Senegal",
          "SO": "Somalia",
          "SR": "Suriname",
          "ST": "Sao Tome and Principe",
          "SV": "El Salvador",
          "SY": "Syrian Arab Republic",
          "SZ": "Swaziland",
          "TC": "Turks and Caicos Islands",
          "TD": "Chad",
          "TF": "French Southern Territories",
          "TG": "Togo",
          "TH": "Thailand",
          "TJ": "Tajikistan",
          "TK": "Tokelau",
          "TL": "Timor-Leste",
          "TM": "Turkmenistan",
          "TN": "Tunisia",
          "TO": "Tonga",
          "TR": "Turkey",
          "TT": "Trinidad and Tobago",
          "TV": "Tuvalu",
          "TW": "Taiwan",
          "TZ": "Tanzania, United Republic of",
          "UA": "Ukraine",
          "UG": "Uganda",
          "UM": "United States Minor Outlying Islands",
          "US": "United States",
          "UY": "Uruguay",
          "UZ": "Uzbekistan",
          "VA": "Holy See (Vatican City State)",
          "VC": "Saint Vincent and the Grenadines",
          "VE": "Venezuela",
          "VG": "Virgin Islands, British",
          "VI": "Virgin Islands, U.S.",
          "VN": "Vietnam",
          "VU": "Vanuatu",
          "WF": "Wallis and Futuna",
          "WS": "Samoa",
          "YE": "Yemen",
          "YT": "Mayotte",
          "ZA": "South Africa",
          "ZM": "Zambia",
          "ZW": "Zimbabwe",
          "all": "Alle Länder"
        }
      }
    },
    "order": [
      "year",
      "month",
      "day"
    ],
    "status_codes": {
      "accommodation": {
        "create_failed": "Ferienwohnung/Zimmer konnte nicht angelegt werden.",
        "destroyed": "Ferienwohnung/Zimmer wurde gelöscht.",
        "successfully_created": "Ferienwohnung/Zimmer erfolgreich angelegt.",
        "successfully_updated": "Ferienwohnung/Zimmer erfolgreich geändert.",
        "update_failed": "Ferienwohnung/Zimmer konnte nicht geändert werden."
      },
      "amenity": {
        "create_failed": "Ausstattungsmerkmal konnte nicht angelegt werden.",
        "destroyed": "Ausstattungsmerkmal wurde gelöscht.",
        "successfully_created": "Ausstattungsmerkmal erfolgreich angelegt.",
        "successfully_updated": "Ausstattungsmerkmal erfolgreich geändert.",
        "update_failed": "Ausstattungsmerkmal konnte nicht geändert werden."
      },
      "approval": {
        "successfully_updated": "Freigabe erfolgreich geändert"
      },
      "attraction": {
        "create_failed": "Attraktion konnte nicht angelegt werden.",
        "destroyed": "Attraktion wurde gelöscht.",
        "successfully_created": "Attraktion erfolgreich angelegt.",
        "successfully_updated": "Attraktion erfolgreich geändert.",
        "update_failed": "Attraktion konnte nicht geändert werden."
      },
      "attraction_distance": {
        "create_failed": "Entfernung zur Attraktion konnte nicht angelegt werden.",
        "destroyed": "Entfernung zur Attraktion wurde gelöscht.",
        "successfully_created": "Entfernung zur Attraktion erfolgreich angelegt.",
        "successfully_updated": "Entfernung zur Attraktion erfolgreich geändert.",
        "update_failed": "Entfernung zur Attraktion konnte nicht geändert werden."
      },
      "block": {
        "create_failed": "Zeitraum konnte nicht angelegt werden.",
        "destroyed": "Zeitraum wurde gelöscht.",
        "successfully_created": "Zeitraum erfolgreich angelegt.",
        "successfully_unblocked": "Zeitraum erfolgreich buchbar gemacht.",
        "successfully_updated": "Zeitraum erfolgreich geändert.",
        "unblocking_failed": "Zeitraum konnte nicht buchbar gemacht werden.",
        "update_failed": "Zeitraum konnte nicht geändert werden."
      },
      "cost": {
        "create_failed": "Zusatzkosten konnte nicht angelegt werden.",
        "destroyed": "Zusatzkosten wurde gelöscht.",
        "successfully_created": "Zusatzkosten erfolgreich angelegt.",
        "successfully_updated": "Zusatzkosten erfolgreich geändert.",
        "update_failed": "Zusatzkosten konnte nicht geändert werden."
      },
      "extra": {
        "create_failed": "Extra konnte nicht angelegt werden.",
        "destroyed": "Extra wurde gelöscht.",
        "successfully_created": "Extra erfolgreich angelegt.",
        "successfully_updated": "Extra erfolgreich geändert.",
        "update_failed": "Extra konnte nicht geändert werden."
      },
      "invitation": {
        "create_failed": "Invitation could not be implemented. ",
        "successfully_created": " Invitation successfully implemented."
      },
      "limitation": {
        "create_failed": "Einschränkung/Besonderheit konnte nicht angelegt werden.",
        "destroyed": "Einschränkung/Besonderheit wurde gelöscht.",
        "successfully_created": "Einschränkung/Besonderheit erfolgreich angelegt.",
        "successfully_updated": "Einschränkung/Besonderheit erfolgreich geändert.",
        "update_failed": "Einschränkung/Besonderheit konnte nicht geändert werden."
      },
      "price": {
        "create_failed": "Preis konnte nicht angelegt werden.",
        "destroyed": "Preis wurde gelöscht.",
        "nested_season": "Das Überlappen von Saisonzeiträumen ist nicht möglich. Bitte legen Sie die einzelnen Saisonpreise aufeinanderfolgend an, so dass die Zeiträume sich nicht überschneiden.",
        "successfully_created": "Preis erfolgreich angelegt.",
        "successfully_updated": "Preis erfolgreich geändert.",
        "update_failed": "Preis konnte nicht geändert werden."
      },
      "property": {
        "create_failed": "Objekt konnte nicht angelegt werden.",
        "destroyed": "Objekt wurde gelöscht.",
        "successfully_created": "Objekt erfolgreich angelegt.",
        "successfully_updated": "Objekt erfolgreich geändert.",
        "update_failed": "Objekt konnte nicht geändert werden."
      },
      "property_photo": {
        "create_failed": "Bild konnte nicht angelegt werden.",
        "destroyed": "Bild wurde gelöscht.",
        "successfully_created": "Bild erfolgreich angelegt.",
        "successfully_updated": "Bild erfolgreich geändert.",
        "update_failed": "Bild konnte nicht geändert werden."
      },
      "travel_booking": {
        "cancel_failed": "Buchung wurde nicht storniert.",
        "confirmation_failed": "Buchung wurde nicht bestätigt.",
        "create_failed": "Buchung konnte nicht angelegt werden.",
        "destroyed": "Buchung wurde gelöscht.",
        "successfully_cancelled": "Buchung wurde storniert.",
        "successfully_confirmed": "Buchung wurde bestätigt.",
        "successfully_created": "Buchung erfolgreich angelegt.",
        "successfully_updated": "Buchung erfolgreich geändert.",
        "update_failed": "Buchung konnte nicht geändert werden."
      },
      "travel_region": {
        "create_failed": "Region konnte nicht angelegt werden.",
        "destroyed": "Region wurde gelöscht.",
        "successfully_created": "Region erfolgreich angelegt.",
        "successfully_updated": "Region erfolgreich geändert.",
        "update_failed": "Region konnte nicht geändert werden."
      },
      "user": {
        "create_failed": "Die Benutzerdaten konnten nicht angelegt werden.",
        "destroyed": "Der Benutzer wurde gelöscht.",
        "must_be_host": "Bitte werden Sie Vermieter.",
        "must_be_renter": "Bitte werden Sie Mieter. Hierzu registrieren Sie sich bitte mit einer weiteren Email-Adresse.",
        "successfully_created": "Die Benutzerdaten wurden erfolgreich angelegt.",
        "successfully_updated": "Die Benutzerdaten wurden erfolgreich geändert.",
        "update_failed": "Die Benutzerdaten konnten nicht geändert werden.",
        "wrong_date_format": "Das Datumsformat ist falsch."
      }
    }
  },
  "administration": {
    "accommodations": {
      "price_change_end_date_label": "Ende: Saisonpreise, die an oder vor diesem Datum beginnen (nicht ausfüllen, um Preise nicht zu ändern)",
      "price_change_label": "Preisänderung (in %, nicht ausfüllen, um Preise nicht zu ändern)",
      "price_change_start_date_label": "Start: Saisonpreise, die an oder nach diesem Datum beginnen (nicht ausfüllen, um Preise nicht zu ändern)"
    },
    "city_name_for_filter": "Namer der Stadt für Suchfilter",
    "landing_pages": {
      "accids": "Unterkunft IDs",
      "country_code": "Länderkürzel",
      "desc": "Beschreibung",
      "edit": "Landing Page bearbeiten",
      "header": "Kopfgrafik",
      "img": "Teaserbild",
      "locale": "Sprachversion",
      "mailer": "E-Mail Linktext",
      "mailer_subject": "E-Mail Betreff",
      "meta_desc": "SEO Beschreibung",
      "meta_keyword": "SEO Stichwörter",
      "search_meta": "Region",
      "slug": "proce",
      "title": "Region"
    },
    "properties": {
      "form": {
        "api_blocked": "In API sperren"
      }
    },
    "travel_bookings": {
      "no_data": "Keine Daten vorhanden"
    }
  },
  "already_cancelled": "Bereits storniert",
  "already_confirmed": "Bereits bestätigt",
  "ancestry": {
    "cannot_delete_descendants": "Cannot delete record because it has descendants.",
    "cannot_rebuild_depth_cache": "Cannot rebuild depth cache for model without depth caching.",
    "conflicting_parent_id": "Conflicting parent id found in node %{node_id}: %{parent_id} for node %{node_id} while expecting %{expected}",
    "exclude_self": "%{class_name} cannot be a descendant of itself.",
    "invalid_ancestry_column": "Invalid format for ancestry column of node %{node_id}: %{ancestry_column}.",
    "invalid_orphan_strategy": "Invalid orphan strategy, valid ones are :rootify, :adopt, :restrict and :destroy.",
    "named_scope_depth_cache": "Named scope '%{scope_name}' is only available when depth caching is enabled.",
    "no_child_for_new_record": "No child ancestry for new record. Save record before performing tree operations.",
    "option_must_be_hash": "Options for has_ancestry must be in a hash.",
    "reference_nonexistent_node": "Reference to nonexistent node in node %{node_id}: %{ancestor_id}.",
    "unknown_depth_option": "Unknown depth option: %{scope_name}.",
    "unknown_option": "Unknown option for has_ancestry: %{key} => %{value}."
  },
  "attributes": {
    "created_at": "Créé le",
    "translations": {
      "description": "Beschreibung",
      "description_de": "Beschreibung (deutsch)",
      "description_en": "Beschreibung (englisch)",
      "description_es": "Beschreibung (spanisch)",
      "description_fr": "Beschreibung (französisch)",
      "description_nl": "Beschreibung (niederländisch)",
      "description_short": "Kurzbeschreibung",
      "description_short_de": "Kurzbeschreibung (deutsch)",
      "description_short_en": "Kurzbeschreibung (englisch)",
      "description_short_es": "Kurzbeschreibung (spanisch)",
      "description_short_fr": "Kurzbeschreibung (französisch)",
      "description_short_nl": "Kurzbeschreibung (niederländisch)",
      "kind": "Art",
      "kind_de": "Art (deutsch)",
      "kind_en": "Art (englisch)",
      "kind_es": "Art (spanisch)",
      "kind_fr": "Art (französisch)",
      "kind_nl": "Art (niederländisch)",
      "title": "Titel",
      "title_de": "Titel (deutsch)",
      "title_en": "Titel (englisch)",
      "title_es": "Titel (spanisch)",
      "title_fr": "Titel (französisch)",
      "title_nl": "Titel (niederländisch)"
    },
    "updated_at": "Modifié le"
  },
  "booking": {
    "additional_costs_host": "Zusatzkosten/Verbrauchskosten",
    "additional_information": "Weitere Angaben",
    "additional_information_annotation": "Bitte wählen Sie hier die Anzahl der Personen und Ihr Wunschobjekt für den zu buchenden Zeitraum.",
    "adult": "Erwachsener",
    "adults": "Erwachsene",
    "arrival_date": "Anreisedatum",
    "arrival_date_annotation": "Bitte wählen Sie hier Ihr gewünschtes Anreisedatum.",
    "availability_check": "Schauen Sie hier, ob Ihr Wunschobjekt verfügbar ist.",
    "availability_txt": "Bitte wählen Sie den von Ihnen gewünschten Zeitraum direkt im Kalender.",
    "available_arrival_date": "Verfügbares Anreisedatum",
    "available_arrival_date_annotation": "Um ein bereits gewähltes Anreisedatum zu ändern, klicken Sie bitte auf ein alternatives Anreisedatum.",
    "booking_headline": "Buchen Sie „%{object_name}“ in 2 Schritten",
    "booking_info": "Buchungsinformationen",
    "booking_overview": "Ihre Buchungsübersicht",
    "booking_period": "Zeitraum",
    "booking_possible_timespace": "Möglicher Buchungszeitraum",
    "booking_process": "Buchungsablauf",
    "booking_process_confirmation": "Nach der Eingabe Ihrer Buchung, erhalten Sie von uns eine Bestätigung per E-Mail.",
    "booking_process_payment_details": "Nach der Bestätigung des Vermieters, empfangen Sie die nötigen Zahlungsinformationen.",
    "booking_summary": "Zusammenfassung Ihrer Buchung",
    "booking_timespace": "Buchungszeitraum",
    "calendar_annotation": "Bitte haben Sie einen Moment Geduld, die Verfügbarkeit des Objektes wird geladen.",
    "cancellation": {
      "accept_conditions": "Mit der Zubuchung der Rücktrittsversicherung akzeptiere ich deren <a href=\"/downloads/terms-conditions/cancellation-insurance-de\" target=\"_blank\" rel=\"noopener noreferrer\">Versicherungsbedingungen</a>.",
      "amount": "Nur %{amount}",
      "opt_in": "Ich möchte zusätzlich eine Reiserücktrittsversicherung für diese Buchung abschließen."
    },
    "casualty_insurance": "inkl. Haftpflichtversicherung:",
    "casualty_insurance_txt": "Nützlich im Falle eines Schadens - ohne Eigenbeteiligung",
    "change": "Ändern",
    "check_payment_info": "Bitte überprüfen Sie Ihre Zahlungsdaten oder kontaktieren Sie gegebenenfalls Ihren Kreditkartenanbieter.",
    "chid_age_full": "Kind (0-17 Jahre)",
    "chidren_age_full": "Kinder (0-17 Jahre)",
    "child_age17": "Kind (2-17 Jahre)",
    "child_age2": "Kind (0-1 Jahre)",
    "child_part_age2": "Baby (0-1 Jahre)",
    "child_part_age2_cost": "Davon Babies (0-1 Jahre)",
    "children_age17": "Kinder (2-17 Jahre)",
    "children_age2": "Kinder (0-1 Jahre)",
    "children_part_age2": "Babies (0–1 Jahre)",
    "comment": "Anmerkungen - Gutscheincode",
    "comment_label_info": "Bitte geben Sie hier Ihren Gutscheincode ein, somit erhalten Sie nach der Buchung Ihre Ermässigung.",
    "comment_note": "Hier bitte Kommentare/Anmerkungen/Gutscheincode eingeben.",
    "confirmation_mail": "Innerhalb der nächsten Minuten erhalten Sie eine Bestätigungsmail an folgende Adresse",
    "confirmation_spam_notice": "Sie haben keine E-Mail erhalten? Möglicherweise ist unsere E-Mail in dem Spam-Ordner Ihres E-Mail-Programmes gelandet.",
    "confirmation_wrong_mail": "Bei Rückfragen zu Ihrer Buchung wenden Sie sich bitte an",
    "contact_host": "Kontakt zum Vermieter",
    "dateselect": "Um einen bereits gewählten Zeitraum zu ändern, klicken Sie bitte auf das das Start- oder Enddatum und wählen Sie anschließend ein neues Datum aus.",
    "deposit": "Kaution",
    "deposit_handling": "Kautionserstattung",
    "duration": "Dauer",
    "duration_of_stay": {
      "one": "%{count} Nacht",
      "other": "%{count} Nächte"
    },
    "duration_of_stay_annotation": "Bitte wählen Sie hier eine Aufenthaltsdauer aus - entsprechend den rechts gezeigten Optionen.",
    "europeene_explanation": "Axa ist Casapilots Versicherungspartner.",
    "from": "von",
    "group": "Ihre Gruppe ",
    "group_comment": "Zusammenstellung der Gruppe",
    "group_max": "Max. Alter",
    "group_min": "Min. Alter",
    "group_years": "Gruppenalter",
    "group_years_sum": "%{min} – %{max} Jahre",
    "hh_additional": "Zusatzkosten",
    "hh_additional_tax": "Ortstaxe",
    "hh_agb": "Allgemeine Geschäftsbedingungen",
    "hh_agb_annotation": "Ich bestätige, dass ich die allgemeinen Geschäftsbedingungen gelesen, verstanden und akzeptiert habe",
    "hh_conditions_and_prices": "Mietbedingungen und Preise",
    "hh_inc_fees": "Inklusive Reservierungsgebühr und Bearbeitungsgebühr",
    "hh_redirect_annotation_pt1": "Sollte die automatische Weiterleitung nicht funktionieren, klicken Sie",
    "hh_redirect_annotation_pt2": "hier.",
    "hh_redirect_hl": "Weiterleitung zu Holiday Home",
    "hh_redirect_txt": "Sie werden nun zu unserem Kooperationsparter Holiday Home weitergeleitet. Bitte haben Sie einen Moment Geduld.",
    "host_contact": "Die Kontaktdaten zum Vermieter erhalten Sie per E-Mail, zusammen mit dem Aufenthaltsschein ca. 3 Wochen vor Beginn des Aufenthalts.",
    "host_cost": "zzgl. der Kosten vor Ort",
    "inc_fees": "Inklusive Reservierungsgebühren und Bearbeitungsgebühr",
    "inc_fees_cancellation": "Inklusive Reiserücktrittsversicherung, Reservierungsgebühr und Bearbeitungsgebühr",
    "info_message_redirect": "Sie werden jetzt automatisch auf die Homepage weitergeleitet.",
    "insurance_names_txt": "Bitte geben Sie die Namen aller Mitreisenden an, die versichert werden sollen. Auf diese Namen wird der Versicherungsschein ausgestellt.",
    "insurance_names_txt_2": "Schreiben Sie jeden Namen in eine eigene Zeile oder trennen Sie sie mit einem Komma. Die Angabe des Nachnamens ist ausreichend.",
    "insurance_tos": "Versicherungs-AGB",
    "insurance_tos_html": "Ich bestätige, dass ich die Versicherungs-AGB gelesen, verstanden und akzeptiert habe",
    "insurances": "Versicherungen",
    "journey": "Ihre Reise",
    "limitations": "Besonderheiten/Einschränkungen",
    "mail_confirmation": "Sie haben die Reservierungsanfrage für Ihr Objekt erfolgreich bestätigt. Der Status der Buchung ist nun verbindlich.",
    "mail_confirmation_annotation": "Haben Sie Fragen zum Buchungsvorgang? Dann kontaktieren Sie uns gerne.",
    "me_redirect_hl": "Weiterleitung zu MER-EVASION",
    "me_redirect_txt": "Sie werden nun zu unserem Kooperationsparter MER-EVASION weitergeleitet. Bitte haben Sie einen Moment Geduld.",
    "mv_redirect_hl": "Weiterleitung zu MONTAGNE-VACANCES",
    "mv_redirect_txt": "Sie werden nun zu unserem Kooperationsparter MONTAGNE-VACANCES weitergeleitet. Bitte haben Sie einen Moment Geduld.",
    "navigation": {
      "availability": "Termine",
      "booking_info": "Kosten",
      "payment": "Zahlung",
      "payment_feedback": "Bestätigung",
      "payment_info": "Zusammenfassung"
    },
    "newsletter_subscription": "Ich möchte den Casapilot-Newsletter erhalten.",
    "night": "Nacht",
    "nights": "Nächte",
    "no_costs": "Keine",
    "number_of_persons": "Anzahl der Personen",
    "payment": "Zahlen Sie jetzt.",
    "payment_accepted": "Vielen Dank für Ihre Buchung.\n\nNach Bestätigung durch den Vermieter erhalten Sie eine E-Mail mit allen nötigen Zahlungsinformationen.\nMit freundlichen Grüßen,\nTeam Casapilot.",
    "payment_declined": "Ihre Zahlung wurde abgelehnt",
    "payment_declined_txt": "Ihre Zahlung wurde leider abgelehnt.",
    "payment_not_possible": "Zahlung derzeit nicht möglich",
    "payment_not_possible_txt": "Eine Zahlung ist derzeit leider nicht möglich.",
    "payment_not_possible_txt2": "Bitte versuchen Sie es später erneut oder kontaktieren Sie gegebenenfalls Ihren Kreditkartenanbieter.",
    "payment_successful": "Ihre Zahlung war erfolgreich.",
    "pet": "Haustier",
    "pet_comment_separator": "Kommentar zu Haustieren:",
    "pets": "Haustiere",
    "pets_not_allowed": "Haustiere sind nicht erlaubt",
    "posible_host_cost": "",
    "posible_host_cost_txt": "Die folgenden Kosten sind nicht im oben genannten Mietpreis enthalten:",
    "possible_costs_host": "Kosten für optionale Ausstattung",
    "price_box_season_annotation": "Die Preise können je nach Saison abweichen.",
    "price_total": "Mietpreis",
    "prices_object": "Preise für Ihr Wunschobjekt",
    "rental_price": "Mietpreis",
    "renter": {
      "birthday_format": "TT.MM.JJJJ"
    },
    "reservation": {
      "failed": "Leider konnte das Objekt nicht rechtzeitig gebucht werden. Bitte versuchen Sie einen anderen Zeitraum."
    },
    "reservation_fee": "inkl. Buchungsgebühr",
    "review": "Überprüfen Sie Ihre Angaben",
    "rotation_day": "Anreisetag",
    "secure": "Sicher in den Urlaub mit Casapilot. Garantiert.",
    "security": {
      "h1": "Ihre Buchung",
      "h2": "Die Bezahlung",
      "h3": "Unser Service",
      "p1": "Ihre persönlichen Daten werden vertraulich behandelt.",
      "p2": "Sichere und einfache Zahlung über das verschlüsselte System von Casapilot.",
      "p3": "Für jegliche Fragen stehen wir Ihnen gerne zur Verfügung."
    },
    "select_bookable_date": "Bitte wählen Sie ein verfügbares Anreisedatum",
    "select_duration": "Bitte wählen Sie zunächst die gewünschte Aufenthaltsdauer im blauen Auswahlfeld.",
    "slider": {
      "month_not_available_html": "In diesem Zeitraum ist<br/> das Objekt nicht verfügbar.",
      "next": "Die nächsten 4 Monate",
      "prev": "Die letzten 4 Monate"
    },
    "sp_redirect_hl": "Weiterleitung zu SKI-PLANET",
    "sp_redirect_txt": "Sie werden nun zu unserem Kooperationsparter SKI-PLANET weitergeleitet. Bitte haben Sie einen Moment Geduld.",
    "tenant_booking": "Ihre Buchung",
    "tenant_data": "Ihre Daten",
    "tenant_residence": "Ihr Wohnsitz",
    "terms_of_service_html": "Ich bestätige, dass ich die <a href=\"/downloads/terms-conditions/guest-de\" target=\"_blank\">AGB</a> von Casapilot gelesen, verstanden und akzeptiert habe.",
    "time": "Uhr",
    "to": "bis",
    "total": "gesamt",
    "travel_cancelation_insurance": "Reiserücktrittsversicherung",
    "travel_cancelation_insurance_dash": "Reiserücktritts-versicherung",
    "travel_cancelation_insurance_plus": "Reiserücktritts- inkl. Reiseversicherung",
    "travel_cancelation_insurance_plus_txt": "Günstiges Rundum-Sorglos-Paket",
    "travel_cancelation_insurance_txt": "Besteht ein Risiko, den Urlaub in letzter Minute zu annulieren?",
    "travel_insurance": "Umfassende Reiseversicherung",
    "travel_insurance_txt": "Vollkasko-Reiseversicherung",
    "traveler_options": {
      "adult": {
        "one": "%{count} Erwachsener",
        "other": "%{count} Erwachsene"
      },
      "all_children": {
        "one": "%{count} Kind (0-17 Jahre)",
        "other": "%{count} Kinder (0-17 Jahre)",
        "zero": "%{count} Kinder (0-17 Jahre)"
      },
      "baby": {
        "one": "%{count} Baby (0-1 Jahre)",
        "other": "%{count} Babies (0-1 Jahre)",
        "zero": "%{count} Babies (0-1 Jahre)"
      },
      "baby_parts": {
        "one": "Davon %{count} Baby (0-1 Jahre)",
        "other": "Davon %{count} Babies (0-1 Jahre)",
        "zero": "Davon %{count} Babies (0-1 Jahre)"
      },
      "child": {
        "one": "%{count} Kind (2-17 Jahre)",
        "other": "%{count} Kinder (2-17 Jahre)",
        "zero": "%{count} Kinder (2-17 Jahre)"
      },
      "pet": {
        "one": "%{count} Haustier",
        "other": "%{count} Haustiere",
        "zero": "%{count} Haustier"
      }
    },
    "travelers": "Mitreisende",
    "try_again": "Erneut versuchen",
    "week": "Woche",
    "weeks": "Wochen"
  },
  "booking_cancel": "Buchung stornieren",
  "booking_confirmation": "Buchungsbestätigung",
  "booking_confirming": "Buchung bestätigen",
  "breakfast_offer": {
    "body": "In diesem Objekt haben Sie die Möglichkeit, vor Ihrem Aufenthalt <a href=\"https://specials.casapilot.com/shop/\" target=\"_blank\" rel=\"noreferrer\">Frühstück oder Menüs hinzu zu buchen</a>. Lassen Sie sich mit leckeren Produkten aus der Region verwöhnen!",
    "title": "NEU: Lassen Sie sich Ihr Frühstück oder Menü liefern!"
  },
  "buttons": {
    "availability": "Verfügbarkeit",
    "book_now": "Jetzt buchen",
    "cancel": "Abbrechen",
    "continue": "Weiter",
    "delete": "Löschen",
    "edit": "Bearbeiten",
    "go_to_summary": "Zur Zusammenfassung",
    "host_acct_create": "Vermieter-Zugang erstellen",
    "login_continue": "Einloggen und Buchung fortsetzen",
    "offers": "Zu unseren Angeboten",
    "pay": "Bezahlen",
    "preview": "Voransicht",
    "price": "Preis",
    "register_continue": "Anmelden und Buchung fortsetzen",
    "register_property": "Jetzt Ihr Haus registrieren",
    "renter_acct_create": "Mieter-Zugang erstellen",
    "reserve_now": "Zahlungspflichtig bestellen",
    "save": "Weiter/Speichern",
    "submit": "Speichern"
  },
  "cancellation": "Stornieren",
  "chat_tool": {
    "widget_id": "ccac878cdcaa38f3ffc731c14c286fd6b483d18cdc48a24e623f97fcf7c68824"
  },
  "confirm": "Bestätigen",
  "confirmed_by_admin": "Durch Administrator bestätigt",
  "confirmed_by_host": "Durch Vermieter bestätigt",
  "cookie_disclaimer": {
    "button_text": "Akzeptieren",
    "link_text": "Mehr erfahren",
    "text": "<p>Diese Website verwendet Cookies.</p>\n<p>Das sind kleine Textdateien, die auf Ihrem Endgerät abgelegt werden und die eine Analyse der Benutzung der Webseite ermöglichen.</p>\n<p>Nähere Informationen hierzu entnehmen Sie bitte unserer Datenschutzerklärung.</p>\n<p>Sie stimmen durch die weitere Nutzung der Webseite mit entsprechender Browser-Einstellung der Verwendung von Cookies in diesem Rahmen zu.</p>"
  },
  "country_codes": {
    "at": "Österreich",
    "be": "Belgien",
    "bg": "Bulgarien",
    "ch": "Schweiz",
    "cy": "Zypern",
    "cz": "Tschechien",
    "de": "Deutschland",
    "dk": "Dänemark",
    "ee": "Estland",
    "es": "Spanien",
    "false": "Norwegen",
    "fi": "Finnland",
    "fr": "Frankreich",
    "gb": "Vereinigtes Königreich",
    "gr": "Griechenland",
    "hr": "Kroatien",
    "ie": "Irland",
    "is": "Island",
    "it": "Italien",
    "li": "Liechtenstein",
    "lt": "Litauen",
    "lu": "Luxemburg",
    "lv": "Lettland",
    "mt": "Malta",
    "nl": "Niederlande",
    "pl": "Polen",
    "pt": "Portugal",
    "ro": "Rumänien",
    "se": "Schweden",
    "si": "Slowenien",
    "sk": "Slowakei",
    "uk": "Vereinigtes Königreich"
  },
  "date": {
    "abbr_day_names": [
      "So",
      "Mo",
      "Di",
      "Mi",
      "Do",
      "Fr",
      "Sa"
    ],
    "abbr_day_names_string": {
      "friday": "Fr",
      "monday": "Mo",
      "saturday": "Sa",
      "sunday": "So",
      "thursday": "Do",
      "tuesday": "Di",
      "wednesday": "Mi"
    },
    "abbr_month_names": [
      null,
      "Jan",
      "Feb",
      "Mär",
      "Apr",
      "Mai",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Okt",
      "Nov",
      "Dez"
    ],
    "day_names": [
      "Sonntag",
      "Montag",
      "Dienstag",
      "Mittwoch",
      "Donnerstag",
      "Freitag",
      "Samstag"
    ],
    "day_names_string": {
      "friday": "Freitag",
      "monday": "Montag",
      "saturday": "Samstag",
      "sunday": "Sonntag",
      "thursday": "Donnerstag",
      "tuesday": "Dienstag",
      "wednesday": "Mittwoch"
    },
    "formats": {
      "calendar_field": "%d.%m.%Y",
      "day_date_month": "dd, DD. MMM",
      "default": "%d.%m.%Y",
      "long": "%e. %B %Y",
      "long_date": "%a. %d.%m.%y",
      "month_year": "MMMM YYYY",
      "only_day": "%e",
      "request_time_scope": "dd. DD.MM.YY",
      "short": "%e. %b"
    },
    "month_names": [
      null,
      "Januar",
      "Februar",
      "März",
      "April",
      "Mai",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "Dezember"
    ],
    "order": [
      "day",
      "month",
      "year"
    ]
  },
  "datetime": {
    "distance_in_words": {
      "about_x_hours": {
        "one": "etwa eine Stunde",
        "other": "etwa %{count} Stunden"
      },
      "about_x_months": {
        "one": "etwa ein Monat",
        "other": "etwa %{count} Monate"
      },
      "about_x_years": {
        "one": "etwa ein Jahr",
        "other": "etwa %{count} Jahre"
      },
      "almost_x_years": {
        "one": "fast ein Jahr",
        "other": "fast %{count} Jahre"
      },
      "half_a_minute": "eine halbe Minute",
      "less_than_x_minutes": {
        "one": "weniger als eine Minute",
        "other": "weniger als %{count} Minuten"
      },
      "less_than_x_seconds": {
        "one": "weniger als eine Sekunde",
        "other": "weniger als %{count} Sekunden"
      },
      "over_x_years": {
        "one": "mehr als ein Jahr",
        "other": "mehr als %{count} Jahre"
      },
      "x_days": {
        "one": "ein Tag",
        "other": "%{count} Tage"
      },
      "x_minutes": {
        "one": "eine Minute",
        "other": "%{count} Minuten"
      },
      "x_months": {
        "one": "ein Monat",
        "other": "%{count} Monate"
      },
      "x_seconds": {
        "one": "eine Sekunde",
        "other": "%{count} Sekunden"
      }
    },
    "prompts": {
      "day": "Tag",
      "hour": "Stunden",
      "minute": "Minuten",
      "month": "Monat",
      "second": "Sekunden",
      "year": "Jahr"
    }
  },
  "days_short": {
    "friday": "Fr",
    "monday": "Mo",
    "saturday": "Sa",
    "sunday": "So",
    "thursday": "Do",
    "tuesday": "Di",
    "wednesday": "Mi"
  },
  "devise": {
    "confirmations": {
      "confirmed": "Ihr Account wurde erfolgreich bestätigt. Sie sind nun eingeloggt.",
      "new": {
        "submit": "Anfordern",
        "title": "Bestätigungsinformationen erneut senden"
      },
      "send_instructions": "Sie erhalten in wenigen Minuten eine E-Mail mit der Anleitung, wie Sie ihr Passwort zurücksetzten können.",
      "send_paranoid_instructions": "If your email address exists in our database, you will receive an email with instructions for how to confirm your email address in a few minutes.",
      "updated": "Ihr Passwort wurde geändert. Sie sind angemeldet."
    },
    "error_occured": "Ein Fehler ist aufgetreten",
    "failure": {
      "already_authenticated": "Sie sind bereits angemeldet.",
      "inactive": "Ihr Account ist nicht aktiv.",
      "invalid": "Ungültige Anmeldedaten.",
      "invalid_token": "Invalid authentication token.",
      "last_attempt": "You have one more attempt before your account is locked.",
      "locked": "Ihr Account ist gesperrt.",
      "not_found_in_database": "Invalid %{authentication_keys} or password.",
      "timeout": "Ihre Sitzung ist abgelaufen, bitte melden Sie sich erneut an.",
      "unauthenticated": "Sie müssen sich anmelden oder registrieren, bevor Sie weiterfahren können.",
      "unconfirmed": "Sie müssen Ihren Account bestätigen, bevor Sie weiterfahren können."
    },
    "mailer": {
      "confirmation_instructions": {
        "subject": "Bitte bestätigen Sie Ihre Registrierung als Nutzer von www.casapilot.com"
      },
      "email_changed": {
        "subject": "Email Changed"
      },
      "password_change": {
        "subject": "Password Changed"
      },
      "reset_password_instructions": {
        "subject": "Ihr Kennwort zurücksetzen für www.casapilot.com"
      },
      "unlock_instructions": {
        "subject": "Ihr Profil auf www.casapilot.com wurde gesperrt"
      }
    },
    "oauth_callbacks": {
      "failure": "Sie konnten nicht mit dem %{kind}-Account angemeldet werden, weil \"%{reason}\".",
      "success": "Erfolgreich mit dem %{kind}-Account angemeldet."
    },
    "omniauth_callbacks": {
      "failure": "Could not authenticate you from %{kind} because \"%{reason}\".",
      "success": "Successfully authenticated from %{kind} account."
    },
    "passwords": {
      "edit": {
        "submit": "Passwort speichern",
        "title": "Passwort ändern"
      },
      "new": {
        "submit": "Passwort zurücksetzen",
        "title": "Passwort vergessen?"
      },
      "no_token": "You can't access this page without coming from a password reset email. If you do come from a password reset email, please make sure you used the full URL provided.",
      "send_instructions": "Sie erhalten in wenigen Minuten eine E-Mail mit der Anleitung, wie Sie ihr Passwort zurücksetzten können.",
      "send_paranoid_instructions": "If your email address exists in our database, you will receive a password recovery link at your email address in a few minutes.",
      "updated": "Ihr Passwort wurde geändert. Sie sind angemeldet.",
      "updated_not_active": "Your password has been changed successfully."
    },
    "registrations": {
      "destroyed": "Ihr Account wurde erfolgreich gelöscht.",
      "edit": {
        "back": "Zurück",
        "cancel": {
          "description": "Unzufrieden?",
          "link": "Mein Profil löschen",
          "question": "Sind sie sicher?",
          "title": "Profil löschen"
        },
        "current_hint": "(Sie benötigen Ihr aktuelles Passwort, um Änderungen vornehmen zu können)",
        "password_hint": "(Leer lassen, wenn Sie es nicht ändern möchten)",
        "submit": "Speichern",
        "title": "Profil bearbeiten"
      },
      "new": {
        "newsletter_subscription": "Ich möchte den Casapilot-Newsletter erhalten",
        "submit": "Profil anlegen",
        "title": "Kostenloses Profil als Vermieter anlegen"
      },
      "signed_up": "Sie haben sich erfolgreich registriert und erhalten nun eine E-Mail zur Bestätigung Ihrer Anmeldung. Bitte öffnen Sie Ihr Postfach und bestätigen Sie Ihre E-Mail-Adresse. Sie haben keine E-Mail erhalten? Möglicherweise ist unser E-Mail in dem Spam-Ordner Ihres E-Mail-Programmes gelandet.",
      "signed_up_but_inactive": "You have signed up successfully. However, we could not sign you in because your account is not yet activated.",
      "signed_up_but_locked": "You have signed up successfully. However, we could not sign you in because your account is locked.",
      "signed_up_but_unconfirmed": "A message with a confirmation link has been sent to your email address. Please follow the link to activate your account.",
      "update_needs_confirmation": "You updated your account successfully, but we need to verify your new email address. Please check your email and follow the confirmation link to confirm your new email address.",
      "updated": "Die Angaben wurden erfolgreich geändert.",
      "updated_but_not_signed_in": "Your account has been updated successfully, but since your password was changed, you need to sign in again."
    },
    "sessions": {
      "already_signed_out": "Signed out successfully.",
      "new": {
        "login_text": "Melden Sie sich hier mit Ihren Zugangsdaten an, um Ihre Immobilien zu verwalten.",
        "submit": "Anmelden",
        "title": "Sie möchten auf Ihr Vermieter-Konto zugreifen? Dann sind Sie hier richtig."
      },
      "signed_in": "",
      "signed_out": "Erfolgreich abgemeldet."
    },
    "shared": {
      "links": {
        "confirmation": "Haben Sie die Bestätigungsemail nicht erhalten?",
        "not_registered": "Sie sind noch kein Mitglied?",
        "password": "Haben Sie Ihr Passwort vergessen?",
        "registered": "Sie sind schon Mitglied?",
        "sign_in": "Hier anmelden",
        "sign_up": "Registrieren",
        "unlock": "Haben Sie die Informationen zur Entsperrung Ihres Accounts nicht erhalten?"
      }
    },
    "unlocks": {
      "new": {
        "sumbit": "Anleitung zur Entsperrung erneut senden",
        "title": "Anleitung zur Entsperrung erneut senden"
      },
      "send_instructions": "Sie erhalten in wenigen Minuten eine E-Mail mit der Anleitung, wie Sie Ihren Account entsperren können.",
      "send_paranoid_instructions": "If your account exists, you will receive an email with instructions for how to unlock it in a few minutes.",
      "unlocked": "Ihr Account wurde entsperrt. Sie sind angemeldet."
    }
  },
  "errors": {
    "format": "%{attribute} %{message}",
    "messages": {
      "accepted": "müssen akzeptiert werden",
      "already_confirmed": "wurde bereits bestätigt",
      "blank": "muss ausgefüllt werden",
      "confirmation": "stimmt nicht mit der Bestätigung überein",
      "confirmation_period_expired": "needs to be confirmed within %{period}, please request a new one",
      "empty": "muss ausgefüllt werden",
      "equal_to": "muss genau %{count} sein",
      "even": "muss gerade sein",
      "exclusion": "ist nicht verfügbar",
      "expired": "has expired, please request a new one",
      "greater_than": "muss größer als %{count} sein",
      "greater_than_or_equal_to": "muss größer oder gleich %{count} sein",
      "in": "must be in %{count}",
      "in_between": "must be in between %{min} and %{max}",
      "inclusion": "ist kein gültiger Wert",
      "invalid": "ist nicht gültig",
      "less_than": "muss kleiner als %{count} sein",
      "less_than_or_equal_to": "muss kleiner oder gleich %{count} sein",
      "model_invalid": "Validation failed: %{errors}",
      "not_a_number": "ist keine Zahl",
      "not_an_integer": "muss ganzzahlig sein",
      "not_found": "nicht gefunden",
      "not_locked": "ist nicht gesperrt",
      "not_saved": {
        "one": "1 error prohibited this %{resource} from being saved:",
        "other": "%{count} errors prohibited this %{resource} from being saved:"
      },
      "odd": "muss ungerade sein",
      "other_than": "must be other than %{count}",
      "password_too_long": "is too long",
      "present": "must be blank",
      "required": "must exist",
      "spoofed_media_type": "has contents that are not what they are reported to be",
      "taken": "has already been taken",
      "too_long": "ist zu lang (nicht mehr als %{count} Zeichen)",
      "too_short": "ist zu kurz (nicht weniger als %{count} Zeichen)",
      "wrong_length": "hat die falsche Länge (muss genau %{count} Zeichen haben)"
    },
    "template": {
      "body": "Veuillez vérifier les champs suivants : ",
      "header": {
        "one": "Impossible d'enregistrer ce %{model} : 1 erreur",
        "other": "Impossible d'enregistrer ce %{model} : %{count} erreurs"
      }
    }
  },
  "extra_services": {
    "body": "In this accommodation you have the possibility to book <a href=\"https://specials.casapilot.com/shop/\">the Casapilot breakfast service</a> before your stay. Let us spoil you with delicious products from the region!",
    "bookable": {
      "1-night-only": "Für eine Nacht buchbar",
      "bikerental": "Fahrradverleih auf Anfrage",
      "breakfast": "Frühstück auf Anfrage",
      "carcharger": "E-Auto Ladestation auf Anfrage",
      "casapilot-breakfast": "Frühstück bei Casapilot buchbar",
      "champagne": "Begrüßungsgetränke auf Anfrage",
      "dinner": "Abendessen auf Anfrage",
      "dog": "Hunde erlaubt",
      "flowers": "Blumen und romantische Deko auf Anfrage",
      "massage": "Massage auf Anfrage",
      "pool": "Pool",
      "sauna": "Sauna",
      "whirlpool": "Whirlpool"
    },
    "included": {
      "1-night-only": "Für eine Nacht buchbar",
      "bikerental": "Fahrradverleih inbegriffen",
      "breakfast": "Frühstück im Preis inbegriffen",
      "carcharger": "E-Auto Ladestation auf Anfrage",
      "casapilot-breakfast": "Frühstück im Preis inbegriffen",
      "champagne": "Begrüßungsgetränke im Preis inbegriffen",
      "dinner": "Abendessen im Preis im Preis inbegriffen",
      "dog": "Hunde erlaubt",
      "flowers": "Blumen und romantische Deko im Preis inbegriffen",
      "massage": "Massage im Preis inbegriffen"
    },
    "title": "NEW: Get your breakfast delivered!"
  },
  "flash": {
    "actions": {
      "create": {
        "notice": "%{resource_name} was successfully created."
      },
      "destroy": {
        "alert": "%{resource_name} could not be destroyed.",
        "notice": "%{resource_name} was successfully destroyed."
      },
      "update": {
        "notice": "%{resource_name} was successfully updated."
      }
    },
    "alert": {
      "accept_tos": "Sie müssen noch die AGBs akzeptieren.",
      "error_too_many_insurants": "Die Anzahl der Reisenden beträgt mehr als 7 accommodation.. Es können maximal 7 Personen versichert werden. Bitte kontaktieren Sie info@casapilot.com.",
      "error_try_again": "Hoppla, es ist ein Fehler aufgetreten. Bitte versuchen Sie es nochmal oder senden Sie uns eine Mail an info@casapilot.com. Vielen Dank",
      "insert_information": "Bitte füllen Sie alle rot markierten Felder aus.",
      "insert_name": "Es muss genau 1 Nachname eingegeben werden.",
      "insert_names_1": "Es müssen genau %{count} Nachnamen eingegeben werden.",
      "insert_names_2": "Nachnamen eingegeben werden.",
      "insurance_error_prebook_period_to_long": "Die Reise darf spätestens innerhalb eines Jahres beginnen.",
      "insurance_over_tenthousand": "Der maximal versicherbare Reisepreis pro Person beträgt 10.000,00 €",
      "insurance_product": "Fehler beim Einholen der Versicherungsprodukte. Bitte versuchen Sie es nochmal."
    }
  },
  "footer": {
    "about": "Über Casapilot",
    "contact_link": "info@casapilot.com?subject=www.casapilot.com",
    "follow_us": "Folge uns bei",
    "imprint_link": "/de/about/imprint",
    "support": "Support",
    "team_cpl": "Das Team Casapilot",
    "team_cpl_link": "https://www.casapilot.com/de/your_benefits",
    "vouchers": "Gutscheine",
    "vouchers_link": "https://shop.casapilot.com/de"
  },
  "header": {
    "facebook_link": "http://www.facebook.com/casapilot.de",
    "hyves_link": "http://www.hyves-share.nl/button/tip/?tipcategoryid=12&rating=5&title=Casapilot&body=www.casapilot.com",
    "phone_annotation_host": "Sie haben Fragen? Kontaktieren Sie uns:",
    "phone_annotation_renter": "Buchungs-Hotline:",
    "phone_host": "Tel. +352 20 20 34 26 20",
    "phone_renter": "+352 20 20 34 26 20",
    "twitter_link": "http://twitter.com/?status=http%3A%2F%2Fwww.casapilot.com"
  },
  "helpers": {
    "label": {
      "holiday_home": {
        "accommodation_amenities": "Ausstattung",
        "accommodation_area": "Fläche (m²)",
        "accommodation_bond": "Kaution (€)",
        "accommodation_bond_refund": "Kautionserstattung",
        "accommodation_created_at": "Angelegt am",
        "accommodation_description": "Beschreibung",
        "accommodation_fee": "Provision (in %)",
        "accommodation_id": "ID",
        "accommodation_kind": "Art des Objekts",
        "accommodation_max_persons": "Personen (max.)",
        "accommodation_number_of_baths": "Bäder",
        "accommodation_number_of_bunk_beds": "Etagenbetten",
        "accommodation_number_of_daybeds": "Schlafcouchen",
        "accommodation_number_of_king_size_beds": "Doppelbetten",
        "accommodation_number_of_rooms": "Schlafzimmer",
        "accommodation_number_of_similar": "Anzahl gleichartiger Unterkünfte",
        "accommodation_number_of_single_beds": "Einzelbetten",
        "accommodation_photos": "Fotos",
        "accommodation_property_id": "Objekt",
        "accommodation_title": "Titel",
        "accommodation_updated_at": "Aktualisiert am",
        "property_country": "Land",
        "property_created_at": "Angelegt am",
        "property_description": "Beschreibung",
        "property_id": "ID",
        "property_locality": "Ort",
        "property_postal_code": "Postleitzahl",
        "property_rating": "Sterne-Kategorie",
        "property_region": "Region",
        "property_street": "Straße",
        "property_title": "Name des Objekts",
        "property_top_object": "Top Objekt",
        "property_travel_region_id": "Ferienregion",
        "property_updated_at": "Aktualisiert am"
      },
      "subscription": {
        "country": "Objektstandort",
        "email": "E-Mail",
        "kind": "Ich verfüge über",
        "kind_apartment": "Apartment",
        "kind_bed_and_breakfast": "Bed & Breakfast",
        "kind_vacation_rental": "Ferienwohnung",
        "language": "Ihre Sprache"
      }
    },
    "select": {
      "prompt": "Bitte wählen"
    },
    "submit": {
      "create": "%{model} erstellen",
      "submit": "%{model} speichern",
      "update": "%{model} aktualisieren"
    }
  },
  "home": {
    "teaser": {
      "text_1": "Wir buchen Ihr Ferienhaus inkl. Flug.<br /> <strong>Buchungs-Hotline:</strong> <br /> +352 20 20 34 26 20",
      "text_2": "Ihr Partner aus Luxemburg",
      "text_3": "Warum Casapilot?<br />Gute Preise, Sicher buchen, Exzellenter Service"
    }
  },
  "homepage": {
    "checks": {
      "headline_1": "Kostenlos inserieren",
      "headline_2": "Im voraus verdienen",
      "headline_3": "Preise selber bestimmen",
      "headline_4": "Flexibel bleiben",
      "text_1": "Das Einstellen Ihres Objekts ist für Sie kostenfrei.",
      "text_2": "Bei Vermietung überweisen wir Ihnen den Betrag bereits zwei Wochen vor Ankunft.",
      "text_3": "Sie allein bestimmen, zu welchen Tarifen Sie Ihr Objekt vermieten.",
      "text_4": "Sie bestimmen die Zeiträume, in denen Ihr Objekt zur Verfügung steht."
    },
    "counter_text": "Ferienhäuser",
    "counter_text_single": "Ferienhaus",
    "head_title": "selected homes",
    "headline": "Vermieten Sie Ihre Ferienunterkunft. Ganz einfach mit Casapilot.",
    "intro_text_1": "Casapilot ist Ihr neuer Partner bei der Vermietung Ihrer Ferienunterkunft und der Vermittlung Ihres Bed & Breakfast-Angebots.",
    "intro_text_2": "Registrieren Sie sich bereits jetzt – so bleiben Sie auf dem Laufenden und erfahren als erstes, wenn unsere neue Plattform zur Verfügung steht.",
    "intro_text_3": "Wir gewinnen für Sie neue Gäste.",
    "relax_cottage_stoerer": {
      "headline": "Wellness Suiten - Hochzeitssuiten",
      "text": "Hochzeitssuiten mit Whirlpool in einem exklusiven<br/>Ambiente für einen romantischen Partnerurlaub."
    },
    "subscription_form": {
      "country": {
        "andorra": "Andorra",
        "austria": "Österreich",
        "belgium": "Belgien",
        "croatia": "Kroatien",
        "danemark": "Dänemark",
        "finland": "Finnland",
        "france": "Frankreich",
        "germany": "Deutschland",
        "great_britain": "England",
        "greece": "Griechenland",
        "hungary": "Ungarn",
        "ibiza": "Ibiza",
        "island": "Island",
        "italy": "Italien",
        "liechtenstein": "Liechtenstein",
        "luxemburg": "Luxemburg",
        "malta": "Malta",
        "monaco": "Monaco",
        "nederland": "Niederlande",
        "norway": "Norwegen",
        "poland": "Polen",
        "portugal": "Portugal",
        "scotland": "Schottland",
        "spain": "Spanien",
        "sweden": "Schweden",
        "switzerland": "Schweiz"
      },
      "email": "E-Mail",
      "email_text": "Ihre E-Mail-Adresse behandeln wir vertraulich.",
      "headline": "Jetzt registrieren und auf dem Laufenden bleiben.",
      "language": {
        "de": "Deutsch",
        "en": "Englisch",
        "es": "Spanisch",
        "fr": "Französisch",
        "nl": "Niederländisch"
      },
      "submit": "Jetzt vormerken"
    }
  },
  "homepage_customer": {
    "book_object": "Buchen",
    "country": "Urlaubsland",
    "head_title": "selected homes",
    "headline": "Für Sie ausgewählte Ferienhäuser, Villas und Suiten",
    "hosts": {
      "headline": "Top Unterkünfte"
    },
    "intro_headline": "Darum bei Casapilot buchen",
    "intro_text_1": "Unsere Prinzipien sind einfach, unsere Suche ist einfach, Ihr Urlaub ist einfach. Einfach schön.",
    "intro_text_1_hl": "Einfach.",
    "intro_text_2": "Wir prüfen alle unsere Objekte sorgfältig und wählen persönlich aus. Erst dann wirds ein Casapilot-Objekt.",
    "intro_text_2_hl": "Ausgewählt.",
    "intro_text_3": "Wenn Sie ankommen ist alles da. Und wenns Probleme gibt, sind wir für Sie da. Verlassen Sie sich drauf.",
    "intro_text_3_hl": "Verlässlich.",
    "landingpage": {
      "headline": "Entdecken Sie neue Urlaubsziele"
    },
    "last_viewed_objects": "Ihre zuletzt angesehenen Objekte",
    "objects_foot_hl": "Auch dies könnte Ihnen gefallen",
    "prebook_object": "Vormerken",
    "reserve": "Buchen",
    "search_arrival": "Anreise",
    "search_button": "Suchen",
    "search_category_1": "Familienurlaub",
    "search_category_2": "Pärchenurlaub",
    "search_category_3": "Abenteuer und Erlebnis",
    "search_category_4": "Wellnes und Verwöhnen",
    "search_category_5": "Weitere Urlaubsvorschläge",
    "search_departure": "Abreise",
    "search_detail": "Detailsuche",
    "search_headline": "Starten Sie hier Ihren Urlaub.",
    "see_object": "Ansehen",
    "slideshow": {
      "ardennen": "Ardennen",
      "ardennen_desc": "Genießen Sie die ländliche Ruhe und entdecken Sie zahlreiche Wander- und Fahrradwege. Nutzen Sie die zahlreichen Freizeitaktivitäten, die die Region Ihnen zu bieten hat.",
      "austria": "Österreich",
      "austria_desc": "Ob Winter oder Sommer, Österreich ist immer eine Reise wert. Im Sommer erkunden Sie Wanderwege, besichtigen Kulturelles und im Winter genießen Sie eine der zahlreichen Skipisten.",
      "cotedazur": "Côte d’Azur",
      "cotedazur_desc": "Die wohl berühmteste Küste Europas. Lassen Sie sich von zahlreichen Shoppingmöglichkeiten, der fantastischen französischen Küche und den herrlichen Stränden verzaubern.",
      "france": "Frankreich",
      "france_desc": "Entdecken Sie die schönsten Ferienhäuser Frankreich’s, an bekannten Orten im Inland als auch an der Küste. Erleben Sie einen erholsamen Urlaub. Herrliche Landschaften laden zu einem unvergesslichen Aufenthalt.",
      "ibiza": "Ibiza",
      "ibiza_desc": "Lassen Sie sich den Luxus auf der exklusiven Mittelmeerinsel nicht entgehen! Traumhafte Strände und das bebende Nachtleben sorgen für ein unvergesslichen Aufenthalt auf Ibiza.",
      "luxemburg": "Luxemburg",
      "luxemburg_desc": "",
      "mallorca": "Mallorca",
      "mallorca_desc": "Entdecken Sie die wunderschönen Strände und den ländlich unberührten Charme der beliebten Mittelmeerinsel. Genießen Sie Ihren Urlaub in einer gemütlichen Finca oder einer schönen Villa.",
      "spain": "Spanien",
      "spain_desc": "Entdecken Sie die schönsten Seiten des spanischen Festlands und dessen Küste mit herrlichen Stränden. Verbringen Sie einen traumhaften Urlaub in einem Ferienhaus in Málaga, an der Costa del Sol, der Costa Blanca...",
      "wellnesssuites": "Wellness Suiten - Hochzeitssuiten",
      "wellnesssuites_desc": "Wellnesssuiten mit Whirlpool in einem exklusiven Ambiente für einen romantischen Partnerurlaub. Frisch verheiratet, Jahrestag oder als Geschenk bieten unsere Hochzeitssuiten jedem Paar Luxus und Erholung"
    }
  },
  "host": {
    "ab": "ab",
    "accept_agbs": "Bitte akzeptieren Sie die Allgemeinen Geschäftsbedingungen.",
    "accommodation": "Apartment",
    "accommodation_number_of_beds_zero": "Bitte geben Sie mindestens eine Art und Anzahl an Betten an.",
    "accommodation_reviews": "Reviews",
    "accommodations": {
      "prices": {
        "day_of_arrival": "Tag der Anreise",
        "day_of_departure": "Tag der Abreise",
        "friday": "Freitag",
        "monday": "Montag",
        "sunday": "Sonntag"
      },
      "suggestions": "Unsere Vorschläge für Sie"
    },
    "add_image": "Foto hinzufügen",
    "add_new_accommodation": "Neues Apartment hinzufügen",
    "add_new_property": "Objekt hinzufügen",
    "add_new_room": "Neues Zimmer hinzufügen",
    "additional_costs": "Zusatzkosten",
    "adress": "Adresse",
    "all_properties": "Alle Objekte von",
    "amenities": "Ausstattung",
    "amount_bathrooms": "Anzahl der Badezimmer",
    "amount_bedrooms": "Anzahl der Schlafzimmer",
    "amount_rooms": "Anzahl der Zimmer",
    "apartment": "Apartment",
    "as": "als",
    "attractions": "Umgebung",
    "avail_in": "Buchbar in",
    "avail_in_2": "Tagen",
    "avail_in_3": "Tag",
    "availabilities": {
      "availabilities": {
        "availabilities_select": "Bitte wählen Sie hier das Kalenderjahr:"
      }
    },
    "availabilities_text": "Wenn Sie einen Tag als nicht buchbar definieren wollen, klicken Sie bitte mit der Maus auf den Tag und dann auf \"Markierung setzen\". Wenn Sie mehrere aufeinanderfolgende Tage als nicht buchbar definieren wollen, klicken Sie bitte auf den ersten und letzten Tag des Zeitraums und danach auf Markierung setzen. Buchungstage die über Casapilot eingehen werden automatisch von unserem System als nicht mehr buchbar markiert.",
    "availability": "Verfügbarkeit",
    "availability_message": "Bitte bearbeiten Sie auch die Verfügbarkeit Ihres Objektes",
    "avatar_text": "Wenn Sie möchten, können Sie hier ein Foto von sich hochladen. Das Foto erscheint in der Kontaktbox Ihres Inserates.",
    "base_rating": "Basis-Bewertung",
    "basics": "Basisinformationen",
    "baths": "Bäder",
    "bed_and_breakfast": "Bed & Breakfast",
    "blocked": "Nicht verfügbar",
    "blocked_msg": "Zu dem gewünschten Zeitraum liegt kein Anreisetag für das Objekt vor. Bitte wählen Sie einen anderen Zeitraum aus.",
    "bookable": "Frei",
    "booked": "Gebucht durch Casapilot",
    "bookings_count": "Personen haben bei diesem Vermieter gebucht",
    "bookings_count_zero": "Dieses Ferienhaus ist neu im Programm",
    "bunk_beds": "Etagenbetten",
    "clearing_message": "Um das Objekt freischalten zu können, müssen Sie folgende Angaben machen.",
    "clearing_missing": "Angaben aus folgenden Bereichen fehlen noch",
    "clearing_status_popup": "Ihr Objekt ist unvollständig",
    "confirm_delete": "Sind Sie sicher, dass dieses Objekt gelöscht werden soll? Diese Aktion kann nicht widerrufen werden.",
    "contact_user": "Kontaktieren",
    "coordinates": "Koordinaten",
    "coordinates_annotation": "Hier können Sie die exakten Koordinaten Ihres Ferienobjekts angeben.",
    "country": "Land",
    "create": "Erstellen",
    "create_holiday_home": "Objekt erstellen",
    "create_property": "Objekt erstellen",
    "cut_image": "Foto zuschneiden",
    "dashboard": {
      "index": {
        "html": {
          "all_objects": "Alle Objekte anzeigen",
          "another_object": "Stellen Sie ein weiteres Objekt ein.",
          "another_object_content": "Je mehr Objekte Sie einstellen, um so mehr können Sie vermieten und verdienen. <br /> Nehmen Sie sich <strong>5 Minuten</strong> Zeit und stellen Sie jetzt ein weiteres Objekt ein.",
          "button": "Jetzt Objekt einstellen",
          "button_another_object": "Weiteres Objekt anlegen",
          "first_object": "Stellen Sie Ihr erstes Ferienhaus ein.",
          "first_object_content": "Gehen Sie den ersten Schritt, um mit Casapilot zu neuen Mietern für ihr Ferienhaus zu kommen: Sie brauchen nur rund <strung>5</strong> Minuten um alle wesentlichen Daten zu erfassen.",
          "news_more": "weitere News",
          "news_specialoffer_text": "Für Ihre zukünftigen Mieter startet Casapilot.com offiziell erst im Juni 2011. Als Dankeschön für Ihr Inserat vor dem 1. Juli 2011 erhalten Sie von uns attraktive Sonderkonditionen.",
          "news_specialoffer_title": "Stellen Sie jetzt Ihr Objekt ein und profitieren Sie von attraktiven Sonderkonditionen",
          "news_title": "Casapilot News",
          "title": "Statistik",
          "your_properties": "Ihre Objekte"
        }
      }
    },
    "daybeds": "Schlafcouchen",
    "del_confirm": "Sind Sie sicher?",
    "delete": "Löschen",
    "description": "Beschreibung",
    "details": "Details",
    "details_missing": "Welche Angaben fehlen noch?",
    "distance_description": "Aktivieren Sie eine Checkbox, um die Entfernung in Kilometern einzugeben.",
    "distance_unit": "km",
    "downloads": "Downloads",
    "duration_of_stay": "Aufenthaltsdauer",
    "edit": "Profil bearbeiten",
    "edit_accommodation": "bearbeiten",
    "edit_holiday_home": "Objekt bearbeiten",
    "edit_image": "Foto bearbeiten",
    "embed_calendar_text": "Sie können diesen Kalender mit Hilfe des hier angegebenen iFrames auf Ihrer Website einbinden:",
    "extras": "Optionale Ausstattungsmerkmale",
    "extras_annotation": "Hier können Sie besondere Anforderungen und Bedingungen für bestimmte Ausstattungsmerkmale konfigurieren.",
    "fallback_text": "Es wurden noch keine Daten eingegeben.",
    "fallback_text_costs": "Keine.",
    "fallback_text_description": "Es wurde noch keine Beschreibung eingegeben.",
    "feedback_message": "Wenn Sie Rückfragen haben, zögern Sie nicht, uns zu kontaktieren:",
    "filter": "Filter",
    "following_rooms_already_created": "Folgende Zimmer wurden bereits angelegt:",
    "forms": "Downloads",
    "from": "Von",
    "general_property_informations": "Allgemeine Objektinformationen",
    "hh_inc_fees": "inkl. Reservierungsgebühr",
    "holiday_home": "Ferienhaus",
    "holiday_homes": {
      "create": {
        "create_failed": "Ihr Objekt konnte nicht angelegt werden. Bitte füllen Sie alle rot markierten Felder aus.",
        "create_successful": "Ihr Objekt wurde erfolgreich erstellt. Hier können Sie nun Fotos hochladen, sowie alle weiteren Informationen zu Ihrem Objekt einstellen."
      },
      "description": {
        "annotations": {
          "property_description": "Beschreiben Sie kurz, was das Objekt für Ihre Gäste ausmacht.",
          "property_description_hint_html": "Ihr Beschreibungstext hilft Ihren Gästen, sich den Urlaubsort bildlich vorzustellen. Beschreiben Sie hier die Atmosphäre und die Attraktionen, die den Urlaubsort und die Urlaubsregion ausmachen. Beschreiben Sie hier <strong>nicht</strong> die Ausstattungsmerkmale oder die Anzahl der Zimmer!",
          "property_description_short": "Werbewirksame Kurzbeschreibung der Ferienunterkunft (max. 88 Zeichen inkl. Leerzeichen)",
          "property_description_short_remaining": "Zeichen verbleiben",
          "property_language": "Ihr Beschreibungstext ist deutsch. Wollen Sie Ihre Beschreibungen in anderen Sprachen anlegen, verwenden Sie bitte die Tabs.",
          "property_language_2": "Wenn Sie keine weitere Fremdsprache sprechen, dann übernimmt Casapilot die Übersetzungen für Sie.",
          "property_rating": "Bitte nur angeben, wenn Ihr Objekt über eine Bewertung verfügt.",
          "property_rating_forbidden": "Die Sternekategorie Ihres Objektes wurden vom Administrator geändert. Wenn Sie diese Einstellung ändern möchten wenden Sie sich bitte an deutsch@casapilot.com.",
          "property_title": "Unter diesem Namen erscheint Ihr Objekt auf der Website."
        },
        "data_multiple_rooms": "Hat Ihr Objekt mehrere separat zu vermietende Zimmer oder Wohnungen?<br/> Dann können Sie hier die Daten für das erste Zimmer oder die erste Wohnung eingeben.",
        "data_single_room": "Ansonsten erfassen Sie bitte Werte, die für das gesamte Haus oder Apartment gelten.",
        "language_de": "deutsch",
        "language_description_1": "Ihr Beschreibungstext ist",
        "language_description_2": "Wollen Sie Ihre Beschreibungen in anderen Sprachen anlegen, verwenden Sie bitte die Tabs.",
        "language_en": "englisch",
        "language_es": "spanisch",
        "language_fr": "französisch",
        "language_nl": "niederländisch",
        "select_language": "Sprachversion"
      },
      "form": {
        "data_multiple_rooms": "Hat Ihr Objekt mehrere separat zu vermietende Zimmer oder Wohnungen?<br/> Dann können Sie hier die Daten für das erste Zimmer oder die erste Wohnung eingeben.",
        "data_single_room": "Ansonsten erfassen Sie bitte Werte, die für das gesamte Haus oder Apartment gelten.",
        "language_de": "deutsch",
        "language_description_1": "Ihr Beschreibungstext ist",
        "language_description_2": "Wollen Sie Ihre Beschreibungen in anderen Sprachen anlegen, verwenden Sie bitte die Tabs.",
        "language_en": "englisch",
        "language_es": "spanisch",
        "language_fr": "französisch",
        "language_nl": "niederländisch",
        "select_language": "Sprachversion"
      },
      "new": {
        "submit": "Objekt erstellen",
        "title": "Erstellen Sie ein neues Objekt"
      }
    },
    "host": "Vermieter",
    "image_alt": "Ansicht des Objektes",
    "image_description_text": "Beschreiben Sie kurz das gezeigte Foto, bspw. Blick in den Garten",
    "image_gallery": "Fotogalerie",
    "image_legend": "Reihenfolge der Bilder per Drag & Drop ändern",
    "image_upload_description": "Wählen Sie hier ein Bild von Ihrem Computer aus. Wir empfehlen ein Format von 1124 x 689 Pixel oder größer (max. 950 KB), damit das Bild auch in der Großansicht Ihre Inserates hochwertig aussieht.",
    "inc_fees": "inkl. Haftpflichtversicherung u. Gebühren",
    "included": "inbegriffen",
    "incomplete": "unvollständig",
    "info": "Über das Objekt",
    "kind": "Art",
    "kind_of_property": "Unterkunftstyp",
    "kind_of_property_available": "Folgende Zimmer sind bereits erstellt:",
    "kind_of_property_none": "Das Objekt hat noch keine Zimmert",
    "king_size_beds": "Doppelbetten",
    "languages": "Sprachen",
    "lat": "Breitengrad N (Beispiel: 47,1537)",
    "limitation": {
      "allowed": "ja",
      "forbidden": "nein",
      "onrequest": "auf Anfrage"
    },
    "limitations": "Besonderheiten",
    "limitations_annotation": "Hier können Sie zusätzliche Besonderheiten festlegen",
    "link_edit_image": "bearbeiten",
    "list": "Zurück",
    "locality": "Lage",
    "long": "Längengrad E (Beispiel: 13,1125)",
    "main_image": "Titelmotiv",
    "main_image_legend": "Ziehen Sie Ihr Wunschmotiv per Drag & Drop hier hin.",
    "manage_properties": "Objekte verwalten",
    "map": "Karte",
    "map_zoom": "Karte vergrößern",
    "max_persons": "Personen (max.)",
    "messages": "Nachrichten",
    "minimum_booking": "Mindestanzahl Übernachtungen",
    "more_images": "weitere Fotos",
    "new_accommodation": "Neues Apartment",
    "new_room": "Neues Zimmer",
    "no_images": "noch keine Fotos vorhanden",
    "not_published": "nicht freigeschaltet",
    "other_costs_text": "Diese Kosten werden nur dargestellt, wenn Sie Angaben vornehmen.",
    "others": "Sonstige",
    "payment": "Zahlungsinformationen",
    "photos": "Fotos",
    "platform_airbnb": "AirBnB",
    "platform_booking": "Booking.com",
    "platform_flipkey": "Flipkey",
    "platform_homeaway": "Homeaway",
    "platform_homelidays": "Homelidays",
    "platform_hometogo": "Hometogo",
    "platform_tripadvisor": "TripAdvisor",
    "platforms": "Plattformen für Export",
    "platforms_annotation": "Hier können Sie Plattformen abschalten",
    "preview": "Voransicht",
    "prices": "Preise",
    "prices_availability": "Preise und Verfügbarkeit",
    "prices_overview": {
      "js_alert": "Bitte verwenden Sie folgende Formatierung für Ihre Preise 1.000,00 oder geben Sie die Preise ausschließlich mit Ziffern ein."
    },
    "properties": {
      "index": {
        "confirm_delete": "Sind Sie sicher, dass dieses Objekt gelöscht werden soll? Diese Aktion kann nicht widerrufen werden."
      }
    },
    "property_id": "Objekt ID",
    "property_title": "Objekt Titel",
    "published": "freigeschaltet",
    "rating": "Bewertung",
    "read_messages": "Nachrichten lesen",
    "regilar_costs_text": "Wenn Sie hier keine Angaben vornehmen, dann gelten diese Kosten als inbegriffen.",
    "region": "Ferienregion",
    "registrations": {
      "edit": {
        "back": "Zurück",
        "cancel": {
          "description": "Unzufrieden?",
          "link": "Mein Profil löschen",
          "question": "Sind sie sicher?",
          "title": "Profil löschen"
        },
        "current_hint": "(Sie benötigen Ihr aktuelles Passwort, um Änderungen vornehmen zu können)",
        "password_hint": "Wenn Sie Ihr Passwort nicht ändern wollen, lassen Sie das Feld bitte leer.",
        "submit": "Speichern",
        "title": "Profil bearbeiten"
      },
      "new": {
        "already_registered": "Ich habe bereits einen Mieter-Account bei Casapilot.",
        "host_account": "Erstellen Sie hier Ihren kostenlosen Vermieter-Zugang zu Casapilot.",
        "newsletter_subscription": "Ich möchte den Casapilot-Newsletter erhalten",
        "not_yet_registered": "Ich habe noch keinen Mieter-Account bei Casapilot.",
        "offers_text": "Oder wollen Sie Urlaub machen und ein Objekt bei Casapilot mieten? Schauen Sie sich unsere Angebote an.",
        "register_account": "Sie möchten eine Immobilie vermieten? Dann sind Sie hier richtig.",
        "register_pls": "Bitte melden Sie sich an.",
        "register_txt": "Hier können Sie ein kostenloses Profil für Mieter erstellen.",
        "submit": "Profil anlegen",
        "terms_of_service_html": "Ich bestätige, dass ich die <a href=\"/downloads/terms-conditions/host-de\" target=\"_blank\">AGB</a> gelesen, verstanden und akzeptiert habe.",
        "title": "Kostenloses Profil als Vermieter anlegen"
      }
    },
    "registrations_addons": {
      "api_documentation": {
        "title": "API Dokumentation"
      },
      "edit_downloads": {
        "bank_data": "Bankverbindung",
        "bank_data_message": "Bitte geben Sie hier Ihre Bankverbindung ein damit wir Ihnen nach einer erfolgten Buchung Ihre Einnahmen überweisen können. Alle Ihre persönlichen Daten werden bei Casapilot vertraulich behandelt.",
        "bic": "BIC",
        "category_forms": "Formulare",
        "commercial_host": "Gewerblicher Vermieter",
        "compendium": "Leitfaden für die Preise 2012",
        "compendium_description": "Hier finden Sie einen hilfreichen Leitfaden zur Erstellung Ihrer Vermietpreise vor.",
        "contact_data": "Kontaktdaten",
        "contact_data_message": "Bitte geben Sie hier ausschließlich Ihre Rechnungsadresse an und keinesfalls die Adresse Ihrer Ferienimmobilie.",
        "edit_payment": null,
        "house_rules": "Hausordnung",
        "iban": "IBAN",
        "invoice_city": "Ort",
        "invoice_company": "Firma",
        "invoice_country": "Land",
        "invoice_fax": "Fax",
        "invoice_house_number": "Hausnummer",
        "invoice_mobile_phone": "Mobiltelefon",
        "invoice_name": "Name",
        "invoice_of_stay": "Endabrechnung",
        "invoice_of_stay_description": "Mithilfe dieses Formulars werden alle zuzüglichen Kosten, die Ihre Gäste wissentlich gebucht haben am Ende des Aufenthalts abgerechnet.",
        "invoice_of_stay_link": "/downloads/invoice_of_stay/Endabrechnung.pdf",
        "invoice_partner_agency": "Partneragentur",
        "invoice_phone": "Telefon",
        "invoice_postal_code": "PLZ",
        "invoice_street": "Straße / Hausnummer",
        "invoice_website": "Webseite",
        "kaution": "Kautionsvordruck",
        "kaution_description": "Der Mieter ist verpflichtet Ihnen spätestens bei der Ankunft die Kaution zu begleichen. Die Kaution dient Ihnen als Sicherheitsleistung gegenüber möglichen Sachbeschädigungen durch Mieter.",
        "kaution_link": "/downloads/deposit.pdf",
        "kind_of_host": "Vermieterart",
        "message": "Um Ihnen die Betreuung Ihrer Gäste zu erleichtern, stellen wir Ihnen hier zwei praktische Formularvordrucke zur Verfügung. <br/>Sie können die Dokumente hier herunterladen, um diese danach auszudrucken und zu verwenden.",
        "private_host": "Privater Vermieter",
        "title": "Zahlungsinformationen",
        "vat_rate": "Umsatzsteuer-ID",
        "wellness": {
          "pool": "Whirlpool und Schwimmbad",
          "sauna": "Sauna",
          "title": "Sicherheitsvorkehrungen für Sauna, Whirlpool und Schwimmbad"
        }
      },
      "edit_payment": {
        "bank_data": "Bank data",
        "bank_data_message": "Please enter your bank details so that we are able to transfer your money for each booking of yours. All your personal information keeps confidential.",
        "bic": "BIC",
        "commercial_host": "Professional owner",
        "contact_data": "Contact Information ",
        "contact_data_message": "Please insert your billing address and not the address of your rental property.\n",
        "iban": "IBAN",
        "invoice_city": "City",
        "invoice_company": "Company",
        "invoice_country": "Country",
        "invoice_fax": "Fax",
        "invoice_house_number": "Street number",
        "invoice_mobile_phone": "Mobile phone",
        "invoice_name": "Name",
        "invoice_partner_agency": "Partner Agency",
        "invoice_phone": "Phone",
        "invoice_postal_code": "Postcode",
        "invoice_street": "Street / House number",
        "invoice_website": "Personal website",
        "kind_of_host": "Type of owner",
        "private_host": "Private owner",
        "title": "Payment information ",
        "vat_rate": "VAT Reg No"
      },
      "edit_tenant": {
        "key_hand_over": "Adresse der Schlüsselübergabe",
        "key_hand_over_city": "Ort",
        "key_hand_over_country": "Land",
        "key_hand_over_different_place": "Ort der Schlüsselübergabe ist nicht der gleiche Ort, wo sich das Vermieterobjekt befindet.",
        "key_hand_over_name": "Name",
        "key_hand_over_postal_code": "PLZ",
        "key_hand_over_street": "Straße",
        "more_languages": "Weitere Sprachkenntnisse",
        "mother_tongue": "Muttersprache",
        "other_language_1": "deutsch",
        "other_language_2": "englisch",
        "other_language_3": "französisch",
        "other_language_4": "niederländisch",
        "other_language_5": "spanisch",
        "title": "Informationen für Ihre Mieter"
      }
    },
    "regular_costs": "Übliche Kosten",
    "rentable_units": "Vermietbare Einheiten",
    "reservations": "Buchungen",
    "room": "Zimmer",
    "rooms": "Zimmer",
    "save_description": "Beschreibung speichern",
    "save_image": "Foto speichern",
    "season_msg": "Sie können aus organisatorischen Gründen die Verfügbarkeiten nur bis einschließlich 09.01.2026 bearbeiten. Sie werden informiert, sobald die Bearbeitung der Verfügbarkeiten für die Saison 2026 freigeschaltet ist.",
    "show": "Zeigen",
    "single_beds": "Einzelbetten",
    "size_capacity": "Größe und Kapazität",
    "square_meters": "Wohnfläche",
    "star": "Stern",
    "star_rating": "Sterne-Bewertung",
    "stars": "Sterne",
    "status_revision": "Ihr Objekt wird überprüft.",
    "status_visible": "Ihr Objekt ist sichtbar.",
    "suite": "Suite",
    "summer_price": "(Sommer)",
    "tenant": "Informationen für Ihre Mieter",
    "thumb_fallback": "/images/thumb_fallback.gif",
    "to": "bis",
    "travel_bookings": {
      "index": {
        "availability": "Verfügbarkeit ansehen",
        "booking_period": "Buchungszeitraum (Anreisedatum)",
        "cancelled": "Abgelehnt",
        "confirmed": "Bestätigt",
        "date_of_receipt": "Eingangsdatum",
        "details": "Details",
        "sort": "Sortieren nach",
        "sort_by_ref_code": "Suche nach Buchungsnummer"
      },
      "show": {
        "accommodation_id": "Unterkunft ID",
        "accommodation_name": "Name",
        "accomoodation": "Unterkunft",
        "bond": "Kaution",
        "booking": "Buchung",
        "booking_created_at": "Gebucht am",
        "booking_id": "Buchungsnummer",
        "booking_process": "Buchungsvorgang",
        "checkin": "Check-In",
        "checkout": "Check-Out",
        "costs": "Kosten",
        "extra_bring": "Mitzubringen",
        "extra_cost": "Kosten für Extras",
        "guest": "Mieter",
        "host_total": "Mieteinnahmen",
        "on_request": "Auf Anfrage",
        "optional_cost": "Optionale Kosten",
        "overview": "« Zurück zur Übersicht",
        "stay": "Aufenthalt",
        "tenant_information": "Angaben zum Mieter",
        "tenant_name": "Name des Mieters",
        "tenant_phone_number": "Telefonnummer des Mieters",
        "title": "Anfrage-Details des Objekts:"
      }
    },
    "update": "Weiter",
    "winter_price": "(Winter)",
    "you_have_got": "Sie haben"
  },
  "host_details": {
    "included": "inklusive",
    "on_request": "Auf Anfrage",
    "see_additional_costs": "Bitte beachten Sie die Hinweise unter „Zusatzkosten“",
    "to_be_brought": "Muss mitgebracht werden"
  },
  "host_navigation": {
    "account": "Profil",
    "dashboard": "Cockpit",
    "messages": "Nachrichten",
    "objects": "Objekte",
    "reservations": "Buchungen",
    "teaser_host": "Sie wollen eine Immobilie vermieten? Jetzt registrieren und mehr verdienen."
  },
  "host_teaser": {
    "button": "Zum Angebot",
    "number_of_baths": "Anzahl der Badezimmer",
    "number_of_persons": "Anzahl der Personen",
    "number_of_rooms": "Anzahl der Schlafzimmer"
  },
  "i18n": {
    "transliterate": {
      "rule": {
        "À": "a",
        "Á": "a",
        "Â": "a",
        "Ä": "ae",
        "Æ": "ae",
        "Ç": "c",
        "È": "e",
        "É": "e",
        "Ê": "e",
        "Ë": "e",
        "Í": "i",
        "Î": "i",
        "Ï": "i",
        "Ñ": "n",
        "Ó": "o",
        "Ô": "o",
        "Ö": "oe",
        "Ù": "u",
        "Ú": "u",
        "Û": "u",
        "Ü": "ue",
        "ß": "ss",
        "à": "a",
        "á": "a",
        "â": "a",
        "ä": "ue",
        "æ": "ae",
        "ç": "c",
        "è": "e",
        "é": "e",
        "ê": "e",
        "ë": "e",
        "í": "i",
        "î": "i",
        "ï": "i",
        "ñ": "n",
        "ó": "o",
        "ô": "o",
        "ö": "oe",
        "ù": "u",
        "ú": "u",
        "û": "u",
        "ü": "ue",
        "ÿ": "y",
        "Œ": "oe",
        "œ": "oe",
        "Ÿ": "y"
      }
    }
  },
  "icons": {
    "first": "icon anfang",
    "last": "icon ende",
    "next": "icon vor",
    "previous": "icon zurück"
  },
  "inquiry_form": {
    "fail_notification": "Die Anfrage konnte nicht versendet werden. Versuchen Sie es bitte später erneut.",
    "inquiry_to": "Anfrage zu Objekt ID: ",
    "send_button": "Anfrage senden",
    "text": "Gerne können Sie uns hier eine unverbindliche Anfrage zusenden.",
    "thank_you_1": "Vielen Dank für Ihre Anfrage bei Casapilot.",
    "thank_you_2": "Wir werden diese schnellstmöglich bearbeiten."
  },
  "landing_page": {
    "ardennen": {
      "goto": "Zum Ardennen Special"
    },
    "austria": {
      "goto": "Zum Österreich Special"
    },
    "cotedazur": {
      "goto": "Zum Côte d'Azur Special"
    },
    "france": {
      "goto": "Zum Frankreich Special"
    },
    "ibiza": {
      "goto": "Zum Ibiza Special"
    },
    "luxemburg": {
      "goto": "Zum Luxemburg Special"
    },
    "mallorca": {
      "goto": "Zum Mallorca Special"
    },
    "more": "Mehr Ferienhäuser in",
    "more_at": "Mehr Ferienhäuser am",
    "more_objects": "Alle Unterkünfte",
    "spain": {
      "goto": "Zum Spanien Special"
    },
    "wellnesssuites": {
      "goto": "Alle Wellness Suiten ansehen"
    }
  },
  "landing_page_teaser": {
    "title": "Jetzt Gutscheine zu reduzierten Preisen sichern"
  },
  "mailer": {
    "attributes": {
      "approval_mailer": {
        "subject": "Freischaltung für Objekt"
      },
      "invitation_mailer": {
        "subject": "Einladung zu Casapilot"
      },
      "travel_booking_mailer": {
        "confirm": {
          "subject": "Ihre Buchungsbestätigung zu %{name}, %{id}"
        },
        "credit_note": {
          "subject": "Ihre Gutschrift zu %{name}, %{id}"
        },
        "payment": {
          "subject": "Ihre Zahlungsbestätigung zu %{name}, %{id}"
        },
        "reservation": {
          "subject": "Ihr Buchungsauftrag zu %{id}"
        },
        "reservation_host": {
          "subject": "Ihre Buchungsbestätigung zu %{name} (%{id})"
        },
        "voucher": {
          "subject": "Ihr Aufenthaltsschein zu %{name}, %{id}"
        }
      }
    },
    "models": {
      "approval_mailer": "Freischaltung",
      "invitation_mailer": "Einladung"
    }
  },
  "meta": {
    "description": "Mieten Sie Ihr Ferienhaus bei Casapilot. Schnell und einfach Angebote aus ganz Europa finden und buchen!",
    "keywords": "Casapilot Ardennen,Casapilot suites,Casapilot Ibiza,Casapilot côte d'azur,wellness,jacuzzi, suite mit whirlpool,Ferienwohnung, Villa mieten, Fewo, Finca, Chalet, Ferienhaus, Last Minute, Ferien, Skiurlaub, günstig reisen, Appartement, B&B, Gruppenunterkünfte, Urlaub, Residenz, Skihütte, Vermieten, Urlaub, Unterkunft, Bungalow, Sommerurlaub, Winterurlaub, Sylvester, Weihnachten, Spanien, Ardennen, Mallorca, Südfrankreich, buchen, Österreich, billig Urlaub buchen.",
    "title": "casapilot | %{title}"
  },
  "not_found": {
    "back_to_homepage": "kein Ergebnis",
    "description": "Entschuldigung, ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
    "number": "+352 20 20 34 26 20",
    "title": "Hoppla, es ist ein Fehler aufgetreten. Bitte versuchen Sie es nochmal oder senden Sie uns eine Mail an info@casapilot.com. Vielen Dank"
  },
  "notepad": {
    "add": "Hinzufügen",
    "full": "Sie können maximal 25 Objekte zum Merkzettel hinzufügen.",
    "headline": "Es befinden sich",
    "headline_part_two": "auf Ihrem Merkzettel",
    "none": "keine",
    "notepad": "Merkzettel",
    "object": "Objekt",
    "objects": "Objekte",
    "remember": "Vormerken",
    "remove": "Entfernen",
    "remove_full": "Vom Merkzettel entfernen",
    "search": "Suche"
  },
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%n %u",
        "negative_format": "-%u%n",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "€"
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 2,
      "round_mode": "default",
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "human": {
      "decimal_units": {
        "format": "%n %u",
        "units": {
          "billion": {
            "one": "Milliarde",
            "others": "Milliarden"
          },
          "million": "Millionen",
          "quadrillion": {
            "one": "Billiarde",
            "others": "Billiarden"
          },
          "thousand": "Tausend",
          "trillion": "Billionen",
          "unit": ""
        }
      },
      "format": {
        "delimiter": "",
        "precision": 1,
        "significant": true,
        "strip_insignificant_zeros": true
      },
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "eb": "EB",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "pb": "PB",
          "tb": "TB",
          "zb": "ZB"
        }
      }
    },
    "nth": {
      "ordinalized": "#<Proc:0x000000010b979508 /Users/patrik/.rbenv/versions/3.2.2/lib/ruby/gems/3.2.0/gems/activesupport-6.1.7.6/lib/active_support/locale/en.rb:26 (lambda)>",
      "ordinals": "#<Proc:0x000000010b979530 /Users/patrik/.rbenv/versions/3.2.2/lib/ruby/gems/3.2.0/gems/activesupport-6.1.7.6/lib/active_support/locale/en.rb:7 (lambda)>"
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%"
      }
    },
    "precision": {
      "format": {
        "delimiter": ""
      }
    }
  },
  "payment_confirmation": "Zahlungsbestätigung",
  "previews": {
    "back_to_homepage": "Zurück zur Homepage",
    "back_to_search": "Zurück zu den Suchergebnissen",
    "submit": "Buchen"
  },
  "price": {
    "activate_standard_prices": "Standard-Preise aktivieren",
    "add_new_season_price": "Neuen saisonalen Preis hinzufügen",
    "add_new_standard_price": "Neuen Standard-Preis hinzufügen",
    "alternatives": "Alternativen:",
    "available_dates": "Verfügbare Daten:",
    "check_in": "Check-in:",
    "check_in_time": "Check-in time:",
    "check_out": "Check-out:",
    "check_out_time": "Check-out Zeit bis:",
    "currency_symbol": "€",
    "current_season_prices": "Aktuelle saisonale Preise",
    "current_season_prices_info": "Preise werden für einen angegebenen Zeitraum festgelegt",
    "current_standard_prices": "Aktuelle Standard-Preise",
    "current_standard_prices_info": "Preise gelten für das gesamte Jahr",
    "customer_price": "Preis für Kunde",
    "duplicate_season_price": "Saisonpreise duplizieren für das nächste Jahr",
    "edit_season_price": "Saisonale Preise bearbeiten",
    "euro_per_long_weekend": "€ pro langes Wochenende",
    "euro_per_night": "€ pro Nacht",
    "euro_per_stay": "€ pro Aufenthalt",
    "euro_per_week": "€ pro Woche",
    "euro_per_weekend": "€ pro Wochenende",
    "from": "ab",
    "long_weekend_consists_of": "langes Wochenende besteht aus",
    "lump_long_weekend": "Gesamtes langes Wochenende",
    "lump_long_weekend_short": "Langes Wochenende",
    "lump_week": "Gesamte Woche",
    "lump_weekend": "Gesamtes Wochenende",
    "more_price_options": "Mehr Preis-Optionen? Legen Sie eine neue Preis-Gruppe an.",
    "nightly_week": "Einzelne Nacht",
    "nightly_week_season": "Einzelne Nacht",
    "nightly_weekend": "Nacht am Wochenende",
    "nightly_weekend_season": "Einzelne Nacht am Wochenende",
    "no_prices": "Es wurden noch keine Preise festgelegt",
    "no_rotation_day": "Anreise an beliebigem Wochentag",
    "not_available": "Wählen Sie einen anderen Anreisetag oder passen Sie die Anzahl der Nächte an.",
    "per_night": "pro Nacht",
    "per_stay": "Pro Aufenthalt",
    "per_week": "pro Woche",
    "per_weekend": "pro Wochenende",
    "price": "Preis",
    "price_lump_long_weekend": "Preis für ein gesamtes langes Wochenende vergeben",
    "price_lump_week": "Preis für eine gesamte Woche vergeben",
    "price_per_night": "Preis pro Nacht",
    "price_single_night": "Preis für eine einzelne Nacht vergeben",
    "price_single_night_weekend": "Preis für eine Nacht am Wochenende vergeben",
    "price_stay_weekdays": "Preis für einen Aufenthalt unter der Woche vergeben",
    "season_price_text": "Hier können Sie individuelle Preise für eine bestimmte Saison definieren, beispielsweise \"Ostern\". Saisonale Preise sind nur gültig, wenn Sie einen Zeitraum definiert haben. Saisonale Preise müssen nicht zwingend angelegt werden, bevor eine Immobilie zur Inserierung freigeschaltet werden kann.",
    "season_prices": "Saisonale Preise",
    "season_title": "Saison-Bezeichnung",
    "single_night": "Preis für eine einzelne Nacht",
    "single_night_weekend": "Preis für eine Nacht am Wochenende",
    "standard_price": "Standard-Preis",
    "standard_price_text": "Legen Sie mindestens einen Standard-Preis an, damit Sie Ihre Immobilie zur Inserierung freischalten können. Wir empfehlen, dass Sie alle Standardpreise anlegen, was aber nicht zwingend erforderlich ist. Standard-Preise sind im ganzen Buchungsjahr gültig.",
    "standard_price_text_2": "Wenn Sie für eine bestimmte Saison einen anderen Preis festlegen wollen, legen Sie bitte ganz unten einen saisonalen Preis an.",
    "standard_prices": "Standard-Preise",
    "stay_weekdays": "Preis für einen Aufenthalt unter der Woche",
    "tooltip_lump_long_weekend": "Ein gesamtes langes Wochenende beinhaltet üblicherweise drei aufeinanderfolgende Übernachtungen.",
    "tooltip_nightly_week": "Eine einzelne Nacht bezieht sich auf eine einzelne Übernachtung unter der Woche, also zwischen Montag und Donnerstag.",
    "tooltip_nightly_weekend": "Eine einzelne Nacht am Wochenende bezieht sich auf eine einzelne Übernachtung am Wochenende, also zwischen Freitag und Sonntag.",
    "tooltip_stay_underweek": "Grundsätzlich beginnt ein Aufenthalt unter der Woche montags und endet freitags.",
    "tooltip_stay_weekdays": "Ein Aufenthalt unter der Woche bezieht sich auf eine Übernachtung während der Woche.",
    "under_week": "Unter der Woche",
    "week_period": "Preis für Zeitraum unter der Woche",
    "week_period_consists_of": "Dieser Preis gilt für aufeinanderfolgende Übernachtungen unter der Woche",
    "week_starts": "Eine Woche beginnt mit der Übernachtung ab",
    "weekend_consists_of": "Dieser Preis gilt für aufeinanderfolgende Übernachtungen von",
    "what_is_common": "Was ist üblich?",
    "what_is_common_1": "Normalerweise beginnt eine Ferienwoche freitags",
    "what_is_common_2": "Normalerweise setzen sich die Wochenendpreise aus Freitag- und Samstagnacht zusammen",
    "whole_weekend": "Preis für ein gesamtes Wochenende vergeben",
    "your_price": "Sie erhalten"
  },
  "processing": {
    "booking": {
      "booking_form": {
        "amex": "American Express",
        "bank_transfer": "Banküberweisung",
        "credit_card": "Mastercard, Visa, Maestro",
        "payment_charge": "Bearbeitungsgebühr",
        "payment_method": "Bezahlungsmethode",
        "payment_method_expl": "Bei Bezahlung mit Kreditkarte entstehen zusätzliche Bearbeitungsgebühren. Diese werden automatisch auf den Gesamtpreis aufaddiert."
      }
    }
  },
  "renter": {
    "contact": "Kontaktinformationen",
    "terms_of_service_html": "Ich bestätige, dass ich die <a href=\"/downloads/renter_tos/casapilot_tos_renter_DE.pdf\" target=\"_blank\">AGB</a> gelesen, verstanden und akzeptiert habe."
  },
  "reserved": "Reserviert",
  "reviews": {
    "accommodation": "Unterkunft",
    "cancel_correct": "Zurück und korrigieren",
    "confirm": "Überprüfen",
    "confirmation_intro": "Bitte überprüfe deine Empfehlung. Kann sie so veröffentlicht werden?",
    "intro_1": "Dein Feedback zählt: Dein Urteil hilft anderen Casapilot-Benutzern, die richtige Unterkunft auszuwählen und uns noch besser zu verstehen, wie du deinen Aufenthalt erlebt hast.",
    "intro_2": "Danke, dass du dir die Zeit nimmst!",
    "mailers": {
      "host_reaction_subject": "Ein Gast hat eine Bewertung abgegeben",
      "invitation_reminder_subject": "Freundliche Erinnerung: Wie war dein Aufenthalt?",
      "invitation_subject": "Wie war dein Aufenthalt?"
    },
    "nps_headline": "Wie wahrscheinlich ist es, dass Du Casapilot weiterempfiehlst?",
    "nps_unlikely": "Unwahrscheinlich",
    "nps_very_likely": "Sehr wahrscheinlich",
    "question_area": "Wie war die Lage/Umgebung des Objekts?",
    "question_cleanliness": "Wie war die Sauberkeit des Objektes?",
    "question_comfort": "Wie war der Komfort der Unterkunft?",
    "question_value": "Wie zufrieden warst Du mit dem Preis/Leistungsverhältnis?",
    "rating_headline": "Wie zufrieden warst du mit der Unterkunft?",
    "rating_no_selection": "Bitte auswählen",
    "rating_selection_1": "1 - Nicht zufrieden",
    "rating_selection_2": "2 - Eher unzufrieden",
    "rating_selection_3": "3 - Neutral",
    "rating_selection_4": "4 - Eher zufrieden",
    "rating_selection_5": "5 - Sehr zufrieden",
    "remaining_chars": "Noch verbleibende Zeichen",
    "review_author": "Author der Empfehlung",
    "review_headline": "Bitte schreibe eine kurze Empfehlung. Was war gut? Was kann verbessert werden?",
    "submit": "Absenden",
    "success_title": "Danke",
    "supbmit": "Indienen",
    "thank_you": "Danke für Deine Empfehlung. Da wir gerade erst begonnen haben, Benutzer um Empfehlungen zu bitten, warten wir mit der Veröffentlichung noch ein wenig, bis wir genügend Bewertungen zusammen haben.",
    "title": "Erstelle eine Empfehlung",
    "travel_dates": "Reisedaten",
    "validation_error": "Bitte fülle alle erforderlichen Felder aus."
  },
  "salutations": {
    "female": "Frau",
    "male": "Herr"
  },
  "search": {
    "additional_results": "Weitere beliebte Urlaubsziele in ",
    "adjust_filters": "Ergebnisse filtern",
    "adjust_request": "Anfrage anpassen",
    "all_cities": "Alle Städte",
    "all_regions": "Alle Regionen",
    "arrival": "Ankunft",
    "availability": {
      "availability_for": "Verfügbarkeit für",
      "available": "Verfügbar",
      "calculate_price_and_availability": "Preise und Verfügbarkeit berechnen ...",
      "check_availability": "Verfügbarkeit prüfen",
      "checking": "Verfügbarkeit wird geprüft",
      "choose_day_of_arrival": "Wählen Sie hier einen Anreisetag:",
      "day_of_arrival": "Anreisetag",
      "free": "frei",
      "no_arrivals": "Für die gewählte Aufenthaltsdauer sind keine Anreisetage verfügbar, bitte wählen Sie eine andere Aufenthaltsdauer.",
      "not_available": "Nicht verfügbar",
      "occupied": "belegt",
      "on_request": "Verfügbarkeit manuell prüfen",
      "update_price_and_availability": "Preise und Verfügbarkeit aktualisieren ..."
    },
    "back_to_search_list": "Zurück zur Suche",
    "banner": {
      "contact_note": "Bitte kontaktieren Sie uns per Mail oder telefonisch.",
      "headline": "Nichts passendes gefunden?",
      "headline_big_1": "Ihre Suche hat leider keine Ergebnisse geliefert.",
      "headline_big_2": "Bitte ändern Sie Ihre Suchkriterien.",
      "offer": "Wir helfen Ihnen sehr gerne persönlich bei der Suche.",
      "offer_big": "Sehr gerne helfen wir Ihnen auch persönlich bei der Suche."
    },
    "check_availability": "Verfügbarkeit prüfen",
    "choose_city": "Stadt wählen",
    "choose_region": "Region wählen",
    "close": "schließen",
    "departure": "Abreise",
    "detail": {
      "allowed_pets": "Haustiere erlaubt",
      "allowed_smoking": "Rauchen erlaubt",
      "allowed_youth": "Jugendgruppen erlaubt",
      "amenities_balcony": "Balkon",
      "amenities_dish": "Geschirrschpüler",
      "amenities_garage": "Fahrzeugstellplatz",
      "amenities_garden": "Garten",
      "amenities_internet": "Internet/WiFi",
      "amenities_pool": "Pool",
      "amenities_sauna": "Sauna",
      "amenities_terasse": "Terrasse",
      "amenities_tv": "TV",
      "amenities_wash": "Waschmaschine",
      "from": "ab",
      "locality_calm": "Ruhig gelegen",
      "locality_city": "Ländlich gelegen",
      "locality_mountains": "In den Bergen gelegen",
      "locality_nature": "In der Natur gelegen",
      "locality_sea": "Am Meer gelegen"
    },
    "detail_search": "Detailsuche",
    "exact_date": "Exaktes Datum",
    "extended_search_result": "Für Ihr gewünschtes Reiseziel konnten wir leider keine verfügbaren Unterkünfte finden. Vielleicht sind für Sie die folgenden Ergebnisse in der Nähe interessant.",
    "filters": {
      "activities": "Aktivitäten",
      "air_conditioning": "Klimaanlage",
      "any": "Egal",
      "apartment": "Apartment",
      "central_heating": "Zentralheizung",
      "distance_to_beach": "Distanz zum Strand",
      "features": "Merkmale",
      "fenced_garden": "Garten (umzäunt)",
      "holiday_home": "Ferienhaus",
      "jacuzzi": "Jacuzzi",
      "jacuzzi_inside": "Jacuzzi innen",
      "jacuzzi_outside": "Jacuzzi außen",
      "kind_of_property": "Unterkunftstyp",
      "lake": "See in der Nähe",
      "limited_mobility": "Barrierefrei",
      "linen_included": "Bettwäsche inklusive",
      "object_place": "Standort",
      "ocean_view": "Meerblick",
      "pets": "Haustiere erlaubt",
      "pool": "Pool",
      "pool_inside": "Pool innen",
      "pool_outside": "Pool außen",
      "sauna": "Sauna",
      "ski": "Ski",
      "stars": "Sterne",
      "suite": "Luxus Suite",
      "teambuilding": "Teambuilding",
      "waterfront": "Am Meer/Küste gelegen",
      "wifi_internet": "Wifi - Internet"
    },
    "map_zoom": "Karte vergrößern",
    "map_zoom_out": "Karte verkleinern",
    "mark": "Vormerken",
    "micro_search_no_results": "Es wurden leider keine Objekte mit der gewünschten ID gefunden.",
    "more": "mehr",
    "more_objects": "Weitere Objekte in der Nähe",
    "no_results": "Ihre Suche hat leider keine Ergebnisse geliefert. Bitte ändern Sie die Suchkriterien.",
    "objects_for_all_arrivals": "Objekte für alle Anreisetage zeigen.",
    "offers_found": "Angebote gefunden",
    "please_enter": "Zielort bitte hier eingeben",
    "reset_filters": "Filter entfernen und alle Ergebnisse anzeigen",
    "results": "Suchergebnisse",
    "search": "Suchen",
    "search_by_object_code": "ID Suche",
    "search_list": "Neue Suche",
    "show_availability": "Verfügbarkeit ansehen",
    "size": "Größe",
    "to_accomondation": "Zum Objekt",
    "your_destination": "Ihr Reiseziel"
  },
  "sending_mails": "Mailversand",
  "service_navigation": {
    "account": "Account"
  },
  "shared": {
    "footer": {
      "breakfast": "Frühstück",
      "breakfast_url": "https://specials.casapilot.com/shop/",
      "contact": "Kontakt",
      "cookie_settings": "Cookie Einstellungen",
      "faq": "FAQ",
      "help": "Hilfe",
      "hosts": "Für Vermieter",
      "imprint": "Impressum",
      "partners": "Partner",
      "privacy": "Datenschutz"
    },
    "service_navigation": {
      "host_area": "Vermieter-Login",
      "locale": {
        "de": "DE",
        "en": "EN",
        "es": "ES",
        "fr": "FR",
        "nl": "NL"
      },
      "offer_flat": "Eigene Ferienimmobilie anbieten",
      "service_navigation": {
        "account": "Account"
      },
      "user": {
        "edit": "Account bearbeiten",
        "sign_in": "Eigentümer Log-In",
        "sign_out": "Logout",
        "sign_up": "Registrieren"
      },
      "vouchers": "Gutscheine",
      "vouchers_url": "https://shop.casapilot.com/de"
    },
    "sub_navigation": {
      "account": "Account",
      "bookings": "Buchungen",
      "dashboard": "Dashboard",
      "objects": "Objekte",
      "statistics": "Statistik"
    }
  },
  "subscription": {
    "email_error": "Die E-Mail-Adresse ist ungültig. Bitte überprüfen Sie Ihre Eingabe.",
    "email_text": "Ihre E-Mail-Adresse behandeln wir vertraulich.",
    "headline": "Jetzt registrieren und auf dem Laufenden bleiben.",
    "missing_field": "Bitte nehmen Sie für alle Felder Angaben vor."
  },
  "support": {
    "array": {
      "last_word_connector": " und ",
      "two_words_connector": " und ",
      "words_connector": ", "
    },
    "select": {
      "prompt": "Bitte wählen:"
    }
  },
  "thank_you": {
    "copy_1": "Wir freuen uns über Ihr Interesse an Casapilot und werden Sie von nun an auf dem Laufenden halten.",
    "copy_2": "Um Ihre Anmeldung endgültig freizuschalten, werden Sie in Kürze eine E-Mail mit einem Bestätigungslink erhalten. Ohne diese Bestätigung kann Ihre Anmeldung nicht fertiggestellt werden.",
    "copy_3": "In allen E-Mail-Aussendungen, die Sie von uns erhalten, finden Sie zudem einen Link, mit dem Sie die Anmeldung kündigen und Ihre Daten wieder löschen können.",
    "copy_4": "Ihr Casapilot-Team",
    "empfehlen": "Bitte empfehlen Sie uns weiter.",
    "headline": "Vielen Dank!"
  },
  "three_good_reasons": "gute Gründe für Ihren Urlaub mit casapilot.com",
  "time": {
    "am": "vormittags",
    "formats": {
      "default": "%A, %d. %B %Y, %H:%M Uhr",
      "long": "%A, %d. %B %Y, %H:%M Uhr",
      "moment": "H:mm",
      "only_second": "%S",
      "short": "%d.%m.%Y, %H:%M",
      "time": "%H:%M h"
    },
    "pm": "nachmittags"
  },
  "travel_booking_price": {
    "booking_fee": "Buchungsgebühr",
    "costs_in_detail": "Kosten im Detail",
    "deposit": {
      "on_location": "Zahlbar vor Ort",
      "refund": {
        "instantly": "Rückzahlung nach Abreise",
        "one_week": "Rückzahlung nach einer Woche",
        "two_weeks": "Rückzahlung nach zwei Wochen"
      },
      "upfront": "Zahlbar an Casapilot"
    },
    "extras": {
      "type_bring": "Selbst mitbringen",
      "type_included": "Inklusive",
      "type_on_location": "Vor Ort",
      "type_on_request": "Auf Anfrage",
      "type_payable": "Muss gemietet werden",
      "type_upfront": "Im Voraus"
    },
    "handling_fee": "Bearbeitungsgebühr",
    "included": "inbegriffen",
    "liability_insurance": "Haftpflichtversicherung",
    "optional_costs": "Optionale Kosten",
    "other_costs": "Sonstige Kosten",
    "payable_on_location": "Zahlbar vor Ort",
    "payable_on_location_colon": "Zahlbar vor Ort:",
    "payable_to_casapilot": "Zahlbar an Casapilot",
    "plus_other_costs": "(zzgl. Sonstige Kosten)",
    "price_error": "Beim Ermitteln des Preises ist ein Fehler aufgetreten.",
    "rent_fees_included": "Miete (inkl. Buchungsgebühr)",
    "total_amount": "Gesamtbetrag",
    "withheld_from_deposit": "Von der Kaution einbehalten:"
  },
  "travel_bookings": {
    "ical_guest_summary": "Casapilot Buchung für %{title}",
    "ical_host_summary": "Buchung für „%{property}“ über Casapilot"
  },
  "universal_tag": {
    "cnv": {
      "conversion_lang": "85855"
    },
    "rmkt": {
      "container_id": "8807",
      "conversion_lang": "85856"
    }
  },
  "voucher": "Aufenthaltsschein",
  "we_book_your_holidayhome": "Wir buchen Ihr Ferienhaus inkl. Flug und Mietwagen.",
  "web_app_theme": {
    "accommodations": "Unterkünfte",
    "add": "Hinzufügen",
    "administration": "Administration",
    "agency": "Call-Center",
    "all": "Alle",
    "amenities": "Ausstattung",
    "approval_status": "Status",
    "approvals": "Freigaben",
    "approve": "Online stellen",
    "approved": "Online",
    "attractions": "Attraktionen",
    "cancel": "Abbrechen",
    "complete": "Zu überprüfen",
    "confirm": "Sind Sie sicher?",
    "console": "Console",
    "costs": "Zusatzkosten",
    "created": "Erstellt",
    "dashboard": "Dashboard",
    "day": "Tag",
    "days": "Tage",
    "delete": "Löschen",
    "delete_map_clipping": "Kartenauschnitt zurücksetzen",
    "edit": "Bearbeiten",
    "editing": "Unvollständig",
    "find": "Finden",
    "fix_rating": "Sternekategorie fixieren?",
    "homepage": "Homepage",
    "invitations": "Einladungen",
    "latest_send": "Zuletzt versendete",
    "limitations": "Einschränkungen/Besonderheiten",
    "list": "Liste",
    "logout": "Logout",
    "new": "Neu",
    "new_users": "Neue Nutzer",
    "notapproved": "Offline gestellt",
    "ogone": {
      "timedout": "Verbindung zum Zahlungssystem konnte nicht hergestellt werden."
    },
    "or": "oder",
    "possible_extras": "Mögliche Werte",
    "possible_limitations": "Mögliche Werte",
    "possible_units": "Mögliche Einheiten",
    "properties": "Objekte",
    "save": "Speichern",
    "search_people": "Personen",
    "search_person": "Person",
    "select": {
      "prompt": "Bitte wählen"
    },
    "send": "Senden",
    "show": "Anzeigen",
    "summary": "Gesamt (All time)",
    "translate": "Übersetzungen",
    "travel_bookings": "Buchungen",
    "travel_regions": "Regionen",
    "unapprove": "Offline stellen",
    "usable_on": "Benutzbar bei",
    "users": "Benutzer",
    "various_options": "Verschiedenes"
  },
  "will_paginate": {
    "container_aria_label": "Pagination",
    "next_label": "»",
    "page_aria_label": "Page %{page}",
    "page_entries_info": {
      "multi_page": "Displaying %{model} %{from} - %{to} of %{count} in total",
      "multi_page_html": "Displaying %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b> of <b>%{count}</b> in total",
      "single_page": {
        "one": "Displaying 1 %{model}",
        "other": "Displaying all %{count} %{model}",
        "zero": "No %{model} found"
      },
      "single_page_html": {
        "one": "Displaying <b>1</b> %{model}",
        "other": "Displaying <b>all&nbsp;%{count}</b> %{model}",
        "zero": "No %{model} found"
      }
    },
    "page_gap": "...",
    "previous_label": "«"
  },
  "your_benefits": {
    "contact": {
      "at": {
        "number": "+352 20 20 34 26 20",
        "text": "(Erreichbar aus Österreich)"
      },
      "be": {
        "number": "+32 28 80 89 83",
        "text": "(Erreichbar aus Belgien)"
      },
      "ch": {
        "number": "+352 20 20 34 26 20",
        "text": "(Erreichbar aus der Schweiz)"
      },
      "de": {
        "number": "+352 20 20 34 26 20",
        "text": "(Erreichbar aus Deutschland)"
      },
      "email": "E-Mail: info@casapilot.com",
      "email_link": "info@casapilot.com",
      "headline": "Sie haben Fragen",
      "intro": "Nehmen Sie Kontakt mit uns auf. Wir helfen gerne!",
      "lu": {
        "number": "+352 (0)20 20 34 32",
        "text": "(Erreichbar aus Luxemburg)"
      },
      "opening_hours": "Sie erreichen uns telefonisch zum Ortstarif:",
      "opening_hours_1": "Montags–Freitags von 9:00h–12:30h und 13:30h–18:00h",
      "opening_hours_2": "Am Wochenende von 14–16 Uhr",
      "partners": "Unsere Partner",
      "phone": "Tel. +352 20 20 34 26"
    },
    "h1": "Warum Casapilot?",
    "h2": "Inklusiv-Preise",
    "h3": "Sicher buchen, sichere Daten, sicher in den Urlaub",
    "h4": "Prima Service und sehr gute Erreichbarkeit",
    "headline_html": "Das Team Casapilot",
    "intro": "Ihr Traumurlaub ist unser wichtigstes Anliegen. Darum werden bei uns Erreichbarkeit, Freundlichkeit und Service groß geschrieben. Testen Sie uns und Sie werden sehr angenehm überrascht sein – das versprechen wir.",
    "list_item2_1": "Die zu einem Reisezeitraum dargestellten Mietpreise sind endgültige Preise",
    "list_item2_2": "Die Kosten für Haftpflichtversicherung und sonstige Gebühren sind enthalten",
    "list_item2_3": "Die möglichen Kosten für Ihren Verbrauch vor Ort werden gut sichtbar aufgeführt",
    "list_item3_1": "Die verschlüsselte Website garantiert, dass Ihre Personendaten geschützt sind",
    "list_item3_2": "Unser zertifizierter Zahlungsanbieter gewährleistet sichere Bezahlung per Überweisung und Kreditkarte",
    "list_item4_1": "Sie können uns unter der Woche und am Wochenende telefonisch zum Ortstarif erreichen",
    "list_item4_2": "Per E-Mail erreichen Sie uns rund um die Uhr. Wir antworten innerhalb von 24 Stunden",
    "list_item4_3": "Sie suchen nach einer speziellen Ferienimmobilie? Wir helfen Ihnen sehr gerne persönlich bei der Suche",
    "p1_1": "Es gibt viele gute Gründe, warum Sie Ihren Traumurlaub auf casapilot.com buchen sollten.",
    "p1_2": "Die wichtigsten Gründe haben wir nachfolgend für Sie im Detail erläutert:",
    "p2": "Auf Casapilot.com gibt es keine unangenehmen Überraschungen für Sie, denn unser Preissystem ist klar und transparent:",
    "p3": "Wir möchten, dass Sie einen unbeschwerten Urlaub genießen können. Die Sicherheit, die wir Ihnen bieten, fängt beim Buchen und Bezahlen an und umfasst auch jeden Tag Ihres Urlaubsaufenthalts vor Ort.",
    "p4": "Unser 5-sprachiges Serviceteam steht zu Ihrer Verfügung und das an 365 Tagen im Jahr. Guter Service ist unsere Stärke.",
    "page_title": "Mehr vermieten. Mehr verdienen. Mit Casapilot.",
    "positions": {
      "accounting": "Buchhaltung",
      "business_development": "Business Development",
      "business_development_spain": "Business Development Spanien",
      "ceo": "Geschäftsführung",
      "cio": "Technische Leitung",
      "design": "Interactive Design",
      "dev": "Webdevelopment",
      "it": "IT Administrator",
      "photography": "Fotografie",
      "pm": "Projektleitung",
      "service": "Kundenbetreuung",
      "service_marketing": "Kundenbetreuung und Marketing",
      "teamleader": "Teamleader"
    }
  }
};
I18n.translations["en"] = {
  "about": {
    "h1": "Easy to post and manage ",
    "h2": "From owner to owner ",
    "h3": "Unrivalled Service – around the clock ",
    "h4": "Post and rent all over Europe ",
    "h5": "Security ",
    "h6": "Attractive Terms ",
    "link_13": "A detailed description of the ",
    "link_23": "Casapilot business model ",
    "link_33": "can be downloaded as a PDF.",
    "p1": "In just a few steps to the finished advert – that is our claim. Thanks to the comprehensive design and many practical features (such as the advert preview to check the advert before posting it) using Casapilot is intuitive and pleasant for you. ",
    "p2": "We are – just like you – owners of a holiday home, which we have been renting ourselves for years. When renting via an online portal and estate agent, we often found that external agents are expensive and not very flexible. That bothered us, and that’s why we started Casapilot. We promise you attractive terms, a high degree of flexibility, and unrivalled service. ",
    "p3": "We are here for you in word and deed 24 hours a day, 365 days a year. So that you can attract customers from all over Europe, we will provide the translations of the description texts for your property into all relevant foreign languages. In addition, we will take care of the formalities, such as advertising, booking, insurance and payment, and we will provide your customers with all the necessary information about your accommodation. ",
    "p4": "We have a pan-European view, and want you to gain customers from all over Europe. Casapilot is from the start presented in five languages: English, German, French, Spanish and Dutch. ",
    "p5": "All bookings are made via a secure, encrypted website and via a certified payment processor. In addition, you will receive payment for every booking directly after your guests arrival. Possible material damage by your renters is covered by the liability insurance which your renters automatically enter into when booking with Casapilot. ",
    "p6": "Advertising your property is free for you. You only pay a commission when you receive a binding booking. Our commissions are added to your rental price. When you enter your prices, the percentage commission amount is calculated automatically. So you can see the net rental price you will receive, and the rental price offered to the tenant. "
  },
  "about_us": {
    "claim": "Casapilot makes the rental of your holiday home simple and profitable.",
    "headline_html": "Rent more. <br /> Earn more. <br /> With Casapilot.",
    "page_title": "Rent more. Earn more. With Casapilot."
  },
  "accommodation_reviews": {
    "area": "Location",
    "cleanliness": "Cleanliness",
    "comfort": "Comfort",
    "hide": "Hide",
    "load_more_reviews": "Load more reviews…",
    "review_translated": "Review translated",
    "reviews": {
      "one": "review",
      "other": "reviews"
    },
    "show_more": "Show more",
    "show_original": "Show original",
    "show_translation": "Show translation",
    "value": "Price-perfrormance"
  },
  "accommodations": {
    "errors": {
      "minstay": "For this accommodation, you have to choose a period of stay, which is divisible by %{minstay}. Please try again."
    },
    "seo": {
      "in": "in",
      "kind": {
        "apartment": "Apartment ",
        "bed_and_breakfast": "B&B rooms ",
        "holiday_home": "Holiday home "
      }
    }
  },
  "activemodel": {
    "errors": {
      "template": {
        "body": "There were problems with the following fields:",
        "header": {
          "one": "1 error prohibited this %{model} from being saved",
          "other": "%{count} errors prohibited this %{model} from being saved"
        }
      }
    }
  },
  "activerecord": {
    "abbr_day_names": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "abbr_day_names_string": {
      "friday": "Fri",
      "monday": "Mon",
      "saturday": "Sat",
      "sunday": "Sun",
      "thursday": "Thu",
      "tuesday": "Tue",
      "wednesday": "Wed"
    },
    "abbr_month_names": [
      null,
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "attributes": {
      "accommodation": {
        "amenities": "Amenities",
        "area": "Surface (m²)",
        "bond": "Deposit",
        "bond_refund": "Deposit Reimbursement",
        "created_at": "Created on",
        "description": "Description",
        "description_short": "Kurzbeschreibung",
        "fee": "Commission (in %)",
        "filter_partition": {
          "all": "Show all accomodations",
          "any_missing": "missing translation",
          "de_missing": "missing German translation",
          "en_missing": "missing English translation",
          "es_missing": "missing spanish translation",
          "fr_missing": "missing French translation ",
          "nl_missing": "missing Dutch translation"
        },
        "filter_partition_all": "Alle Unterkünfte anzeigen",
        "filter_partition_any_missing": "mit fehlender Übersetzung",
        "filter_partition_de_missing": "ohne deutsche Übersetzung",
        "filter_partition_en_missing": "ohne englische Übersetzung",
        "filter_partition_es_missing": "ohne spanische Übersetzung",
        "filter_partition_fr_missing": "ohne französische Übersetzung",
        "filter_partition_nl_missing": "ohne niederländische Übersetzung",
        "id": "ID",
        "kind": "Type",
        "max_persons": "Persons (max.)",
        "number_of_baths": "Bathrooms",
        "number_of_bunk_beds": "Bunk beds",
        "number_of_daybeds": "Sofa beds",
        "number_of_king_size_beds": "Double beds",
        "number_of_rooms": "Rooms",
        "number_of_similar": "Number of identical accommodations \n",
        "number_of_single_beds": "Single beds",
        "photos": "Photos",
        "property_id": "Accomodation",
        "title": "Title",
        "updated_at": "Updated on",
        "user_rating": "Basisbewertung"
      },
      "amenity": {
        "apartment": "Apartment",
        "bed_and_breakfast": "Bed & Breakfast",
        "category": "Category",
        "created_at": "Created on",
        "holiday_home": "Holiday Home",
        "id": "ID",
        "name": "Identifier",
        "updated_at": "Updated on"
      },
      "attraction": {
        "category": "Category",
        "created_at": "Created on",
        "id": "ID",
        "name": "Identifier",
        "updated_at": "Updated on "
      },
      "attraction_distance": {
        "created_at": "Created on",
        "distance": "Distance",
        "id": "ID",
        "updated_at": "Updated on "
      },
      "block": {
        "accommodation": "Holiday Home/Room",
        "beginning": "Closed from",
        "created_at": "Created on",
        "ending": "Closed to",
        "id": "ID",
        "updated_at": "Updated on"
      },
      "cost": {
        "created_at": "Created on",
        "id": "ID",
        "inclusive": "inclusive",
        "mandatory": "Mandatory costs",
        "name": "Identifier",
        "per_animal": "per animal",
        "per_box": "per box",
        "per_consumption": "per consumption and current market price",
        "per_cubic_meter": "per m³",
        "per_day": "per day",
        "per_day_and_person": "per day and person",
        "per_day_and_piece": "per day and piece",
        "per_hour": "per hour",
        "per_kwh": "per kWh",
        "per_liter": "per liter",
        "per_midweek": "per midweek",
        "per_night": "per night",
        "per_night_and_animal": "per night and animal",
        "per_night_and_person": "per night and person",
        "per_package": "per package",
        "per_person": "per person",
        "per_piece": "per piece",
        "per_set": "per set",
        "per_stay": "per stay",
        "per_week": "per week",
        "per_weekend": "per weekend",
        "updated_at": "Updated on"
      },
      "extra": {
        "breakfast": "Breakfast",
        "bring": "To be brought",
        "created_at": "Created at",
        "dish_towels": "Dish towels",
        "id": "ID",
        "included": "Included",
        "kind": "Type",
        "linen": "Bed linen",
        "on_request": "on request",
        "optional": "Optional",
        "payable": "Available",
        "price": "Price",
        "towels": "Bath towels",
        "updated_at": "Updated at"
      },
      "inquiry_form": {
        "day_of_arrival": "Day of arrival",
        "day_of_departure": "Day of departure",
        "email": "E-Mail",
        "inquiry": "Request",
        "message": "Message",
        "name": "Name",
        "object_id": "Accommodation ID",
        "phone": "Phone",
        "updated_at": "Actualizado el"
      },
      "limitation": {
        "allowed": "Permitted",
        "bring_with": "Selbst mitbringen",
        "can_be_rented": "Mieten möglich",
        "created_at": "Created at",
        "forbidden": "Not allowed",
        "id": "ID",
        "must_be_rented": "Mietverpflichtung",
        "name": "Name",
        "onrequest": "on request",
        "updated_at": "Updated at"
      },
      "price": {
        "accommodation": "Holiday Home/Room",
        "beginning": "Valid from",
        "created_at": "Created on",
        "default_price": "Standard rate",
        "ending": "Valid until",
        "friday": "Friday",
        "friday_abbr": "Fr",
        "id": "ID",
        "monday": "Monday",
        "monday_abbr": "Mo",
        "payment_type": "method of payment",
        "price": "Price",
        "rotation_day": "bed linen exchange",
        "saturday": "Saturday",
        "saturday_abbr": "Sa",
        "sunday": "Sunday",
        "sunday_abbr": "Su",
        "thursday": "Thursday",
        "thursday_abbr": "Th",
        "tuesday": "Tuesday",
        "tuesday_abbr": "Tu",
        "updated_at": "Updated on",
        "wednesday": "Wednesday",
        "wednesday_abbr": "We"
      },
      "property": {
        "country": "Country",
        "created_at": "Created on",
        "description": "Description",
        "description_short": "Short description",
        "filter_partition_all": "Show all accommodations",
        "filter_partition_any_missing": "with missing translation",
        "filter_partition_de_missing": "without german translation",
        "filter_partition_en_missing": "without english translation",
        "filter_partition_es_missing": "without spanish translation",
        "filter_partition_fr_missing": "without french translation",
        "filter_partition_nl_missing": "without dutch translation",
        "id": "ID",
        "internal_memo": "Internal Reference",
        "locality": "Place",
        "postal_code": "Zip code",
        "rating": "Star Category",
        "region": "Region",
        "street": "Street",
        "title": "Name of property",
        "top_object": "Top accommodation",
        "travel_region_id": "Holiday region",
        "updated_at": "Updated on"
      },
      "property_photo": {
        "created_at": "Created on",
        "description": "Description",
        "file": "Picture",
        "id": "ID",
        "updated_at": "Updated on"
      },
      "travel_booking": {
        "accommodation": "Unterkunft",
        "amount_total": "Rechnungsbetrag",
        "cancel_ins_amount": "Reiserücktrittsvericherung",
        "casualty_ins_amount": "Haftpflichtversicherung",
        "created_at": "Booking created",
        "id": "ID",
        "number_of_adults": "Erwachsene",
        "number_of_children": "Kinder",
        "number_of_infants": "Kleinkinder",
        "number_of_pets": "Haustiere",
        "ref_code": "Rechnungsnummer",
        "renter": "Mieter",
        "state": "Status",
        "travel_ins_amount": "Umfassende Reiseversicherung",
        "travel_range": "Reisezeitraum"
      },
      "travel_region": {
        "country_code": "Country",
        "created_at": "Created on",
        "custom_geocode": "Manual map",
        "id": "ID",
        "name": "Name in national language",
        "updated_at": "Updated on"
      },
      "user": {
        "additional_emails": "Additional Emails",
        "additional_emails_csv": "Additional Emails (separated by commas)",
        "admin": "Administrator",
        "agent": "Telephone operator",
        "agent_lead": "Agency Management",
        "api_user": "API User",
        "authentication_token": "Auth Token",
        "avatar": "Your picture",
        "birthday": "Birthday",
        "cellphone": "Mobile",
        "city": "City",
        "country": "Country",
        "created_at": "Created on",
        "current_password": "Current Password",
        "description": "Description",
        "email": "E-mail",
        "first_name": "First name",
        "host": "Host",
        "id": "ID",
        "invoice_city": "City (Contact information)",
        "invoice_company": "Company (Contact information)",
        "invoice_country": "Country (Contact information)",
        "invoice_mobile_phone": "Mobile phone (contact details)",
        "invoice_name": "Name (Contact information)",
        "invoice_phone": "Phone (Contact information)",
        "invoice_postal_code": "Postcode (Contact information)",
        "invoice_street": "Street (Contact information)",
        "key_hand_over_city": "City (Address for key exchange)",
        "key_hand_over_country": "Country (Address for key exchange)",
        "key_hand_over_name": "Name (Address for key exchange)",
        "key_hand_over_postal_code": "Postcode (Address for key exchange)",
        "key_hand_over_street": "Street (Address for key exchange)",
        "last_name": "Last name",
        "last_sign_in_at": "Last logged in on",
        "mother_tongue": "Mother tongue",
        "name": "Name",
        "newsletter": "Subscribe to Newsletter",
        "password": "Password",
        "password_confirmation": "Repeat password",
        "phone": "Telephone",
        "postal_code": "ZIP",
        "remember_me": "Remember me",
        "remove_avatar": "Remove Image",
        "renter": "Customer",
        "salutation": "Title",
        "street_nr": "Street / number",
        "terms_of_service": "General Sales Conditions",
        "translator": "Translator",
        "updated_at": "Updated on",
        "vat_rate": "VAT rate"
      }
    },
    "day_names": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "day_names_string": {
      "friday": "Friday",
      "monday": "Monday",
      "saturday": "Saturday",
      "sunday": "Sunday",
      "thursday": "Thursday",
      "tuesday": "Tuesday",
      "wednesday": "Wednesday"
    },
    "errors": {
      "full_messages": {
        "format": "%{attribute}%{message}"
      },
      "messages": {
        "accepted": "must be accepted",
        "blank": "can't be blank",
        "confirmation": "doesn't match confirmation",
        "empty": "can't be empty",
        "equal_to": "must be equal to %{count}",
        "even": "must be even",
        "exclusion": "is reserved",
        "greater_than": "must be greater than %{count}",
        "greater_than_or_equal_to": "must be greater than or equal to %{count}",
        "inclusion": "is not included in the list",
        "invalid": "is invalid",
        "less_than": "must be less than %{count}",
        "less_than_or_equal_to": "must be less than or equal to %{count}",
        "not_a_number": "is not a number",
        "not_an_integer": "must be an integer",
        "odd": "must be odd",
        "record_invalid": "Validation failed: %{errors}",
        "restrict_dependent_destroy": {
          "has_many": "Cannot delete record because dependent %{record} exist",
          "has_one": "Cannot delete record because a dependent %{record} exists"
        },
        "taken": "has already been taken",
        "too_long": "is too long (maximum is %{count} characters)",
        "too_short": "is too short (minimum is %{count} characters)",
        "wrong_length": "is the wrong length (should be %{count} characters)"
      },
      "models": {
        "amenity": {
          "attributes": {
            "name": {
              "invalid": "may only contain letters"
            }
          }
        },
        "attraction": {
          "attributes": {
            "name": {
              "invalid": "may only contain letters"
            }
          }
        },
        "block": {
          "attributes": {
            "ending": {
              "range_too_short": "has to start at least one day after the beginning of the period"
            }
          }
        },
        "cost": {
          "attributes": {
            "name": {
              "invalid": "may only contain letters"
            }
          }
        },
        "extra": {
          "attributes": {
            "kind": {
              "invalid": "should only contain letters"
            }
          }
        },
        "limitation": {
          "attributes": {
            "name": {
              "invalid": "may just contain letters"
            }
          }
        },
        "price": {
          "attributes": {
            "base": {
              "lump_price_exists": "There is already a standard price for this period",
              "nested_season": "The overlapping of season periods is not possible. Please enter the season prices sequentially, so that the periods do not overlap.",
              "nightly_price_exists": "There is already a price for one of these days",
              "no_night_selected": "Select at least one weekday",
              "not_linked_up": "The weekdays have to be successive with the package price"
            },
            "ending": {
              "range_too_short": "has to be at least one day after the start of the validity period"
            }
          },
          "not_blank": "is not empty"
        },
        "travel_region": {
          "attributes": {
            "name": {
              "invalid": "may only contain letters"
            }
          }
        }
      },
      "template": {
        "body": "Bitte überprüfen Sie die folgenden Felder:",
        "header": {
          "one": "Konnte %{model} nicht speichern: ein Fehler.",
          "other": "Konnte %{model} nicht speichern: %{count} Fehler."
        }
      }
    },
    "models": {
      "accommodation": "Holiday Home/Room",
      "amenity": "Facilities feature",
      "attraction": "Attraction",
      "attraction_distance": "Distance to attractions",
      "block": "Blocked time period",
      "cost": "Additional costs",
      "extra": "Optional equipment features",
      "limitation": "Specific features",
      "price": "Price",
      "property": "Property",
      "property_photo": "Photo",
      "travel_booking": "Buchung",
      "travel_region": "Region",
      "user": "User"
    },
    "month_names": [
      null,
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "options": {
      "accommodation": {
        "bond_refund": {
          "instantly": "immediately upon departure",
          "one_week": "one week after departure",
          "two_weeks": "two weeks after departure"
        },
        "kind": {
          "apartment": "Apartment",
          "bed_and_breakfast": "Bed & Breakfast",
          "holiday_home": "Holiday Home"
        }
      },
      "amenity": {
        "category": {
          "business": "Business",
          "domestic": "Domestic appliances",
          "exclusive": "Wellness and leisure",
          "exterior": "Outside",
          "general": "General",
          "location": "Location",
          "multimedia": "Multimedia",
          "orientation": "Orientation",
          "other": "Equipment for people with reduced mobility",
          "view": "View"
        }
      },
      "attraction": {
        "category": {
          "activities": "Activities",
          "other": "Other",
          "places": "Places"
        }
      },
      "extra": {
        "extra_type": {
          "bring": "To be brought",
          "included": "Included",
          "on_request": "on request",
          "payable": "Has to be leased"
        },
        "unit": {
          "per_night": "per night",
          "per_night_and_person": "per night/person",
          "per_person": "per person",
          "per_piece": "per unit",
          "per_set": "pro Set",
          "per_stay": "per stay"
        }
      },
      "limitation": {
        "name": {
          "allowed": "Permited",
          "forbidden": "Not allowed",
          "onrequest": "on request"
        }
      },
      "price": {
        "payment_type": {
          "lump": "inclusive",
          "nightly": "per night"
        },
        "rotation_day": {
          "friday": "Friday",
          "monday": "Monday",
          "saturday": "Saturday",
          "sunday": "Sunday",
          "thursday": "Thursday",
          "tuesday": "tuesday",
          "wednesday": "wednesday"
        }
      },
      "travel_region": {
        "country_code": {
          "AD": "Andorra",
          "AE": "United Arab Emirates",
          "AF": "Afghanistan",
          "AG": "Antigua and Barbuda",
          "AI": "Anguilla",
          "AL": "Albania",
          "AM": "Armenia",
          "AN": "Netherlands Antilles",
          "AO": "Angola",
          "AP": "Asia / Pacific Region",
          "AQ": "Antarctica",
          "AR": "Argentina",
          "AS": "American Samoa",
          "AT": "Austria",
          "AU": "Australia",
          "AW": "Aruba",
          "AX": "Aland Islands",
          "AZ": "Azerbaijan",
          "BA": "Bosnia and Herzegovina",
          "BB": "Barbados",
          "BD": "Bangladesh",
          "BE": "Belgium",
          "BF": "Burkina Faso",
          "BG": "Bulgaria",
          "BH": "Bahrain",
          "BI": "Burundi",
          "BJ": "Benin",
          "BL": "Saint Bartelemey",
          "BM": "Bermuda",
          "BN": "Brunei Darussalam",
          "BO": "Bolivia",
          "BR": "Brazil",
          "BS": "Bahamas",
          "BT": "Bhutan",
          "BV": "Bouvet Island",
          "BW": "Botswana",
          "BY": "Belarus",
          "BZ": "Belize",
          "CA": "Canada",
          "CC": "Cocos ( Keeling) Islands",
          "CD": "Congo , The Democratic Republic of the",
          "CF": "Central African Republic",
          "CG": "Congo",
          "CH": "Switzerland",
          "CI": "Cote d'Ivoire",
          "CK": "Cook Islands",
          "CL": "Chile",
          "CM": "Cameron",
          "CN": "China",
          "CO": "Colombia",
          "CR": "Costa Rica",
          "CU": "Cuba",
          "CV": "Cape Verde",
          "CX": "Christmas Island",
          "CY": "Cyprus",
          "CZ": "Czech Republic",
          "DE": "Germany",
          "DJ": "Djibouti",
          "DK": "Denmark",
          "DM": "Dominica",
          "DO": "Dominican Republic",
          "DZ": "Algeria",
          "EC": "Equador",
          "EE": "Estonia",
          "EG": "Egypt",
          "EH": "Western Sahara",
          "ER": "Eritrea",
          "ES": "Spain",
          "ET": "Ethiopia",
          "EU": "Europe",
          "FI": "Finland",
          "FJ": "Fiji",
          "FK": "Falkland Islands (Mavinas)",
          "FM": "Micronesia, Federated States of",
          "FO": "Faroe Islands",
          "FR": "France",
          "FX": "France, Metropolitan",
          "GA": "Gabon",
          "GB": "United Kingdom",
          "GD": "Grenada",
          "GE": "Georgia",
          "GF": "French Guiana",
          "GG": "Guernsey",
          "GH": "Ghana",
          "GI": "Gibraltar",
          "GL": "Greenland",
          "GM": "Gambia",
          "GN": "Guinea",
          "GP": "Guadeloupe",
          "GQ": "Equatorial Guinea",
          "GR": "Greece",
          "GS": "South Georgia and the South Sandwich Islands",
          "GT": "Guatemala",
          "GU": "Guam",
          "GW": "Guinea-Bissau",
          "GY": "Guyana",
          "HK": "Hong Kong",
          "HM": "Heard Island and McDonald Islands",
          "HN": "Honduras",
          "HR": "Croatia",
          "HT": "Haiti",
          "HU": "Hungary",
          "ID": "Indonesia",
          "IE": "Ireland",
          "IL": "Israel",
          "IM": "Isle of Man",
          "IN": "India",
          "IO": "British Indian Ocean Territory",
          "IQ": "Iraq",
          "IR": "Iran, Islamic Republic of",
          "IS": "Iceland",
          "IT": "Italy",
          "JE": "Jersey",
          "JM": "Jamaica",
          "JO": "Jordan",
          "JP": "Japan",
          "KE": "Kenya",
          "KG": "Kyrgyzstan",
          "KH": "Cambodia",
          "KI": "Kiribati",
          "KM": "Kiribati",
          "KN": "Saint Kitts and Nevis",
          "KP": "Korea, Democratic People's Republic of",
          "KR": "Korea, Republic of",
          "KW": "Kuwait",
          "KY": "Cayman Islands",
          "KZ": "Kazakhstan",
          "LA": "Lao People's Democratic Republic",
          "LB": "Lebanon",
          "LC": "Saint Lucia",
          "LI": "Liechtenstein",
          "LK": "Sri Lanka",
          "LR": "Liberia",
          "LS": "Lesotho",
          "LT": "Lithuania",
          "LU": "Luxembourg",
          "LV": "Latvia",
          "LY": "Libyan Arab Jamahiriya",
          "MA": "Morocco",
          "MC": "Monaco",
          "MD": "Moldova, Republic of",
          "ME": "Montenegro",
          "MF": "Saint Martin",
          "MG": "Madagascar",
          "MH": "Marshall Islands",
          "MK": "Macedonia",
          "ML": "Mali\n",
          "MM": "Myanmar",
          "MN": "Mongolia",
          "MO": "Macao",
          "MP": "Northern Mariana Islands",
          "MQ": "Martinique",
          "MR": "Mauritania",
          "MS": "Montserrat",
          "MT": "Malta",
          "MU": "Mauritius",
          "MV": "Maldives",
          "MW": "Malawi",
          "MX": "Mexico",
          "MY": "Malaysia",
          "MZ": "Mozambique",
          "NA": "Namibia",
          "NC": "New Caledonia",
          "NE": "Niger",
          "NF": "Norfolk Island",
          "NG": "Nigeria",
          "NI": "Nicaragua",
          "NL": "Netherlands",
          "NO": "Noruega",
          "NP": "Nepal",
          "NR": "Nauru",
          "NU": "Niue",
          "NZ": "New Zealand",
          "OM": "Oman",
          "PA": "Panama",
          "PE": "Peru",
          "PF": "French Polynesia",
          "PG": "Papua New Guinea",
          "PH": "Philippines",
          "PK": "Pakistan",
          "PL": "Poland",
          "PM": "Saint Pierre and Miquelon",
          "PN": "Pitcairn",
          "PR": "Puerto Rico",
          "PS": "Palestinian Territory",
          "PT": "Portugal",
          "PW": "Palau",
          "PY": "Paraguay",
          "QA": "Qatar",
          "RE": "Reunion",
          "RO": "Romania",
          "RS": "Serbia",
          "RU": "Russian Federation",
          "RW": "Rwanda",
          "SA": "Saudi Arabia",
          "SB": "Solomon Islands",
          "SC": "Seychelles",
          "SD": "Sudan",
          "SE": "Sweden",
          "SG": "Singapore",
          "SH": "Saint Helena",
          "SI": "Slovenia",
          "SJ": "Svalbard and Jan Mayen",
          "SK": "Slovakia",
          "SL": "Sierra Leone",
          "SM": "San Marino",
          "SN": "Senegal",
          "SO": "Somalia",
          "SR": "Suriname",
          "ST": "Sao Tome and Principe",
          "SV": "El Salvador",
          "SY": "Syrian Arab Republic",
          "SZ": "Swaziland",
          "TC": "Turks and Caicos Islands",
          "TD": "Chad",
          "TF": "French Southern Territories",
          "TG": "Togo",
          "TH": "Thailand",
          "TJ": "Tajikistan",
          "TK": "Tokelau",
          "TL": "Timor-Leste",
          "TM": "Turkmenistan",
          "TN": "Tunisia",
          "TO": "Tonga",
          "TR": "Turkey",
          "TT": "Trinidad and Tobago",
          "TV": "Tuvalu",
          "TW": "Taiwan",
          "TZ": "Tanzania, United Republic of",
          "UA": "Ukraine",
          "UG": "Uganda",
          "UM": "United States Minor Outlying Islands",
          "US": "United States",
          "UY": "Uruguay",
          "UZ": "Uzbekistan",
          "VA": "Holy See (Vatican City State)",
          "VC": "Saint Vincent and the Grenadines",
          "VE": "Venezuela",
          "VG": "Virgin Islands, British",
          "VI": "Virgin Islands, U.S.",
          "VN": "Vietnam",
          "VU": "Vanuatu",
          "WF": "Wallis and Futuna",
          "WS": "Samoa",
          "YE": "Yemen",
          "YT": "Mayotte",
          "ZA": "South Africa",
          "ZM": "Zambia",
          "ZW": "Zimbabwe",
          "all": "All countries"
        }
      }
    },
    "order": [
      "year",
      "month",
      "day"
    ],
    "status_codes": {
      "accommodation": {
        "create_failed": "Holiday Home/Room could not be created.",
        "destroyed": "Holiday Home/Room has been deleted.",
        "successfully_created": "Holiday Home/Room succesfully set up.",
        "successfully_updated": "Holiday Home/Room succesfully updated.",
        "update_failed": "Holiday Home/Room can not be updated."
      },
      "amenity": {
        "create_failed": "Facilities feature could not be set up.",
        "destroyed": "Facilities feature has been deleted ",
        "successfully_created": "Facilities feature successfully set up.",
        "successfully_updated": "Facilities feature is successfully updated.",
        "update_failed": "Facilities feature could not be updated."
      },
      "approval": {
        "successfully_updated": "Freigabe erfolgreich geändert"
      },
      "attraction": {
        "create_failed": "Attraction could not be set up.",
        "destroyed": "Attraction has been deleted.",
        "successfully_created": "Attraction successfully set up.",
        "successfully_updated": "Attraction was successfully updated.",
        "update_failed": "Attraction could not be updated."
      },
      "attraction_distance": {
        "create_failed": "Distance to attraction could not be set up.",
        "destroyed": "Distance to attraction has been deleted.",
        "successfully_created": "Distance to attraction successfully set up.",
        "successfully_updated": "Distance to attraction successfully updated.",
        "update_failed": "Distance to attraction could not be updated."
      },
      "block": {
        "create_failed": "Period could not be set up.",
        "destroyed": "Period has been deleted.",
        "successfully_created": "Period was successfully set up.",
        "successfully_unblocked": "Time period successfully made bookable. ",
        "successfully_updated": "Period was successfully updated.",
        "unblocking_failed": "Time period could not be made bookable. ",
        "update_failed": "Period could not be updated."
      },
      "cost": {
        "create_failed": "Additional cost could not be set up.",
        "destroyed": "Additional cost has been deleted.",
        "successfully_created": "Description of additional costs has been set up successfully.",
        "successfully_updated": "Description of additional costs has been changed successfully.",
        "update_failed": "Description of additional costs couldn't be edited."
      },
      "extra": {
        "create_failed": "Extra could not be created.",
        "destroyed": "Extra was deleted.",
        "successfully_created": "Extra successfully created.",
        "successfully_updated": "Extra successfully updated.",
        "update_failed": "Extra could not be updated."
      },
      "invitation": {
        "create_failed": "Invitation could not be implemented. ",
        "successfully_created": " Invitation successfully implemented."
      },
      "limitation": {
        "create_failed": "Specific feature creation failed.",
        "destroyed": "Specific feature is cancelled.",
        "successfully_created": "Specific feature successfully created.",
        "successfully_updated": "Specific feature successfully updated.",
        "update_failed": "Specific feature update failed."
      },
      "price": {
        "create_failed": "Price could not be set up.",
        "destroyed": "Price has been deleted.",
        "nested_season": "The overlapping of season periods is not possible. Please enter the season prices sequentially, so that the periods do not overlap.",
        "successfully_created": "Price successfully set up.",
        "successfully_updated": "Price successfully edited.",
        "update_failed": "Price could not be edited."
      },
      "property": {
        "create_failed": "Property couldn't be set up.",
        "destroyed": "Property has been deleted.",
        "successfully_created": "Property successfully set up.",
        "successfully_updated": "Property successfully edited.",
        "update_failed": "Property couldn't be edited."
      },
      "property_photo": {
        "create_failed": "Picture couldn't be set up.",
        "destroyed": "Picture has been deleted.",
        "successfully_created": "Picture successfully set up.",
        "successfully_updated": "Picture successfully edited.",
        "update_failed": "Picture could not be edited."
      },
      "travel_booking": {
        "cancel_failed": "Buchung wurde nicht storniert.",
        "confirmation_failed": "Buchung wurde nicht bestätigt.",
        "create_failed": "Buchung konnte nicht angelegt werden.",
        "destroyed": "Buchung wurde gelöscht.",
        "successfully_cancelled": "Buchung wurde storniert.",
        "successfully_confirmed": "Buchung wurde bestätigt.",
        "successfully_created": "Buchung erfolgreich angelegt.",
        "successfully_updated": "Buchung erfolgreich geändert.",
        "update_failed": "Buchung konnte nicht geändert werden."
      },
      "travel_region": {
        "create_failed": "Region could not be set up.",
        "destroyed": "Region has been deleted.",
        "successfully_created": "Region has been set up successfully.",
        "successfully_updated": "Region has been successfully edited.",
        "update_failed": "Region could not be edited."
      },
      "user": {
        "create_failed": "User data creation failed.",
        "destroyed": "The user has been deleted.",
        "must_be_host": "Please become a host (e.q. accept terms [TODO])",
        "must_be_renter": "Please become customer. Therefore, please register with an other Email-address.",
        "successfully_created": "The user has been successfully created.",
        "successfully_updated": "The user has been successfully updated.",
        "update_failed": "The user data update has failed.",
        "wrong_date_format": "The format of date is wrong."
      }
    }
  },
  "administration": {
    "accommodations": {
      "price_change_end_date_label": "End: Season prices starting on or before (leave empty for no change)",
      "price_change_label": "Season price change (in %, leave empty for no change)",
      "price_change_start_date_label": "Start: Season prices starting on or after (leave empty for no change)"
    },
    "city_name_for_filter": "Namer der Stadt für Suchfilter",
    "landing_pages": {
      "accids": "Accommodation ID's",
      "country_code": "Länderkürzel",
      "desc": "Description",
      "edit": "Edit Landing Page",
      "header": "Header",
      "img": "Teaser",
      "locale": "Language",
      "mailer": "E-Mail Linktext",
      "mailer_subject": "E-mail Subject",
      "meta_desc": "SEO Description",
      "meta_keyword": "SEO Keywords",
      "search_meta": "Region",
      "slug": "Name",
      "title": "Region"
    },
    "properties": {
      "form": {
        "api_blocked": "Block in API"
      }
    },
    "travel_bookings": {
      "no_data": "No data available"
    }
  },
  "already_cancelled": "Bereits storniert",
  "already_confirmed": "Already confirmed",
  "ancestry": {
    "cannot_delete_descendants": "Cannot delete record because it has descendants.",
    "cannot_rebuild_depth_cache": "Cannot rebuild depth cache for model without depth caching.",
    "conflicting_parent_id": "Conflicting parent id found in node %{node_id}: %{parent_id} for node %{node_id} while expecting %{expected}",
    "exclude_self": "%{class_name} cannot be a descendant of itself.",
    "invalid_ancestry_column": "Invalid format for ancestry column of node %{node_id}: %{ancestry_column}.",
    "invalid_orphan_strategy": "Invalid orphan strategy, valid ones are :rootify, :adopt, :restrict and :destroy.",
    "named_scope_depth_cache": "Named scope '%{scope_name}' is only available when depth caching is enabled.",
    "no_child_for_new_record": "No child ancestry for new record. Save record before performing tree operations.",
    "option_must_be_hash": "Options for has_ancestry must be in a hash.",
    "reference_nonexistent_node": "Reference to nonexistent node in node %{node_id}: %{ancestor_id}.",
    "unknown_depth_option": "Unknown depth option: %{scope_name}.",
    "unknown_option": "Unknown option for has_ancestry: %{key} => %{value}."
  },
  "attributes": {
    "created_at": "Créé le",
    "translations": {
      "description": "Description",
      "description_de": "Description (German)",
      "description_en": "Description (English)",
      "description_es": "Description (Spanish)",
      "description_fr": "Description (French)",
      "description_nl": "Description (Dutch)",
      "description_short": "Kurzbeschreibung",
      "description_short_de": "Kurzbeschreibung (deutsch)",
      "description_short_en": "Kurzbeschreibung (englisch)",
      "description_short_es": "Kurzbeschreibung (spanisch)",
      "description_short_fr": "Kurzbeschreibung (französisch)",
      "description_short_nl": "Kurzbeschreibung (niederländisch)",
      "kind": "Art",
      "kind_de": "Art (deutsch)",
      "kind_en": "Art (englisch)",
      "kind_es": "Art (spanisch)",
      "kind_fr": "Art (französisch)",
      "kind_nl": "Art (niederländisch)",
      "title": "Title",
      "title_de": "Title (German)",
      "title_en": "Title (English)",
      "title_es": "Title (Spanish)",
      "title_fr": "Title (French)",
      "title_nl": "Title (Dutch)"
    },
    "updated_at": "Modifié le"
  },
  "booking": {
    "additional_costs_host": "Extra/consumption costs",
    "additional_information": "More information",
    "additional_information_annotation": "Please select the number of people and your desired booking period.",
    "adult": "Adult",
    "adults": "Adults",
    "arrival_date": "Arrival date",
    "arrival_date_annotation": "Please select your desired arrival date.",
    "availability_check": "Availability check",
    "availability_txt": "Please select your desired dates directly in the calendar.",
    "available_arrival_date": "Available arrival date",
    "available_arrival_date_annotation": "To change a selected arrival date, just click on an alternative date.",
    "booking_headline": "Book „%{object_name}“ in 2 steps",
    "booking_info": "Booking information",
    "booking_overview": "Your booking overview",
    "booking_period": "Period",
    "booking_possible_timespace": "Dates available",
    "booking_process": "Booking process",
    "booking_process_confirmation": "After entering your booking, you will receive a confirmation by e-mail.",
    "booking_process_payment_details": "After the confirmation of the owner, you will obtain the needed payment details.",
    "booking_summary": "Your booking summary",
    "booking_timespace": "Booking period",
    "calendar_annotation": "Please wait. Your accommodation's availability is loading.",
    "cancellation": {
      "accept_conditions": "With the booking of the travel cancellation insurance I accept their insurance <a href=\"/downloads/terms-conditions/cancellation-insurance-en\" target=\"_blank\" rel=\"noopener noreferrer\">conditions</a>.",
      "amount": "Only %{amount}",
      "opt_in": "I would like to take out a travel cancellation insurance for this booking."
    },
    "casualty_insurance": "Damage insurance incl.:",
    "casualty_insurance_txt": "Useful in case of damage - no deductible",
    "change": "Modify",
    "check_payment_info": "Please check your payment information or contact your bank.",
    "chid_age_full": "Child (0-17 years)",
    "chidren_age_full": "Children (0-17 years)",
    "child_age17": "Child (2-17 years)",
    "child_age2": "Child (0-1)",
    "child_part_age2": "Baby (0-1 years)",
    "child_part_age2_cost": "Thereof babies (0-1 years)",
    "children_age17": "Children (2–17 years)",
    "children_age2": "Children (0-1)",
    "children_part_age2": "Babies (0-1 years)",
    "comment": "Remarks - Voucher code",
    "comment_label_info": "Please enter your travel voucher here to receive the discount with the booking request.",
    "comment_note": "Enter comments / remarks / coupon code here. ",
    "confirmation_mail": "A confirmation e-mail will be sent at the following address",
    "confirmation_spam_notice": "Your mailbox is empty? Please check the spam folder.",
    "confirmation_wrong_mail": "In case of questions regarding your booking please contact us at",
    "contact_host": "Contact information",
    "dateselect": "You want to change a blocked period ? Just click on the start or end date and select a new one in order to replace the previous.",
    "deposit": "Deposit",
    "deposit_handling": "Deposit Reimbursement",
    "duration": "Duration",
    "duration_of_stay": {
      "one": "%{count} Night",
      "other": "%{count} Nights"
    },
    "duration_of_stay_annotation": "Please select your possible period of stay which you can see on your right .",
    "europeene_explanation": "Axa is partner of Casapilot for travel insurance.",
    "from": "from",
    "group": "Your group",
    "group_comment": "Compilation of the group",
    "group_max": "Max. age",
    "group_min": "Min. age",
    "group_years": "Age of group",
    "group_years_sum": "%{min} – %{max} years",
    "hh_additional": "Additional cost ",
    "hh_additional_tax": "Tourist tax ",
    "hh_agb": "General Terms and Conditions.",
    "hh_agb_annotation": "I confirm that I have read, understood and accepted the General Terms and Conditions",
    "hh_conditions_and_prices": "Rental conditions and prices",
    "hh_inc_fees": "Booking and handling fee included",
    "hh_redirect_annotation_pt1": "If the automatic redirection does not work, click\n",
    "hh_redirect_annotation_pt2": "Here",
    "hh_redirect_hl": "Redirecting to Holiday Home",
    "hh_redirect_txt": "You will be redirected to our partner Holiday Homes.\nPlease be patient.",
    "host_contact": "You will receive a voucher with the owner's contact details by email, three weeks before your stay.",
    "host_cost": "Additional costs not included",
    "inc_fees": "Booking fee and handling fee included",
    "inc_fees_cancellation": "Travel insurance, booking fee and handling fee included",
    "info_message_redirect": "You will automatically be redirected to the homepage.",
    "insurance_names_txt": "Please provide the names of all travelers. The insurance policy will be issued in these names.",
    "insurance_names_txt_2": "Please fill in each name on a separate line or separate them with a comma. The last name is sufficient.",
    "insurance_tos": "Insurances-Terms",
    "insurance_tos_html": "I confirm that I have read, understood and accepted the terms and conditions of the insurance",
    "insurances": "Insurances",
    "journey": "Your journey ",
    "limitations": "Specifics/Limitations",
    "mail_confirmation": "Thank you!",
    "mail_confirmation_annotation": "Do you have questions about the booking procedure? Then please contact us. ",
    "me_redirect_hl": "Redirecting to MER-EVASION",
    "me_redirect_txt": "You will be redirected to our partner MER-EVASION.\nPlease be patient.",
    "mv_redirect_hl": "Redirecting to MONTAGNE-VACANCES",
    "mv_redirect_txt": "You will be redirected to our partner MONTAGNE-VACANCES.\nPlease be patient.",
    "navigation": {
      "availability": "Dates",
      "booking_info": "Costs",
      "payment": "Payment",
      "payment_feedback": "Confirmation",
      "payment_info": "Summary"
    },
    "newsletter_subscription": "I want to receive the Casapilot newsletter. ",
    "night": "Night",
    "nights": "Nights",
    "no_costs": "Neither",
    "number_of_persons": "Persons max.",
    "payment": "Payment.",
    "payment_accepted": "Thank you for your booking.\nAfter confirmation by the owner, you will receive an e-mail with all the necessary payment information.\nKind regards,\nTeam Casapilot",
    "payment_declined": "Your payment was declined",
    "payment_declined_txt": "Your payment was unfortunately rejected.",
    "payment_not_possible": "Payment is currently not possible",
    "payment_not_possible_txt": "Payment is unfortunately not possible now.",
    "payment_not_possible_txt2": "Please try again later or contact the bank that issued the credit card.",
    "payment_successful": "Your payment was successful.",
    "pet": "Pet",
    "pet_comment_separator": "Comment regarding pets:",
    "pets": "Pets",
    "pets_not_allowed": "Pets are not allowed",
    "posible_host_cost": "",
    "posible_host_cost_txt": "The following costs are not included in the above rental price:",
    "possible_costs_host": "Optional charges for specific equipment",
    "price_box_season_annotation": "Prices may be different depending on the season.",
    "price_total": "Total price",
    "prices_object": "Price of the selected home",
    "rental_price": "Rent",
    "renter": {
      "birthday_format": "DD.MM.YYYY"
    },
    "reservation": {
      "failed": "Unfortunately, the accommodation has already been booked. Please try an other period. "
    },
    "reservation_fee": "Booking fee incl.",
    "review": "Check your data",
    "rotation_day": "Arrival",
    "secure": "Safely on holiday with Casapilot. Guaranteed.",
    "security": {
      "h1": "Your booking",
      "h2": "The payment",
      "h3": "Our Service",
      "p1": "Your personal data is treated confidentially. ",
      "p2": "Safe and easy payment with the secured Casapilot-system.",
      "p3": "For any questions please do not hesitate to contact us."
    },
    "select_bookable_date": "Please select an available date",
    "select_duration": "Please select your period of stay in the blue box.",
    "slider": {
      "month_not_available_html": "The accommodation is not available during this period.",
      "next": "Next 4 months",
      "prev": "Previous 4 months"
    },
    "sp_redirect_hl": "Redirecting to SKI-PLANET",
    "sp_redirect_txt": "You will be redirected to our partner SKI-PLANET. \nPlease be patient. ",
    "tenant_booking": "Your booking",
    "tenant_data": "Your contact details",
    "tenant_residence": "Country",
    "terms_of_service_html": "I confirm that I have read, understood and accepted the <a href=\"/downloads/terms-conditions/guest-en\" target=\"_blank\">General Terms and Conditions</a>. ",
    "time": "&npsp;",
    "to": "to",
    "total": "total",
    "travel_cancelation_insurance": "Travel insurance",
    "travel_cancelation_insurance_dash": "Travel insurance",
    "travel_cancelation_insurance_plus": "Including cancellation insurance",
    "travel_cancelation_insurance_plus_txt": "Full insurance included",
    "travel_cancelation_insurance_txt": "Risk of cancellation or interruption of stay ? Think about it",
    "travel_insurance": "Extensive travel insurance",
    "travel_insurance_txt": "Full travel insurance",
    "traveler_options": {
      "adult": {
        "one": "%{count} adult",
        "other": "%{count} adults"
      },
      "all_children": {
        "one": "%{count} child (2-17 years)",
        "other": "%{count} children (2-17 years)",
        "zero": "%{count} children (0-17 years)"
      },
      "baby": {
        "one": "%{count} baby (0-1 years)",
        "other": "%{count} babies (0-1 years)",
        "zero": "%{count} babies (0-1 years)"
      },
      "baby_parts": {
        "one": "Thereof %{count} baby (0-1 years)",
        "other": "Thereof %{count} babies (0-1 years)",
        "zero": "Thereof %{count} babies (0-1 years)"
      },
      "child": {
        "one": "%{count} child (2-17 years)",
        "other": "%{count} children (2-17 years)",
        "zero": "%{count} children (2-17 years)"
      },
      "pet": {
        "one": "%{count} pet",
        "other": "%{count} pets",
        "zero": "%{count} pets"
      }
    },
    "travelers": "Travelers ",
    "try_again": "Try again please",
    "week": "Week",
    "weeks": "Weeks"
  },
  "booking_cancel": "Cancel booking",
  "booking_confirmation": "Booking confirmation",
  "booking_confirming": "Confirm booking",
  "breakfast_offer": {
    "body": "In this accommodation you have the possibility to <a href=\"https://specials.casapilot.com/shop/\" target=\"_blank\" rel=\"noreferrer\">book breakfast or a meal</a> before your stay. Let us spoil you with delicious products from the region!",
    "title": "NEW: Get your breakfast or menu delivered!"
  },
  "buttons": {
    "availability": "Availability",
    "book_now": "Book now",
    "cancel": "Cancel",
    "continue": "Next",
    "delete": "Delete",
    "edit": "Edit",
    "go_to_summary": "To summary",
    "host_acct_create": "Create an owner account",
    "login_continue": "Log in and resume the booking",
    "offers": "Our offers",
    "pay": "Pay",
    "preview": "Preview",
    "price": "Price",
    "register_continue": "Sign in and resume the booking",
    "register_property": "Register your house now",
    "renter_acct_create": "Create a renter account",
    "reserve_now": "Book with obligation to pay",
    "save": "Next/Save",
    "submit": "Save"
  },
  "cancellation": "Stornieren",
  "chat_tool": {
    "widget_id": ""
  },
  "confirm": "Confirm",
  "confirmed_by_admin": "Confirmed by administrator",
  "confirmed_by_host": "Confirmed by owner",
  "cookie_disclaimer": {
    "button_text": "Accept",
    "link_text": "Learn more",
    "text": "<p>This site uses cookies.</p>\n<p>These are small text files that are stored on your device and allow an analysis of the use of the website.</p>\n<p>For more information, please refer to our privacy policy.</p>\n<p>By continuing to use the website with the appropriate browser settings, you agree to the use of cookies in this context.</p>"
  },
  "country_codes": {
    "at": "Austria",
    "be": "Belgium",
    "bg": "Bulgaria",
    "ch": "Switzerland",
    "cy": "Cyprus",
    "cz": "Czech Republic",
    "de": "Germany",
    "dk": "Denmark",
    "ee": "Estonia",
    "es": "Spain",
    "false": "Norway",
    "fi": "Finland",
    "fr": "France",
    "gb": "United Kingdom",
    "gr": "Greece",
    "hr": "Croatia",
    "ie": "Ireland",
    "is": "Iceland",
    "it": "Italy",
    "li": "Liechtenstein",
    "lt": "Lithuania",
    "lu": "Luxembourg",
    "lv": "Latvia",
    "mt": "Malta",
    "nl": "Netherlands",
    "pl": "Poland",
    "pt": "Portugal",
    "ro": "Romania",
    "se": "Sweden",
    "si": "Slovenia",
    "sk": "Slovakia",
    "uk": "United Kingdom"
  },
  "date": {
    "abbr_day_names": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "abbr_day_names_string": {
      "friday": "Fr",
      "monday": "Mo",
      "saturday": "Sa",
      "sunday": "So",
      "thursday": "Do",
      "tuesday": "Di",
      "wednesday": "Mi"
    },
    "abbr_month_names": [
      null,
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "day_names": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "day_names_string": {
      "friday": "Freitag",
      "monday": "Montag",
      "saturday": "Samstag",
      "sunday": "Sonntag",
      "thursday": "Donnerstag",
      "tuesday": "Dienstag",
      "wednesday": "Mittwoch"
    },
    "formats": {
      "calendar_field": "%d.%m.%Y",
      "day_date_month": "dd, DD. MMM",
      "default": "%d/%m/%Y",
      "long": "%B %d, %Y",
      "long_date": "%a. %d.%m.%y",
      "month_year": "MMMM YYYY",
      "only_day": "%e",
      "request_time_scope": "dd. DD/MM/YY",
      "short": "%b %d"
    },
    "month_names": [
      null,
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "order": [
      "year",
      "month",
      "day"
    ]
  },
  "datetime": {
    "distance_in_words": {
      "about_x_hours": {
        "one": "about 1 hour",
        "other": "about %{count} hours"
      },
      "about_x_months": {
        "one": "about 1 month",
        "other": "about %{count} months"
      },
      "about_x_years": {
        "one": "about 1 year",
        "other": "about %{count} years"
      },
      "almost_x_years": {
        "one": "almost 1 year",
        "other": "almost %{count} years"
      },
      "half_a_minute": "half a minute",
      "less_than_x_minutes": {
        "one": "less than a minute",
        "other": "less than %{count} minutes"
      },
      "less_than_x_seconds": {
        "one": "less than 1 second",
        "other": "less than %{count} seconds"
      },
      "over_x_years": {
        "one": "over 1 year",
        "other": "over %{count} years"
      },
      "x_days": {
        "one": "1 day",
        "other": "%{count} days"
      },
      "x_minutes": {
        "one": "1 minute",
        "other": "%{count} minutes"
      },
      "x_months": {
        "one": "1 month",
        "other": "%{count} months"
      },
      "x_seconds": {
        "one": "1 second",
        "other": "%{count} seconds"
      }
    },
    "prompts": {
      "day": "Day",
      "hour": "Hour",
      "minute": "Minute",
      "month": "Month",
      "second": "Seconds",
      "year": "Year"
    }
  },
  "days_short": {
    "friday": "Fri",
    "monday": "Mon",
    "saturday": "Sat",
    "sunday": "Sun",
    "thursday": "Thur",
    "tuesday": "Tue",
    "wednesday": "Wed"
  },
  "devise": {
    "confirmations": {
      "confirmed": "Your account has been confirmed. You are logged in.",
      "new": {
        "submit": "Submit",
        "title": "Resend confirmation instructions"
      },
      "send_instructions": "In a few minutes you'll receive an email with instructions to reset your password.",
      "send_paranoid_instructions": "If your email address exists in our database, you will receive an email with instructions for how to confirm your email address in a few minutes.",
      "updated": "Your password has been updated. You are registered."
    },
    "error_occured": "An error occured",
    "failure": {
      "already_authenticated": "You are already registered.",
      "inactive": "Your account is not active",
      "invalid": "Invalid login details.",
      "invalid_token": "Invalid authentication token.",
      "last_attempt": "You have one more attempt before your account is locked.",
      "locked": "Your account is blocked.",
      "not_found_in_database": "Invalid %{authentication_keys} or password.",
      "timeout": "Your session is expired, please log in again.",
      "unauthenticated": "You have to log in or register before going further.",
      "unconfirmed": "You have to confirm your account before going further."
    },
    "mailer": {
      "confirmation_instructions": {
        "subject": "Please confirm your registration as a user of www.casapilot.com"
      },
      "email_changed": {
        "subject": "Email Changed"
      },
      "password_change": {
        "subject": "Password Changed"
      },
      "reset_password_instructions": {
        "subject": "Reset your password for www.casapilot.com"
      },
      "unlock_instructions": {
        "subject": "Your profile on www.casapilot.com was blocked."
      }
    },
    "oauth_callbacks": {
      "failure": "You could not login as %{kind}-Account because \"%{reason}\".",
      "success": "You are successfully logged in as %{kind}-Account."
    },
    "omniauth_callbacks": {
      "failure": "Could not authenticate you from %{kind} because \"%{reason}\".",
      "success": "Successfully authenticated from %{kind} account."
    },
    "passwords": {
      "edit": {
        "submit": "Save password",
        "title": "Change password"
      },
      "new": {
        "submit": "Reset password instructions",
        "title": "Forgot your password ?"
      },
      "no_token": "You can't access this page without coming from a password reset email. If you do come from a password reset email, please make sure you used the full URL provided.",
      "send_instructions": "In a few minutes you will receive an email with instructions to reset your password.",
      "send_paranoid_instructions": "If your email address exists in our database, you will receive a password recovery link at your email address in a few minutes.",
      "updated": "Your password has been updated. You are logged in.",
      "updated_not_active": "Your password has been changed successfully."
    },
    "registrations": {
      "destroyed": "Your account has been deleted successfully.",
      "edit": {
        "back": "Back",
        "cancel": {
          "description": "Unhappy ?",
          "link": "Delete my account",
          "question": "Are you sure ?",
          "title": "Delete profile"
        },
        "current_hint": "(you will need your current password to make changes)",
        "password_hint": "(leave a blank if you do not want to change it)",
        "submit": "Save",
        "title": "Edit profile"
      },
      "new": {
        "newsletter_subscription": "I would like to receive the Casapilot Newsletter.",
        "submit": "New profile",
        "title": "Create your profile as an owner for free"
      },
      "signed_up": "You have been registered successfully. You will receive an activation email.\nYour mailbox is empty ? Please check the spam folder.",
      "signed_up_but_inactive": "You have signed up successfully. However, we could not sign you in because your account is not yet activated.",
      "signed_up_but_locked": "You have signed up successfully. However, we could not sign you in because your account is locked.",
      "signed_up_but_unconfirmed": "A message with a confirmation link has been sent to your email address. Please follow the link to activate your account.",
      "update_needs_confirmation": "You updated your account successfully, but we need to verify your new email address. Please check your email and follow the confirmation link to confirm your new email address.",
      "updated": "Data has been successfully updated.",
      "updated_but_not_signed_in": "Your account has been updated successfully, but since your password was changed, you need to sign in again."
    },
    "sessions": {
      "already_signed_out": "Signed out successfully.",
      "new": {
        "login_text": "Log in here to manage your property. ",
        "submit": "Login",
        "title": "You want to access your account? Then you are right. "
      },
      "signed_in": "You logged in successfully.",
      "signed_out": "You logged off successfully."
    },
    "shared": {
      "links": {
        "confirmation": "Didn’t receive confirmation instructions ?",
        "not_registered": "Not yet a member? ",
        "password": "Did you forget your password ?",
        "registered": "Already a member?",
        "sign_in": "Sign in here ",
        "sign_up": "Sign up",
        "unlock": "You didn't receive unlock instructions ?"
      }
    },
    "unlocks": {
      "new": {
        "sumbit": "Resend unlock instructions",
        "title": "Resend unlock instructions"
      },
      "send_instructions": "You will receive in a few minutes an email with instructions to unlock your account.",
      "send_paranoid_instructions": "If your account exists, you will receive an email with instructions for how to unlock it in a few minutes.",
      "unlocked": "Your account has been unlocked. You are logged in."
    }
  },
  "errors": {
    "format": "%{attribute} %{message}",
    "messages": {
      "accepted": "must be accepted",
      "already_confirmed": "has already been confirmed",
      "blank": "can't be blank",
      "confirmation": "doesn't match %{attribute}",
      "confirmation_period_expired": "needs to be confirmed within %{period}, please request a new one",
      "empty": "can't be empty",
      "equal_to": "must be equal to %{count}",
      "even": "must be even",
      "exclusion": "is reserved",
      "expired": "has expired, please request a new one",
      "greater_than": "must be greater than %{count}",
      "greater_than_or_equal_to": "must be greater than or equal to %{count}",
      "in": "must be in %{count}",
      "in_between": "must be in between %{min} and %{max}",
      "inclusion": "is not included in the list",
      "invalid": "is invalid",
      "less_than": "must be less than %{count}",
      "less_than_or_equal_to": "must be less than or equal to %{count}",
      "model_invalid": "Validation failed: %{errors}",
      "not_a_number": "is not a number",
      "not_an_integer": "must be an integer",
      "not_found": "no found",
      "not_locked": "is not blocked",
      "not_saved": {
        "one": "1 error prohibited this %{resource} from being saved:",
        "other": "%{count} errors prohibited this %{resource} from being saved:"
      },
      "odd": "must be odd",
      "other_than": "must be other than %{count}",
      "password_too_long": "is too long",
      "present": "must be blank",
      "required": "must exist",
      "spoofed_media_type": "has contents that are not what they are reported to be",
      "taken": "has already been taken",
      "too_long": {
        "one": "is too long (maximum is 1 character)",
        "other": "is too long (maximum is %{count} characters)"
      },
      "too_short": {
        "one": "is too short (minimum is 1 character)",
        "other": "is too short (minimum is %{count} characters)"
      },
      "wrong_length": {
        "one": "is the wrong length (should be 1 character)",
        "other": "is the wrong length (should be %{count} characters)"
      }
    },
    "template": {
      "body": "Veuillez vérifier les champs suivants : ",
      "header": {
        "one": "Impossible d'enregistrer ce %{model} : 1 erreur",
        "other": "Impossible d'enregistrer ce %{model} : %{count} erreurs"
      }
    }
  },
  "extra_services": {
    "body": "In this accommodation you have the possibility to book <a href=\"https://specials.casapilot.com/shop/\">the Casapilot breakfast service</a> before your stay. Let us spoil you with delicious products from the region!",
    "bookable": {
      "1-night-only": "Booking possible for 1 night",
      "bikerental": "Bicycle rental on request",
      "breakfast": "Breakfast on request",
      "carcharger": "E-car charging station on request",
      "casapilot-breakfast": "Breakfast bookable with Casapilot",
      "champagne": "Welcome drinks on request",
      "dinner": "Dinner on request",
      "dog": "Dogs allowed",
      "flowers": "Flowers and romantic decoration on request",
      "massage": "Massage on request",
      "pool": "Pool",
      "sauna": "Sauna",
      "whirlpool": "Whirlpool"
    },
    "included": {
      "1-night-only": "Booking possible for 1 night",
      "bikerental": "Bicycle rental included",
      "breakfast": "Breakfast included",
      "carcharger": "E-car charging station included",
      "casapilot-breakfast": "Breakfast included",
      "champagne": "Welcome drinks included",
      "dinner": "Dinner included",
      "dog": "Dogs allowed",
      "flowers": "Flowers and romantic decoration can be booked",
      "massage": "Massage included"
    },
    "title": "NEW: Get your breakfast delivered!"
  },
  "flash": {
    "actions": {
      "create": {
        "notice": "%{resource_name} was successfully created."
      },
      "destroy": {
        "alert": "%{resource_name} could not be destroyed.",
        "notice": "%{resource_name} was successfully destroyed."
      },
      "update": {
        "notice": "%{resource_name} was successfully updated."
      }
    },
    "alert": {
      "accept_tos": "Please accept the general terms and conditions.",
      "error_too_many_insurants": "The number of travelers is more than 7 people, but 7 people maximum can be ensured. Please contact info@casapilot.com.",
      "error_try_again": "An error occurred. Please try again.",
      "insert_information": "Please fill in all red marked fields.",
      "insert_name": "Please provide 1 last name.",
      "insert_names_1": "Please fill in exactly %{count} last names.",
      "insert_names_2": "last names filled in.",
      "insurance_error_prebook_period_to_long": "Your stay has to begin within one year.",
      "insurance_over_tenthousand": "The maximum insurable travel cost per person is 10.000,00 €",
      "insurance_product": "An error with insurance products occurred. Please try again."
    }
  },
  "footer": {
    "about": "About Casapilot",
    "contact_link": "info@casapilot.com?subject=www.casapilot.com ",
    "follow_us": "Follow us on",
    "imprint_link": "/en/about/imprint",
    "support": "Support",
    "team_cpl": "The Team Casapilot",
    "team_cpl_link": "https://www.casapilot.com/en/your_benefits",
    "vouchers": "Voucher",
    "vouchers_link": "https://shop.casapilot.com"
  },
  "header": {
    "facebook_link": "http://www.facebook.com/casapilot.fr",
    "hyves_link": "http://www.hyves-share.nl/button/tip/?tipcategoryid=12&rating=5&title=Casapilot&body=www.casapilot.com ",
    "phone_annotation_host": ".",
    "phone_annotation_renter": "Booking hotline:",
    "phone_host": "+352 20 20 34 33",
    "phone_renter": "+352 20 20 34 33",
    "twitter_link": "http://twitter.com/?status=http%3A%2F%2Fwww.casapilot.com "
  },
  "helpers": {
    "label": {
      "holiday_home": {
        "accommodation_amenities": "Amenities",
        "accommodation_area": "Living area (m²)",
        "accommodation_bond": "Deposit (€)",
        "accommodation_bond_refund": "Deposit Reimbursement",
        "accommodation_created_at": "Created on",
        "accommodation_description": "Description",
        "accommodation_fee": "Commission (in %) ",
        "accommodation_id": "ID",
        "accommodation_kind": "Type of accommodation",
        "accommodation_max_persons": "Persons (max.)",
        "accommodation_number_of_baths": "Bath",
        "accommodation_number_of_bunk_beds": "Bunk beds",
        "accommodation_number_of_daybeds": "Sofa Beds ",
        "accommodation_number_of_king_size_beds": "Double beds",
        "accommodation_number_of_rooms": "Bedroom",
        "accommodation_number_of_similar": "Number of identical accommodations \n",
        "accommodation_number_of_single_beds": "Single beds",
        "accommodation_photos": "Pictures",
        "accommodation_property_id": "Property",
        "accommodation_title": "Title",
        "accommodation_updated_at": "Updated on",
        "property_country": "Country",
        "property_created_at": "Created on",
        "property_description": "Description",
        "property_id": "ID",
        "property_locality": "City",
        "property_postal_code": "Postal code",
        "property_rating": " Star Category",
        "property_region": "Region",
        "property_street": "Street",
        "property_title": "Name of property",
        "property_top_object": "Top accommodation\n",
        "property_travel_region_id": "Holiday region",
        "property_updated_at": "Updated on"
      },
      "subscription": {
        "country": "Property location",
        "email": "E-Mail",
        "kind": "I have :",
        "kind_apartment": "Apartment ",
        "kind_bed_and_breakfast": "Bed & Breakfast ",
        "kind_vacation_rental": "Holiday home ",
        "language": "Your language"
      }
    },
    "select": {
      "prompt": "Please select"
    },
    "submit": {
      "create": "Create %{model}",
      "submit": "Save %{model}",
      "update": "Update %{model}"
    }
  },
  "home": {
    "teaser": {
      "text_1": "We book your holiday home including car rental. <br /> <strong> Booking Hotline: </ strong> <br /> +352 20 20 34 33",
      "text_2": "Your Partner from Luxembourg",
      "text_3": "Why Casapilot? <br /> Good rates, Secure booking, Excellent service"
    }
  },
  "homepage": {
    "checks": {
      "headline_1": "Free advertising",
      "headline_2": "Earn in advance",
      "headline_3": "Your determine the price",
      "headline_4": "complete flexibility",
      "text_1": "Posting your property is free for you. ",
      "text_2": "When your property is rented, we will transfer the amount to you two weeks before the arrival of your guests.",
      "text_3": "You determine which rates you will charge for your property ",
      "text_4": "You determine the time periods in which your property is available "
    },
    "counter_text": "Holiday Homes",
    "counter_text_single": "Holiday Home",
    "head_title": "selected homes",
    "headline": "Rent your holiday accommodation. Nice and easy with Casapilot.",
    "intro_text_1": "Casapilot is your new partner in the rental of your holiday accommodation and the management of your Bed & Breakfast offering.",
    "intro_text_2": "Register now – you will stay up to date and be the first to know when our new platform is available.",
    "intro_text_3": "We will acquire new guests for you.",
    "relax_cottage_stoerer": {
      "headline": "Wellness Suites - Honeymoon Suites",
      "text": "Wellness suites with whirlpool in an exclusive ambiance<br/>for a romantic holiday with your partner."
    },
    "subscription_form": {
      "country": {
        "andorra": "Andorra",
        "austria": "Austria",
        "belgium": "Belgium",
        "croatia": "Croatia",
        "danemark": "Denmark",
        "finland": "Finland",
        "france": "France",
        "germany": "Germany",
        "great_britain": "Great Britain",
        "greece": "Greece",
        "hungary": "Hungary",
        "ibiza": "Ibiza",
        "island": "Iceland",
        "italy": "Italy",
        "liechtenstein": "Lichtenstein",
        "luxemburg": "Luxembourg",
        "malta": "Malta",
        "monaco": "Monaco",
        "nederland": "Nederland",
        "norway": "Norway",
        "poland": "Poland",
        "portugal": "Portugal",
        "scotland": "Scotland",
        "spain": "Spain",
        "sweden": "Sweden",
        "switzerland": "Switzerland"
      },
      "email": "E-Mail",
      "email_text": " We will keep your e-mail address confidential.",
      "headline": "Register now and stay up to date.",
      "language": {
        "de": "German",
        "en": "English ",
        "es": "Spanish",
        "fr": " French",
        "nl": " Dutch"
      },
      "submit": "Make a note of it now"
    }
  },
  "homepage_customer": {
    "book_object": "Book",
    "country": "Holiday destination",
    "head_title": "selected homes",
    "headline": "Selected holiday homes for you ",
    "hosts": {
      "headline": "Best Vacation Rentals"
    },
    "intro_headline": "Why to book with Casapilot.",
    "intro_text_1": "Our principles are simple, our search is simple, your vacation is easy. Simply wonderful. ",
    "intro_text_1_hl": "Easy.",
    "intro_text_2": "All the accommodations are choosen personally and checked carefully. Only then, it becomes a Casapilot accomodation.",
    "intro_text_2_hl": "Selected.",
    "intro_text_3": "At your arrival, everything is there. In case of problem, we are there. You can rely on.",
    "intro_text_3_hl": "Reliable.",
    "landingpage": {
      "headline": "Favorite places to travel "
    },
    "last_viewed_objects": "Recently viewed accommodations",
    "objects_foot_hl": "You might also like",
    "prebook_object": "Notice",
    "reserve": "Book",
    "search_arrival": "Arrival",
    "search_button": "Search",
    "search_category_1": "Family Holidays",
    "search_category_2": "Couple Holiday",
    "search_category_3": "Adventure",
    "search_category_4": "Wellness",
    "search_category_5": "More suggestions",
    "search_departure": "Departure",
    "search_detail": "Fine search",
    "search_headline": "Your holiday starts here! ",
    "see_object": "Show",
    "slideshow": {
      "ardennen": "Ardennes",
      "ardennen_desc": "Enjoy the rural tranquillity and discover the many hiking and biking trails. Benefit from the numerous recreational activities the region has got to offer.",
      "austria": "Austria",
      "austria_desc": "Winter or summer, Austria is always worth a visit. In summer, you can explore the hiking trails or do cultural visits and in winter you can enjoy the ski slopes. ",
      "cotedazur": "Côte d'Azur",
      "cotedazur_desc": "Probably the most famous coastline in Europe. Be enchanted by numerous shopping opportunities, fantastic French cuisine and beautiful beaches. ",
      "france": "France",
      "france_desc": "Discover the most beautiful holiday homes in France. Visit famous places inland and on the coast. The holiday houses offer everything for a relaxing holiday. Magnificent landscapes invite you to an unforgettable stay. ",
      "ibiza": "Ibiza",
      "ibiza_desc": "Do not miss out on the luxury of this exclusive Mediterranean island! Fantastic beaches and the exciting nightlife ensure an unforgettable stay on Ibiza.",
      "luxemburg": "Luxemburg",
      "luxemburg_desc": "",
      "mallorca": "Mallorca",
      "mallorca_desc": "Discover the beautiful beaches and the unspoilt rural charm of the popular Mediterranean island. Enjoy your holiday in a cosy country house or a beautiful villa.",
      "spain": "Spain",
      "spain_desc": "Discover the most beautiful sites of the Spanish mainland and its coast with wonderful beaches. Enjoy an unforgettable stay in a holiday home in Malaga, on the Costa del Sol, the Costa Blanca, the Costa Brava,… ",
      "wellnesssuites": "Wellness Suites - Honeymoon Suites",
      "wellnesssuites_desc": "Wellness suites with whirlpool in an exclusive ambiance for a romantic holiday with your partner. Just married, anniversary or as a gift, our bridal suites are offering for each pair luxury and relaxation."
    }
  },
  "host": {
    "ab": "from",
    "accept_agbs": "Please accept the terms and conditions.",
    "accommodation": "Accommodation",
    "accommodation_number_of_beds_zero": "Please enter at least one type and number of beds.",
    "accommodation_reviews": "Reviews",
    "accommodations": {
      "prices": {
        "day_of_arrival": "Day of arrival ",
        "day_of_departure": "Day of departure ",
        "friday": "Friday",
        "monday": "Monday",
        "sunday": "Sunday"
      },
      "suggestions": "Our suggestions for you"
    },
    "add_image": "Add picture",
    "add_new_accommodation": "Add new Accoommodation",
    "add_new_property": "Add new Property",
    "add_new_room": "Add a new room",
    "additional_costs": "Additional costs",
    "adress": "Address",
    "all_properties": "All properties",
    "amenities": "Amenities",
    "amount_bathrooms": "Number of bathrooms from",
    "amount_bedrooms": "Number of bedrooms",
    "amount_rooms": "Number of bedrooms \n",
    "apartment": "Apartment",
    "as": "as",
    "attractions": "Surroundings",
    "avail_in": "Bookable in",
    "avail_in_2": "days",
    "avail_in_3": "day",
    "availabilities": {
      "availabilities": {
        "availabilities_select": "Please choose the calendar year:"
      }
    },
    "availabilities_text": "If you want to define a day as not bookable, please click on the day and then on \"set mark\". If you want to define multiple days as not bookable, please click on the first and last day of the time period and then set the marker. Booking days which are entered via Casapilot are automatically marked by our system as non-bookable. ",
    "availability": "Availability",
    "availability_message": "Please update the availability of your accomodation",
    "avatar_text": "If you like, you can upload a photo here. The photo will appear in the contact box of your advertisement. ",
    "base_rating": "Basic rating",
    "basics": "Basic informations",
    "baths": "Bathrooms",
    "bed_and_breakfast": "Bed & Breakfast",
    "blocked": "Not available",
    "blocked_msg": "There is no available arrival day for the chosen period. Please choose another period.",
    "bookable": "Available",
    "booked": "Booked by Casapilot",
    "bookings_count": "people have booked with this host",
    "bookings_count_zero": "This holiday home is new in our program",
    "bunk_beds": "Bunk beds",
    "clearing_message": "Please fill in the following details to get your accomodation approved.",
    "clearing_missing": "Object details are missing in the following sections",
    "clearing_status_popup": "Your accomodation is incomplete",
    "confirm_delete": "Are you sure that this property should be deleted? This action can not be undone.",
    "contact_user": "Contact",
    "coordinates": "Coordinates",
    "coordinates_annotation": "Here you can specify the accurate coordinates of your accomodation.",
    "country": "Country",
    "create": "Create",
    "create_holiday_home": "Set up a property",
    "create_property": "Set up a property",
    "cut_image": "Crop picture",
    "dashboard": {
      "index": {
        "html": {
          "all_objects": "Show all poperties",
          "another_object": "Set up another object.",
          "another_object_content": "The more objects you set up, the more you can rent and earn. <br /> Take <strong>5 minutes</strong> and add another object.",
          "button": "Post your property now",
          "button_another_object": "Create another object.",
          "first_object": "Set up your first holiday home.",
          "first_object_content": "Take the first step in your cooperation with Casapilot to acquire new renters for your holiday home or Your holiday apartment: it only takes about <strong>5 minutes</strong>to enter all of the main information.",
          "news_more": "other news",
          "news_specialoffer_text": "For your future renters, Casapilot.com will officially be launched in June 2011. As a thank you, you will receive very attractive special terms for submitting your advertisement before July 1, 2011.",
          "news_specialoffer_title": "Post your property now and profit from attractive special terms.",
          "news_title": "Casapilot News",
          "title": "Statistics",
          "your_properties": "Your properties"
        }
      }
    },
    "daybeds": "Sofa beds",
    "del_confirm": "Are you sure ?",
    "delete": "Delete",
    "description": "Description",
    "details": "Details",
    "details_missing": "Which information is missing ?",
    "distance_description": "Activate a checkbox to enter the distance in kilometres.",
    "distance_unit": "km",
    "downloads": "Downloads",
    "duration_of_stay": "Period of stay",
    "edit": "Edit",
    "edit_accommodation": "Edit amenity",
    "edit_holiday_home": "Edit property",
    "edit_image": "Edit picture",
    "embed_calendar_text": "You can embed this calendar to your website with these iFrames:",
    "extras": "Optional features",
    "extras_annotation": "You can configure special features here.",
    "fallback_text": "No information has been entered.",
    "fallback_text_costs": "No.",
    "fallback_text_description": "No description has been entered.",
    "feedback_message": "If any questions occure, please do not hesitate to contact us:",
    "filter": "Filter",
    "following_rooms_already_created": "Following room has been created yet :",
    "forms": "Forms",
    "from": "From",
    "general_property_informations": "Main property informations",
    "hh_inc_fees": "Booking charges incl.",
    "holiday_home": "Holiday home",
    "holiday_homes": {
      "create": {
        "create_failed": "Your property could not be created. Please fill in all of the fields marked in red.",
        "create_successful": "Your property was set up successfully. Here you can upload pictures and all other information on your property. "
      },
      "description": {
        "annotations": {
          "property_description": "Enter a short description of what your property has to offer your guests.",
          "property_description_hint_html": "Your description text helps your guests to form an image of the holiday location. Describe the atmosphere and attractions which make up the location and region. Do  <strong>not</strong> describe the features of the house or the number of rooms here!",
          "property_description_short": "Short description of the holiday home (max. 88 characters incl. spaces)",
          "property_description_short_remaining": "Letters remaining",
          "property_language": "Please use tabs in order to complete description in other languages.",
          "property_language_2": "If you do not speak any other languages, Casapilot can provide translations for you.",
          "property_rating": "Please only indicate if your property has an evaluation.",
          "property_rating_forbidden": "The star rating of your accomodation has been approved by the team Casapilot. In case of complaint, contact us at en@casapilot.com",
          "property_title": "Your property will appear under this name on the website."
        },
        "data_multiple_rooms": "If your house has several bedrooms or flats and if you rent them separately, you can enter the information concerning the first bedroom or flat here.",
        "data_single_room": "Otherwise, please give the values applicable to the whole house or apartment.",
        "language_de": "German",
        "language_description_1": "Description of your accomodation is",
        "language_description_2": "Please use tabs in order to complete description in other languages.",
        "language_en": "English",
        "language_es": "Spanish",
        "language_fr": "French",
        "language_nl": "Dutch",
        "select_language": "Language"
      },
      "form": {
        "data_multiple_rooms": "If your house has several bedrooms or flats and if you rent them separately, you can enter the information concerning the first bedroom or flat here.",
        "data_single_room": "Otherwise, please give the values applicable to the whole house or apartment.",
        "language_de": "German",
        "language_description_1": "Description of your accomodation is",
        "language_description_2": "Please use tabs in order to complete description in other languages.",
        "language_en": "English",
        "language_es": "Spanish",
        "language_fr": "French",
        "language_nl": "Dutch",
        "select_language": "Language"
      },
      "new": {
        "submit": "set up a property",
        "title": "Set up a new Property"
      }
    },
    "host": "Host",
    "image_alt": "View of property",
    "image_description_text": "Please give a short description of the picture, e.g. view into the garden.",
    "image_gallery": "Pictures gallery",
    "image_legend": "Change order of pictures by drag and drop",
    "image_upload_description": "Select a picture from your computer. We recommend a minimum size of 1124 x 689 pixels (max. 950 KB) in order to provide quality images to our visitors.",
    "inc_fees": "Damage insurance and fees incl.",
    "included": "included",
    "incomplete": "incomplete",
    "info": "About the property",
    "kind": "Type",
    "kind_of_property": "Type of accommodation",
    "kind_of_property_available": "Following rooms are already created :",
    "kind_of_property_none": "The house has no more rooms",
    "king_size_beds": "Double beds",
    "languages": "Languages",
    "lat": "Latitude (eg. 47.153900)",
    "limitation": {
      "allowed": "yes",
      "forbidden": "no",
      "onrequest": "on request"
    },
    "limitations": "Specifics",
    "limitations_annotation": "You can define specific features here",
    "link_edit_image": "edit",
    "list": "Back",
    "locality": "Place",
    "long": "Longitude (eg. 13.152367)",
    "main_image": "Main picture",
    "main_image_legend": "Drag your main picture here.",
    "manage_properties": "Manage your properties",
    "map": "Map",
    "map_zoom": "Larger map",
    "max_persons": "Persons (max.)",
    "messages": "Messages",
    "minimum_booking": "Minimum nights",
    "more_images": "more pictures",
    "new_accommodation": "New Accommodation",
    "new_room": "New room",
    "no_images": "no pictures available",
    "not_published": "not published",
    "other_costs_text": "These costs are only shown if you give the information.",
    "others": "Others",
    "payment": "Payment Information",
    "photos": "Pictures",
    "platform_airbnb": "AirBnB",
    "platform_booking": "Booking.com",
    "platform_flipkey": "Flipkey",
    "platform_homeaway": "Homeaway",
    "platform_homelidays": "Homelidays",
    "platform_hometogo": "Hometogo",
    "platform_tripadvisor": "TripAdvisor",
    "platforms": "Platforms for export",
    "platforms_annotation": "You can switch off the export for specific platforms",
    "preview": "Preview",
    "prices": "Prices",
    "prices_availability": "Prices and availability",
    "prices_overview": {
      "js_alert": "Please use the fowolling format when entering your prices 1.000,00 or enter the prices only with digits."
    },
    "properties": {
      "index": {
        "confirm_delete": "Are you sure that this property should be deleted? This action can not be undone."
      }
    },
    "property_id": "Accommodation ID ",
    "property_title": "Accommodation title",
    "published": "Online",
    "rating": "Rating",
    "read_messages": "Read messages",
    "regilar_costs_text": "If you don't give any information here, these costs will be considered as included.",
    "region": "Holiday region",
    "registrations": {
      "edit": {
        "back": "back",
        "cancel": {
          "description": "Unhappy ?",
          "link": "Delete my account",
          "question": "Are you sure ?",
          "title": "Delete profile"
        },
        "current_hint": "(you will need your current password to make changes)",
        "password_hint": "If you do not want to change your password, just leave this field blank.",
        "submit": "save",
        "title": "Edit profile"
      },
      "new": {
        "already_registered": "I already have a renter account on Casapilot.",
        "host_account": "Create your free owner account for Casapilot.",
        "newsletter_subscription": "I would like to receive the Casapilot Newsletter.",
        "not_yet_registered": "I am not yet a Casapilot renter.",
        "offers_text": "Or do you want to go on holiday and book an accommodation with Casapilot? Look at our offers. ",
        "register_account": "Do you want to rent a property? Then you are right. ",
        "register_pls": "Please log in.",
        "register_txt": "Here you can create your profile for free.",
        "submit": "New profile",
        "terms_of_service_html": "I confirm that I have read, understood and accepted the <a href=\"/downloads/terms-conditions/host-en\" target=\"_blank\">General Sales Conditions</a>. ",
        "title": "Create your profile as an owner for free"
      }
    },
    "registrations_addons": {
      "api_documentation": {
        "title": "API documentation"
      },
      "edit_downloads": {
        "bank_data": "Bankverbindung",
        "bank_data_message": "Bitte geben Sie hier Ihre Bankverbindung ein damit wir Ihnen nach einer erfolgten Buchung Ihre Einnahmen überweisen können. Alle Ihre persönlichen Daten werden bei Casapilot vertraulich behandelt.",
        "bic": "BIC",
        "category_forms": "Schedules ",
        "commercial_host": "Gewerblicher Vermieter",
        "compendium": "Guideline for the prices 2012",
        "compendium_description": "Discover a helpful guide to fix your rental prices. ",
        "contact_data": "Kontaktdaten",
        "contact_data_message": "Bitte geben Sie hier ausschließlich Ihre Rechnungsadresse an und keinesfalls die Adresse Ihrer Ferienimmobilie.",
        "edit_payment": null,
        "house_rules": "House Rules",
        "iban": "IBAN",
        "invoice_city": "Ort",
        "invoice_company": "Firma",
        "invoice_country": "Land",
        "invoice_fax": "Fax",
        "invoice_house_number": "Hausnummer",
        "invoice_mobile_phone": "Mobiltelefon",
        "invoice_name": "Name",
        "invoice_of_stay": "Invoice of stay",
        "invoice_of_stay_description": "This form helps you to charge your guests at the end of the stay.",
        "invoice_of_stay_link": "/downloads/invoice_of_stay/Invoice_of_stay.pdf",
        "invoice_partner_agency": "Partneragentur",
        "invoice_phone": "Telefon",
        "invoice_postal_code": "PLZ",
        "invoice_street": "Straße / Hausnummer",
        "invoice_website": "Webseite",
        "kaution": "Desposit form",
        "kaution_description": "The client has to pay the deposit on the arrival. The deposit serves in case of abuse.",
        "kaution_link": "/downloads/deposit.pdf",
        "kind_of_host": "Vermieterart",
        "message": "In order to help you to take care of your guests, we provide here two practical forms. You can download and print them.",
        "private_host": "Privater Vermieter",
        "title": "Forms",
        "vat_rate": "Umsatzsteuer-ID",
        "wellness": {
          "pool": "Hot tub and swimming pool",
          "sauna": "Sauna",
          "title": "Safety rules for sauna, hot tub and swimming pool"
        }
      },
      "edit_payment": {
        "bank_data": "Bank data",
        "bank_data_message": "Please enter your bank details so that we are able to transfer your money for each booking of yours. All your personal information keeps confidential.",
        "bic": "BIC",
        "commercial_host": "Professional owner",
        "contact_data": "Contact Information ",
        "contact_data_message": "Please insert your billing address and not the address of your rental property.\n",
        "iban": "IBAN",
        "invoice_city": "City",
        "invoice_company": "Company",
        "invoice_country": "Country",
        "invoice_fax": "Fax",
        "invoice_house_number": "Street number",
        "invoice_mobile_phone": "Mobile phone",
        "invoice_name": "Name",
        "invoice_partner_agency": "Partner Agency",
        "invoice_phone": "Phone",
        "invoice_postal_code": "Postcode",
        "invoice_street": "Street / House number",
        "invoice_website": "Personal website",
        "kind_of_host": "Type of owner",
        "private_host": "Private owner",
        "title": "Payment information ",
        "vat_rate": "VAT Reg No"
      },
      "edit_tenant": {
        "key_hand_over": "Address for key exchange ",
        "key_hand_over_city": "City",
        "key_hand_over_country": "Country",
        "key_hand_over_different_place": "Location of key exchange is not the same location where the rental property is located. ",
        "key_hand_over_name": "Name",
        "key_hand_over_postal_code": "Postcode",
        "key_hand_over_street": "Street",
        "more_languages": "Other languages ",
        "mother_tongue": "Mother tongue",
        "other_language_1": "German",
        "other_language_2": "English",
        "other_language_3": "French",
        "other_language_4": "Nederlands",
        "other_language_5": "Spanish",
        "title": "Information for your renters "
      }
    },
    "regular_costs": "General costs",
    "rentable_units": "Units to rent",
    "reservations": "Bookings",
    "room": "Room",
    "rooms": "Bedrooms",
    "save_description": "Save description",
    "save_image": "Save picture",
    "season_msg": "For organizational reasons, you only can edit the availability up to and including 01/09/2026. You will be informed once the processing of the availability for the season 2026 is activated.",
    "show": "View all",
    "single_beds": "Single beds",
    "size_capacity": "Size and capacity",
    "square_meters": "Living area",
    "star": "Star",
    "star_rating": "Stars-Evaluation",
    "stars": "Stars",
    "status_revision": "Validation in progress",
    "status_visible": "This accommodation is validated and available for booking.",
    "suite": "Suite",
    "summer_price": "(summer)",
    "tenant": "information for your customers",
    "thumb_fallback": "/images/thumb_fallback.gif",
    "to": "until",
    "travel_bookings": {
      "index": {
        "availability": "Check availability",
        "booking_period": "Booking period (arrival date)",
        "cancelled": "Refused",
        "confirmed": "Confirmed",
        "date_of_receipt": "Date of receipt",
        "details": "Details",
        "sort": "Sort by",
        "sort_by_ref_code": "Suche nach Buchungsnummer"
      },
      "show": {
        "accommodation_id": "Accommodation ID",
        "accommodation_name": "Name",
        "accomoodation": "Accommodation",
        "bond": "Security deposit",
        "booking": "Booking",
        "booking_created_at": "Booked on",
        "booking_id": "Booking number",
        "booking_process": "Booking process",
        "checkin": "Check-In",
        "checkout": "Check-Out",
        "costs": "Costs",
        "extra_bring": "To bring",
        "extra_cost": "Incidental costs",
        "guest": "Tenant",
        "host_total": "Rental income",
        "on_request": "On request",
        "optional_cost": "Optional costs",
        "overview": "« Back to overview",
        "stay": "Stay",
        "tenant_information": "Information about the tenant",
        "tenant_name": "Name of the tenant",
        "tenant_phone_number": "Phone number of the tenant",
        "title": "Request details for object:"
      }
    },
    "update": "Next",
    "winter_price": "(winter)",
    "you_have_got": "You have got"
  },
  "host_details": {
    "included": "included",
    "on_request": "On request",
    "see_additional_costs": "Please note the information under “Additional costs“",
    "to_be_brought": "Has to be brought"
  },
  "host_navigation": {
    "account": "Profile",
    "dashboard": "Cockpit",
    "messages": "Messages",
    "objects": "Objects",
    "reservations": "Bookings",
    "teaser_host": "Do you want to rent an accommodation? Register now and earn more."
  },
  "host_teaser": {
    "button": "Go to offer",
    "number_of_baths": "Number of bathrooms",
    "number_of_persons": "Persons (max.)",
    "number_of_rooms": "Number of bedrooms"
  },
  "i18n": {
    "transliterate": {
      "rule": {
        "À": "a",
        "Á": "a",
        "Â": "a",
        "Ä": "ae",
        "Æ": "ae",
        "Ç": "c",
        "È": "e",
        "É": "e",
        "Ê": "e",
        "Ë": "e",
        "Í": "i",
        "Î": "i",
        "Ï": "i",
        "Ñ": "n",
        "Ó": "o",
        "Ô": "o",
        "Ö": "oe",
        "Ù": "u",
        "Ú": "u",
        "Û": "u",
        "Ü": "ue",
        "ß": "ss",
        "à": "a",
        "á": "a",
        "â": "a",
        "ä": "ue",
        "æ": "ae",
        "ç": "c",
        "è": "e",
        "é": "e",
        "ê": "e",
        "ë": "e",
        "í": "i",
        "î": "i",
        "ï": "i",
        "ñ": "n",
        "ó": "o",
        "ô": "o",
        "ö": "oe",
        "ù": "u",
        "ú": "u",
        "û": "u",
        "ü": "ue",
        "ÿ": "y",
        "Œ": "oe",
        "œ": "oe",
        "Ÿ": "y"
      }
    }
  },
  "icons": {
    "first": "start",
    "last": "end",
    "next": "forward",
    "previous": "back"
  },
  "inquiry_form": {
    "fail_notification": "Your enquiry wasn't transmitted successfully. Please try again later.",
    "inquiry_to": "Enquiry Accommodation ID: ",
    "send_button": "Send Enquiry",
    "text": "Feel free to send us here under a non-binding enquiry.",
    "thank_you_1": "Thank you for your enquiry at Casapilot.",
    "thank_you_2": "We will answer you as soon as possible."
  },
  "landing_page": {
    "ardennen": {
      "goto": "Ardennes Special"
    },
    "austria": {
      "goto": "Austria Special"
    },
    "cotedazur": {
      "goto": "Côte d'Azur Special"
    },
    "france": {
      "goto": "France Special"
    },
    "ibiza": {
      "goto": "Ibiza Special"
    },
    "luxemburg": {
      "goto": "Zum Luxemburg Special"
    },
    "mallorca": {
      "goto": "Mallorca Special"
    },
    "more": "More holiday homes",
    "more_at": "More holiday homes at",
    "more_objects": "All properties",
    "spain": {
      "goto": "Spain Special"
    },
    "wellnesssuites": {
      "goto": "Wellness Suites Special"
    }
  },
  "landing_page_teaser": {
    "title": "Obtain vouchers at reduced prices now"
  },
  "mailer": {
    "attributes": {
      "approval_mailer": {
        "subject": "Accommodation validation"
      },
      "invitation_mailer": {
        "subject": "Invitation to Casapilot"
      },
      "travel_booking_mailer": {
        "confirm": {
          "subject": "Your booking confirmation of %{name}, %{id}"
        },
        "credit_note": {
          "subject": "Your credit rating  %{name}, %{id}"
        },
        "payment": {
          "subject": "Your payment confirmation %{name}, %{id}"
        },
        "reservation": {
          "subject": "Your booking order of %{id}"
        },
        "reservation_host": {
          "subject": "Your booking confirmation of %{name} (%{id})"
        },
        "voucher": {
          "subject": "Your ticket to stay  %{name}, %{id}"
        }
      }
    },
    "models": {
      "approval_mailer": "Approval",
      "invitation_mailer": "Invitation"
    }
  },
  "meta": {
    "description": "Rent your holiday home with Casapilot. Quickly and easily find and book cheap deals from all over Europe!",
    "keywords": "Holiday apartment, book villa, apartment, finca, chalet, cottage, Last Minute, Holidays, Ski holidays, cheap travel, apartment, B&B, group accommodations, holidays, residence, ski lodge, rent, travel, accommodation, bungalow, summer holidays, winter holidays, New Year, Christmas, Spain, Ardennes, Mallorca, Southern France, book, Austria, cheap holiday. ",
    "title": "casapilot | %{title}"
  },
  "not_found": {
    "back_to_homepage": "Back to homepage",
    "description": "Apologies, there was a problem. If you have just completed a booking, please contact our booking hotline: or try again.",
    "number": "+352 20 20 34 33",
    "title": "Sorry, an error has occurred. Please try again."
  },
  "notepad": {
    "add": "Add",
    "full": "You can add max. 25 objects to the wishlist. ",
    "headline": "There are",
    "headline_part_two": "on your wish list",
    "none": "no",
    "notepad": "Wish list",
    "object": "Object",
    "objects": "Objects",
    "remember": "Mark",
    "remove": "Remove",
    "remove_full": "Remove from wish list",
    "search": "Search"
  },
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "negative_format": "-%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "€"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "round_mode": "default",
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "human": {
      "decimal_units": {
        "format": "%n %u",
        "units": {
          "billion": "Billion",
          "million": "Million",
          "quadrillion": "Quadrillion",
          "thousand": "Thousand",
          "trillion": "Trillion",
          "unit": ""
        }
      },
      "format": {
        "delimiter": "",
        "precision": 1,
        "significant": true,
        "strip_insignificant_zeros": true
      },
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "eb": "EB",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "pb": "PB",
          "tb": "TB",
          "zb": "ZB"
        }
      }
    },
    "nth": {
      "ordinalized": "#<Proc:0x000000010b979508 /Users/patrik/.rbenv/versions/3.2.2/lib/ruby/gems/3.2.0/gems/activesupport-6.1.7.6/lib/active_support/locale/en.rb:26 (lambda)>",
      "ordinals": "#<Proc:0x000000010b979530 /Users/patrik/.rbenv/versions/3.2.2/lib/ruby/gems/3.2.0/gems/activesupport-6.1.7.6/lib/active_support/locale/en.rb:7 (lambda)>"
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%"
      }
    },
    "precision": {
      "format": {
        "delimiter": ""
      }
    }
  },
  "payment_confirmation": "Payment confirmation",
  "previews": {
    "back_to_homepage": "Back to homepage",
    "back_to_search": "Back to search results",
    "submit": "Book"
  },
  "price": {
    "activate_standard_prices": "Enable standard prices",
    "add_new_season_price": "Add a new season price",
    "add_new_standard_price": "Add a new standard price",
    "alternatives": "Alternatives:",
    "available_dates": "Available dates:",
    "check_in": "Check-in:",
    "check_in_time": "Check-in time:",
    "check_out": "Check-out:",
    "check_out_time": "Check-out time:",
    "currency_symbol": "€",
    "current_season_prices": "Current season prices",
    "current_season_prices_info": "Prices will be defined for a specific time period",
    "current_standard_prices": "Current standard prices",
    "current_standard_prices_info": "Prices are for the whole year",
    "customer_price": "Price for customer",
    "duplicate_season_price": "Duplicate season prices to next year",
    "edit_season_price": "Adapt the season prices",
    "euro_per_long_weekend": "€ per long weekend",
    "euro_per_night": "€ per night",
    "euro_per_stay": "€ per stay",
    "euro_per_week": "€ per week ",
    "euro_per_weekend": "€ per weekend",
    "from": "From",
    "long_weekend_consists_of": "long weekend consists of  ",
    "lump_long_weekend": "Long weekend ",
    "lump_long_weekend_short": "Long weekend ",
    "lump_week": "Week",
    "lump_weekend": "Weekend",
    "more_price_options": "More prices options ? Set up a new pricing group.",
    "nightly_week": "Single night",
    "nightly_week_season": "Single night ",
    "nightly_weekend": "Night on the weekend  ",
    "nightly_weekend_season": "Single night on the weekend  ",
    "no_prices": " No prices have been entered. ",
    "no_rotation_day": "Arrival at any day of the week",
    "not_available": "Choose another arrival day or adjust the number of nights.",
    "per_night": "per night",
    "per_stay": "per stay ",
    "per_week": "per week",
    "per_weekend": "per weekend",
    "price": "Price",
    "price_lump_long_weekend": "Assign price for long weekend  ",
    "price_lump_week": "Assign price for a week",
    "price_per_night": "price per night ",
    "price_single_night": "Assign price for a single night",
    "price_single_night_weekend": "Assign a price for a weekend night",
    "price_stay_weekdays": "Assign a price for a midweek",
    "season_price_text": "Seasonal prices are only valid if you have defined a time period. Seasonal prices are not required before a property can be released for advertisement. ",
    "season_prices": "Season price",
    "season_title": "Name of the season",
    "single_night": "Price for a single night  ",
    "single_night_weekend": "Price for a weekend night",
    "standard_price": "Standard price",
    "standard_price_text": "Enter at least a standard price, so that your property can be released for advertisement. We recommend that you enter all standard prices, which is not required, however. Standard prices are valid throughout the booking year. ",
    "standard_price_text_2": "If you want to set another price for a certain season, please enter the seasonal price at the bottom.",
    "standard_prices": "Standard price",
    "stay_weekdays": "Price for a midweek",
    "tooltip_lump_long_weekend": "A  complete long weekend generally includes three successive nights. ",
    "tooltip_nightly_week": "An individual night is based on a single night’s stay during the week, between Monday and Thursday. ",
    "tooltip_nightly_weekend": "An individual weekend night is based on a single night’s stay on the weekend, between Friday and Sunday.",
    "tooltip_stay_underweek": "Usually a stay during the week begins Monday and ends on Friday.",
    "tooltip_stay_weekdays": "A stay during the week refers to a night during the week rate.",
    "under_week": "Midweek",
    "week_period": "Price for a stay during the week",
    "week_period_consists_of": "This price is valid for consecutive nights during the week",
    "week_starts": "A holiday week starts",
    "weekend_consists_of": "This price applies for the following nights",
    "what_is_common": "What is common ?",
    "what_is_common_1": "A holiday week usually starts on Fridays (Benelux) or Saturdays (rest of Europe)",
    "what_is_common_2": "The price for the weekends is usually a composition of Friday and Saturday night",
    "whole_weekend": "Assign a price for the weekend",
    "your_price": "You earn"
  },
  "processing": {
    "booking": {
      "booking_form": {
        "amex": "American Express",
        "bank_transfer": "Bank transfer",
        "credit_card": "Mastercard, Visa, Maestro",
        "payment_charge": "Booking fee",
        "payment_method": "Payment method",
        "payment_method_expl": "If paying by credit card, you have to pay additional credit card fees. These are automatically added to the total price. "
      }
    }
  },
  "renter": {
    "contact": "Contact information",
    "terms_of_service_html": "I confirm that I have read, understood and accepted the <a href=\"/downloads/terms-conditions/guest-en\" target=\"_blank\">Terms and Conditions</ a>."
  },
  "reserved": "Booked",
  "reviews": {
    "accommodation": "Accommodation",
    "cancel_correct": "Go back and correct",
    "confirm": "Confirm",
    "confirmation_intro": "Please review your recommendation. Can it be published like this?",
    "intro_1": "Your feedback counts: Your recommendation helps other Casapilot users to select the accommodation that’s right for them and us to understand better how you experienced your stay.",
    "intro_2": "Thanks for taking the time!",
    "mailers": {
      "host_reaction_subject": "A guest posted a review",
      "invitation_reminder_subject": "Friendly reminder: How was your stay?",
      "invitation_subject": "How was your stay?"
    },
    "nps_headline": "How likely is is that you recommend Casapilot?",
    "nps_unlikely": "Unlikely",
    "nps_very_likely": "Very likely",
    "question_area": "How was the location of the accommodation?",
    "question_cleanliness": "How clean was the accommodation?",
    "question_comfort": "How satisfied were you with the comfort?",
    "question_value": "How was the cost/benefit ratio of the accommodation?",
    "rating_headline": "How satisfied have you been with the accommodation?",
    "rating_no_selection": "Please select",
    "rating_selection_1": "1 - Not satisfied",
    "rating_selection_2": "2 - Rather dissatisfied",
    "rating_selection_3": "3 - Neutral",
    "rating_selection_4": "4 - Rather satisfied",
    "rating_selection_5": "5 - Very satisfied",
    "remaining_chars": "Remaining chracters",
    "review_author": "Author of the recommendation",
    "review_headline": "Please write a short recommendation. What was good? What can be improved?",
    "submit": "Submit",
    "success_title": "Thank you",
    "supbmit": "Indienen",
    "thank_you": "Thank you for your recommendation. Since we have just started asking users for recommendations, we will wait until we have enough reviews gathered before publishing.",
    "title": "Create a recommendation",
    "travel_dates": "Travel dates",
    "validation_error": "Please fill out all required fields."
  },
  "salutations": {
    "female": "Ms",
    "male": "Mister "
  },
  "search": {
    "additional_results": "Other favorite tourist destinations in",
    "adjust_filters": "Filter results",
    "adjust_request": "Adjust request",
    "all_cities": "All places",
    "all_regions": "All regions",
    "arrival": "Arrival",
    "availability": {
      "availability_for": "Availability for",
      "available": "Available",
      "calculate_price_and_availability": "Check prices and availability...",
      "check_availability": "Check availability",
      "checking": "Checking availability",
      "choose_day_of_arrival": "Please choose a day of arrival:",
      "day_of_arrival": "Arrival",
      "free": "available",
      "no_arrivals": "They are no available days of arrival for this period, please choose a different duration of stay. ",
      "not_available": "Not available",
      "occupied": "occupied",
      "on_request": "Check availability",
      "update_price_and_availability": "Refresh prices and availability ..."
    },
    "back_to_search_list": "Back to search results",
    "banner": {
      "contact_note": "Please contact us by mail or by phone.",
      "headline": "You couldn't find anything suitable? ",
      "headline_big_1": "Your search has unfortunately provided no results. ",
      "headline_big_2": "Please change your search criteria. ",
      "offer": "We are happy to help you personally in your search.",
      "offer_big": "We are happy to assist you personally in your search. "
    },
    "check_availability": "Check availability",
    "choose_city": "All places",
    "choose_region": "All regions",
    "close": "close",
    "departure": "Departure",
    "detail": {
      "allowed_pets": "Pets allowed",
      "allowed_smoking": "Smoking allowed",
      "allowed_youth": "Youth groups allowed",
      "amenities_balcony": "Balcony",
      "amenities_dish": "Dishwasher",
      "amenities_garage": "Parking",
      "amenities_garden": "Garden",
      "amenities_internet": "Internet/WiFi",
      "amenities_pool": "Pool",
      "amenities_sauna": "Sauna",
      "amenities_terasse": "Terrace",
      "amenities_tv": "TV",
      "amenities_wash": "Wash machine",
      "from": "from",
      "locality_calm": "Quietly located",
      "locality_city": "At countryside",
      "locality_mountains": "At mountain",
      "locality_nature": "In the nature",
      "locality_sea": "At sea"
    },
    "detail_search": "Detailed search",
    "exact_date": "Exact date",
    "extended_search_result": "We could not find any available accommodation for your chosen destination. Maybe the following accommodations in the surroundings could be interesting for you. ",
    "filters": {
      "activities": "Activities",
      "air_conditioning": "Air conditioning",
      "any": "Any",
      "apartment": "Apartment",
      "central_heating": "Central heating",
      "distance_to_beach": "Distance from beach",
      "features": "Characteristics",
      "fenced_garden": "Garden (fenced)",
      "holiday_home": "Holiday house",
      "jacuzzi": "Jacuzzi",
      "jacuzzi_inside": "Jacuzzi inside",
      "jacuzzi_outside": "Jacuzzi outside",
      "kind_of_property": "Type of property",
      "lake": "Lake closeby",
      "limited_mobility": "Limited mobility",
      "linen_included": "Linen included",
      "object_place": "Location",
      "ocean_view": "Sea view",
      "pets": "Pets allowed",
      "pool": "Pool",
      "pool_inside": "Pool inside",
      "pool_outside": "Pool outside",
      "sauna": "Sauna",
      "ski": "Ski",
      "stars": "Stars",
      "suite": "Luxus Suite",
      "teambuilding": "Teambuilding",
      "waterfront": "Situated at the sea/coast",
      "wifi_internet": "Wifi - internet"
    },
    "map_zoom": "Larger Map",
    "map_zoom_out": "Reduce Map",
    "mark": "Notice",
    "micro_search_no_results": "Unfortunately, there is no object for this ID.",
    "more": "more",
    "more_objects": "Other offers in this region",
    "no_results": "Your search returned no results. Please change your search criteria.",
    "objects_for_all_arrivals": "Show objects for all arrival dates. ",
    "offers_found": "Holiday proposals",
    "please_enter": "Enter your destination here",
    "reset_filters": "Remove filters and show all results",
    "results": "Search results",
    "search": "Search",
    "search_by_object_code": "ID search",
    "search_list": "New search",
    "show_availability": "Show availability",
    "size": "Size",
    "to_accomondation": "More details",
    "your_destination": "Your destination"
  },
  "sending_mails": "Mail delivery",
  "service_navigation": {
    "account": "My account"
  },
  "shared": {
    "footer": {
      "breakfast": "Breakfast",
      "breakfast_url": "https://specials.casapilot.com/shop/",
      "contact": "Contact",
      "cookie_settings": "Cookie Settings",
      "faq": "FAQ",
      "help": "Help",
      "hosts": "For Hosts",
      "imprint": "Disclaimer",
      "partners": "Partners",
      "privacy": "Privacy"
    },
    "service_navigation": {
      "host_area": "Host Area",
      "locale": {
        "de": "DE",
        "en": "EN",
        "es": "ES",
        "fr": "FR",
        "nl": "NL"
      },
      "offer_flat": "Offer your Accommodation",
      "service_navigation": {
        "account": "Account"
      },
      "user": {
        "edit": "Edit Account",
        "sign_in": "Homeowners",
        "sign_out": "Logout",
        "sign_up": "Sign up"
      },
      "vouchers": "Voucher",
      "vouchers_url": "https://shop.casapilot.com"
    },
    "sub_navigation": {
      "account": "Account",
      "bookings": "Bookings",
      "dashboard": "Dashboard",
      "objects": "Objects",
      "statistics": "Statistics"
    }
  },
  "subscription": {
    "email_error": "The e-mail address is invalid. Please check your entry.",
    "email_text": "We will keep your e-mail address confidential.",
    "headline": "Register now and stay up to date.",
    "missing_field": "Please fill in all fields."
  },
  "support": {
    "array": {
      "last_word_connector": ", and ",
      "two_words_connector": " and ",
      "words_connector": ", "
    },
    "select": {
      "prompt": "Bitte wählen:"
    }
  },
  "thank_you": {
    "copy_1": "Thank you for your interest in Casa Pilot. You will be kept up to date on all information from now on. ",
    "copy_2": "In order to complete your registration, you will shortly receive an e-mail with a confirmation link. Without this confirmation, your registration cannot be completed.",
    "copy_3": "In all of the e-mail messages you receive from us, you will find a link for canceling your registration and deleting your data.",
    "copy_4": "Your Casapilot Team",
    "empfehlen": "Please recommend us to others. ",
    "headline": "Thank you!"
  },
  "three_good_reasons": "good reasons for your holiday with casapilot.com",
  "time": {
    "am": "am",
    "formats": {
      "default": "%a, %d %b %Y %H:%M:%S %z",
      "long": "%B %d, %Y %H:%M",
      "moment": "H:mm",
      "only_second": "%S",
      "short": "%d/%m/%Y, %H:%M",
      "time": "%H:%M h"
    },
    "pm": "pm"
  },
  "travel_booking_price": {
    "booking_fee": "Booking fee",
    "costs_in_detail": "Costs in detail",
    "deposit": {
      "on_location": "Payable on location",
      "refund": {
        "instantly": "Reimbursement on departure",
        "one_week": "Reimbursement after a week",
        "two_weeks": "Reimbursement after two weeks"
      },
      "upfront": "Payable to Casapilot"
    },
    "extras": {
      "type_bring": "Bring your own",
      "type_included": "Included",
      "type_on_location": "On location",
      "type_on_request": "On request",
      "type_payable": "Must be rented",
      "type_upfront": "Upfront"
    },
    "handling_fee": "Handling Fee",
    "included": "included",
    "liability_insurance": "Liability insurance",
    "optional_costs": "Optional costs",
    "other_costs": "Other costs",
    "payable_on_location": "Payable on site",
    "payable_on_location_colon": "Payable on site:",
    "payable_to_casapilot": "Payable to Casapilot",
    "plus_other_costs": "(plus other costs)",
    "price_error": "An error occurred while determining the price.",
    "rent_fees_included": "Rent (incl. booking fee)",
    "total_amount": "Total amount",
    "withheld_from_deposit": "Withheld from the deposit:"
  },
  "travel_bookings": {
    "ical_guest_summary": "Casapilot Booking for %{title}",
    "ical_host_summary": "Booking for “%{property}” with Casapilot"
  },
  "universal_tag": {
    "cnv": {
      "conversion_lang": "85851"
    },
    "rmkt": {
      "container_id": "8811",
      "conversion_lang": "85860"
    }
  },
  "voucher": "Voucher",
  "we_book_your_holidayhome": "We can book your holiday house incl. flight and rental car.",
  "web_app_theme": {
    "accommodations": "Accommodations",
    "add": "Add",
    "administration": "Administration",
    "agency": "Call center",
    "all": "All",
    "amenities": "Facilities feature",
    "approval_status": "Status",
    "approvals": "Approvals",
    "approve": "Go live",
    "approved": "Online",
    "attractions": "Attractions",
    "cancel": "Cancel",
    "complete": "To be approved",
    "confirm": "Are you sure?",
    "console": "Console",
    "costs": "Additional costs",
    "created": "Created",
    "dashboard": "Cockpit",
    "day": "day",
    "days": "Days",
    "delete": "Delete",
    "delete_map_clipping": "Replace map section",
    "edit": "Edit",
    "editing": "Incomplete",
    "find": "Search",
    "fix_rating": "Sternekategorie fixieren?",
    "homepage": "Homepage",
    "invitations": "Invitations",
    "latest_send": "Last sent ",
    "limitations": "Specific features",
    "list": "List",
    "logout": "Logout",
    "new": "New",
    "new_users": "New user ",
    "notapproved": "Was set offline",
    "ogone": {
      "timedout": "Verbindung zum Zahlungssystem konnte nicht hergestellt werden."
    },
    "or": "or",
    "possible_extras": "Choices",
    "possible_limitations": "Options",
    "possible_units": "Possible units",
    "properties": "Properties",
    "save": "Save",
    "search_people": "Persons",
    "search_person": "Person",
    "select": {
      "prompt": "Please select"
    },
    "send": "sent",
    "show": "Show",
    "summary": "All",
    "translate": "Translations",
    "travel_bookings": "Buchungen",
    "travel_regions": "Regions",
    "unapprove": "Put offline",
    "usable_on": "Usable On",
    "users": "Users",
    "various_options": "Various Options"
  },
  "will_paginate": {
    "container_aria_label": "Pagination",
    "next_label": "»",
    "page_aria_label": "Page %{page}",
    "page_entries_info": {
      "multi_page": "Displaying %{model} %{from} - %{to} of %{count} in total",
      "multi_page_html": "Displaying %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b> of <b>%{count}</b> in total",
      "single_page": {
        "one": "Displaying 1 %{model}",
        "other": "Displaying all %{count} %{model}",
        "zero": "No %{model} found"
      },
      "single_page_html": {
        "one": "Displaying <b>1</b> %{model}",
        "other": "Displaying <b>all&nbsp;%{count}</b> %{model}",
        "zero": "No %{model} found"
      }
    },
    "page_gap": "...",
    "previous_label": "«"
  },
  "your_benefits": {
    "contact": {
      "at": {
        "number": "+352 20 20 34 26 20",
        "text": "(Available from Austria)"
      },
      "be": {
        "number": "+32 28 80 89 83",
        "text": "(Available from Belgium)"
      },
      "ch": {
        "number": "+352 20 20 34 26 20",
        "text": "(Available from Switzerland)"
      },
      "de": {
        "number": "+352 20 20 34 26 20",
        "text": "(Available from Germany)"
      },
      "email": "E-Mail: info@casapilot.com",
      "email_link": "info@casapilot.com",
      "headline": "You have questions",
      "intro": "Please contact us. We're here to help!",
      "lu": {
        "number": "+352 (0)20 20 34 26 20",
        "text": "(Available from Luxemburg)"
      },
      "opening_hours": "You can reach us by phone at local rates:",
      "opening_hours_1": "Monday–Friday from 9:00h–12:30h and 13:30h–18:00h",
      "opening_hours_2": "At weekends from 14-16",
      "partners": "Our partners",
      "phone": "Tel. +352 20 20 34 33"
    },
    "h1": "Why Casapilot?",
    "h2": "All-inclusive prices",
    "h3": "Secure booking, secure data, secure holiday",
    "h4": "Great service and very good accessibility",
    "headline_html": "The Casapilot Team",
    "intro": "Your dream vacation is our top concern. Accessibility, convenience and service play a big role. Convince yourself and you will be pleasantly surprised - we promise.",
    "list_item2_1": "The rental prices presented for a certain holiday period are final prices",
    "list_item2_2": "The costs of the damage insurance and other fees are included",
    "list_item2_3": "The possible costs of consumption on site are listed clearly visible",
    "list_item3_1": "The secured website garantuees that your personal data is protected",
    "list_item3_2": "Our certified Payment Provider garantees secure payment by bank transfer or credit card",
    "list_item4_1": "You can reach us by phone at local rates during the week and on weekends",
    "list_item4_2": "We are reachable by e-mail 24/7. We respond within 24 hours",
    "list_item4_3": "Looking for a special holiday property? We will gladly help you personally to find",
    "p1_1": "There are many good reasons why you should book your dream vacation on casapilot.com.",
    "p1_2": "The main reasons are explained in detail below:",
    "p2": "There are no unpleasant surprises for you, as our pricing system is clear and transparent:",
    "p3": "We want you to enjoy a carefree holiday. The security we offer starts with the booking and the payment, and includes every day of your vacation on site.",
    "p4": "Our 5-lingual service team is at your disposal 365 days a year. Good service is our strength.",
    "page_title": "Rent more. Earn more. With Casapilot. ",
    "positions": {
      "accounting": "Accounting",
      "business_development": "Business Development",
      "business_development_spain": "Business Development Spain",
      "ceo": "Management",
      "cio": "Technical Director",
      "design": "Interactive Design",
      "dev": "Webdevelopment ",
      "it": "IT administrator",
      "photography": "Photography",
      "pm": "Head of Project",
      "service": "Customer Service",
      "service_marketing": "Customer Service and Marketing",
      "teamleader": "Teamleader"
    }
  }
};
I18n.translations["es"] = {
  "about": {
    "h1": "Insertar y administrar fácilmente",
    "h2": "De propietario a propietario",
    "h3": "Servicio sin igual - 24 horas al día ",
    "h4": "Anunciar y alquilar en toda Europa",
    "h5": "Seguridad",
    "h6": "Condiciones atractivas",
    "link_13": "Una descripción detallada del",
    "link_23": "modelo de negocio Casapilot",
    "link_33": "se puede descargar en formato PDF. ",
    "p1": "Tener un anuncio listo en pocos pasos - este es nuestro objetivo. Un diseño transparente y muchas funciones prácticas, como por ejemplo la vista previa de los anuncios para ver si responden a las exigencias del propietario, hacen que el uso del sitio Web de Casapilot sea intuitivo y agradable. ",
    "p2": "Somos – como usted - propietarios de una casa de vacaciones que alquilamos desde hace varios años. Cuando se alquila mediante portales en línea y agentes hemos observado a menudo que los agentes externos son caros y no muy flexibles. Por ello hemos creado Casapilot. Le prometemos condiciones favorables, una alta flexibilidad y un servicio inigualable. ",
    "p3": "Estamos a su disposición 24 horas al día y 365 días al año. Para poder conseguir clientes en toda Europa, nos encargamos de la traducción de los textos descriptivos de su propiedad. Además nos encargamos de los trámites como la publicidad, las reservas, los seguros, los pagos, y facilitamos a sus clientes toda la información necesaria acerca de su casa de vacaciones. ",
    "p4": "Pensamos a nivel europeo y deseamos conseguirle clientes en toda Europa. Por lo tanto desde el comienzo Casapilot se presenta en cinco idiomas: inglés, alemán, francés, español y neerlandés.",
    "p5": "Todas las reservas se ejecutan mediante un sitio web codificado y un servicio de pagos certificado. Usted recibe el pago de cada reserva directamente después de la llegada de sus clientes. Los posibles daños causados por sus inquilinos están cubiertos por el seguro que sus inquilinos conciertan automáticamente al reservar con Casapilot. ",
    "p6": "La subscripción del anuncio es totalmente gratuita. La comisión sólo es aplicable cuando usted recibe una reserva definitiva. Aplicamos nuestra comisión sobre el precio del alquiler. Para cada reserva se aplica una comisión."
  },
  "about_us": {
    "claim": "Casapilot hace el alquiler de su casa de vacaciones fácil y rentable.",
    "headline_html": "Alquilar más. <br /> Ganar más. <br /> Con Casapilot.",
    "page_title": "Alquilar más. Ganar más. Con Casapilot."
  },
  "accommodation_reviews": {
    "area": "Alrededores",
    "cleanliness": "Limpieza",
    "comfort": "Confort",
    "hide": "Muestra menos",
    "load_more_reviews": "Cargar más evaluaciónes…",
    "review_translated": "Evaluación traducida",
    "reviews": {
      "one": "evaluación",
      "other": "evaluaciónes"
    },
    "show_more": "Mostrar más",
    "show_original": "Mostrar original",
    "show_translation": "Ver traducción",
    "value": "Calidad"
  },
  "accommodations": {
    "errors": {
      "minstay": "Por esta propiedad, se debe seleccionar una duración de estancia. Por favor, inténtalo de nuevo. %{minstay}"
    },
    "seo": {
      "in": "en",
      "kind": {
        "apartment": "Apartamento ",
        "bed_and_breakfast": "Habitaciones B&B ",
        "holiday_home": "Casa de vacaciones "
      }
    }
  },
  "activemodel": {
    "errors": {
      "template": {
        "body": "There were problems with the following fields:",
        "header": {
          "one": "1 error prohibited this %{model} from being saved",
          "other": "%{count} errors prohibited this %{model} from being saved"
        }
      }
    }
  },
  "activerecord": {
    "abbr_day_names": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "abbr_day_names_string": {
      "friday": "Fri",
      "monday": "Mon",
      "saturday": "Sat",
      "sunday": "Sun",
      "thursday": "Thu",
      "tuesday": "Tue",
      "wednesday": "Wed"
    },
    "abbr_month_names": [
      null,
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "attributes": {
      "accommodation": {
        "amenities": "Equipamiento",
        "area": "Superficie (m²)",
        "bond": "Fianza",
        "bond_refund": "Restitución de la fianza",
        "created_at": "Creado el",
        "description": "Descripción",
        "description_short": "Kurzbeschreibung",
        "fee": "Comisión (en %)",
        "filter_partition": {
          "all": "Mostrar todos los alojamientos",
          "any_missing": "falta la traducción",
          "de_missing": "sin traducción alemana",
          "en_missing": "sin traducción inglesa",
          "es_missing": "sin traducción española",
          "fr_missing": "sin traducción francesa",
          "nl_missing": "sin traducción olandesa"
        },
        "filter_partition_all": "Alle Unterkünfte anzeigen",
        "filter_partition_any_missing": "mit fehlender Übersetzung",
        "filter_partition_de_missing": "ohne deutsche Übersetzung",
        "filter_partition_en_missing": "ohne englische Übersetzung",
        "filter_partition_es_missing": "ohne spanische Übersetzung",
        "filter_partition_fr_missing": "ohne französische Übersetzung",
        "filter_partition_nl_missing": "ohne niederländische Übersetzung",
        "id": "ID",
        "kind": "Tipo",
        "max_persons": "Personas (max.)",
        "number_of_baths": "Cuarto de baño",
        "number_of_bunk_beds": "Litera doble",
        "number_of_daybeds": "Sofá cama",
        "number_of_king_size_beds": "Camas dobles",
        "number_of_rooms": "Dormitorio",
        "number_of_similar": "Número de alojamientos del mismo tipo\n",
        "number_of_single_beds": "Camas simples",
        "photos": "Fotos",
        "property_id": "Alojamiento",
        "title": "Nombre",
        "updated_at": "Actualizado",
        "user_rating": "Basisbewertung"
      },
      "amenity": {
        "apartment": "Piso",
        "bed_and_breakfast": "Bed & Breakfast ",
        "category": "Categoría",
        "created_at": "Creado el",
        "holiday_home": "Casa de vacaciones",
        "id": "ID",
        "name": "Nombre",
        "updated_at": "Actualizado el"
      },
      "attraction": {
        "category": "Categoría",
        "created_at": "Creado el",
        "id": "ID",
        "name": "Nombre",
        "updated_at": "Actualizado el"
      },
      "attraction_distance": {
        "created_at": "Creado el",
        "distance": "Distancia",
        "id": "ID",
        "updated_at": "Actualizado el"
      },
      "block": {
        "accommodation": "Casa de vacaciones/habitación",
        "beginning": "Indisponible desde",
        "created_at": "Creado el",
        "ending": "Indisponible hasta",
        "id": "ID",
        "updated_at": "Actualizado el"
      },
      "cost": {
        "created_at": "Creado el",
        "id": "ID",
        "inclusive": "incluido",
        "mandatory": "Campo obligatorio",
        "name": "Nombre",
        "per_animal": "por animal",
        "per_box": "por box",
        "per_consumption": "por consumo y precio de mercado actual",
        "per_cubic_meter": "por m³",
        "per_day": "por día",
        "per_day_and_person": "por día y persona",
        "per_day_and_piece": "por día y unidad",
        "per_hour": "por hora",
        "per_kwh": "por kWh",
        "per_liter": "por litro",
        "per_midweek": "por mitad de semana",
        "per_night": "por noche",
        "per_night_and_animal": "por noche y animal",
        "per_night_and_person": "por noche y persona",
        "per_package": "por paquete",
        "per_person": "por persona",
        "per_piece": "por unidad",
        "per_set": "por set",
        "per_stay": "por estancia",
        "per_week": "por semana",
        "per_weekend": "por semana",
        "updated_at": "Actualizado el"
      },
      "extra": {
        "breakfast": "Desayuno",
        "bring": "No incluido",
        "created_at": "Creado el",
        "dish_towels": "Trapos",
        "id": "ID",
        "included": "Incluido",
        "kind": "Tipo",
        "linen": "Ropa",
        "on_request": "previa petición",
        "optional": "Opcional",
        "payable": "Se puede reservar",
        "price": "Precio",
        "towels": "Toallas",
        "updated_at": "Actualizado el"
      },
      "inquiry_form": {
        "day_of_arrival": "Día de llegada",
        "day_of_departure": "Día de partida",
        "email": "E-mail",
        "inquiry": "Solicitud",
        "message": "Mensaje",
        "name": "Nombre",
        "object_id": "ID Alojamiento",
        "phone": "Teléfono",
        "updated_at": "Actualizado el"
      },
      "limitation": {
        "allowed": "Permitido",
        "bring_with": "Selbst mitbringen",
        "can_be_rented": "Mieten möglich",
        "created_at": "Creado el",
        "forbidden": "Prohibido",
        "id": "ID",
        "must_be_rented": "Mietverpflichtung",
        "name": "Nombre",
        "onrequest": "previa petición",
        "updated_at": "Actualizado el"
      },
      "price": {
        "accommodation": "Casa de vacaciones/habitación",
        "beginning": "Válido desde\n",
        "created_at": "Creado el",
        "default_price": "Precio estándar ",
        "ending": "Válido hasta",
        "friday": "Viernes",
        "friday_abbr": "Vie.",
        "id": "ID",
        "monday": "Lunes",
        "monday_abbr": "Lu.",
        "payment_type": "Modo de pago \n",
        "price": "Precio",
        "rotation_day": "Cambio de ropa de cama",
        "saturday": "Sábado",
        "saturday_abbr": "Sá.",
        "sunday": "Domingo",
        "sunday_abbr": "Do.",
        "thursday": "Jueves",
        "thursday_abbr": "Jue.",
        "tuesday": "Martes",
        "tuesday_abbr": "Ma.",
        "updated_at": "Actualizado el",
        "wednesday": "Miércoles",
        "wednesday_abbr": "Miér."
      },
      "property": {
        "country": "País",
        "created_at": "Creado el",
        "description": "Descripción",
        "description_short": "Breve descripción",
        "filter_partition_all": "Mostrar todas las habitaciones",
        "filter_partition_any_missing": "con traducción faltante",
        "filter_partition_de_missing": "sin traducción alemana",
        "filter_partition_en_missing": "sin traducción inglesa",
        "filter_partition_es_missing": "sin traducción española",
        "filter_partition_fr_missing": "sin traducción francesa",
        "filter_partition_nl_missing": "sin traducción holandesa",
        "id": "ID",
        "internal_memo": "Nota interna\n",
        "locality": "Lugar",
        "postal_code": "Código postal",
        "rating": "Categoría en estrellas\n",
        "region": "Región",
        "street": "Calle",
        "title": "Nombre del alojamiento",
        "top_object": "Alojamiento superior\n",
        "travel_region_id": "Región de vacaciones\n",
        "updated_at": "Actualizado el"
      },
      "property_photo": {
        "created_at": "Creado el",
        "description": "Descripción",
        "file": "Foto",
        "id": "ID",
        "updated_at": "Actualizado el"
      },
      "travel_booking": {
        "accommodation": "Unterkunft",
        "amount_total": "Rechnungsbetrag",
        "cancel_ins_amount": "Reiserücktrittsvericherung",
        "casualty_ins_amount": "Haftpflichtversicherung",
        "created_at": "Reserva creada",
        "id": "ID",
        "number_of_adults": "Erwachsene",
        "number_of_children": "Kinder",
        "number_of_infants": "Kleinkinder",
        "number_of_pets": "Haustiere",
        "ref_code": "Rechnungsnummer",
        "renter": "Mieter",
        "state": "Status",
        "travel_ins_amount": "Umfassende Reiseversicherung",
        "travel_range": "Reisezeitraum"
      },
      "travel_region": {
        "country_code": "País",
        "created_at": "Creado el",
        "custom_geocode": "Localización manual",
        "id": "ID",
        "name": "Nombre en el idioma local ",
        "updated_at": "Actualizado el"
      },
      "user": {
        "additional_emails": "Correos electrónicos adicionales",
        "additional_emails_csv": "Correos electrónicos adicionales (separados por comas)",
        "admin": "Administrador",
        "agent": "Agente de teléfono",
        "agent_lead": "Dirección de la agencia\n",
        "api_user": "Usuario API",
        "authentication_token": "Auth Token",
        "avatar": "Su foto",
        "birthday": "Aniversario",
        "cellphone": "Móvil",
        "city": "Localidad",
        "country": "País",
        "created_at": "Registrado el ",
        "current_password": "Contraseña actual ",
        "description": "Descripción",
        "email": "E-mail",
        "first_name": "Nombre",
        "host": "propietario",
        "id": "ID",
        "invoice_city": "Ciudad (Datos de contacto)",
        "invoice_company": "Empresa (Datos de contacto)",
        "invoice_country": "País (Datos de contacto)",
        "invoice_mobile_phone": "Teléfono móvil (datos de contacto)",
        "invoice_name": "Nombre (Datos de contacto)",
        "invoice_phone": "Teléfono (Datos de contacto)",
        "invoice_postal_code": "Código postal (Datos de contacto)",
        "invoice_street": "Calle (Datos de contacto)",
        "key_hand_over_city": "Ciudad (Dirección para entrega de la llave)",
        "key_hand_over_country": "País (Dirección para entrega de la llave)",
        "key_hand_over_name": "Nombre (Dirección para entrega de la llave)",
        "key_hand_over_postal_code": "Código postal (Dirección para entrega de la llave)",
        "key_hand_over_street": "Calle (Dirección para entrega de la llave)",
        "last_name": "Apellido",
        "last_sign_in_at": "Conectado por última vez el ",
        "mother_tongue": "Lengua materna",
        "name": "Nombre",
        "newsletter": "Suscribir al boletín de noticias",
        "password": "Contraseña",
        "password_confirmation": "Repetir contraseña",
        "phone": "Teléfono",
        "postal_code": "CP",
        "remember_me": "Seguir conectado",
        "remove_avatar": "Quitar la imagen ",
        "renter": "Inquilino",
        "salutation": "Tratamiento",
        "street_nr": "Calle / número",
        "terms_of_service": "Condiciones generales de venta",
        "translator": "Traductor",
        "updated_at": "Actualizado el",
        "vat_rate": "Importe IVA"
      }
    },
    "day_names": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "day_names_string": {
      "friday": "Friday",
      "monday": "Monday",
      "saturday": "Saturday",
      "sunday": "Sunday",
      "thursday": "Thursday",
      "tuesday": "Tuesday",
      "wednesday": "Wednesday"
    },
    "errors": {
      "full_messages": {
        "format": "%{attribute}%{message}"
      },
      "messages": {
        "accepted": "debe ser aceptado",
        "blank": "no puede estar en blanco",
        "confirmation": "no coincide con la confirmación",
        "empty": "no puede estar vacío",
        "equal_to": "debe ser igual a %{count}",
        "even": "debe ser par",
        "exclusion": "está reservado",
        "greater_than": "debe ser mayor que %{count}",
        "greater_than_or_equal_to": "debe ser mayor que o igual a %{count}",
        "inclusion": "no está incluido en la lista",
        "invalid": "no es válido",
        "less_than": "debe ser menor que %{count}",
        "less_than_or_equal_to": "debe ser menor que o igual a %{count}",
        "not_a_number": "no es un número",
        "not_an_integer": "debe ser un entero",
        "odd": "debe ser impar",
        "record_invalid": "La validación falló: %{errors}",
        "restrict_dependent_destroy": {
          "has_many": "Cannot delete record because dependent %{record} exist",
          "has_one": "Cannot delete record because a dependent %{record} exists"
        },
        "taken": "ya está en uso",
        "too_long": "es demasiado largo (%{count} caracteres máximo)",
        "too_short": "es demasiado corto (%{count} caracteres mínimo)",
        "wrong_length": "no tiene la longitud correcta (%{count} caracteres exactos)"
      },
      "models": {
        "amenity": {
          "attributes": {
            "name": {
              "invalid": "Sólo puede contener letras "
            }
          }
        },
        "attraction": {
          "attributes": {
            "name": {
              "invalid": "Sólo puede contener letras "
            }
          }
        },
        "block": {
          "attributes": {
            "ending": {
              "range_too_short": "Debe ser al menos un día tras el inicio del período "
            }
          }
        },
        "cost": {
          "attributes": {
            "name": {
              "invalid": "Sólo puede contener letras "
            }
          }
        },
        "extra": {
          "attributes": {
            "kind": {
              "invalid": "sólo puede contener letras"
            }
          }
        },
        "limitation": {
          "attributes": {
            "name": {
              "invalid": "Sólo puede contener letras"
            }
          }
        },
        "price": {
          "attributes": {
            "base": {
              "lump_price_exists": "Ya hay una tarifa global para el período ",
              "nested_season": "El traslape de períodos de temporada no es posible. Por favor, ponga los diferentes precios de temporada individualmente y consecutivamente, de modo que las fechas no se superpongan.",
              "nightly_price_exists": "Ya hay un precio para uno de los días",
              "no_night_selected": "Por favor, seleccione al menos un día de la semana.",
              "not_linked_up": "En precios globales, los días de la semana deben ser contiguos"
            },
            "ending": {
              "range_too_short": "Debe ser al menos un día tras el inicio del período de validez "
            }
          },
          "not_blank": "No está vacío \n"
        },
        "travel_region": {
          "attributes": {
            "name": {
              "invalid": "Sólo debe contener letras "
            }
          }
        }
      },
      "template": {
        "body": "Se encontraron problemas con los siguientes campos:",
        "header": {
          "one": "No se pudo guardar este/a %{model} porque se encontró 1 error",
          "other": "No se pudo guardar este/a %{model} porque se encontraron %{count} errores"
        }
      }
    },
    "models": {
      "accommodation": "Casa de vacaciones/habitación",
      "amenity": "Características del equipamiento",
      "attraction": "Atracción",
      "attraction_distance": "Distancia a atracciones",
      "block": "Período bloqueado",
      "cost": "Gastos adicionales",
      "extra": "Características opcionales",
      "limitation": "Particularidades",
      "price": "Precio",
      "property": "Alojamiento",
      "property_photo": "Foto",
      "travel_booking": "Buchung",
      "travel_region": "Región",
      "user": "Usuario"
    },
    "month_names": [
      null,
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "options": {
      "accommodation": {
        "bond_refund": {
          "instantly": "inmediatamente a la salida",
          "one_week": "una semana después de la salida",
          "two_weeks": "dos semanas después de la salida"
        },
        "kind": {
          "apartment": "Piso",
          "bed_and_breakfast": "Bed & Breakfast",
          "holiday_home": "Casa de vacaciones"
        }
      },
      "amenity": {
        "category": {
          "business": "Negocio",
          "domestic": "Equipamiento doméstico",
          "exclusive": "Wellness y ocio",
          "exterior": "Fuera",
          "general": "General",
          "location": "Sitio",
          "multimedia": "Multimedia",
          "orientation": "Orientación",
          "other": "Equipamiento para personas con movilidad reducida",
          "view": "Vista"
        }
      },
      "attraction": {
        "category": {
          "activities": "Actividades",
          "other": "Otros",
          "places": "Lugares"
        }
      },
      "extra": {
        "extra_type": {
          "bring": "No incluido",
          "included": "Incluido",
          "on_request": "previa petición",
          "payable": "Alquiler obligado"
        },
        "unit": {
          "per_night": "por noche",
          "per_night_and_person": "por noche y persona",
          "per_person": "por persona",
          "per_piece": "por unidad",
          "per_set": "por set",
          "per_stay": "por estancia"
        }
      },
      "limitation": {
        "name": {
          "allowed": "Permitido",
          "forbidden": "Prohibido",
          "onrequest": "previa petición"
        }
      },
      "price": {
        "payment_type": {
          "lump": "global",
          "nightly": "por noche"
        },
        "rotation_day": {
          "friday": "Viernes",
          "monday": "Lunes",
          "saturday": "Sábado",
          "sunday": "Domingo",
          "thursday": "Jueves",
          "tuesday": "Martes",
          "wednesday": "Miércoles"
        }
      },
      "travel_region": {
        "country_code": {
          "AD": "Andorra",
          "AE": "Emiratos Árabes Unidos",
          "AF": "Afganistán",
          "AG": "Antigua y Barbuda",
          "AI": "Anguila",
          "AL": "Albania",
          "AM": "Armenia",
          "AN": "Antillas Holandesas",
          "AO": "Angola",
          "AP": "Región de Asia / Pacífico",
          "AQ": "Antarctica",
          "AR": "Argentina",
          "AS": "Samoa Americana",
          "AT": "Austria",
          "AU": "Australia",
          "AW": "Aruba",
          "AX": "Islas de Aland",
          "AZ": "Azerbaiyán",
          "BA": "Bosnia y Herzegovina",
          "BB": "Barbados",
          "BD": "Bangladés",
          "BE": "Bélgica",
          "BF": "Burkina Faso",
          "BG": "Bulgaria",
          "BH": "Baréin",
          "BI": "Burundi",
          "BJ": "Benín",
          "BL": "San Bartolomé",
          "BM": "Bermudas",
          "BN": "Brunéi",
          "BO": "Bolivia",
          "BR": "Brasil",
          "BS": "Bahamas",
          "BT": "Bután",
          "BV": "Isla Bouvet",
          "BW": "Botsuana",
          "BY": "Bielorrusia",
          "BZ": "Belice",
          "CA": "Canadá",
          "CC": "Islas Cocos",
          "CD": "República Democrática del Congo",
          "CF": "República Centroafricana",
          "CG": "Congo",
          "CH": "Suiza",
          "CI": "Costa de Marfil",
          "CK": "Islas Cook",
          "CL": "Chile",
          "CM": "Camerún",
          "CN": "China",
          "CO": "Colombia",
          "CR": "Costa Rica",
          "CU": "Cuba",
          "CV": "Cabo Verde",
          "CX": "Isla de Navidad",
          "CY": "Chipre",
          "CZ": "República Checa",
          "DE": "Alemania",
          "DJ": "Yibuti",
          "DK": "Dinamarca",
          "DM": "Dominica",
          "DO": "República Dominicana",
          "DZ": "Argelia",
          "EC": "Ecuador",
          "EE": "Estonia",
          "EG": "Egipto",
          "EH": "Sahara Occidental",
          "ER": "Eritrea",
          "ES": "España",
          "ET": "Etiopía",
          "EU": "Europa",
          "FI": "Finlandia",
          "FJ": "Fiyi",
          "FK": "Islas Malvinas",
          "FM": "Micronesia",
          "FO": "Islas Feroe",
          "FR": "Francia",
          "FX": "Francia Metropolitana",
          "GA": "Gabón",
          "GB": "Reino Unido",
          "GD": "Granada",
          "GE": "Georgia",
          "GF": "Guyana Francesa",
          "GG": "Guernsey",
          "GH": "Ghana",
          "GI": "Gibraltar",
          "GL": "Groenlandia",
          "GM": "Gambia",
          "GN": "Guinea",
          "GP": "Guadalupe",
          "GQ": "Guinea Ecuatorial",
          "GR": "Grecia",
          "GS": "Islas Georgias del Sur y Sandwich del Sur",
          "GT": "Guatemala",
          "GU": "Guam",
          "GW": "Guinea-Bissau",
          "GY": "Guyana",
          "HK": "Hong Kong",
          "HM": "Islas Heard y McDonald",
          "HN": "Honduras",
          "HR": "Croacia",
          "HT": "Haití",
          "HU": "Hungría",
          "ID": "Indonesia",
          "IE": "Irlanda",
          "IL": "Israel",
          "IM": "Isla de Man",
          "IN": "India",
          "IO": "Territorio Británico del Océano Índico",
          "IQ": "Irak",
          "IR": "República Islámica de Irán",
          "IS": "Islandia",
          "IT": "Italia",
          "JE": "Jersey",
          "JM": "Jamaica",
          "JO": "Jordania",
          "JP": "Japón",
          "KE": "Kenia",
          "KG": "Kirguistán",
          "KH": "Camboya",
          "KI": "Kiribati",
          "KM": "Comoras",
          "KN": "San Cristóbal y Nieves",
          "KP": "República Popular Democrática de Corea",
          "KR": "República de Corea",
          "KW": "Kuwait",
          "KY": "Islas Caimán",
          "KZ": "Kazajistán",
          "LA": "República Democrática Popular Lao",
          "LB": "Líbano",
          "LC": "Santa Lucía",
          "LI": "Liechtenstein",
          "LK": "Sri Lanka",
          "LR": "Liberia",
          "LS": "Lesoto",
          "LT": "Lituania",
          "LU": "Luxemburgo",
          "LV": "Letonia",
          "LY": "Jamahiriya Árabe Libia",
          "MA": "Marruecos",
          "MC": "Mónaco",
          "MD": "República de Moldavia",
          "ME": "Montenegro",
          "MF": "Isla de San Martín",
          "MG": "Madagascar",
          "MH": "Islas Marshall",
          "MK": "Macedonia",
          "ML": "Malí",
          "MM": "Birmania",
          "MN": "Mongolia",
          "MO": "Macao",
          "MP": "Islas Marianas del Norte",
          "MQ": "Martinica",
          "MR": "Mauritania",
          "MS": "Montserrat",
          "MT": "Malta",
          "MU": "Mauricio",
          "MV": "Maldivas",
          "MW": "Malaui",
          "MX": "México",
          "MY": "Malasia",
          "MZ": "Mozambique",
          "NA": "Namibia",
          "NC": "Nueva Caledonia",
          "NE": "Níger",
          "NF": "Isla Norfolk",
          "NG": "Nigeria",
          "NI": "Nicaragua",
          "NL": "Países Bajos",
          "NO": "Noruega",
          "NP": "Nepal",
          "NR": "Nauru",
          "NU": "Niue",
          "NZ": "Nueva Zelanda",
          "OM": "Omán",
          "PA": "Panamá",
          "PE": "Perú",
          "PF": "Polinesia Francesa",
          "PG": "Papúa Nueva Guinea",
          "PH": "Filipinas",
          "PK": "Pakistán",
          "PL": "Polonia",
          "PM": "San Pedro y Miquelón",
          "PN": "Islas Pitcairn",
          "PR": "Puerto Rico",
          "PS": "Territorio Palestino",
          "PT": "Portugal",
          "PW": "Palaos",
          "PY": "Paraguay",
          "QA": "Catar",
          "RE": "Reunión",
          "RO": "Rumania",
          "RS": "Serbia",
          "RU": "Federación Rusa",
          "RW": "Ruanda",
          "SA": "Arabia Saudita",
          "SB": "Islas Salomón",
          "SC": "Seychelles",
          "SD": "Sudán",
          "SE": "Suecia",
          "SG": "Singapur",
          "SH": "Santa Helena",
          "SI": "Eslovenia",
          "SJ": "Svalbard y Jan Mayen",
          "SK": "Eslovaquia",
          "SL": "Sierra Leona",
          "SM": "San Marino",
          "SN": "Senegal",
          "SO": "Somalia",
          "SR": "Surinam",
          "ST": "Santo Tomé y Príncipe",
          "SV": "El Salvador",
          "SY": "República Árabe Siria",
          "SZ": "Suazilandia",
          "TC": "Islas Turcas y Caicos",
          "TD": "Chad",
          "TF": "Tierras Australes Francesas",
          "TG": "Togo",
          "TH": "Tailandia",
          "TJ": "Tayikistán",
          "TK": "Tokelau",
          "TL": "Timor oriental",
          "TM": "Turkmenistán",
          "TN": "Túnez",
          "TO": "Tonga",
          "TR": "Turquía",
          "TT": "Trinidad y Tobago",
          "TV": "Tuvalu",
          "TW": "Taiwán",
          "TZ": "República Unida de Tanzania",
          "UA": "Ucrania",
          "UG": "Uganda",
          "UM": "Islas Ultramarinas de Estados Unidos",
          "US": "Estados Unidos",
          "UY": "Uruguay",
          "UZ": "Uzbekistán",
          "VA": "Santa Sede (Estado de la Ciudad del Vaticano)",
          "VC": "San Vicente y las Granadinas",
          "VE": "Venezuela",
          "VG": "Islas Vírgenes Británicas",
          "VI": "Islas Vírgenes de los Estados Unidos",
          "VN": "Vietnam",
          "VU": "Vanuatu",
          "WF": "Wallis y Futuna",
          "WS": "Samoa",
          "YE": "Yemen",
          "YT": "Mayote",
          "ZA": "Sudáfrica",
          "ZM": "Zambia",
          "ZW": "Zimbabue",
          "all": "Todos los países"
        }
      }
    },
    "order": [
      "year",
      "month",
      "day"
    ],
    "status_codes": {
      "accommodation": {
        "create_failed": "No se pudo crear la casa de vacaciones/habitación.",
        "destroyed": "La casa de vacaciones/habitación ha sido borrada.\n",
        "successfully_created": "Casa de vacaciones/habitación creada correctamente.\n",
        "successfully_updated": "Casa de vacaciones/habitación cambiada correctamente.\n",
        "update_failed": "No se pudo cambiar la casa de vacaciones/habitación.\n"
      },
      "amenity": {
        "create_failed": "No se pudo crear los datos del equipamiento.",
        "destroyed": "Datos del equipamiento eliminados.",
        "successfully_created": "Datos del equipamiento creados.",
        "successfully_updated": "Datos del equipamiento cambiados.",
        "update_failed": "No se pudo cambiar los datos del equipamiento."
      },
      "approval": {
        "successfully_updated": "Freigabe erfolgreich geändert"
      },
      "attraction": {
        "create_failed": "No se pudo crear las atracciones.",
        "destroyed": "Atracciones eliminadas.",
        "successfully_created": "Atracciones creadas.",
        "successfully_updated": "Atracciones cambiadas correctamente.",
        "update_failed": "No se pudo cambiar las atracciones."
      },
      "attraction_distance": {
        "create_failed": "No se pudo crear la distancia a atracciones.",
        "destroyed": "Distancia a atracciones eliminada.",
        "successfully_created": "Distancia a atracciones creada.",
        "successfully_updated": "Distancia a atracciones cambiada.",
        "update_failed": "No se pudo cambiar la distancia a atracciones.\n"
      },
      "block": {
        "create_failed": "No se pudo crear el período.",
        "destroyed": "Periodo eliminado.",
        "successfully_created": "Periodo creado.",
        "successfully_unblocked": "Período hecho reservable correctamente",
        "successfully_updated": "Periodo cambiado.",
        "unblocking_failed": "El período no se pudo hacer reservable",
        "update_failed": "No se pudo cambiar el período."
      },
      "cost": {
        "create_failed": "No se pudo crear los gastos adicionales.",
        "destroyed": "Gastos adicionales eliminados.",
        "successfully_created": "Gastos adicionales creados.",
        "successfully_updated": "Gastos adicionales cambiados.",
        "update_failed": "No se pudo cambiar los gastos adicionales."
      },
      "extra": {
        "create_failed": "El suplemento no ha sido creado.",
        "destroyed": "Suplemento eliminado.",
        "successfully_created": "Suplemento creado.",
        "successfully_updated": "Suplemento cambiado.",
        "update_failed": "No se pudo cambiar el suplemento."
      },
      "invitation": {
        "create_failed": "La invitación no se pudo realizar",
        "successfully_created": "Invitación realizada correctamente"
      },
      "limitation": {
        "create_failed": "No se pudo crear la particularidad.",
        "destroyed": "La particularidad ha sido eliminada.",
        "successfully_created": "Particularidad creada.",
        "successfully_updated": "Particularidad cambiada.",
        "update_failed": "No se pudo cambiar la particularidad."
      },
      "price": {
        "create_failed": "No se pudo crear el precio.",
        "destroyed": "Precio eliminado.\n",
        "nested_season": "El traslape de períodos de temporada no es posible. Por favor, ponga los diferentes precios de temporada individualmente y consecutivamente, de modo que las fechas no se superpongan.",
        "successfully_created": "Precio creado.\n",
        "successfully_updated": "Precio cambiado.",
        "update_failed": "No se pudo cambiar el precio."
      },
      "property": {
        "create_failed": "No se pudo crear el alojamiento.",
        "destroyed": "Alojamiento eliminado.",
        "successfully_created": "Alojamiento creado.\n",
        "successfully_updated": "Alojamiento cambiado.",
        "update_failed": "No se pudo cambiar el alojamiento."
      },
      "property_photo": {
        "create_failed": "No se pudo crear la imagen.",
        "destroyed": "Imagen eliminada.",
        "successfully_created": "Imagen creada.\n",
        "successfully_updated": "Imagen cambiada.\n",
        "update_failed": "No se pudo cambiar la imagen."
      },
      "travel_booking": {
        "cancel_failed": "Buchung wurde nicht storniert.",
        "confirmation_failed": "Buchung wurde nicht bestätigt.",
        "create_failed": "Buchung konnte nicht angelegt werden.",
        "destroyed": "Buchung wurde gelöscht.",
        "successfully_cancelled": "Buchung wurde storniert.",
        "successfully_confirmed": "Buchung wurde bestätigt.",
        "successfully_created": "Buchung erfolgreich angelegt.",
        "successfully_updated": "Buchung erfolgreich geändert.",
        "update_failed": "Buchung konnte nicht geändert werden."
      },
      "travel_region": {
        "create_failed": "No se pudo crear la región.",
        "destroyed": "Región eliminada.",
        "successfully_created": "Región creada.",
        "successfully_updated": "Región cambiada.",
        "update_failed": "No se pudo cambiar la región."
      },
      "user": {
        "create_failed": "No se pudo crear los datos del usuario.",
        "destroyed": "Usuario eliminado.",
        "must_be_host": "Por favor hágase arrendador (por ej. aceptar AGB [TODO])",
        "must_be_renter": "Ser inquilino! Para eso, por favor regístrese con otra dirección de correo electrónico. ",
        "successfully_created": "Usuario creado correctamente.",
        "successfully_updated": "Usuario modificado correctamente.",
        "update_failed": "No se pudo modificar los datos del usuario.",
        "wrong_date_format": "El formato de fecha es incorrecto."
      }
    }
  },
  "administration": {
    "accommodations": {
      "price_change_end_date_label": "Fin: Precios de temporada a partir de esta fecha o antes (no rellene para evitar cambiar los precios)",
      "price_change_label": "Cambio de precio (en%, no completar para no cambiar los precios)",
      "price_change_start_date_label": "Inicio: Precios de temporada que comienzan en esta fecha o después (no rellene para no cambiar los precios)"
    },
    "city_name_for_filter": "Namer der Stadt für Suchfilter",
    "landing_pages": {
      "accids": "ID-alojamiento",
      "country_code": "Länderkürzel",
      "desc": "Descripción",
      "edit": "Editar Landing Page",
      "header": "Header",
      "img": "Teaser",
      "locale": "Idioma",
      "mailer": "Texto enlace e-mail",
      "mailer_subject": "Asunto del e-mail",
      "meta_desc": "Descripción SEO",
      "meta_keyword": "Palabras claves SEO",
      "search_meta": "Región",
      "slug": "Identificador",
      "title": "Región"
    },
    "properties": {
      "form": {
        "api_blocked": "Bloquear en API"
      }
    },
    "travel_bookings": {
      "no_data": "No hay datos disponibles"
    }
  },
  "already_cancelled": "Bereits storniert",
  "already_confirmed": "Confirmado ya",
  "ancestry": {
    "cannot_delete_descendants": "Cannot delete record because it has descendants.",
    "cannot_rebuild_depth_cache": "Cannot rebuild depth cache for model without depth caching.",
    "conflicting_parent_id": "Conflicting parent id found in node %{node_id}: %{parent_id} for node %{node_id} while expecting %{expected}",
    "exclude_self": "%{class_name} cannot be a descendant of itself.",
    "invalid_ancestry_column": "Invalid format for ancestry column of node %{node_id}: %{ancestry_column}.",
    "invalid_orphan_strategy": "Invalid orphan strategy, valid ones are :rootify, :adopt, :restrict and :destroy.",
    "named_scope_depth_cache": "Named scope '%{scope_name}' is only available when depth caching is enabled.",
    "no_child_for_new_record": "No child ancestry for new record. Save record before performing tree operations.",
    "option_must_be_hash": "Options for has_ancestry must be in a hash.",
    "reference_nonexistent_node": "Reference to nonexistent node in node %{node_id}: %{ancestor_id}.",
    "unknown_depth_option": "Unknown depth option: %{scope_name}.",
    "unknown_option": "Unknown option for has_ancestry: %{key} => %{value}."
  },
  "attributes": {
    "created_at": "Créé le",
    "translations": {
      "description": "Descripción",
      "description_de": "Descripción (alemán)",
      "description_en": "Descripción (inglés)",
      "description_es": "Descripción (español)",
      "description_fr": "Descripción (francés)",
      "description_nl": "Descripción (holandés)",
      "description_short": "Kurzbeschreibung",
      "description_short_de": "Kurzbeschreibung (deutsch)",
      "description_short_en": "Kurzbeschreibung (englisch)",
      "description_short_es": "Kurzbeschreibung (spanisch)",
      "description_short_fr": "Kurzbeschreibung (französisch)",
      "description_short_nl": "Kurzbeschreibung (niederländisch)",
      "kind": "Art",
      "kind_de": "Art (deutsch)",
      "kind_en": "Art (englisch)",
      "kind_es": "Art (spanisch)",
      "kind_fr": "Art (französisch)",
      "kind_nl": "Art (niederländisch)",
      "title": "Título",
      "title_de": "Título (alemán)",
      "title_en": "Título (inglés)",
      "title_es": "Título (español)",
      "title_fr": "Título (francés)",
      "title_nl": "Título (holandés)"
    },
    "updated_at": "Modifié le"
  },
  "booking": {
    "additional_costs_host": "Gastos/consumo adicionales",
    "additional_information": "Más información",
    "additional_information_annotation": "Por favor, seleccione el número de personas y su deseado período de reservación.",
    "adult": "Adulto",
    "adults": "Adultos",
    "arrival_date": "Fecha de llegada",
    "arrival_date_annotation": "Por favor seleccione su fecha de llegada deseada.",
    "availability_check": "Compruebe que esta vivienda está disponible",
    "availability_txt": "Por favor seleccione sus fechas deseadas directamente en el calendario.",
    "available_arrival_date": "Fecha de llegada disponible",
    "available_arrival_date_annotation": "Para cambiar una fecha ya seleccionada, haga clic en una fecha alternativa.",
    "booking_headline": "Reserve „%{object_name}“ en 2 pasos",
    "booking_info": "Información de reserva",
    "booking_overview": "Resumen de su reserva",
    "booking_period": "Período",
    "booking_possible_timespace": "Fechas disponibles",
    "booking_process": "Proceso de reserva",
    "booking_process_confirmation": "Despuès de introducir su reserva, usted recibirá un correo electrónico de confirmación.",
    "booking_process_payment_details": "Después de la confirmación del propietario, usted recibrá la información de pago necesaria.",
    "booking_summary": "Resumen de su reserva ",
    "booking_timespace": "Periodo de reserva",
    "calendar_annotation": "Un momento, por favor. La disponibilidad de su vivienda se actualiza.",
    "cancellation": {
      "accept_conditions": "Con la reserva del seguro de cancelación de viaje acepto sus <a href=\"/downloads/terms-conditions/cancellation-insurance-es\" target=\"_blank\" rel=\"noopener noreferrer\">condiciones de seguro</a>.",
      "amount": "Sólo %{amount}",
      "opt_in": "Me gustaría contratar un seguro de cancelación de viaje para esta reserva."
    },
    "casualty_insurance": "incl. seguro de daño:",
    "casualty_insurance_txt": "Util en caso de daños - no deducción",
    "change": "Cambiar el período de reserva",
    "check_payment_info": "Por favor, consulte su información de pago o póngase en contacto con su banco.",
    "chid_age_full": "Niño (0-17 años) ",
    "chidren_age_full": "Niños (0-17 años)",
    "child_age17": "Niño (2-17 años)",
    "child_age2": "Niño (0-1 años)",
    "child_part_age2": "Bebé (0-1 años)",
    "child_part_age2_cost": "De eso bebés (0-1 años)",
    "children_age17": "Niños (2-17 años)",
    "children_age2": "Niños (0-1 años)",
    "children_part_age2": "Bebés (0-1 años)",
    "comment": "Notas - bono",
    "comment_label_info": "Entrar aquí el bono de viaje de este modo se obtiene después de la reserva el descuento.",
    "comment_note": "Introduzca comentarios / observaciones / código de cupón aquí.",
    "confirmation_mail": "Recibirá una confirmación por email en la siguiente dirección",
    "confirmation_spam_notice": "¿No ha recibido nuestro correo electrónico? Revise la caja de spam.",
    "confirmation_wrong_mail": "Para preguntas acerca de su reserva, póngase en contacto con nosotros via",
    "contact_host": "Información de contacto",
    "dateselect": "¿ Desea cambiar un periodo bloqueado ? Pinche en la fecha de inicio o al final del periodo y seleccione una nueva fecha (de inicio o al final) que se sustituirá al anterior.",
    "deposit": "Fianza ",
    "deposit_handling": "Restitución de la fianza",
    "duration": "Duración",
    "duration_of_stay": {
      "one": "%{count} Noche",
      "other": "%{count} Noches"
    },
    "duration_of_stay_annotation": "Seleccione su posible período de estancia - respectivo a los opciones que se pueden ver a la derecha.",
    "europeene_explanation": "Axa es el socio de Casapilot por el seguro de viaje.",
    "from": "de",
    "group": "Tu grupo",
    "group_comment": "Compilación del grupo",
    "group_max": "Edad max.",
    "group_min": "Min edad",
    "group_years": "Edad grupo",
    "group_years_sum": "%{min} – %{max} años",
    "hh_additional": "Gastos adicionales ",
    "hh_additional_tax": "Tasa de estancia ",
    "hh_agb": "Condiciones generales de venta",
    "hh_agb_annotation": "Certifico que he leído, comprendido y aceptado las condiciones generales de venta. ",
    "hh_conditions_and_prices": "Condiciones de alquiler y precios",
    "hh_inc_fees": "incl. gastos de reserva y de gestión",
    "hh_redirect_annotation_pt1": "Si la redirección automática no funciona, haga clic ",
    "hh_redirect_annotation_pt2": "aquí se",
    "hh_redirect_hl": "Redirección a Holiday Home\n",
    "hh_redirect_txt": "Usted será redirigido a nuestro socio Holiday Home.\nPor favor, sea paciente.",
    "host_contact": "Usted recibirá los datos del propietario por correo electrónico con el vale de estancia tres semanas antes de su estancia.",
    "host_cost": "Gastos adicionales no incluidos",
    "inc_fees": "incl. gastos de reserva y de gestión",
    "inc_fees_cancellation": "incl. seguro de cancelación de viaje, gastos de reserva y de gestión",
    "info_message_redirect": "Usted será automáticamente redirigido a la página principal",
    "insurance_names_txt": "Indique el nombre de todos los viajeros que asegurar. La póliza de seguro se emitirá en estos nombres.",
    "insurance_names_txt_2": "Por favor introduce cada nombre en lineas separadas o separarlos con comas. El apellido es suficiente.",
    "insurance_tos": "Seguros-Condiciones",
    "insurance_tos_html": "He leído, comprendido y aceptado los términos y condiciones del seguro.",
    "insurances": "Seguros",
    "journey": "Su viaje ",
    "limitations": "Particularidades/Restricciones",
    "mail_confirmation": "Muchas Gracias!",
    "mail_confirmation_annotation": "¿Tiene preguntas acerca del proceso de reserva? Entonces, póngase en contacto con nosotros por favor. ",
    "me_redirect_hl": "Redirección a MER-EVASION",
    "me_redirect_txt": "Usted será redirigido a nuestro socio MER-EVASION.\nPor favor, sea paciente.",
    "mv_redirect_hl": "Redirección a MONTAGNE-VACANCES ",
    "mv_redirect_txt": "Usted será redirigido a nuestro socio MONTAGNE-VACANCES.\nPor favor, sea paciente.",
    "navigation": {
      "availability": "Fechas",
      "booking_info": "Gastos",
      "payment": "Pago",
      "payment_feedback": "Confirmación",
      "payment_info": "Resumen"
    },
    "newsletter_subscription": "Deseo recibir el boletín de noticias de Casapilot. ",
    "night": "Noche",
    "nights": "Noches",
    "no_costs": "Ningun",
    "number_of_persons": "Número des personas",
    "payment": "Pago.",
    "payment_accepted": "Gracias por su reserva",
    "payment_declined": "Su pago es rechazado",
    "payment_declined_txt": "Su pago es aceptado.",
    "payment_not_possible": "El pago no es posible actualmente",
    "payment_not_possible_txt": "El pago desgraciamente no es posible ahora.",
    "payment_not_possible_txt2": "Por favor, inténtelo de nuevo más tarde o póngase en contacto con el banco emisor de la tarjeta de crédito.",
    "payment_successful": "Su pago es aceptado.",
    "pet": "Mascota",
    "pet_comment_separator": "Comentario sobre mascotas:",
    "pets": "Mascotas",
    "pets_not_allowed": "No se permiten mascotas",
    "posible_host_cost": "",
    "posible_host_cost_txt": "Los siguientes gastos no están incluidos en el precio de alquiler anterior:",
    "possible_costs_host": "Cargos opcionales de usuario de equipo especifico",
    "price_box_season_annotation": "Los precios pueden variar según la temporada.",
    "price_total": "Precio total",
    "prices_object": "Precio de la vivienda seleccionada",
    "rental_price": "Alquiler",
    "renter": {
      "birthday_format": "DD.MM.AAAA"
    },
    "reservation": {
      "failed": "Lamentablemente, el alojamiento es reservado ya. Por favor, seleccione un período diferente. "
    },
    "reservation_fee": "incl. gastos de reserva",
    "review": "Revise sus datos",
    "rotation_day": "Llegada",
    "secure": "Seguro de vacaciones con Casapilot. Garantizado.",
    "security": {
      "h1": "Su reserva",
      "h2": "La remuneración",
      "h3": "Nuestro servicio",
      "p1": "Sus datos personales serán tratados confidencialmente. ",
      "p2": "Pago seguro y fácil con el sistema cifrado de Casapilot.",
      "p3": "Si usted tiene preguntas, no dude en contactar con nosotros. "
    },
    "select_bookable_date": "Seleccione una fecha de llegada disponible",
    "select_duration": "Por favor, elija su periodo de estancia en el cuadro de selección azul.",
    "slider": {
      "month_not_available_html": "El objeto no está disponible en aquel período. ",
      "next": "Los próximos cuatro meses",
      "prev": "Los 4 meses anteriores"
    },
    "sp_redirect_hl": "Redirección a SKI-PLANET ",
    "sp_redirect_txt": "Usted será redirigido a nuestro socio SKI-PLANET.\nPor favor, sea paciente.",
    "tenant_booking": "Su reserva",
    "tenant_data": "Sus datos",
    "tenant_residence": "Su domicilio",
    "terms_of_service_html": "Certifico que he leído, comprendido y aceptado <a href=\"/downloads/terms-conditions/guest-es\" target=\"_blank\">las condiciones generales de venta</a>. ",
    "time": ". ",
    "to": "a",
    "total": "total",
    "travel_cancelation_insurance": "Seguro de viaje",
    "travel_cancelation_insurance_dash": "Seguro de viaje",
    "travel_cancelation_insurance_plus": "Seguro de cancelación incluido",
    "travel_cancelation_insurance_plus_txt": "Seguro todo riesgo incluido",
    "travel_cancelation_insurance_txt": "Riesgo de anulación o interupción de la estancia ? Puede ser util",
    "travel_insurance": "Seguro de viaje completo",
    "travel_insurance_txt": "Seguro de viaje completo",
    "traveler_options": {
      "adult": {
        "one": "%{count} Adulto",
        "other": "%{count} Adultos"
      },
      "all_children": {
        "one": "%{count} Niño (0-17 años)",
        "other": "%{count} Niños (0-17 años)"
      },
      "baby": {
        "one": "%{count} Bebé (0-1 años)",
        "other": "%{count} Bebés (0-1 años)"
      },
      "baby_parts": {
        "one": "De eso %{count} bebé (0-1 años)",
        "other": "De eso %{count} bebés (0-1 años)"
      },
      "child": {
        "one": "%{count} Niño (2-17 años)",
        "other": "%{count} Niños (2-17 años)"
      },
      "pet": {
        "one": "%{count} Mascota",
        "other": "%{count} Mascotas"
      }
    },
    "travelers": "Compañeros de viaje ",
    "try_again": "Inténtele de nuevo por favor",
    "week": "Semana",
    "weeks": "Semanas"
  },
  "booking_cancel": "Anular la reserva",
  "booking_confirmation": "Confirmación de reserva",
  "booking_confirming": "Confirmar la reserva",
  "breakfast_offer": {
    "body": "En este objeto tienes la posibilidad de <a href=\"https://specials.casapilot.com/shop/\" target=\"_blank\" rel=\"noreferrer\">reservar desayunos o menús</a> antes de tu estancia. ¡Déjese mimar con deliciosos productos de la región!",
    "title": "NUEVO: Recibe tu desayuno o menú a domicilio"
  },
  "buttons": {
    "availability": "Disponibilidad",
    "book_now": "Reserve ahora",
    "cancel": "Cancelar",
    "continue": "Continuar",
    "delete": "Borrar",
    "edit": "Editar",
    "go_to_summary": "Ir al resumen",
    "host_acct_create": "Crear una cuenta propietario",
    "login_continue": "Iniciar sesión y continuar con la reserva",
    "offers": "Nuestras ofertas ",
    "pay": "Pagar",
    "preview": "Vista previa\n",
    "price": "Precio",
    "register_continue": "Registrarse y continuar con la reserva",
    "register_property": "Registre su casa ahora",
    "renter_acct_create": "Crear una cuenta inquilino",
    "reserve_now": "Reservar",
    "save": "Guardar",
    "submit": "Guardar"
  },
  "cancellation": "Stornieren",
  "chat_tool": {
    "widget_id": ""
  },
  "confirm": "Confirmar",
  "confirmed_by_admin": "Confirmado por el administrador",
  "confirmed_by_host": "Confirmado por el propietario",
  "cookie_disclaimer": {
    "button_text": "Aceptar",
    "link_text": "Aprender más",
    "text": "<p>Casapilot utiliza cookies para fines analíticos, publicitarios y de personalización.</p>\n<p>Si continúas navegando por este sitio web, aceptas el uso de estas cookies.\n<p>Puedes cambiar en cualquier momento la configuración .</p>"
  },
  "country_codes": {
    "at": "Austria",
    "be": "Bélgica",
    "bg": "Bulgaria",
    "ch": "Suiza",
    "cy": "Chipre",
    "cz": "República Checa",
    "de": "Alemania",
    "dk": "Dinamarca",
    "ee": "Estonia",
    "es": "España",
    "false": "Noruega",
    "fi": "Finlandia",
    "fr": "Francia",
    "gb": "Reino Unido",
    "gr": "Grecia",
    "hr": "Croacia",
    "ie": "Irlanda",
    "is": "Islandia",
    "it": "Italia",
    "li": "Liechtenstein",
    "lt": "Lituania",
    "lu": "Luxemburgo",
    "lv": "Letonia",
    "mt": "Malta",
    "nl": "Países Bajos",
    "pl": "Polonia",
    "pt": "Portugal",
    "ro": "Rumanía",
    "se": "Suecia",
    "si": "Eslovenia",
    "sk": "Eslovaquia",
    "uk": "Reino Unido"
  },
  "date": {
    "abbr_day_names": [
      "Dom",
      "Lun",
      "Mar",
      "Mie",
      "Jue",
      "Vie",
      "Sab"
    ],
    "abbr_day_names_string": {
      "friday": "Vie",
      "monday": "Lun",
      "saturday": "Sab",
      "sunday": "Dom",
      "thursday": "Jue",
      "tuesday": "Mar",
      "wednesday": "Mie"
    },
    "abbr_month_names": [
      null,
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic"
    ],
    "day_names": [
      "Domingo",
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado"
    ],
    "day_names_string": {
      "friday": "Viernes",
      "monday": "Lunes",
      "saturday": "Sábado",
      "sunday": "Domingo",
      "thursday": "Jueves",
      "tuesday": "Martes",
      "wednesday": "Miércoles"
    },
    "formats": {
      "calendar_field": "%d.%m.%Y",
      "day_date_month": "dd, DD. MMM",
      "default": "%d/%m/%Y",
      "long": "%d de %B de %Y",
      "long_date": "%a. %d.%m.%y",
      "month_year": "MMMM YYYY",
      "only_day": "%e",
      "request_time_scope": "dd. DD/MM/YY",
      "short": "%d de %b"
    },
    "month_names": [
      null,
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre"
    ],
    "order": [
      "day",
      "month",
      "year"
    ]
  },
  "datetime": {
    "distance_in_words": {
      "about_x_hours": {
        "one": "alrededor de 1 hora",
        "other": "alrededor de %{count} horas"
      },
      "about_x_months": {
        "one": "alrededor de 1 mes",
        "other": "alrededor de %{count} meses"
      },
      "about_x_years": {
        "one": "alrededor de 1 año",
        "other": "alrededor de %{count} años"
      },
      "almost_x_years": {
        "one": "casi 1 año",
        "other": "casi %{count} años"
      },
      "half_a_minute": "medio minuto",
      "less_than_x_minutes": {
        "one": "menos de 1 minuto",
        "other": "menos de %{count} minutos"
      },
      "less_than_x_seconds": {
        "one": "menos de 1 segundo",
        "other": "menos de %{count} segundos"
      },
      "over_x_years": {
        "one": "más de 1 año",
        "other": "más de %{count} años"
      },
      "x_days": {
        "one": "1 día",
        "other": "%{count} días"
      },
      "x_minutes": {
        "one": "1 minuto",
        "other": "%{count} minutos"
      },
      "x_months": {
        "one": "1 mes",
        "other": "%{count} meses"
      },
      "x_seconds": {
        "one": "1 segundo",
        "other": "%{count} segundos"
      }
    },
    "prompts": {
      "day": "Día",
      "hour": "Hora",
      "minute": "Minutos",
      "month": "Mes",
      "second": "Segundos",
      "year": "Año"
    }
  },
  "days_short": {
    "friday": "Vie.",
    "monday": "Lu.",
    "saturday": "Sá.",
    "sunday": "Do.",
    "thursday": "Jue.",
    "tuesday": "Ma.",
    "wednesday": "Miér."
  },
  "devise": {
    "confirmations": {
      "confirmed": "Su cuenta conectado correctamente. ",
      "new": {
        "submit": "Enviar",
        "title": "Enviar de nuevo la información de confirmación"
      },
      "send_instructions": "En unos minutos recibirá un e-mail con instrucciones para recuperar su contraseña.",
      "send_paranoid_instructions": "If your email address exists in our database, you will receive an email with instructions for how to confirm your email address in a few minutes.",
      "updated": "Se ha modificado su contraseña. Usted está conectado."
    },
    "error_occured": "Hay un error.",
    "failure": {
      "already_authenticated": "Ya está registrado.",
      "inactive": "Su cuenta no está activa.",
      "invalid": "Datos de registro inválidos.",
      "invalid_token": "Token de autentificación inválido.",
      "last_attempt": "You have one more attempt before your account is locked.",
      "locked": "Su cuenta está bloqueada.",
      "not_found_in_database": "Invalid %{authentication_keys} or password.",
      "timeout": "Su sesión ha expirado, por favor acceda de nuevo.",
      "unauthenticated": "Debe acceder o registrarse antes de poder continuar.",
      "unconfirmed": "Debe confirmar su cuenta antes de poder continuar."
    },
    "mailer": {
      "confirmation_instructions": {
        "subject": "Por favor confirme su inscripción como usuario de www.casapilot.com"
      },
      "email_changed": {
        "subject": "Email Changed"
      },
      "password_change": {
        "subject": "Password Changed"
      },
      "reset_password_instructions": {
        "subject": "Restablecer su contraseña para www.casapilot.com"
      },
      "unlock_instructions": {
        "subject": "Se ha bloqueado su perfil en www.casapilot.com"
      }
    },
    "oauth_callbacks": {
      "failure": "No pudo acceder con la cuenta-%{kind}, porque \"%{reason}\". ",
      "success": "Conectado correctamente con la cuenta %{kind}"
    },
    "omniauth_callbacks": {
      "failure": "Could not authenticate you from %{kind} because \"%{reason}\".",
      "success": "Successfully authenticated from %{kind} account."
    },
    "passwords": {
      "edit": {
        "submit": "Guardar contraseña ",
        "title": "Cambiar contraseña"
      },
      "new": {
        "submit": "Recuperar contraseña",
        "title": "¿Olvidó su contraseña?"
      },
      "no_token": "You can't access this page without coming from a password reset email. If you do come from a password reset email, please make sure you used the full URL provided.",
      "send_instructions": "En unos minutos recibirá un e-mail con instrucciones para recuperar su contraseña.",
      "send_paranoid_instructions": "If your email address exists in our database, you will receive a password recovery link at your email address in a few minutes.",
      "updated": "Se ha modificado su contraseña. Usted está conectado.",
      "updated_not_active": "Your password has been changed successfully."
    },
    "registrations": {
      "destroyed": "Su cuenta ha sido borrada correctamente.",
      "edit": {
        "back": "Atrás",
        "cancel": {
          "description": "¿Insatisfecho?",
          "link": "Borrar mi perfil.",
          "question": "¿Está seguro?",
          "title": "Borrar perfil"
        },
        "current_hint": "(Necesita su contraseña actual para poder realizar modificaciones)",
        "password_hint": "(Dejar vacío si no se desea cambiarlo)",
        "submit": "Guardar",
        "title": "Editar perfil"
      },
      "new": {
        "newsletter_subscription": "Deseo recibir el boletín de noticias de Casapilot",
        "submit": "Crear perfil",
        "title": "Crear su propio perfil como propietario gratuitamente"
      },
      "signed_up": "Se ha registrado correctamente. Va a recibir un e-mail para la activación.\n¿No ha recibido nuestro correo electrónico? Revise la caja de spam.",
      "signed_up_but_inactive": "You have signed up successfully. However, we could not sign you in because your account is not yet activated.",
      "signed_up_but_locked": "You have signed up successfully. However, we could not sign you in because your account is locked.",
      "signed_up_but_unconfirmed": "A message with a confirmation link has been sent to your email address. Please follow the link to activate your account.",
      "update_needs_confirmation": "You updated your account successfully, but we need to verify your new email address. Please check your email and follow the confirmation link to confirm your new email address.",
      "updated": "Se han modificado correctamente los datos.",
      "updated_but_not_signed_in": "Your account has been updated successfully, but since your password was changed, you need to sign in again."
    },
    "sessions": {
      "already_signed_out": "Signed out successfully.",
      "new": {
        "login_text": "Conectarse aquí con su acceso para administrar su propiedad.",
        "submit": "Iniciar sesión",
        "title": "Quiere acceder a su cuenta de propietario? Aquí está en el correcto. "
      },
      "signed_in": "Conectado correctamente",
      "signed_out": "Desconectado correctamente"
    },
    "shared": {
      "links": {
        "confirmation": "¿No ha recibido el e-mail de confirmación?",
        "not_registered": "Aún no es miembro? ",
        "password": "¿Ha olvidado su contraseña?",
        "registered": "Ya es miembro? ",
        "sign_in": "Iniciar sesión aquí",
        "sign_up": "Registrar",
        "unlock": "¿No ha recibido información sobre el desbloqueo de su cuenta?"
      }
    },
    "unlocks": {
      "new": {
        "sumbit": "Enviar de nuevo las instrucciones para el bloqueo",
        "title": "Enviar de nuevo las instrucciones para el bloqueo"
      },
      "send_instructions": "Recibirá en unos minutos un e-mail con instrucciones para desbloquear su cuenta.",
      "send_paranoid_instructions": "If your account exists, you will receive an email with instructions for how to unlock it in a few minutes.",
      "unlocked": "Su cuenta ha sido desbloqueada. Está conectado."
    }
  },
  "errors": {
    "format": "%{attribute} %{message}",
    "messages": {
      "accepted": "debe ser aceptado",
      "already_confirmed": "ya está confirmado",
      "blank": "no puede estar en blanco",
      "confirmation": "no coincide con la confirmación",
      "confirmation_period_expired": "needs to be confirmed within %{period}, please request a new one",
      "empty": "no puede estar vacío",
      "equal_to": "debe ser igual a %{count}",
      "even": "debe ser par",
      "exclusion": "está reservado",
      "expired": "has expired, please request a new one",
      "greater_than": "debe ser mayor que %{count}",
      "greater_than_or_equal_to": "debe ser mayor que o igual a %{count}",
      "in": "must be in %{count}",
      "in_between": "must be in between %{min} and %{max}",
      "inclusion": "no está incluido en la lista",
      "invalid": "no es válido",
      "less_than": "debe ser menor que %{count}",
      "less_than_or_equal_to": "debe ser menor que o igual a %{count}",
      "model_invalid": "Validation failed: %{errors}",
      "not_a_number": "no es un número",
      "not_an_integer": "debe ser un entero",
      "not_found": "no se encontró",
      "not_locked": "no está bloqueado",
      "not_saved": {
        "one": "1 error prohibited this %{resource} from being saved:",
        "other": "%{count} errors prohibited this %{resource} from being saved:"
      },
      "odd": "debe ser impar",
      "other_than": "must be other than %{count}",
      "password_too_long": "is too long",
      "present": "must be blank",
      "required": "must exist",
      "spoofed_media_type": "has contents that are not what they are reported to be",
      "taken": "has already been taken",
      "too_long": "es demasiado largo (%{count} caracteres máximo)",
      "too_short": "es demasiado corto (%{count} caracteres mínimo)",
      "wrong_length": "no tiene la longitud correcta (%{count} caracteres exactos)"
    },
    "template": {
      "body": "Veuillez vérifier les champs suivants : ",
      "header": {
        "one": "Impossible d'enregistrer ce %{model} : 1 erreur",
        "other": "Impossible d'enregistrer ce %{model} : %{count} erreurs"
      }
    }
  },
  "extra_services": {
    "body": "In this accommodation you have the possibility to book <a href=\"https://specials.casapilot.com/shop/\">the Casapilot breakfast service</a> before your stay. Let us spoil you with delicious products from the region!",
    "bookable": {
      "1-night-only": "Reserva posible para 1 noche",
      "bikerental": "Alquiler de bicicletas bajo petición",
      "breakfast": "Desayuno bajo solicitud",
      "carcharger": "Estación de recarga para coches eléctricos bajo petición",
      "casapilot-breakfast": "Desayuno reservable en Casapilot",
      "champagne": "Bebidas de bienvenida bajo solicitud",
      "dinner": "Cena bajo solicitud",
      "dog": "Perros permitidos",
      "flowers": "Flores y decoración romántica bajo solicitud",
      "massage": "Masaje bajo solicitud",
      "pool": "Piscina",
      "sauna": "Sauna",
      "whirlpool": "Jacuzzi"
    },
    "included": {
      "1-night-only": "Reserva posible para 1 noche",
      "bikerental": "Alquiler de bicicletas incluido",
      "breakfast": "Desayuno incluido",
      "carcharger": "Estación de carga para coches eléctricos incluida",
      "casapilot-breakfast": "Desayuno incluido",
      "champagne": "Bebidas de bienvenida incluidas",
      "dinner": "Cena incluida",
      "dog": "Perros permitidos",
      "flowers": "Flores y decoración romántica incluidas",
      "massage": "Masaje incluido"
    },
    "title": "NEW: Get your breakfast delivered!"
  },
  "flash": {
    "actions": {
      "create": {
        "notice": "%{resource_name} was successfully created."
      },
      "destroy": {
        "alert": "%{resource_name} could not be destroyed.",
        "notice": "%{resource_name} was successfully destroyed."
      },
      "update": {
        "notice": "%{resource_name} was successfully updated."
      }
    },
    "alert": {
      "accept_tos": "Por favor acepta las condiciones.",
      "error_too_many_insurants": "El número de viajeros est más de 7 personas, pero no se puede aseguras más de 7 personas. Por favor, póngase en contacto con info@casapilot.com.",
      "error_try_again": "Un error ha ocurrido. Inténtalo de nuevo por favor.",
      "insert_information": "Por favor, llene los campos marcados en rojo.",
      "insert_name": "Por favor introduce 1 apellido.",
      "insert_names_1": "Por favor, introduzca exactamente %{count} apellidos.",
      "insert_names_2": "apellidos introducidos.",
      "insurance_error_prebook_period_to_long": "Su estancia tiene que empezar dentro de un año.",
      "insurance_over_tenthousand": "El costo máximo asegurable por seguro de viaje es de 10.000,00 € por persona.",
      "insurance_product": "Un error con los productos de seguro ha ocurrido. Inténtalo de nuevo por favor."
    }
  },
  "footer": {
    "about": "Sobre Casapilot",
    "contact_link": "info@casapilot.com?subject=www.casapilot.com ",
    "follow_us": "Síguenos en",
    "imprint_link": "/es/about/imprint",
    "support": "Support",
    "team_cpl": "El equipo Casapilot",
    "team_cpl_link": "https://www.casapilot.com/es/your_benefits",
    "vouchers": "Voucher",
    "vouchers_link": "https://shop.casapilot.com/es"
  },
  "header": {
    "facebook_link": "http://www.facebook.com/casapilot.es",
    "hyves_link": "http://www.hyves-share.nl/button/tip/?tipcategoryid=12&rating=5&title=Casapilot&body=www.casapilot.com",
    "phone_annotation_host": "¿Usted tiene preguntas? Póngase en contacto con nosotros:",
    "phone_annotation_renter": "Línea directa reservación:",
    "phone_host": "Teléfono +352 20 20 34 33",
    "phone_renter": "+352 20 20 34 33",
    "twitter_link": "http://twitter.com/?status=http%3A%2F%2Fwww.casapilot.com\nheader.twitter_link"
  },
  "helpers": {
    "label": {
      "holiday_home": {
        "accommodation_amenities": "Equipamiento",
        "accommodation_area": "Superficie vivienda (m²)",
        "accommodation_bond": "Fianza (€)",
        "accommodation_bond_refund": "Restitución de la fianza",
        "accommodation_created_at": "Creado el",
        "accommodation_description": "Descripción",
        "accommodation_fee": "Comisión (en %)",
        "accommodation_id": "ID",
        "accommodation_kind": "Tipo de alojamiento",
        "accommodation_max_persons": "Personas (max.)",
        "accommodation_number_of_baths": "Baños",
        "accommodation_number_of_bunk_beds": "Litera doble",
        "accommodation_number_of_daybeds": "Sofás cama",
        "accommodation_number_of_king_size_beds": "Camas dobles",
        "accommodation_number_of_rooms": "Dormitorio",
        "accommodation_number_of_similar": "Número de alojamientos del mismo tipo\n",
        "accommodation_number_of_single_beds": "Camas simples",
        "accommodation_photos": "Fotos",
        "accommodation_property_id": "Alojamiento",
        "accommodation_title": "Título",
        "accommodation_updated_at": "Actualizado el",
        "property_country": "País",
        "property_created_at": "Creado el",
        "property_description": "Descripción",
        "property_id": "ID",
        "property_locality": "Ciudad",
        "property_postal_code": "Código postal",
        "property_rating": "Categoría en estrellas\n",
        "property_region": "Región",
        "property_street": "Calle",
        "property_title": "Nombre del alojamiento",
        "property_top_object": "Propiedad superior\n",
        "property_travel_region_id": "Región de vacaciones",
        "property_updated_at": "Actualizado el"
      },
      "subscription": {
        "country": "Situación del alojamiento\n",
        "email": "E-mail",
        "kind": "Dispongo de\n",
        "kind_apartment": "Piso ",
        "kind_bed_and_breakfast": "Bed & Breakfast ",
        "kind_vacation_rental": "Casa de vacaciones ",
        "language": "Su idioma"
      }
    },
    "select": {
      "prompt": "Por favor seleccione"
    },
    "submit": {
      "create": "Guardar %{model}",
      "submit": "Guardar %{model}",
      "update": "Actualizar %{model}"
    }
  },
  "home": {
    "teaser": {
      "text_1": "Podemos reservar su casa de vacaciones incl. vuelo. <br /> <strong>Línea directa reservación:</strong> <br /> +34 93 18 45 049",
      "text_2": "Su sociedad de Luxemburgo",
      "text_3": "¿Por qué reservar con Casapilot?<br />Buenos precios, reserve de forma segura, servicio 5 estrellas\n"
    }
  },
  "homepage": {
    "checks": {
      "headline_1": "Insertar gratuitamente\n",
      "headline_2": "Ingresos por anticipado\n",
      "headline_3": "Decide los precios por sí mismo",
      "headline_4": "Permanece flexible\n",
      "text_1": "El anuncio de su propiedad es gratuito.",
      "text_2": "En caso de alquiler le pagamos el importe dos semanas antes de la llegada de los clientes.\n",
      "text_3": "Solamente usted decide la tarifa a la que se alquila su propiedad.",
      "text_4": "Usted decide el período en que su propiedad está disponible."
    },
    "counter_text": "Casas de vacaciones",
    "counter_text_single": "Casa de vacaciones",
    "head_title": "casas seleccionadas",
    "headline": "Alquile su casa de vacaciones fácilmente con Casapilot.",
    "intro_text_1": "Casapilot es su nuevo socio en el alquiler de su casa de vacaciones y de su oferta de habitación y desayuno.",
    "intro_text_2": "Inscríbase ya para estar al corriente y ser el primero cuando nuestra nueva plataforma esté disponible.",
    "intro_text_3": "Conseguimos nuevos clientes para usted.",
    "relax_cottage_stoerer": {
      "headline": "Suite bienestar - Noite de Núpcias",
      "text": "Bienestar suites con jacuzzi en un entorno exclusivo<br/>para una escapada romántica con su compañero."
    },
    "subscription_form": {
      "country": {
        "andorra": "Andorra",
        "austria": "Austria",
        "belgium": "Bélgica",
        "croatia": "Croacia",
        "danemark": "Dinamarca",
        "finland": "Finlandia",
        "france": "Francia",
        "germany": "Alemania",
        "great_britain": "Inglaterra",
        "greece": "Grecia",
        "hungary": "Hungría",
        "ibiza": "Ibiza",
        "island": "Islandia",
        "italy": "Italia",
        "liechtenstein": "Liechtenstein",
        "luxemburg": "Luxemburgo",
        "malta": "Malta",
        "monaco": "Mónaco",
        "nederland": "Holanda",
        "norway": "Noruega",
        "poland": "Polonia",
        "portugal": "Portugal",
        "scotland": "Escocia",
        "spain": "España",
        "sweden": "Suecia",
        "switzerland": "Suiza"
      },
      "email": "correo electrónico",
      "email_text": "Trataremos su dirección de correo electrónico confidencialmente.",
      "headline": "Inscríbase ahora para estar al corriente.",
      "language": {
        "de": "Alemán",
        "en": "Inglés",
        "es": "Hispanos",
        "fr": "Francés",
        "nl": "Holandés"
      },
      "submit": "Anotar ahora"
    }
  },
  "homepage_customer": {
    "book_object": "Reservar",
    "country": "Destino de vacaciones",
    "head_title": "selected homes",
    "headline": "Apartamentos y casas de vacaciones seleccionados para usted",
    "hosts": {
      "headline": "Encuentra los mejores alquileres vacacionales"
    },
    "intro_headline": "¿Por qué reservar su estancia con Casapilot?",
    "intro_text_1": "Nuestros principios son simples, nuestra búsqueda es simple, sus vacaciones son fáciles. Simplemente.",
    "intro_text_1_hl": "Simple.",
    "intro_text_2": "Revisamos todos nuestros artículos cuidadosamente y elegimos personalmente. Entonces sólo, se convierte en un alojamiento Casapilot.",
    "intro_text_2_hl": "Seleccionado.",
    "intro_text_3": "Cuando se llega todo está allí. Si tiene un problema, estamos disponible. Se puede confiar en nosotros.",
    "intro_text_3_hl": "Fiable.",
    "landingpage": {
      "headline": "Los mejores lugares de vacaciones "
    },
    "last_viewed_objects": "Alojamientos vistos recientemente",
    "objects_foot_hl": "Tambien le podría gustar a",
    "prebook_object": "Notar",
    "reserve": "Reservar ",
    "search_arrival": "Llegada",
    "search_button": "Buscar",
    "search_category_1": "En familia",
    "search_category_2": "En pareja",
    "search_category_3": "Aventura",
    "search_category_4": "Descanso",
    "search_category_5": "Más sugerencias",
    "search_departure": "Salida",
    "search_detail": "Búsqueda detallada",
    "search_headline": "Aquí se empiezan sus vacaciones. ",
    "see_object": "Mostrar",
    "slideshow": {
      "ardennen": "Casas de vacaciones en las Ardenas",
      "ardennen_desc": "Goce de la tranquilidad rural y descubre los numerosos senderos y pistas para ciclistas. Disfrute de las muchas actividades recreativas que la región puede ofrecer.",
      "austria": "Casas de vacaciones en Austria",
      "austria_desc": "Invierno o verano, Austria siempre vale la pena una visita. En el verano usted puede explorar senderos o hacer visitas culturales y en invierno se puede disfrutar de las pistas de esquí.",
      "cotedazur": "Casas de vacaciones en la Costa Azul",
      "cotedazur_desc": "Probablemente la línea costera más famosa de Europa. Déjese encantar por numerosas tiendas y comercios, la fantástica cocina francesa y hermosas playas.",
      "france": "Casas de vacaciones en Francia",
      "france_desc": "Descubre las casas de vacaciones más bellas de Francia. Visite los lugares más conocidos al interior del país, como en la costa. Los magníficos paisajes le invitan a pasar unas vacaciones memorables. ",
      "ibiza": "Casas de vacaciones en Ibiza",
      "ibiza_desc": "No perde el lujo en la isla mediterránea exclusiva! Hermosas playas y la vida nocturna garantizan una estancia inolvidable en Ibiza.",
      "luxemburg": "Luxemburg",
      "luxemburg_desc": "",
      "mallorca": "Casas de vacaciones Mallorca",
      "mallorca_desc": "Descubre las hermosas playas y las zonas rurales de la isla mediterránea popular. Disfrute de sus vacaciones en una acogedora finca o una hermosa villa. ",
      "spain": "Casas de vacaciones en España",
      "spain_desc": "Descubre los lugares más bellos de la península española y de su costa con playas maravillosas. Pase unas vacaciones memorables en una casa da vacaciones en Málaga, la Costa del Sol, la Costa Blanca, la Costa Brava,… ",
      "wellnesssuites": "Suite bienestar - Noite de Núpcias",
      "wellnesssuites_desc": "Bienestar suites con jacuzzi en un entorno exclusivo para una escapada romántica con su compañero. Recién casados, aniversario o como un regalo, nuestras suites ofrecen lujo y descanso a cada pareja."
    }
  },
  "host": {
    "ab": "desde",
    "accept_agbs": "Por favor acepte las condiciones generales de venta.",
    "accommodation": "Alojamiento",
    "accommodation_number_of_beds_zero": "Por favor, introduzca al menos un tip y el número de cama.",
    "accommodation_reviews": "Reviews",
    "accommodations": {
      "prices": {
        "day_of_arrival": "Día de llegada",
        "day_of_departure": "Día de partida ",
        "friday": "Viernes",
        "monday": "Lunes",
        "sunday": "Domingo"
      },
      "suggestions": "Nuestras sugerencias para usted"
    },
    "add_image": "Añadir foto",
    "add_new_accommodation": "Añadir nueva información",
    "add_new_property": "Añadir alojamiento",
    "add_new_room": "Agregar una nueva cámara",
    "additional_costs": "Gastos adicionales",
    "adress": "Dirección",
    "all_properties": "Todos los alojamientos de",
    "amenities": "Características",
    "amount_bathrooms": "Número de baños desde",
    "amount_bedrooms": "Cantidad de habitaciones",
    "amount_rooms": "Número de habitaciones",
    "apartment": "Apartamento",
    "as": "como",
    "attractions": "Ambiente",
    "avail_in": "Reservable en",
    "avail_in_2": "días",
    "avail_in_3": "día",
    "availabilities": {
      "availabilities": {
        "availabilities_select": "Por favor, seleccione el año calendario aquí:"
      }
    },
    "availabilities_text": "Si desea marcar un día como no disponible, haga clic con el ratón sobre el día y luego en \"Marcar\". Si desea marcar más días consecutivos como no disponibles, haga clic en el primer y último día del período y después en “Marcar”. Los días de reserva que se introducen en Casapilot serán marcados automáticamente por nuestro sistema como no reservables.",
    "availability": "Disponibilidad",
    "availability_message": "Por favor, actualice la disponibilidad de su alojamiento",
    "avatar_text": "Si lo desea, puede subir aquí una foto suya. La foto aparecerá en la casilla de contacto de su anuncio.",
    "base_rating": "Evaluación primaria",
    "basics": "Información básica",
    "baths": "Baños",
    "bed_and_breakfast": "Bed & Breakfast",
    "blocked": "No disponible",
    "blocked_msg": "No hay días de llegadas disponibles para el período seleccionado. Por favor, elija un otro período.",
    "bookable": "Disponible",
    "booked": "Reservado por Casapilot",
    "bookings_count": "personas han reservado con este propietario",
    "bookings_count_zero": "Este alojamiento es nuevo en el programa",
    "bunk_beds": "Litera doble",
    "clearing_message": "Para activar este alojamiento, usted tiene que proporcionar la siguiente información.",
    "clearing_missing": "Los siguiente información todavía se faltan",
    "clearing_status_popup": "Su alojamiento es incompleto",
    "confirm_delete": "¿Está seguro de que desea borrar esta propiedad? Esta acción no se puede deshacer.",
    "contact_user": "Contacto",
    "coordinates": "Coordenadas",
    "coordinates_annotation": "Aquí puede especificar las coordenadas exactas de su alojamiento.",
    "country": "País",
    "create": "Crear",
    "create_holiday_home": "Crear alojamiento",
    "create_property": "Crear alojamiento",
    "cut_image": "Recortar foto",
    "dashboard": {
      "index": {
        "html": {
          "all_objects": "Mostrar todas las propiedades",
          "another_object": "Introducir otro alojamiento.",
          "another_object_content": "Cuanto más alojamientos introduce, más puede alquilar y ganar dinero. <br /> Tome <strong>5 minutos</strong> para introducir otros alojamientos.",
          "button": "Insertar una propiedad ahora",
          "button_another_object": "Añadir un alojamiento",
          "first_object": "Inserte su primera casa de vacaciones",
          "first_object_content": "Dé el primer paso para hacer de Casapilot su nuevo arrendador para su casa de vacaciones o su apartamento de vacaciones: solamente necesita unos <strong>5 minutos</strong> para registrar todos los datos importantes.",
          "news_more": "más noticias",
          "news_specialoffer_text": "Casapilot.com comienza oficialmente el 1 de junio de 2011 para sus futuros clientes. Como agradecimiento por su anuncio antes del 1 de julio de 2011 le ofrecemos unas condiciones especiales.",
          "news_specialoffer_title": "Introduzca ahora su alojamiento y aproveche las atractivas condiciones especiales.",
          "news_title": "Noticias de Casapilot",
          "title": "Estadísticas",
          "your_properties": "Su alojamiento"
        }
      }
    },
    "daybeds": "Sofás cama",
    "del_confirm": "¿Está seguro?",
    "delete": "Borrar",
    "description": "Descripción",
    "details": "detalles",
    "details_missing": "¿Qué información le falta?",
    "distance_description": "Active una casilla para introducir la distancia en km.",
    "distance_unit": "km",
    "downloads": "Descargas",
    "duration_of_stay": "Duración de la estancia",
    "edit": "Editar",
    "edit_accommodation": "Editar alojamiento",
    "edit_holiday_home": "Modificar alojamiento",
    "edit_image": "Editar foto",
    "embed_calendar_text": "Puede integrar el calendario en su sito web con estos iFrames:",
    "extras": "Suplementos",
    "extras_annotation": "Aquí se puede ajustar diversas funciones.",
    "fallback_text": "No se han introducido los datos.",
    "fallback_text_costs": "No",
    "fallback_text_description": "No se ha introducido ninguna descripción.",
    "feedback_message": "Si tiene preguntas, por favor contacte nuestro apoyo :",
    "filter": "Filtro",
    "following_rooms_already_created": "La siguiente cámara se ha creado :",
    "forms": "Forma",
    "from": "Desde",
    "general_property_informations": "Información general sobre el alojamiento",
    "hh_inc_fees": "incl. gastos de reserva",
    "holiday_home": "Casa de vacaciones",
    "holiday_homes": {
      "create": {
        "create_failed": "Su propiedad no se pudo insertar. Por favor, rellene todos los campos marcados en rojo.",
        "create_successful": "Su propiedad se ha insertado correctamente. Aquí puede cargar fotos e indicar todas las informaciones sobre su propiedad."
      },
      "description": {
        "annotations": {
          "property_description": "Describa brevemente lo que ofrece su propiedad a los clientes.",
          "property_description_hint_html": "La descripción permite que el cliente imagine sus vacaciones. No la escriba con un estilo telegráfico, o repeticiones del equipamiento o de la superficie de su vivienda. Alabe su atmósfera, su comodidad, póngase en el lugar del cliente que no conoce ni la región ni la casa, y que quiere a la vez divertirse y tranquilizarse. Insista en las ventajas de seguridad para las familias, las ventajas de diversiones para los jóvenes y las ventajas de relajación y descubrimiento en general.",
          "property_description_short": "Breve descripción del alojamiento (máx. 88 caracteres incl. espacios)",
          "property_description_short_remaining": "Caracteres restantes",
          "property_language": "Por favor, use las etiquetas para completar la descriptión en otros idiomas.",
          "property_language_2": "Si usted no habla otro idioma extranjero, entonces Casapilot se hace cargo de las traducciones para usted.",
          "property_rating": "Indique los datos solamente si su propiedad dispone de una evaluación.",
          "property_rating_forbidden": "La clasificación de su propiedad ha sido aprobado por el equipo Casapilot. En caso de reclamación, por favor contacte nos en es@casapilot.com",
          "property_title": "Su propiedad aparece en la página web con este nombre."
        },
        "data_multiple_rooms": "¿Tiene su casa varias habitaciones o viviendas separadas para alquilar?<br/>Entonces puede indicar aquí los datos de la primera habitación o vivienda.",
        "data_single_room": "De lo contrario, introduzca los valores que se aplican a toda la casa o apartamento.",
        "language_de": "Alemán",
        "language_description_1": "Su descripción esta",
        "language_description_2": "Por favor, use las etiquetas para completar la descripción en otros idiomas.",
        "language_en": "Inglés",
        "language_es": "Español",
        "language_fr": "Francés",
        "language_nl": "Holandés",
        "select_language": "Idioma"
      },
      "form": {
        "data_multiple_rooms": "¿Tiene su casa varias habitaciones o viviendas separadas para alquilar?\n<br/>Entonces puede indicar aquí los datos de la primera habitación o vivienda.",
        "data_single_room": "De lo contrario, introduzca los valores que se aplican a toda la casa o apartamento.",
        "language_de": "Alemán",
        "language_description_1": "Su descripción esta",
        "language_description_2": "Por favor, use las etiquetas para completar la descripción en otros idiomas.",
        "language_en": "Inglés",
        "language_es": "Español",
        "language_fr": "Francés",
        "language_nl": "Holandés",
        "select_language": "Idioma"
      },
      "new": {
        "submit": "Crear alojamiento",
        "title": "Crear un nuevo alojamiento"
      }
    },
    "host": "propietario",
    "image_alt": "Vista previa de la propiedad",
    "image_description_text": "Describa brevemente la foto que se muestra, por ejemplo,” Vista del jardín”.",
    "image_gallery": "Galería de fotos",
    "image_legend": "Modificar la secuencia de fotos con Arrastrar y Pegar",
    "image_upload_description": "Seleccione una foto del ordenador. Se recomienda una talla mínima de 1124 x 689 pixeles (max. 950 KB) para ofrecer imágenes de calidad a los visitantes del sitio.",
    "inc_fees": "incl. seguro de daño y gastos",
    "included": "incluido",
    "incomplete": "incompleto",
    "info": "Sobre el alojamiento",
    "kind": "Tipo",
    "kind_of_property": "Tipo de alojamiento",
    "kind_of_property_available": "Ya están creadas las siguientes habitaciones: ",
    "kind_of_property_none": "La casa no tiene más habitaciones",
    "king_size_beds": "Camas dobles",
    "languages": "Idiomas",
    "lat": "Latitud (ejemplo : 41.836536)",
    "limitation": {
      "allowed": "Si",
      "forbidden": "no",
      "onrequest": "solicitud"
    },
    "limitations": "Particularidades",
    "limitations_annotation": "Aquí se puede especificar otras particularidades.",
    "link_edit_image": "editar",
    "list": "Atrás",
    "locality": "Lugar",
    "long": "Longitud (ejemplo : 2.737289)",
    "main_image": "Tema del título",
    "main_image_legend": "Ponga aquí el tema deseado con Arrastrar y Pegar.",
    "manage_properties": "Administrar los alojamientos",
    "map": "Mapa",
    "map_zoom": "Aumentar el mapa",
    "max_persons": "Personas (max.)",
    "messages": "Noticias",
    "minimum_booking": "Mínimo noches",
    "more_images": "Otras fotos",
    "new_accommodation": "Nuevo alojamiento",
    "new_room": "Nueva cámara",
    "no_images": "No hay más fotos disponibles",
    "not_published": "No validado",
    "other_costs_text": "Estos gastos sólo se muestran si indica la información.",
    "others": "Otros",
    "payment": "Información sobre el pago",
    "photos": "Fotos",
    "platform_airbnb": "AirBnB",
    "platform_booking": "Booking.com",
    "platform_flipkey": "Flipkey",
    "platform_homeaway": "Homeaway",
    "platform_homelidays": "Homelidays",
    "platform_hometogo": "Hometogo",
    "platform_tripadvisor": "TripAdvisor",
    "platforms": "Platforms for export",
    "platforms_annotation": "You can switch off the export for specific platforms",
    "preview": "Vista previa",
    "prices": "Precios",
    "prices_availability": "Precios y disponibilidad",
    "prices_overview": {
      "js_alert": "Por favor, use el siguiente formato para sus precios: 1.000,00 o introduzca los precios sólo con cifras."
    },
    "properties": {
      "index": {
        "confirm_delete": "¿Está seguro de que desea borrar esta propiedad? Esta acción no se puede deshacer.\\n"
      }
    },
    "property_id": "ID alojamiento",
    "property_title": "Título alojamiento",
    "published": "Validado",
    "rating": "Evaluación",
    "read_messages": "Leer noticias",
    "regilar_costs_text": "Si no indica la información aquí, entonces estos gastos se considerarán incluidos.",
    "region": "Región de vacaciones",
    "registrations": {
      "edit": {
        "back": "Atrás",
        "cancel": {
          "description": "¿Insatisfecho?",
          "link": "Borrar mi perfil.",
          "question": "¿Está seguro?",
          "title": "Borrar perfil"
        },
        "current_hint": "(Necesita su contraseña actual para poder realizar modificaciones)",
        "password_hint": "Si no se desea cambiar su contraseña, deje el campo vacío.",
        "submit": "Guardar",
        "title": "Editar perfil"
      },
      "new": {
        "already_registered": "Ya estoy registrado como inquilino en Casapilot.",
        "host_account": "Cree su gratis acceso de propietario en Casapilot aquí.",
        "newsletter_subscription": "Deseo recibir el boletín de noticias de Casapilot",
        "not_yet_registered": "Ya no estoy inquilino en Casapilot.",
        "offers_text": "O quiere ir de vacaciones y alquiler un alojamiento en Casapilot? Consulta nuestras ofertas. ",
        "register_account": "Quiere alquiler un inmueble? Aquí está en el correcto. ",
        "register_pls": "Por favor inicie sesión.",
        "register_txt": "Aquí se puede crear un perfil gratuito para los inquilinos.",
        "submit": "Crear perfil",
        "terms_of_service_html": "He leído, entiendo y acepto <a href=\"/downloads/terms-conditions/host-es\" target=\"_blank\">las condiciones generales de venta</a>.",
        "title": "Crear su propio perfil como propietario gratuitamente"
      }
    },
    "registrations_addons": {
      "api_documentation": {
        "title": "Documentación API"
      },
      "edit_downloads": {
        "bank_data": "Bankverbindung",
        "bank_data_message": "Bitte geben Sie hier Ihre Bankverbindung ein damit wir Ihnen nach einer erfolgten Buchung Ihre Einnahmen überweisen können. Alle Ihre persönlichen Daten werden bei Casapilot vertraulich behandelt.",
        "bic": "BIC",
        "category_forms": "Formularios ",
        "commercial_host": "Gewerblicher Vermieter",
        "compendium": "Guía por los precios de 2012 ",
        "compendium_description": "Aquí una guía útil para fijar los precios de alquiler.",
        "contact_data": "Kontaktdaten",
        "contact_data_message": "Bitte geben Sie hier ausschließlich Ihre Rechnungsadresse an und keinesfalls die Adresse Ihrer Ferienimmobilie.",
        "edit_payment": null,
        "house_rules": "House Rules",
        "iban": "IBAN",
        "invoice_city": "Ort",
        "invoice_company": "Firma",
        "invoice_country": "Land",
        "invoice_fax": "Fax",
        "invoice_house_number": "Hausnummer",
        "invoice_mobile_phone": "Mobiltelefon",
        "invoice_name": "Name",
        "invoice_of_stay": "Factura final",
        "invoice_of_stay_description": "Por favor completa el siguiente formulario con los gastos adicionales para poder facturar al cliente al final de la estancia.",
        "invoice_of_stay_link": "/downloads/invoice_of_stay/Factura_Final.pdf",
        "invoice_partner_agency": "Partneragentur",
        "invoice_phone": "Telefon",
        "invoice_postal_code": "PLZ",
        "invoice_street": "Straße / Hausnummer",
        "invoice_website": "Webseite",
        "kaution": "Fianza forma",
        "kaution_description": "El cliente tiene que pagar la fianza a la llegada.\nEsta fianza sirve como depósito de seguridad en caso de abuso por el cliente.",
        "kaution_link": "/downloads/deposit.pdf",
        "kind_of_host": "Vermieterart",
        "message": "Para facilitar la gestión de sus clientes, le ofrecemos dos formas de la práctica. <br/>Puede descargar los formularios e imprimirlos.",
        "private_host": "Privater Vermieter",
        "title": "Formas",
        "vat_rate": "Umsatzsteuer-ID",
        "wellness": {
          "pool": "Hot tub and swimming pool",
          "sauna": "Sauna",
          "title": "Safety rules for sauna, hot tub and swimming pool"
        }
      },
      "edit_payment": {
        "bank_data": "Datos bancarios",
        "bank_data_message": "Por favor, introduzca sus datos bancarios para poder realizar pagos a su cuenta. Toda su información personal es confidencial.",
        "bic": "BIC",
        "commercial_host": "Arrendador comercial",
        "contact_data": "Datos de contacto ",
        "contact_data_message": "Introduzca la dirección de facturación y no la dirección del alojamiento.",
        "iban": "IBAN",
        "invoice_city": "Ciudad",
        "invoice_company": "Empresa",
        "invoice_country": "País",
        "invoice_fax": "Fax",
        "invoice_house_number": "Número de la casa",
        "invoice_mobile_phone": "Móvil",
        "invoice_name": "Nombre",
        "invoice_partner_agency": "Otro socio",
        "invoice_phone": "Teléfono",
        "invoice_postal_code": "Código postal",
        "invoice_street": "Calle / Número de casa",
        "invoice_website": "Página web personal",
        "kind_of_host": "Tipo de arrendador",
        "private_host": "Arrendador privado ",
        "title": "Información de pago ",
        "vat_rate": "Número IVA"
      },
      "edit_tenant": {
        "key_hand_over": "Dirección para entrega de la llave ",
        "key_hand_over_city": "Ciudad",
        "key_hand_over_country": "País",
        "key_hand_over_different_place": "El lugar de la entrega de la llave no es el mismo que el lugar donde está la vivienda. ",
        "key_hand_over_name": "Nombre",
        "key_hand_over_postal_code": "Código postal",
        "key_hand_over_street": "Calle",
        "more_languages": "Conocimiento de otros idiomas ",
        "mother_tongue": "Lengua materna",
        "other_language_1": "Alemán",
        "other_language_2": "Inglés",
        "other_language_3": "Francés",
        "other_language_4": "Holandés",
        "other_language_5": "Hispanos",
        "title": "Información para su inquilino"
      }
    },
    "regular_costs": "Otros gastos",
    "rentable_units": "Unidades alquilables",
    "reservations": "Reservas",
    "room": "Habitación",
    "rooms": "Habitaciones",
    "save_description": "Guardar descripción",
    "save_image": "Guardar foto",
    "season_msg": "Por motivos de organización, solamente puede editar la disponibilidad hasta el 09.01.2026 inclusive. Usted será informado cuando la gestión de la disponibilidad por la temporada 2026 está activada.",
    "show": "Mostrar",
    "single_beds": "Camas simples",
    "size_capacity": "Tamaño y capacidad",
    "square_meters": "Superficie útil",
    "star": "Estrella",
    "star_rating": "Estrellas-Evaluación",
    "stars": "Estrellas",
    "status_revision": "Validación en curso",
    "status_visible": "Su alojamiento está validado y puede ser reservado.",
    "suite": "Suite",
    "summer_price": "(verano)",
    "tenant": "Información para el cliente",
    "thumb_fallback": "/images/thumb_fallback.gif",
    "to": "hasta",
    "travel_bookings": {
      "index": {
        "availability": "Verificar la disponibilidad",
        "booking_period": "Periodo de reserva (feche de llegada)",
        "cancelled": "Rechazado",
        "confirmed": "Confirmado",
        "date_of_receipt": "Fecha de entrada",
        "details": "Detalles",
        "sort": "Ordenar por",
        "sort_by_ref_code": "Suche nach Buchungsnummer"
      },
      "show": {
        "accommodation_id": "ID Alojamiento",
        "accommodation_name": "Nombre",
        "accomoodation": "Alojamiento",
        "bond": "Depósito",
        "booking": "Reserva",
        "booking_created_at": "Reservado el",
        "booking_id": "Número de reserva",
        "booking_process": "Procesa de reserva",
        "checkin": "Check-In",
        "checkout": "Check-Out",
        "costs": "Gastos",
        "extra_bring": "A llevar",
        "extra_cost": "Cargos adicionales",
        "guest": "Inquilino",
        "host_total": "Ingresos por alquiler",
        "on_request": "A petición",
        "optional_cost": "Gastos opcionales",
        "overview": "« Volver al resumen",
        "stay": "Estancia",
        "tenant_information": "Información sobre del alquilador",
        "tenant_name": "Nombre del alquilador",
        "tenant_phone_number": "Número de teléfono del alquilador",
        "title": "Detalles de la solicitud para el objeto: "
      }
    },
    "update": "Siguiente",
    "winter_price": "(invierno)",
    "you_have_got": "Usted tiene"
  },
  "host_details": {
    "included": "incluido",
    "on_request": "Bajo demanda",
    "see_additional_costs": "Tenga en cuenta la información en “Gastos adicionales”",
    "to_be_brought": "Debe ser traído"
  },
  "host_navigation": {
    "account": "Perfil",
    "dashboard": "Cockpit",
    "messages": "Mensajes",
    "objects": "Alojamientos",
    "reservations": "Reservas",
    "teaser_host": "¿Quiere alquilar su propiedad? Regístrese ahora y gane más."
  },
  "host_teaser": {
    "button": "Más información",
    "number_of_baths": "Cantidad de baños",
    "number_of_persons": "Personas (max.)",
    "number_of_rooms": "Numero de habitaciones"
  },
  "i18n": {
    "transliterate": {
      "rule": {
        "À": "a",
        "Á": "a",
        "Â": "a",
        "Ä": "ae",
        "Æ": "ae",
        "Ç": "c",
        "È": "e",
        "É": "e",
        "Ê": "e",
        "Ë": "e",
        "Í": "i",
        "Î": "i",
        "Ï": "i",
        "Ñ": "n",
        "Ó": "o",
        "Ô": "o",
        "Ö": "oe",
        "Ù": "u",
        "Ú": "u",
        "Û": "u",
        "Ü": "ue",
        "ß": "ss",
        "à": "a",
        "á": "a",
        "â": "a",
        "ä": "ue",
        "æ": "ae",
        "ç": "c",
        "è": "e",
        "é": "e",
        "ê": "e",
        "ë": "e",
        "í": "i",
        "î": "i",
        "ï": "i",
        "ñ": "n",
        "ó": "o",
        "ô": "o",
        "ö": "oe",
        "ù": "u",
        "ú": "u",
        "û": "u",
        "ü": "ue",
        "ÿ": "y",
        "Œ": "oe",
        "œ": "oe",
        "Ÿ": "y"
      }
    }
  },
  "icons": {
    "first": "start",
    "last": "end",
    "next": "forward",
    "previous": "back"
  },
  "inquiry_form": {
    "fail_notification": "Your enquiry wasn't transmitted successfully. Please try again later.",
    "inquiry_to": "Solicitud ID Alojamiento:",
    "send_button": "Enviar",
    "text": "Le invitamos a enviarnos una pedido no vinculante.",
    "thank_you_1": "Gracias por su consulta en Casapilot.",
    "thank_you_2": "Le responderemos lo antes posible."
  },
  "landing_page": {
    "ardennen": {
      "goto": "Special Ardenas"
    },
    "austria": {
      "goto": "Special Austria"
    },
    "cotedazur": {
      "goto": "Special Costa Azul"
    },
    "france": {
      "goto": "Special Francia"
    },
    "ibiza": {
      "goto": "Special Ibiza"
    },
    "luxemburg": {
      "goto": "Zum Luxemburg Special"
    },
    "mallorca": {
      "goto": "Special Mallorca"
    },
    "more": "Más casas de vacaciones ",
    "more_at": "Más casas de vacaciones en",
    "more_objects": "Más ofertas",
    "spain": {
      "goto": "Special España "
    },
    "wellnesssuites": {
      "goto": "Más suite de bienestar"
    }
  },
  "landing_page_teaser": {
    "title": "Consiga vales a precios reducidos"
  },
  "mailer": {
    "attributes": {
      "approval_mailer": {
        "subject": "Validación del alojamiento"
      },
      "invitation_mailer": {
        "subject": "Invitación a Casapilot"
      },
      "travel_booking_mailer": {
        "confirm": {
          "subject": "Confirmación de su reserva %{name}, %{id}"
        },
        "credit_note": {
          "subject": "Su calificación crediticia %{name}, %{id}"
        },
        "payment": {
          "subject": "Confirmación de su pago %{name}, %{id}"
        },
        "reservation": {
          "subject": "Su pedido de reserva de %{id}"
        },
        "reservation_host": {
          "subject": "Su confirmación de reserva de %{name} (%{id})"
        },
        "voucher": {
          "subject": "Su boleto para quedarse %{name}, %{id}\n"
        }
      }
    },
    "models": {
      "approval_mailer": "Validación",
      "invitation_mailer": "invitación"
    }
  },
  "meta": {
    "description": "Alquile su casa de vacaciones con Casapilot. Encontrar y reservar casas de vacaciones en toda Europa, rápidamente y fácilmente! ",
    "keywords": "Apartamento de vacaciones, reservar villa, apartamento, finca, chalet, casa de vacaciones, de última hora, vacaciones, vacaciones de esquí, viajes baratos, apartamento, B&B, alojamiento para grupos, vacaciones, residencia de vacaciones, ski lodge, alquiler, viaje, alojamiento, bungalow, vacaciones de verano, vacaciones de invierno, Año Nuevo, Navidad, España, Ardenas, Mallorca, Francia del Sur, reservar, Austria, vacaciones baratas. ",
    "title": "casapilot | %{title}"
  },
  "not_found": {
    "back_to_homepage": "no se encontró ",
    "description": "Si acaba de completar una reserva, póngase en contacto con nuestra línea directa de reservas",
    "number": "+352 20 20 34 33",
    "title": "lo siento, ha ocurrido un error."
  },
  "notepad": {
    "add": "Añadir",
    "full": "Usted puede añadir max. 25 alojamientos a la lista",
    "headline": "Hay",
    "headline_part_two": "en su lista",
    "none": "ningún",
    "notepad": "Lista",
    "object": "Alojamiento",
    "objects": "Alojamientos",
    "remember": "Tomar nota",
    "remove": "Remover",
    "remove_full": "Remover de la lista",
    "search": "Buscar"
  },
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%n %u",
        "negative_format": "-%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "€"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "round_mode": "default",
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "human": {
      "decimal_units": {
        "format": "%n %u",
        "units": {
          "billion": "Mil millones",
          "million": "Millón",
          "quadrillion": "Cuatrillón",
          "thousand": "Mil",
          "trillion": "Trillón",
          "unit": ""
        }
      },
      "format": {
        "delimiter": "",
        "precision": 1,
        "significant": true,
        "strip_insignificant_zeros": true
      },
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "eb": "EB",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "pb": "PB",
          "tb": "TB",
          "zb": "ZB"
        }
      }
    },
    "nth": {
      "ordinalized": "#<Proc:0x000000010b979508 /Users/patrik/.rbenv/versions/3.2.2/lib/ruby/gems/3.2.0/gems/activesupport-6.1.7.6/lib/active_support/locale/en.rb:26 (lambda)>",
      "ordinals": "#<Proc:0x000000010b979530 /Users/patrik/.rbenv/versions/3.2.2/lib/ruby/gems/3.2.0/gems/activesupport-6.1.7.6/lib/active_support/locale/en.rb:7 (lambda)>"
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%"
      }
    },
    "precision": {
      "format": {
        "delimiter": ""
      }
    }
  },
  "payment_confirmation": "Confirmación de pago",
  "previews": {
    "back_to_homepage": "Volver a la página principal",
    "back_to_search": "Volver a los resultados",
    "submit": "Reserva"
  },
  "price": {
    "activate_standard_prices": "Activar precios estándar",
    "add_new_season_price": "Añadir nuevo precio de temporada",
    "add_new_standard_price": "Añadir nuevo precio estándar",
    "alternatives": "Alternativas:",
    "available_dates": "Fechas disponibles:",
    "check_in": "Check-in:",
    "check_in_time": "Hora de llegada:",
    "check_out": "Check-out:",
    "check_out_time": "Hora de salida:",
    "currency_symbol": "€",
    "current_season_prices": "Precio actual de temporada",
    "current_season_prices_info": "Los precios se fijan para los periodos indicados",
    "current_standard_prices": "Precio estándar actual",
    "current_standard_prices_info": "Los precios son para todo el año",
    "customer_price": "Precio para el cliente",
    "duplicate_season_price": "Duplicar los precios de temporada para el próximo año",
    "edit_season_price": "Editar los precios de temporada ",
    "euro_per_long_weekend": "€ por fin de semana largo",
    "euro_per_night": "€ por noche",
    "euro_per_stay": "€ por estancia",
    "euro_per_week": "€ por semana ",
    "euro_per_weekend": "€ por fin de semana ",
    "from": "desde",
    "long_weekend_consists_of": "El fin de semana largo se compone de",
    "lump_long_weekend": "Fin de semana largo",
    "lump_long_weekend_short": "Fin de semana largo",
    "lump_week": "Semana\n",
    "lump_weekend": "Fin de semana\n",
    "more_price_options": "¿Más opciones de precios?\nIndique un nuevo grupo de precios.",
    "nightly_week": "Una noche (semana)\n",
    "nightly_week_season": "Una sola noche",
    "nightly_weekend": "Noche (fin de semana)",
    "nightly_weekend_season": "Una noche del fin de semana",
    "no_prices": "No se han fijado los precios aún",
    "no_rotation_day": "Llegada en cualquier día de la semana",
    "not_available": "Elija otro día de llegada o adapte el número de noches.",
    "per_night": "Por noche",
    "per_stay": "Por estancia ",
    "per_week": "Por semana ",
    "per_weekend": "Por fin de semana",
    "price": "Precio",
    "price_lump_long_weekend": "Mostrar el precio de un fin de semana largo",
    "price_lump_week": "Mostrar el precio de una semana",
    "price_per_night": "Precio por noche",
    "price_single_night": "Mostrar el precio de una noche\n",
    "price_single_night_weekend": "Asignar precio de una noche del fin de semana",
    "price_stay_weekdays": "Asignar precio para media semana",
    "season_price_text": "Los precios de temporada solamente son válidos si ha definido un período. No es necesario indicar los precios de temporada obligatoriamente antes de poder activar una propiedad para subscripion.\n",
    "season_prices": "Precio de temporada",
    "season_title": "Nombre de la temporada",
    "single_night": "Precio de una noche\n",
    "single_night_weekend": "Precio de una noche del fin de semana",
    "standard_price": "Precio estándar",
    "standard_price_text": "Indique al menos un precio estándar para que su propiedad pueda activarse para subscripion. Recomendamos que indique todos los precios estándar, pero no es obligatorio. Los precios estándar son válidos para todo el año de reservas.",
    "standard_price_text_2": "Si desea especificar una temporada determinada a un precio diferente, por favor indique debajo un precio de temporada.",
    "standard_prices": "Precio estándar",
    "stay_weekdays": "Precio para media semana",
    "tooltip_lump_long_weekend": "Un fin de semana largo completo incluye normalmente tres noches seguidas.",
    "tooltip_nightly_week": "Una sola noche se refiere a una noche de la semana laboral, es decir de lunes a jueves.",
    "tooltip_nightly_weekend": "Una sola noche en el fin de semana se refiere a una sola noche entre el viernes y el domingo.",
    "tooltip_stay_underweek": "Normalmente una media semana empieza el lunes y termina el viernes.",
    "tooltip_stay_weekdays": "Una estancia durante la semana se refiere a las noches entre el lunes y el viernes.",
    "under_week": "Media semana",
    "week_period": "Precio por una estancia durante la semana.",
    "week_period_consists_of": "Este precio se aplica por las noches consecutivas durante la semana.",
    "week_starts": "Una semana empieza",
    "weekend_consists_of": "Este precio es válido para las noches consecutivas de",
    "what_is_common": "¿Qué es usual?",
    "what_is_common_1": "La semana de vacaciones suele comenzar los sabados",
    "what_is_common_2": "Normalmente los precios del fin de semana incluyen las noches del viernes y del sábado",
    "whole_weekend": "Asignar precio del fin de semana",
    "your_price": "Usted gana"
  },
  "processing": {
    "booking": {
      "booking_form": {
        "amex": "American Express",
        "bank_transfer": "Transferencia bancaria",
        "credit_card": "Mastercard, Visa, Maestro",
        "payment_charge": "Gastos de tramitación",
        "payment_method": "Forma de pago",
        "payment_method_expl": "En caso de pago con la tarjeta de crédito, hay gastos adicionales de procesamiento. Estos se añaden automáticamente al precio total."
      }
    }
  },
  "renter": {
    "contact": "Información de contacto",
    "terms_of_service_html": "He leído, comprendido y aceptado las <a href=\"/downloads/renter_tos/casapilot_tos_renter_ES.pdf\" target=\"_blank\">Condiciones</ a>."
  },
  "reserved": "Reservado",
  "reviews": {
    "accommodation": "Alojamiento",
    "cancel_correct": "Go back and correct",
    "confirm": "Confirm",
    "confirmation_intro": "Please review your recommendation. Can it be published like this?",
    "intro_1": "Your feedback counts: Your recommendation helps other Casapilot users to select the accommodation that’s right for them and us to understand better how you experienced your stay.",
    "intro_2": "Thanks for taking the time!",
    "mailers": {
      "host_reaction_subject": "Un invitado publicó una reseña",
      "invitation_reminder_subject": "Recordatorio amistoso: Cómo fue tu estancia?",
      "invitation_subject": "Cómo fue tu estancia?"
    },
    "nps_headline": "How likely is is that you recommend Casapilot?",
    "nps_unlikely": "Unlikely",
    "nps_very_likely": "Very likely",
    "question_area": "How was the location of the accommodation?",
    "question_cleanliness": "How clean was the accommodation?",
    "question_comfort": "How satisfied were you with the comfort?",
    "question_value": "How was the cost/benefit ratio of the accommodation?",
    "rating_headline": "How satisfied have you been with the accommodation?",
    "rating_no_selection": "Please select",
    "rating_selection_1": "1 - Not satisfied",
    "rating_selection_2": "2 - Rather dissatisfied",
    "rating_selection_3": "3 - Neutral",
    "rating_selection_4": "4 - Rather satisfied",
    "rating_selection_5": "5 - Very satisfied",
    "remaining_chars": "Remaining chracters",
    "review_author": "Author of the recommendation",
    "review_headline": "Please write a short recommendation. What was good? What was bad?",
    "submit": "Submit",
    "success_title": "Thank you",
    "supbmit": "Indienen",
    "thank_you": "Thank you for your recommendation. Since we have just started asking users for recommendations, we will wait until we have enough reviews gathered before publishing.",
    "title": "Create a recommendation",
    "travel_dates": "Travel dates",
    "validation_error": "Please fill out all required fields."
  },
  "salutations": {
    "female": "Señora ",
    "male": "Señor "
  },
  "search": {
    "additional_results": "Otros destinos preferidos en",
    "adjust_filters": "más filtros",
    "adjust_request": "Ajustar solicitud",
    "all_cities": "Todas las ciudades",
    "all_regions": "Todas las Regiones",
    "arrival": "Llegada",
    "availability": {
      "availability_for": "Disponibilidad para",
      "available": "Disponible",
      "calculate_price_and_availability": "Calculando los precios y la disponibilidad...",
      "check_availability": "Verificar disponibilidad",
      "checking": "Verificación de la disponibilidad ",
      "choose_day_of_arrival": "Seleccione un día de llegada",
      "day_of_arrival": "Llegada",
      "free": "libre",
      "no_arrivals": "No hay días de llegada disponibles para el período seleccionado. Por favor, seleccione una diferente longitud de estancia. ",
      "not_available": "No disponible ",
      "occupied": "ocupado",
      "on_request": "Comprobar la disponibilidad",
      "update_price_and_availability": "Actualizar precios y disponibilidad ..."
    },
    "back_to_search_list": "Volver a los resultados",
    "banner": {
      "contact_note": "Por favor, póngase en contacto con nosotros por mail o teléfono. ",
      "headline": "No encuentra nada adecuado? ",
      "headline_big_1": "Lamentablemente, su búsqueda no produjo resultados. ",
      "headline_big_2": "Por favor cambie sus criterios de búsqueda. ",
      "offer": "Estaremos encantados de ayudarle personalmente en su búsqueda.",
      "offer_big": "Estaremos encantados de ayudarle personalmente en su búsqueda."
    },
    "check_availability": "Verificar disponibilidad",
    "choose_city": "Todos los países",
    "choose_region": "Todas las regiones",
    "close": "cerca",
    "departure": "Salida",
    "detail": {
      "allowed_pets": "Se admite animales",
      "allowed_smoking": "Se permite fumar",
      "allowed_youth": "Grupos de jóvenes permitidos",
      "amenities_balcony": "Balcón",
      "amenities_dish": "Lavavajillas",
      "amenities_garage": "Estacionamiento",
      "amenities_garden": "Jardín",
      "amenities_internet": "Internet/WiFi",
      "amenities_pool": "Piscina",
      "amenities_sauna": "Sauna",
      "amenities_terasse": "Terraza",
      "amenities_tv": "TV",
      "amenities_wash": "Lavadora",
      "from": "desde",
      "locality_calm": "Tranquilo",
      "locality_city": "En el campo",
      "locality_mountains": "En la montana",
      "locality_nature": "En la naturaleza",
      "locality_sea": "En el mar"
    },
    "detail_search": "Búsqueda detallada",
    "exact_date": "Fecha exacta",
    "extended_search_result": "No hay alojamientos disponibles para su destino de vacaciones. Quizás que los siguientes resultados podrían interesarle también. ",
    "filters": {
      "activities": "Actividades",
      "air_conditioning": "Aire acondicionado",
      "any": "Todo",
      "apartment": "Apartamento",
      "central_heating": "Calefacción central",
      "distance_to_beach": "Distancia de la playa",
      "features": "Características",
      "fenced_garden": "Jardín vallado",
      "holiday_home": "Casa de vacaciones",
      "jacuzzi": "Jacuzzi",
      "jacuzzi_inside": "Jacuzzi interior",
      "jacuzzi_outside": "Jacuzzi exterior",
      "kind_of_property": "Clase del objeto",
      "lake": "Lago cercano",
      "limited_mobility": "Movilidad reducida",
      "linen_included": "Ropa de cama incluida",
      "object_place": "Ubicación",
      "ocean_view": "Vistas al mar",
      "pets": "Se admite animales",
      "pool": "Piscina",
      "pool_inside": "Piscina interior",
      "pool_outside": "Piscina exterior",
      "sauna": "Sauna",
      "ski": "Esquí",
      "stars": "Estrellas",
      "suite": "Luxus Suite",
      "teambuilding": "Teambuilding",
      "waterfront": "Situado junto al mar/costa",
      "wifi_internet": "Wifi - internet"
    },
    "map_zoom": "Ampliar el mapa",
    "map_zoom_out": "Reducir el mapa",
    "mark": "Anotar",
    "micro_search_no_results": "Desafortunadamente, no hay ningún objeto con el ID deseado.",
    "more": "más",
    "more_objects": "Más ofertas en la región",
    "no_results": "Su búsqueda no produjo resultados. Por favor cambie sus criterios de búsqueda.",
    "objects_for_all_arrivals": "Mostrar objetos para todas las fechas de llegada.",
    "offers_found": "Ofertas encontradas",
    "please_enter": "Introduzca su destino",
    "reset_filters": "Eliminar filtros y mostrar todos los resultados",
    "results": "Resultados de la búsqueda",
    "search": "Buscar",
    "search_by_object_code": "Búsqueda por código",
    "search_list": "Nueva búsqueda",
    "show_availability": "Ver disponibilidad",
    "size": "Dimensión",
    "to_accomondation": "Más info",
    "your_destination": "Su destino"
  },
  "sending_mails": "Envío de correo",
  "service_navigation": {
    "account": "Mi cuenta"
  },
  "shared": {
    "footer": {
      "breakfast": "Oferta de desayuno",
      "breakfast_url": "https://specials.casapilot.com/shop/",
      "contact": "Contacto",
      "cookie_settings": "Configuración de cookies",
      "faq": "FAQ",
      "help": "Ayuda",
      "hosts": "Para propietarios",
      "imprint": "Aviso legal",
      "partners": "Socios",
      "privacy": "Datos personales"
    },
    "service_navigation": {
      "host_area": "Arrendador",
      "locale": {
        "de": "DE",
        "en": "EN",
        "es": "ES",
        "fr": "FR",
        "nl": "NL"
      },
      "offer_flat": "Proponer casas de vacaciones propias",
      "service_navigation": {
        "account": "Account"
      },
      "user": {
        "edit": "Editar cuenta",
        "sign_in": "Propietario",
        "sign_out": "Logout",
        "sign_up": "Registrar"
      },
      "vouchers": "Vouchers",
      "vouchers_url": "https://shop.casapilot.com/es"
    },
    "sub_navigation": {
      "account": "Cuenta",
      "bookings": "Reservas",
      "dashboard": "Dashboard",
      "objects": "Objetos",
      "statistics": "Estadísticas"
    }
  },
  "subscription": {
    "email_error": "La dirección de correo electrónico no es válida. Por favor, revise la ortografía.",
    "email_text": "Su dirección de correo electrónico se mantendrá confidencial. ",
    "headline": "Inscríbase ahora para estar al día. ",
    "missing_field": "Por favor indique todos los campos."
  },
  "support": {
    "array": {
      "last_word_connector": ", y ",
      "two_words_connector": " y ",
      "words_connector": ", "
    },
    "select": {
      "prompt": "Por favor seleccione"
    }
  },
  "thank_you": {
    "copy_1": "Agradecemos su interés en Casapilot y le mantendremos al día a partir de ahora.",
    "copy_2": "Para activar su inscripción, en breve recibirá un correo electrónico con un enlace de confirmación. Sin esta confirmación su inscripción no podrá ser completada. ",
    "copy_3": "En todos los correos electrónicos que reciba de nosotros también encontrará un enlace que le permitirá cancelar la inscripción y borrar sus datos de nuevo. ",
    "copy_4": "Su equipo Casapilot",
    "empfehlen": "Por favor recomiéndenos a otros",
    "headline": "muchas gracias!"
  },
  "three_good_reasons": "buenas razones para sus vacaciones con casapilot.com",
  "time": {
    "am": "am",
    "formats": {
      "default": "%A, %d de %B de %Y %H:%M:%S %z",
      "long": "%d de %B de %Y %H:%M",
      "moment": "H:mm",
      "only_second": "%S",
      "short": "%d/%m/%Y, %H:%M",
      "time": "%H:%M h"
    },
    "pm": "pm"
  },
  "travel_booking_price": {
    "booking_fee": "Tarifa de reserva",
    "costs_in_detail": "Costos en detalle",
    "deposit": {
      "on_location": "A pagar en el sitio",
      "refund": {
        "instantly": "Reembolso inmediatamente a la salida",
        "one_week": "Reembolso una semana después de la salida",
        "two_weeks": "Reembolso dos semanas después de la salida"
      },
      "upfront": "Pagadero a Casapilot"
    },
    "extras": {
      "type_bring": "Trae el tuyo",
      "type_included": "Incluido",
      "type_on_location": "En el sitio",
      "type_on_request": "A pedido",
      "type_payable": "Debe ser alquilado",
      "type_upfront": "Por adelantado"
    },
    "handling_fee": "Gastos de tramitación",
    "included": "incluido",
    "liability_insurance": "Seguro de responsabilidad",
    "optional_costs": "Costos opcionales",
    "other_costs": "Otros costos",
    "payable_on_location": "A pagar en el sitio",
    "payable_on_location_colon": "A pagar en el sitio:",
    "payable_to_casapilot": "Pagadero a Casapilot",
    "plus_other_costs": "(más otros costos)",
    "price_error": "Ocurrió un error al determinar el precio.",
    "rent_fees_included": "Alquiler (incl. tasa de reserva)",
    "total_amount": "Precio total",
    "withheld_from_deposit": "Retenido del depósito:"
  },
  "travel_bookings": {
    "ical_guest_summary": "Reserva de Casapilot para %{title}",
    "ical_host_summary": "Reserva por “%{property}” con Casapilot"
  },
  "universal_tag": {
    "cnv": {
      "conversion_lang": "85854"
    },
    "rmkt": {
      "container_id": "8810",
      "conversion_lang": "85859"
    }
  },
  "voucher": "Vale de estancia",
  "we_book_your_holidayhome": "Podemos reservar su casa de vacaciones inclusive vuelo y coche de alquiler.",
  "web_app_theme": {
    "accommodations": "Alojamientos",
    "add": "Añadir",
    "administration": "Administración",
    "agency": "Centro de llamadas\n",
    "all": "Todo",
    "amenities": "Características",
    "approval_status": "Estado",
    "approvals": "Validaciones",
    "approve": "Activar",
    "approved": "En línea",
    "attractions": "Atracciones",
    "cancel": "Interrumpir",
    "complete": "A validar",
    "confirm": "¿Está seguro?",
    "console": "Console",
    "costs": "Gastos adicionales",
    "created": "Creado",
    "dashboard": "Panel de instrumentos",
    "day": "Día",
    "days": "Días",
    "delete": "Borrar",
    "delete_map_clipping": "Restablecer mapa\n",
    "edit": "Editar",
    "editing": "Incompleto",
    "find": "Buscar",
    "fix_rating": "Sternekategorie fixieren?",
    "homepage": "Página inicial",
    "invitations": "Invitación",
    "latest_send": "Último enviado\n",
    "limitations": "Particularidades",
    "list": "Lista",
    "logout": "Logout",
    "new": "Nuevo",
    "new_users": "Nuevo usuario\n",
    "notapproved": "No aprobado",
    "ogone": {
      "timedout": "Verbindung zum Zahlungssystem konnte nicht hergestellt werden."
    },
    "or": "o",
    "possible_extras": "Opciones",
    "possible_limitations": "Oportunidades",
    "possible_units": "Unidades posibles",
    "properties": "Alojamientos",
    "save": "Guardar",
    "search_people": "Personas",
    "search_person": "Persona",
    "select": {
      "prompt": "Seleccione"
    },
    "send": "Enviar",
    "show": "Mostrar",
    "summary": "Todas",
    "translate": "Traducciones",
    "travel_bookings": "Buchungen",
    "travel_regions": "Regiones",
    "unapprove": "Desaprobar",
    "usable_on": "Utilizable en",
    "users": "Usuario",
    "various_options": "Varios"
  },
  "will_paginate": {
    "container_aria_label": "Pagination",
    "next_label": "»",
    "page_aria_label": "Page %{page}",
    "page_entries_info": {
      "multi_page": "Displaying %{model} %{from} - %{to} of %{count} in total",
      "multi_page_html": "Displaying %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b> of <b>%{count}</b> in total",
      "single_page": {
        "one": "Displaying 1 %{model}",
        "other": "Displaying all %{count} %{model}",
        "zero": "No %{model} found"
      },
      "single_page_html": {
        "one": "Displaying <b>1</b> %{model}",
        "other": "Displaying <b>all&nbsp;%{count}</b> %{model}",
        "zero": "No %{model} found"
      }
    },
    "page_gap": "...",
    "previous_label": "«"
  },
  "your_benefits": {
    "contact": {
      "at": {
        "number": "+352 20 20 34 26 20",
        "text": "(Contacto de Austria)"
      },
      "be": {
        "number": "+32 28 80 89 83",
        "text": "(Contacto de Belgica)"
      },
      "ch": {
        "number": "+352 20 20 34 26 20",
        "text": "(Contacto de Suiza)"
      },
      "de": {
        "number": "+352 20 20 34 26 20",
        "text": "(Contacto de Alemania)"
      },
      "email": "E-Mail: info@casapilot.com",
      "email_link": "info@casapilot.com",
      "headline": "¿Usted tiene preguntas?",
      "intro": "Póngase en contacto con nosotros. ¡Estamos aquí para ayudarle!",
      "lu": {
        "number": "+352 (0)20 20 34 26 20",
        "text": "(Contacto de Luxemburgo)"
      },
      "opening_hours": "Puede contactarnos por teléfono a tarifas locales:",
      "opening_hours_1": "Lunes a viernes de 9:00h a 12:30h y de 13:30h a 18:00h",
      "opening_hours_2": "El fin de semana de las 14 a las 16",
      "partners": "Nuestros socios ",
      "phone": "Tel. +34 (0)93 18 450 49"
    },
    "h1": "¿Por qué Casapilot?",
    "h2": "Precios todo incluido",
    "h3": "Reserva segura, datos seguros, vacaciones seguras ",
    "h4": "Un excelente servicio y muy buena accesibilidad",
    "headline_html": "El equipo Casapilot",
    "intro": "Sus vacaciones de sueño son nuestra principal preocupación. Accesibilidad, comodidad y servicio son nuestros prioridades. Haga la prueba y usted quedará gratamente sorprendido.  ",
    "list_item2_1": "Los precios de alquiler presentados para un período de viaje son precios finales",
    "list_item2_2": "Los gastos por el seguro de daño y otros gastos son incluidos",
    "list_item2_3": "Los gastos posibles para el consumo en el lugar son enumerados claramente visibles",
    "list_item3_1": "El sitio web cifrado garantiza que sus datos personales están protegidos",
    "list_item3_2": "El servicio de pagos certificado garantiza un pago seguro por transferencia bancaria o tarjeta de crédito",
    "list_item4_1": "Puede comunicarse con nosotros por teléfono a tarifas locales, durante la semana y los fines de semana",
    "list_item4_2": "Estamos siempre disponibles por e-mail. Respondemos dentro de las 24 horas",
    "list_item4_3": "¿Está buscando una propiedad especial de vacaciones? Estaremos encantados de ayudarle personalmente en su búsqueda",
    "p1_1": "Hay muchas buenas razones por las que debe reservar sus vacaciones de ensueño en casapilot.com. ",
    "p1_2": "Las principales razones son elucidadas de manera detallada en lo que sigue:",
    "p2": "En Casapilot.com no hay sorpresas desagradables para usted, como nuestro sistema de precios es claro y transparente:",
    "p3": "Queremos que usted disfrute de unas vacaciones despreocupadas. La seguridad que le ofrecemos comienza a la reserva y al pago, e incluye todos los días de su estancia de vacaciones en el lugar. ",
    "p4": "El equipo 5-lingual está a su disposición 365 días al año. Un bueno servicio es nuestra fuerza. ",
    "page_title": "Alquilar más. Ganar más. Con Casapilot.",
    "positions": {
      "accounting": "Contabilidad",
      "business_development": "Business Development",
      "business_development_spain": "Business Development España",
      "ceo": "Administración",
      "cio": "Director técnico",
      "design": "Interactive Design ",
      "dev": "Webdevelopment ",
      "it": "Administrador IT",
      "photography": "Fotografía",
      "pm": "Administración de Proyecto",
      "service": "Servicio al cliente",
      "service_marketing": "Servicio al cliente y marketing",
      "teamleader": "Teamleader"
    }
  }
};
I18n.translations["fr"] = {
  "about": {
    "h1": "Facile à introduire et à gérer  ",
    "h2": "De propriétaire à propriétaire",
    "h3": "Un service irréprochable - 24 heures sur 24",
    "h4": "Aux quatre coins de l'Europe",
    "h5": "Sécurité",
    "h6": "Des conditions alléchantes",
    "link_13": "Une description détaillée du ",
    "link_23": "Modèle d'affaires Casapilot",
    "link_33": "peut être téléchargé comme fichier PDF.",
    "p1": "Nous garantissons une publication aussi simple que possible. Grâce à la mise en page très claire et à ses nombreuses fonctions pratiques, le site Web de Casapilot est très intuitif et facile à utiliser. Il permet par exemple de pré-visualiser une annonce avant même sa publication. Vous pouvez de cette manière vous assurer qu'elle répond entièrement à vos attentes. ",
    "p2": "Tout comme vous, nous sommes propriétaires d'une maison de vacances que nous louons depuis plusieures années. Nous avons toutefois constaté que la location via des portails en ligne ou des agences implique trop souvent l'intervention d'intermédiaires externes coûteux et peu flexibles ou fiables. Nous avons décidé de créer Casapilot afin de mettre en place un système qui réponde aux attentes des propriétaires. En deux mots, un système qui soit simplement efficace et abordable. ",
    "p3": "365 jours par an, de jour comme de nuit, votre logement est disponible sur le site de Casapilot. Votre annonce est consultable en 5 langues, et les réservations sont automatiques : les clients réservent directement sur le site Web de Casapilot ou via son call-center. ",
    "p4": "Grâce à notre équipe de spécialistes en communication et web-marketing, nous travaillons à l'échelle de l'Europe entière. Nous utilisons un système de publicité très ciblé, nous travaillons entre autres durablement le référencement Google et autres moteurs de recherche. ",
    "p5": "Chez Casapilot, toutes les réservations sont enregistrées sur notre site Web sécurisé et sont traitées par un système de paiement certifié. Le loyer est versé sur le compte bancaire du propriétaire directement après l'arrivée des clients. Les éventuels dommages locatifs sont couverts par une assurance-dégâts spécifique, à laquelle tous les clients souscrivent automatiquement. ",
    "p6": "Votre annonce est 100% gratuite. Casapilot fonctionne uniquement à la performance, c'est à dire que nous ajoutons une petite surcharge sur votre prix de vente, pour que vous, comme nous pourrions réaliser un bénéfice."
  },
  "about_us": {
    "claim": "Casapilot gère et sécurise. Avec Casapilot, pas de perte de temps. Le propriétaire se concentre sur le principal : la satisfaction de ses clients. Casapilot s'occupe du reste.",
    "headline_html": "Avec Casapilot, la location est simple et rentable.",
    "page_title": "Avec Casapilot, la location est simple et rentable."
  },
  "accommodation_reviews": {
    "area": "Alentours",
    "cleanliness": "Propreté",
    "comfort": "Confort",
    "hide": "Montrer moins",
    "load_more_reviews": "Charger plus d’évaluations…",
    "review_translated": "Évaluation traduit",
    "reviews": {
      "one": "évaluation",
      "other": "évaluations"
    },
    "show_more": "Montre plus",
    "show_original": "Afficher l’original",
    "show_translation": "Afficher la traduction",
    "value": "Qualité-prix"
  },
  "accommodations": {
    "errors": {
      "minstay": "Pour cet hébergement, vous devez sélectionner une période de séjour, qui est divisible par %{minstay}. Veuillez réessayer s'il vous plaît."
    },
    "seo": {
      "in": "à",
      "kind": {
        "apartment": "Appartement ",
        "bed_and_breakfast": "Chambre B&B ",
        "holiday_home": "Maison de vacances "
      }
    }
  },
  "activemodel": {
    "errors": {
      "template": {
        "body": "There were problems with the following fields:",
        "header": {
          "one": "1 error prohibited this %{model} from being saved",
          "other": "%{count} errors prohibited this %{model} from being saved"
        }
      }
    }
  },
  "activerecord": {
    "abbr_day_names": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "abbr_day_names_string": {
      "friday": "Fri",
      "monday": "Mon",
      "saturday": "Sat",
      "sunday": "Sun",
      "thursday": "Thu",
      "tuesday": "Tue",
      "wednesday": "Wed"
    },
    "abbr_month_names": [
      null,
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "attributes": {
      "accommodation": {
        "amenities": "Caractéristiques",
        "area": "Surface (m²)",
        "bond": "Caution",
        "bond_refund": "Restitution de la caution",
        "created_at": "Créé le",
        "description": "Description",
        "description_short": "Kurzbeschreibung",
        "fee": "Commission (en %)",
        "filter_partition": {
          "all": "Voir tous les logements",
          "any_missing": "traduction manquante",
          "de_missing": "traduction allemande manquante",
          "en_missing": "traduction anglaise manquante",
          "es_missing": "traduction espagnol manquante",
          "fr_missing": "traduction française manquante",
          "nl_missing": "traduction néerlandaise manquante"
        },
        "filter_partition_all": "Alle Unterkünfte anzeigen",
        "filter_partition_any_missing": "mit fehlender Übersetzung",
        "filter_partition_de_missing": "ohne deutsche Übersetzung",
        "filter_partition_en_missing": "ohne englische Übersetzung",
        "filter_partition_es_missing": "ohne spanische Übersetzung",
        "filter_partition_fr_missing": "ohne französische Übersetzung",
        "filter_partition_nl_missing": "ohne niederländische Übersetzung",
        "id": "ID",
        "kind": "Type",
        "max_persons": "Personnes (max)",
        "number_of_baths": "Salle de bains",
        "number_of_bunk_beds": "Lits superposés",
        "number_of_daybeds": "Canapés-lits",
        "number_of_king_size_beds": "Lits doubles",
        "number_of_rooms": "Équipement",
        "number_of_similar": "Nombre de logements du même type.",
        "number_of_single_beds": "Lits simples",
        "photos": "Photos",
        "property_id": "Hébergement",
        "title": "Nom",
        "updated_at": "Mis à jour",
        "user_rating": "Basisbewertung"
      },
      "amenity": {
        "apartment": "Appartement",
        "bed_and_breakfast": "Chambre d'hôte",
        "category": "Catégorie",
        "created_at": "Créé le",
        "holiday_home": "Maison de vacances",
        "id": "ID",
        "name": "Identification",
        "updated_at": "Mis à jour"
      },
      "attraction": {
        "category": "Catégorie",
        "created_at": "Créé le",
        "id": "ID",
        "name": "Identification",
        "updated_at": "Mis à jour"
      },
      "attraction_distance": {
        "created_at": "Créé le",
        "distance": "Distance",
        "id": "ID",
        "updated_at": "Mis à jour"
      },
      "block": {
        "accommodation": "Maison de vacances/Chambre",
        "beginning": "Fermé du",
        "created_at": "Créé le",
        "ending": "Fermé jusqu'au",
        "id": "ID",
        "updated_at": "Mis à jour"
      },
      "cost": {
        "created_at": "Créé le",
        "id": "ID",
        "inclusive": "inclue",
        "mandatory": "Coûts obligatoires",
        "name": "Identification",
        "per_animal": "par animal",
        "per_box": "par box",
        "per_consumption": "par consommation et prix actuel du marché",
        "per_cubic_meter": "par m³",
        "per_day": "par jour",
        "per_day_and_person": "par jour par personne",
        "per_day_and_piece": "par jour par unité",
        "per_hour": "par heure",
        "per_kwh": "par kWh",
        "per_liter": "par litre",
        "per_midweek": "par milieu de semaine",
        "per_night": "par nuit",
        "per_night_and_animal": "par nuit et animal",
        "per_night_and_person": "par nuit par personne",
        "per_package": "par paquet",
        "per_person": "par personne",
        "per_piece": "par unité",
        "per_set": "par set",
        "per_stay": "par séjour",
        "per_week": "par semaine",
        "per_weekend": "par weekend",
        "updated_at": "Mis à jour"
      },
      "extra": {
        "breakfast": "Petit déjeuner",
        "bring": "À emporter",
        "created_at": "Créé le",
        "dish_towels": "Essuies de vaisselle",
        "id": "ID",
        "included": "Inclus",
        "kind": "Type",
        "linen": "Draps de lit",
        "on_request": "sur demande",
        "optional": "Frais d'utilisation d'équipement spécifique",
        "payable": "Disponible",
        "price": "Prix",
        "towels": "Serviettes de bain",
        "updated_at": "Mis à jour le"
      },
      "inquiry_form": {
        "day_of_arrival": "Jour d'arrivée",
        "day_of_departure": "Jour de départ",
        "email": "Adresse e-mail",
        "inquiry": "Demande",
        "message": "Message",
        "name": "Identification",
        "object_id": "ID Hébergement",
        "phone": "Téléphone",
        "updated_at": "Actualizado el"
      },
      "limitation": {
        "allowed": "Autorisés",
        "bring_with": "Selbst mitbringen",
        "can_be_rented": "Mieten möglich",
        "created_at": "Créé le",
        "forbidden": "Interdits",
        "id": "ID",
        "must_be_rented": "Mietverpflichtung",
        "name": "Nom",
        "onrequest": "sur demande",
        "updated_at": "Mis à jour le"
      },
      "price": {
        "accommodation": "Maison de vacances/Chambre",
        "beginning": "Valable depuis",
        "created_at": "Créé le",
        "default_price": "Prix standard",
        "ending": "Valable jusqu'au",
        "friday": "Vendredi",
        "friday_abbr": "Ven",
        "id": "ID",
        "monday": "Lundi",
        "monday_abbr": "Lun",
        "payment_type": "Moyen de paiement",
        "price": "Prix",
        "rotation_day": "Changement de draps",
        "saturday": "Samedi",
        "saturday_abbr": "Sam",
        "sunday": "Dimanche",
        "sunday_abbr": "Dim",
        "thursday": "Jeudi",
        "thursday_abbr": "Jeu",
        "tuesday": "Mardi",
        "tuesday_abbr": "Mar",
        "updated_at": "Mis à jour",
        "wednesday": "Mercredi",
        "wednesday_abbr": "Mer"
      },
      "property": {
        "country": "Pays",
        "created_at": "Créé le",
        "description": "Description",
        "description_short": "Description courte",
        "filter_partition_all": "Montrer tous les hébergements",
        "filter_partition_any_missing": "avec traduction manquante",
        "filter_partition_de_missing": "sans traduction allemande",
        "filter_partition_en_missing": "sans traduction anglaise",
        "filter_partition_es_missing": "sans traduction espagnole",
        "filter_partition_fr_missing": "sans traduction française",
        "filter_partition_nl_missing": "sans traduction néerlandaise",
        "id": "ID",
        "internal_memo": "Note interne",
        "locality": "Localité",
        "postal_code": "Code postal",
        "rating": "Etoiles",
        "region": "Région",
        "street": "Rue",
        "title": "Nom de l'hébergement",
        "top_object": "Top Hébergement",
        "travel_region_id": "Région touristique",
        "updated_at": "Mis à jour"
      },
      "property_photo": {
        "created_at": "Créé le",
        "description": "Description",
        "file": "Photo",
        "id": "ID",
        "updated_at": "Mis à jour"
      },
      "travel_booking": {
        "accommodation": "Unterkunft",
        "amount_total": "Rechnungsbetrag",
        "cancel_ins_amount": "Reiserücktrittsvericherung",
        "casualty_ins_amount": "Haftpflichtversicherung",
        "created_at": "Réservation créée",
        "id": "ID",
        "number_of_adults": "Erwachsene",
        "number_of_children": "Kinder",
        "number_of_infants": "Kleinkinder",
        "number_of_pets": "Haustiere",
        "ref_code": "Rechnungsnummer",
        "renter": "Mieter",
        "state": "Status",
        "travel_ins_amount": "Umfassende Reiseversicherung",
        "travel_range": "Reisezeitraum"
      },
      "travel_region": {
        "country_code": "Pays",
        "created_at": "Créé le",
        "custom_geocode": "Localiser manuellement",
        "id": "ID",
        "name": "Nom dans la langue nationale",
        "updated_at": "Mis à jour"
      },
      "user": {
        "additional_emails": "Additional Emails",
        "additional_emails_csv": "E-mails supplémentaires (séparés par des virgules)",
        "admin": "Administrateur",
        "agent": "Standardiste",
        "agent_lead": "Direction de l'agence",
        "api_user": "Utilisateur API",
        "authentication_token": "Auth Token",
        "avatar": "Image",
        "birthday": "Anniversaire",
        "cellphone": "Mobile",
        "city": "Localité",
        "country": "Pays",
        "created_at": "Enregistré le",
        "current_password": "Mot de passe actuel",
        "description": "Description",
        "email": "Adresse e-mail",
        "first_name": "Prénom",
        "host": "Propriétaire",
        "id": "ID",
        "invoice_city": "Ville (Coordonnées)",
        "invoice_company": "Société (Coordonnées)",
        "invoice_country": "Pays  (Coordonnées)",
        "invoice_mobile_phone": "Numéro de GSM (coordonnées)",
        "invoice_name": "Nom (Coordonnées)",
        "invoice_phone": "Téléphone (Coordonnées)",
        "invoice_postal_code": "CP (Coordonnées)",
        "invoice_street": "Rue (Coordonnées)",
        "key_hand_over_city": "Ville (Emplacement des clés)",
        "key_hand_over_country": "Pays (Emplacement des clés)",
        "key_hand_over_name": "Nom (Emplacement des clés)",
        "key_hand_over_postal_code": "CP (Emplacement des clés)",
        "key_hand_over_street": "Rue (Emplacement des clés)",
        "last_name": "Nom",
        "last_sign_in_at": "Dernière connexion le",
        "mother_tongue": "Langue maternelle",
        "name": "Nom",
        "newsletter": "S'abonner à la newsletter",
        "password": "Mot de passe",
        "password_confirmation": "Répéter le mot de passe",
        "phone": "Téléphone",
        "postal_code": "CP",
        "remember_me": "Se souvenir de moi",
        "remove_avatar": "Effacer l'image",
        "renter": "Locataire",
        "salutation": "Titre",
        "street_nr": "Rue / numéro",
        "terms_of_service": "Conditions générales de Vente",
        "translator": "Traducteur",
        "updated_at": "Mis à jour",
        "vat_rate": "TVA"
      }
    },
    "day_names": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "day_names_string": {
      "friday": "Friday",
      "monday": "Monday",
      "saturday": "Saturday",
      "sunday": "Sunday",
      "thursday": "Thursday",
      "tuesday": "Tuesday",
      "wednesday": "Wednesday"
    },
    "errors": {
      "full_messages": {
        "format": "%{attribute} %{message}"
      },
      "messages": {
        "accepted": "doit être accepté(e)",
        "blank": "doit être rempli(e)",
        "confirmation": "ne concorde pas avec la confirmation",
        "empty": "doit être rempli(e)",
        "equal_to": "doit être égal à %{count}",
        "even": "doit être pair",
        "exclusion": "n'est pas disponible",
        "greater_than": "doit être supérieur à %{count}",
        "greater_than_or_equal_to": "doit être supérieur ou égal à %{count}",
        "inclusion": "n'est pas inclus(e) dans la liste",
        "invalid": "n'est pas valide",
        "less_than": "doit être inférieur à %{count}",
        "less_than_or_equal_to": "doit être inférieur ou égal à %{count}",
        "not_a_number": "n'est pas un nombre",
        "not_an_integer": "doit être un nombre entier",
        "odd": "doit être impair",
        "record_invalid": "La validation a échoué : %{errors}",
        "restrict_dependent_destroy": {
          "has_many": "Cannot delete record because dependent %{record} exist",
          "has_one": "Cannot delete record because a dependent %{record} exists"
        },
        "taken": "n'est pas disponible",
        "too_long": "est trop long (pas plus de %{count} caractères)",
        "too_short": "est trop court (au moins %{count} caractères)",
        "wrong_length": "ne fait pas la bonne longueur (doit comporter %{count} caractères)"
      },
      "models": {
        "amenity": {
          "attributes": {
            "name": {
              "invalid": "n'utiliser que des lettres"
            }
          }
        },
        "attraction": {
          "attributes": {
            "name": {
              "invalid": "n'utiliser que des lettres"
            }
          }
        },
        "block": {
          "attributes": {
            "ending": {
              "range_too_short": "Dois être au moins un jour après le début de cette période"
            }
          }
        },
        "cost": {
          "attributes": {
            "name": {
              "invalid": "n'utiliser que des lettres"
            }
          }
        },
        "extra": {
          "attributes": {
            "kind": {
              "invalid": "ne peut contenir que des lettres"
            }
          }
        },
        "limitation": {
          "attributes": {
            "name": {
              "invalid": "ne peut contenir que des lettres"
            }
          }
        },
        "price": {
          "attributes": {
            "base": {
              "lump_price_exists": "Il existe déjà un tarif pour cette période",
              "nested_season": "Le superposition des différentes périodes n'est pas possible. Veuillez introduire les différents prix de saison l'un après l'autre, de sorte que ces périodes ne se chevauchent pas.",
              "nightly_price_exists": "Il existe déjà un prix pour la journée",
              "no_night_selected": "Veuillez sélectionner au moins une semaine",
              "not_linked_up": "Les prix forfaitaire pour les jours ouvrables doivent être cohérents"
            },
            "ending": {
              "range_too_short": "doit être au moins un jour après le début de la période"
            }
          },
          "not_blank": "n'est pas vide"
        },
        "travel_region": {
          "attributes": {
            "name": {
              "invalid": "n'utiliser que des lettres"
            }
          }
        }
      },
      "template": {
        "body": "Veuillez vérifier les champs suivants : ",
        "header": {
          "one": "Impossible d'enregistrer ce %{model} : 1 erreur",
          "other": "Impossible d'enregistrer ce %{model} : %{count} erreurs"
        }
      }
    },
    "models": {
      "accommodation": "Maison de vacances/Chambre",
      "amenity": "Équipement",
      "attraction": "Activité",
      "attraction_distance": "Distance de l'activité",
      "block": "Périodes fermées",
      "cost": "Charges sur place",
      "extra": "Suppléments",
      "limitation": "Particularités",
      "price": "Prix",
      "property": "Hébergement",
      "property_photo": "Photo",
      "travel_booking": "Buchung",
      "travel_region": "Région",
      "user": "Utilisateur"
    },
    "month_names": [
      null,
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "options": {
      "accommodation": {
        "bond_refund": {
          "instantly": "lors du départ des clients",
          "one_week": "une semaine après le départ",
          "two_weeks": "deux semaines après le départ"
        },
        "kind": {
          "apartment": "Appartement",
          "bed_and_breakfast": "Chambre d'hôte",
          "holiday_home": "Maison de vacances"
        }
      },
      "amenity": {
        "category": {
          "business": "Business",
          "domestic": "Équipement domestique",
          "exclusive": "Wellness et loisir",
          "exterior": "Équipement extérieur",
          "general": "Équipement général",
          "location": "Situation",
          "multimedia": "Équipement multimédia",
          "orientation": "Orientation",
          "other": "Équipement pour des personnes à mobilité réduite",
          "view": "Vue sur"
        }
      },
      "attraction": {
        "category": {
          "activities": "Activités",
          "other": "Autres",
          "places": "Lieux"
        }
      },
      "extra": {
        "extra_type": {
          "bring": "À emporter",
          "included": "Inclus",
          "on_request": "sur demande",
          "payable": "Location obligatoire"
        },
        "unit": {
          "per_night": "Par nuit",
          "per_night_and_person": "par nuit par personne",
          "per_person": "par personnes",
          "per_piece": "par unité",
          "per_set": "par set",
          "per_stay": "par séjour"
        }
      },
      "limitation": {
        "name": {
          "allowed": "Autorisés",
          "forbidden": "Interdits",
          "onrequest": "sur demande"
        }
      },
      "price": {
        "payment_type": {
          "lump": "Inclus",
          "nightly": "par nuit"
        },
        "rotation_day": {
          "friday": "Vendredi",
          "monday": "Lundi",
          "saturday": "Samedi",
          "sunday": "Dimanche",
          "thursday": "Jeudi",
          "tuesday": "Mardi",
          "wednesday": "Mercredi"
        }
      },
      "travel_region": {
        "country_code": {
          "AD": "Andorre",
          "AE": "Émirats Arabes Unis",
          "AF": "Afghanistan",
          "AG": "Antigua et Barbuda",
          "AI": "Anguilla",
          "AL": "Albanie",
          "AM": "Arménie",
          "AN": "Antilles néerlandaises",
          "AO": "Angola",
          "AP": "Asie/Pacifique",
          "AQ": "Antarctique",
          "AR": "Argentine",
          "AS": "Samoa américaines",
          "AT": "Autriche",
          "AU": "Australie",
          "AW": "Aruba",
          "AX": "Îles Aland",
          "AZ": "Azerbaïdjan",
          "BA": "Bosnie-Herzégovine",
          "BB": "Barbade",
          "BD": "Bangladesh",
          "BE": "Belgique",
          "BF": "Burkina Faso",
          "BG": "Bulgarie",
          "BH": "Bahreïn",
          "BI": "Burundi",
          "BJ": "Bénin",
          "BL": "Saint Barthélemy",
          "BM": "Bermudes",
          "BN": "Brunei Darussalam",
          "BO": "Bolivie",
          "BR": "Brésil",
          "BS": "Bahamas",
          "BT": "Bhoutan",
          "BV": "Île Bouvet",
          "BW": "Botswana",
          "BY": "Belarus",
          "BZ": "Belize",
          "CA": "Canada",
          "CC": "Îles Cocos",
          "CD": "Congo (RDC)",
          "CF": "République Centre Africaine",
          "CG": "Congo",
          "CH": "Suisse",
          "CI": "Côte d'Ivoire",
          "CK": "Îles Cook",
          "CL": "Chili",
          "CM": "Cameroun",
          "CN": "Chine",
          "CO": "Colombie",
          "CR": "Costa Rica",
          "CU": "Cuba",
          "CV": "Cap Vert",
          "CX": "Christmas Island",
          "CY": "Chypre",
          "CZ": "République Tchèque",
          "DE": "Allemagne",
          "DJ": "Djibouti",
          "DK": "Danemark",
          "DM": "Dominique",
          "DO": "République Dominicaine",
          "DZ": "Algérie",
          "EC": "Équateur",
          "EE": "Estonie",
          "EG": "Égypte",
          "EH": "Sahara Occidental",
          "ER": "L'Érythrée",
          "ES": "Espagne",
          "ET": "Éthiopie",
          "EU": "Europe",
          "FI": "Finlande",
          "FJ": "Îles Fidji",
          "FK": "Îles Fakland",
          "FM": "Micronésie",
          "FO": "Îles Féroé",
          "FR": "France",
          "FX": "France métropolitaine",
          "GA": "Gabon",
          "GB": "Grande-Bretagne",
          "GD": "Grenade",
          "GE": "Géorgie",
          "GF": "Guinée Française",
          "GG": "Guernesey",
          "GH": "Ghana",
          "GI": "Gibraltar",
          "GL": "Groenland",
          "GM": "Gambie",
          "GN": "Guinée",
          "GP": "Guadeloupe",
          "GQ": "Guinée Équatoriale",
          "GR": "Grèce",
          "GS": "Géorgie du Sud et îles Sandwich du Sud",
          "GT": "Guatemala",
          "GU": "Guam",
          "GW": "Guinée-Bissau",
          "GY": "Guyane",
          "HK": "Hong-Kong",
          "HM": "Îles Heard et McDonald",
          "HN": "Honduras",
          "HR": "Croatie",
          "HT": "Haïti",
          "HU": "Hongrie",
          "ID": "Indonésie",
          "IE": "Irlande",
          "IL": "Israël",
          "IM": "Îles de Man",
          "IN": "Inde",
          "IO": "Territoire britannique de l'océan Indien",
          "IQ": "Irak",
          "IR": "Iran",
          "IS": "Islande",
          "IT": "Italie",
          "JE": "Jersey",
          "JM": "Jamaïque",
          "JO": "Jordanie",
          "JP": "Japon",
          "KE": "Kenya",
          "KG": "Kirghizstan",
          "KH": "Cambodge",
          "KI": "Kiribati",
          "KM": "Comores",
          "KN": "Saint-Kitts-et-Nevis",
          "KP": "Corée",
          "KR": "Corée",
          "KW": "Koweït",
          "KY": "Îles Caïman",
          "KZ": "Kazakhstan",
          "LA": "République Démocratique du Laos",
          "LB": "Liban",
          "LC": "Sainte-Lucie",
          "LI": "Liechtenstein",
          "LK": "Sri Lanka",
          "LR": "Liberia",
          "LS": "Lesotho",
          "LT": "Lituanie",
          "LU": "Luxembourg",
          "LV": "Latvia",
          "LY": "Jamahiriya arabe libyenne",
          "MA": "Maroc",
          "MC": "Monaco",
          "MD": "Moldavie",
          "ME": "Monténégro",
          "MF": "Saint-Martin",
          "MG": "Madagascar",
          "MH": "Îles Marshall",
          "MK": "Macédoine",
          "ML": "Mali",
          "MM": "Myanmar",
          "MN": "Mongolie",
          "MO": "Macao",
          "MP": "Îles Mariannes du Nord",
          "MQ": "Martinique",
          "MR": "Mauritanie",
          "MS": "Montserrat",
          "MT": "Malte",
          "MU": "Île Maurice",
          "MV": "Maldives",
          "MW": "Malawi",
          "MX": "Mexique",
          "MY": "Malaisie",
          "MZ": "Mozambique",
          "NA": "Namibie",
          "NC": "Nouvelles Calédonie",
          "NE": "Niger",
          "NF": "Île Norfolk",
          "NG": "Nigeria",
          "NI": "Nicaragua",
          "NL": "Pays-Bas",
          "NO": "Norvège",
          "NP": "Népal",
          "NR": "Nauru",
          "NU": "Niue",
          "NZ": "Nouvelle-Zélande",
          "OM": "Oman",
          "PA": "Panama",
          "PE": "Pérou",
          "PF": "Polynésie Française",
          "PG": "Papouasie-Nouvelle-Guinée",
          "PH": "Philippines",
          "PK": "Pakistan",
          "PL": "Pologne",
          "PM": "Saint-Pierre-et-Miquelon ",
          "PN": "Pitcairn",
          "PR": "Puerto Rico",
          "PS": "Palestine",
          "PT": "Portugal",
          "PW": "Palau",
          "PY": "Paraguay",
          "QA": "Qatar",
          "RE": "Réunion (Île de la)",
          "RO": "Roumanie",
          "RS": "Serbie",
          "RU": "Russie",
          "RW": "Rwanda",
          "SA": "Arabie Saoudite",
          "SB": "Îles Salomon",
          "SC": "Seychelles",
          "SD": "Soudan",
          "SE": "Suède",
          "SG": "Singapour",
          "SH": "Sainte-Hélène",
          "SI": "Slovénie",
          "SJ": "Svalbard et Jan Mayen",
          "SK": "Slovaquie",
          "SL": "Sierra Leone",
          "SM": "Saint-Marin",
          "SN": "Sénégal",
          "SO": "Somalie",
          "SR": "Surinam",
          "ST": "Sao Tomé et Principe",
          "SV": "Salvador",
          "SY": "Syrie",
          "SZ": "Swaziland",
          "TC": "Îles Turks et Caicos",
          "TD": "Tchad",
          "TF": "Terres australes françaises",
          "TG": "Togo",
          "TH": "Thaïlande",
          "TJ": "Tadjikistan",
          "TK": "Tokélaou",
          "TL": "Timor-Leste",
          "TM": "Turkménistan",
          "TN": "Tunisie",
          "TO": "Tonga",
          "TR": "Turquie",
          "TT": "Trinité-et-Tobago",
          "TV": "Tuvalu",
          "TW": "Taïwan",
          "TZ": "Tanzanie",
          "UA": "Ukraine",
          "UG": "Ouganda",
          "UM": "United States Minor Outlying Islands",
          "US": "États-Unis",
          "UY": "Uruguay",
          "UZ": "Ouzbékistan",
          "VA": "Vatican",
          "VC": "Saint-Vincent-et-le Grenadines",
          "VE": "Venezuela",
          "VG": "Îles Vierges Britanniques",
          "VI": "Îles Vierges, U.S.",
          "VN": "Vietnam",
          "VU": "Vanuatu",
          "WF": "Wallis et Futuna",
          "WS": "Samoa",
          "YE": "Yémen",
          "YT": "Mayotte",
          "ZA": "Afrique du Sud",
          "ZM": "Zambie",
          "ZW": "Zimbabwe",
          "all": "Tous les pays"
        }
      }
    },
    "order": [
      "year",
      "month",
      "day"
    ],
    "status_codes": {
      "accommodation": {
        "create_failed": "Impossible de créer la Maison de vacances/Chambre.",
        "destroyed": "La Maison de vacances/Chambre est effacée.",
        "successfully_created": "La Maison de vacances/Chambre est créée avec succès.",
        "successfully_updated": "La Maison de vacances/Chambre a été modifiée avec succès.",
        "update_failed": "Impossible de modifier la Maison de vacances/Chambre."
      },
      "amenity": {
        "create_failed": "Impossible de créer l'élément.",
        "destroyed": "L'élément a été effacé.",
        "successfully_created": "L'élément a été créé avec succès.",
        "successfully_updated": "L'élément a été modifié avec succès.",
        "update_failed": "Impossible de modifier cet élément."
      },
      "approval": {
        "successfully_updated": "Freigabe erfolgreich geändert"
      },
      "attraction": {
        "create_failed": "Impossible de créer l'activité.",
        "destroyed": "L'activité a été effacée.",
        "successfully_created": "L'activité a été créée avec succès.",
        "successfully_updated": "L'activité a été mise à jour avec succès.",
        "update_failed": "L'activité n'a pas pu être modifiée."
      },
      "attraction_distance": {
        "create_failed": "Impossible de valider la distance de l'activité.",
        "destroyed": "La distance de l'activité a été supprimée.",
        "successfully_created": "La distance de l'activité a été créée avec succès.",
        "successfully_updated": "La distance de l'activité a été modifiée avec succès.",
        "update_failed": "La distance de l'activité n'a pas pu être modifiée."
      },
      "block": {
        "create_failed": "Impossible de créer la période.",
        "destroyed": "La période a été supprimée.",
        "successfully_created": "La période a été créée avec succès.",
        "successfully_unblocked": "La période a bien été mise à disposition.",
        "successfully_updated": "La période a été modifiée avec succès.",
        "unblocking_failed": "La période n'a pas pu être mise à disposition.",
        "update_failed": "Impossible de modifier la période."
      },
      "cost": {
        "create_failed": "Impossible de créer la charge.",
        "destroyed": "La charge a été supprimée.",
        "successfully_created": "La charge a été créée avec succès.",
        "successfully_updated": "La charge a été modifiée avec succès.",
        "update_failed": "Impossible de modifier la charge."
      },
      "extra": {
        "create_failed": "Le supplément n'a pas pu être créé.",
        "destroyed": "Le supplément a été effacé.",
        "successfully_created": "Le supplément a été créé avec succès.",
        "successfully_updated": "Le supplément a été mis à jour.",
        "update_failed": "Le supplément n'a pas pu être mis à jour."
      },
      "invitation": {
        "create_failed": "L'invitation n'a pas pu être créée.",
        "successfully_created": "L'invitation a été créée avec succès."
      },
      "limitation": {
        "create_failed": "La mise à jour des particularités a échoué.",
        "destroyed": "La particularité a été effacée.",
        "successfully_created": "La particularité a été créée avec succès.",
        "successfully_updated": "La particularité a été mise à jour avec succès.",
        "update_failed": "La particularité n'a pas pu être mise à jour."
      },
      "price": {
        "create_failed": "Impossible de créer le prix.",
        "destroyed": "Le prix a été supprimé.",
        "nested_season": "Le superposition des différentes périodes n'est pas possible. Veuillez introduire les différents prix de saison l'un après l'autre, de sorte que ces périodes ne se chevauchent pas.",
        "successfully_created": "Le prix a été créé avec succès.",
        "successfully_updated": "Le prix a été modifié avec succès.",
        "update_failed": "Impossible de modifier le prix."
      },
      "property": {
        "create_failed": "Impossible de créer l'hébergement.",
        "destroyed": "L'hébergement a été effacé.",
        "successfully_created": "L'hébergement a été créé avec succès.",
        "successfully_updated": "L'hébergement a été modifié avec succès.",
        "update_failed": "Impossible de modifier l'hébergement."
      },
      "property_photo": {
        "create_failed": "Impossible d'insérer la photo.",
        "destroyed": "La photo a été effacée.",
        "successfully_created": "La photo a été insérée avec succès.",
        "successfully_updated": "La photo a été changée avec succès.",
        "update_failed": "Impossible de modifier la photo."
      },
      "travel_booking": {
        "cancel_failed": "Buchung wurde nicht storniert.",
        "confirmation_failed": "Buchung wurde nicht bestätigt.",
        "create_failed": "Buchung konnte nicht angelegt werden.",
        "destroyed": "Buchung wurde gelöscht.",
        "successfully_cancelled": "Buchung wurde storniert.",
        "successfully_confirmed": "Buchung wurde bestätigt.",
        "successfully_created": "Buchung erfolgreich angelegt.",
        "successfully_updated": "Buchung erfolgreich geändert.",
        "update_failed": "Buchung konnte nicht geändert werden."
      },
      "travel_region": {
        "create_failed": "Impossible de créer la région.",
        "destroyed": "La région a été effacée.",
        "successfully_created": "La région a été créée avec succès.",
        "successfully_updated": "La région a été modifiée avec succès.",
        "update_failed": "Impossible de modifier la région."
      },
      "user": {
        "create_failed": "Impossible de créer l'utilisateur.",
        "destroyed": "Utilisateur effacé.",
        "must_be_host": "Veuillez devenir propriétaire.",
        "must_be_renter": "Devenez locataire. Veuillez vous enregistrer avec une autre adresse mail. ",
        "successfully_created": "Utilisateur créé avec succès.",
        "successfully_updated": "Utilisateur modifié avec succès.",
        "update_failed": "Impossible de modifier l'utilisateur.",
        "wrong_date_format": "Le format de date n'est pas valable."
      }
    }
  },
  "administration": {
    "accommodations": {
      "price_change_end_date_label": "Fin: Prix de la saison commençant à cette date ou avant (ne pas renseigner pour éviter de changer les prix)",
      "price_change_label": "Changement de prix (en %, ne pas renseigner pour ne pas modifier les prix)",
      "price_change_start_date_label": "Début: Prix de la saison commençant à cette date ou après (ne pas renseigner pour ne pas modifier les prix)"
    },
    "city_name_for_filter": "Namer der Stadt für Suchfilter",
    "landing_pages": {
      "accids": "ID-Hébergement",
      "country_code": "Länderkürzel",
      "desc": "Description",
      "edit": "Modifier Landing Page",
      "header": "Header",
      "img": "Teaser",
      "locale": "Version linguistique",
      "mailer": "Texte courrier électronique",
      "mailer_subject": "Objet courrier électronique",
      "meta_desc": "Description SEO",
      "meta_keyword": "Mots-clés SEO",
      "search_meta": "Région",
      "slug": "Nom",
      "title": "Région"
    },
    "properties": {
      "form": {
        "api_blocked": "bloquer dans l'API"
      }
    },
    "travel_bookings": {
      "no_data": "Pas de données disponibles"
    }
  },
  "already_cancelled": "Bereits storniert",
  "already_confirmed": "Déjà confirmé",
  "ancestry": {
    "cannot_delete_descendants": "Cannot delete record because it has descendants.",
    "cannot_rebuild_depth_cache": "Cannot rebuild depth cache for model without depth caching.",
    "conflicting_parent_id": "Conflicting parent id found in node %{node_id}: %{parent_id} for node %{node_id} while expecting %{expected}",
    "exclude_self": "%{class_name} cannot be a descendant of itself.",
    "invalid_ancestry_column": "Invalid format for ancestry column of node %{node_id}: %{ancestry_column}.",
    "invalid_orphan_strategy": "Invalid orphan strategy, valid ones are :rootify, :adopt, :restrict and :destroy.",
    "named_scope_depth_cache": "Named scope '%{scope_name}' is only available when depth caching is enabled.",
    "no_child_for_new_record": "No child ancestry for new record. Save record before performing tree operations.",
    "option_must_be_hash": "Options for has_ancestry must be in a hash.",
    "reference_nonexistent_node": "Reference to nonexistent node in node %{node_id}: %{ancestor_id}.",
    "unknown_depth_option": "Unknown depth option: %{scope_name}.",
    "unknown_option": "Unknown option for has_ancestry: %{key} => %{value}."
  },
  "attributes": {
    "created_at": "Créé le",
    "translations": {
      "description": "Description",
      "description_de": "Description (allemand)",
      "description_en": "Description (anglais)",
      "description_es": "Description (espagnol)",
      "description_fr": "Description (français)",
      "description_nl": "Description (néerlandais)",
      "description_short": "Kurzbeschreibung",
      "description_short_de": "Kurzbeschreibung (deutsch)",
      "description_short_en": "Kurzbeschreibung (englisch)",
      "description_short_es": "Kurzbeschreibung (spanisch)",
      "description_short_fr": "Kurzbeschreibung (französisch)",
      "description_short_nl": "Kurzbeschreibung (niederländisch)",
      "kind": "Art",
      "kind_de": "Art (deutsch)",
      "kind_en": "Art (englisch)",
      "kind_es": "Art (spanisch)",
      "kind_fr": "Art (französisch)",
      "kind_nl": "Art (niederländisch)",
      "title": "Titre",
      "title_de": "Titre (allemand)",
      "title_en": "Titre (anglais)",
      "title_es": "Titre (espagnol)",
      "title_fr": "Titre (français)",
      "title_nl": "Titre (néerlandais)"
    },
    "updated_at": "Modifié le"
  },
  "booking": {
    "additional_costs_host": "Coûts supplémentaires/consommations sur place",
    "additional_information": "Plus d'informations",
    "additional_information_annotation": "Veuillez choisir le nombre de personnes ainsi que la période que vous souhaitez louer.",
    "adult": "Adulte",
    "adults": "Adultes",
    "arrival_date": "Date d'arrivée",
    "arrival_date_annotation": "Sélectionnez votre date d'arrivée souhaitée.",
    "availability_check": "Vérifiez que ce logement est disponible",
    "availability_txt": "Veuillez sélectionner vos dates directement dans le calendrier.",
    "available_arrival_date": "Date d'arrivée disponible",
    "available_arrival_date_annotation": "Pour modifier une date d'arrivée sélectionnée, cliquez sur une date de remplacement.",
    "booking_headline": "Réservez „%{object_name}“ en 2 étapes. ",
    "booking_info": "Informations sur la réservation",
    "booking_overview": "Résumé de votre réservation",
    "booking_period": "Période",
    "booking_possible_timespace": "Périodes disponibles",
    "booking_process": "Déroulement de réservation",
    "booking_process_confirmation": "Après avoir effectué votre réservation, vous recevez par courrier électronique une confirmation de réservation.",
    "booking_process_payment_details": "Dès que le propriétaire confirme celle-ci, vous obtenez tous les détails du paiement.",
    "booking_summary": "Récapitulatif de votre réservation",
    "booking_timespace": "Période de réservation",
    "calendar_annotation": "Un moment svp. La disponibilité de votre logement est en cours de chargement.",
    "cancellation": {
      "accept_conditions": "En réservant l’assurance annulation de voyage, j’accepte leurs <a href=\"/downloads/terms-conditions/cancellation-insurance-fr\" target=\"_blank\" rel=\"noopener noreferrer\">conditions d’assurance</a>.",
      "amount": "Seulement %{amount}",
      "opt_in": "Je souhaite souscrire une assurance annulation de voyage pour cette réservation."
    },
    "casualty_insurance": "Assurance-dégâts inclue:",
    "casualty_insurance_txt": "Très utile en cas de dégât - pas de franchise",
    "change": "Modifier la période de réservation",
    "check_payment_info": "Veuillez vérifier vos informations de paiement ou contacter votre banque.",
    "chid_age_full": "Enfant (0-17 ans)",
    "chidren_age_full": "Enfants (0-17 ans)",
    "child_age17": "Enfant (2-17 ans)",
    "child_age2": "Enfant (0-1 ans)",
    "child_part_age2": "Bébé (0-1 ans)",
    "child_part_age2_cost": "Dont bébés (0-1 ans)",
    "children_age17": "Enfants (2-17 ans)",
    "children_age2": "Enfants (0-1 ans)",
    "children_part_age2": "Bébés (0-1 ans)",
    "comment": "Remarque - Bon de reduction",
    "comment_label_info": "Entrez ici votre bon de voyage, ainsi vous obtiendrez après la réservation la réduction.",
    "comment_note": "Veuillez introduire commentaires / remarques / code coupon ici. ",
    "confirmation_mail": "Vous allez recevoir un e-mail de confirmation à l'adresse suivante",
    "confirmation_spam_notice": "Vous n'avez pas reçu notre e-mail ? Vérifiez votre boite spam.",
    "confirmation_wrong_mail": "Pour toute question en rapport avec votre réservation, veuillez nous contacter au",
    "contact_host": "Coordonnées du propriétaire",
    "dateselect": "Vous voulez modifier une période bloquée ? Cliquez sur la date de début ou de fin de cette période puis sélectionnez une nouvelle date (de début ou de fin) qui remplacera la précédente.",
    "deposit": "Caution",
    "deposit_handling": "Restitution de la caution ",
    "duration": "Durée",
    "duration_of_stay": {
      "one": "%{count} Nuit",
      "other": "%{count} Nuits"
    },
    "duration_of_stay_annotation": "Sélectionnez la durée de votre séjour parmi les périodes possibles affichées à droite.",
    "europeene_explanation": "Axa est le partenaire de Casapilot concernant les assurances voyage.",
    "from": "de",
    "group": "Votre groupe",
    "group_comment": "Composition de votre groupe",
    "group_max": "Âge Max.",
    "group_min": "Min. âge",
    "group_years": "Âge Groupe",
    "group_years_sum": "%{min} – %{max}  Âge ",
    "hh_additional": "Frais supplémentaires",
    "hh_additional_tax": "Taxe de séjour",
    "hh_agb": "Conditions générales de vente",
    "hh_agb_annotation": "Je confirme avoir lu, compris et accepté les conditions générales de vente",
    "hh_conditions_and_prices": "Conditions de location et prix",
    "hh_inc_fees": "Frais de réservation et de traitement inclus",
    "hh_redirect_annotation_pt1": "Si la redirection automatique ne fonctionne pas, cliquez ",
    "hh_redirect_annotation_pt2": "Ici",
    "hh_redirect_hl": "Redirection vers Holiday Home",
    "hh_redirect_txt": "Vous allez être redirigé vers notre partenaire Holiday Home. Veuillez patienter s'il vous plaît. ",
    "host_contact": "Vous recevrez les coordonnées du propriétaire par e-mail avec le ticket de séjour trois semaines avant le début de votre séjour.",
    "host_cost": "Frais supplémentaires non compris",
    "inc_fees": "Frais de réservation et de traitement inclus",
    "inc_fees_cancellation": "Assurance annulation de voyage, frais de réservation et de traitement inclus",
    "info_message_redirect": "Vous allez automatiquement être redirigé vers la page d'accueil",
    "insurance_names_txt": "Veuillez communiquer le nom de tous les vacanciers à assurer. La police d'assurance sera émise à ces noms.",
    "insurance_names_txt_2": "Veuillez renseigner chaque nom sur une ligne séparée ou séparez-les par une virgule. Le nom de famille est suffisant.",
    "insurance_tos": "Assurances-CGV",
    "insurance_tos_html": "Je confirme avoir lu, compris et accepté les CGV de l'assurance",
    "insurances": "Assurances",
    "journey": "Votre voyage ",
    "limitations": "Spécificités/Restrictions",
    "mail_confirmation": "Merci!",
    "mail_confirmation_annotation": "Avez-vous des questions concernant le processus de réservation? Contactez-nous. ",
    "me_redirect_hl": "Redirection vers MER-EVASION",
    "me_redirect_txt": "Vous allez être redirigé vers notre partenaire MER-EVASION. Veuillez patienter s'il vous plaît. ",
    "mv_redirect_hl": "Redirection vers MONTAGNE-VACANCES",
    "mv_redirect_txt": "Vous allez être redirigé vers notre partenaire MONTAGNE-VACANCES. Veuillez patienter s'il vous plaît. ",
    "navigation": {
      "availability": "Dates",
      "booking_info": "Coûts",
      "payment": "Confirmation",
      "payment_feedback": "Paiement",
      "payment_info": "Résumé"
    },
    "newsletter_subscription": "Je souhaite recevoir la newsletter Casapilot. ",
    "night": "Nuit",
    "nights": "Nuits",
    "no_costs": "Aucun",
    "number_of_persons": "Nombre de personnes",
    "payment": "Paiement.",
    "payment_accepted": "Merci pour votre réservation.\nAprès la confirmation par le propriétaire, vous recevrez un e-mail avec toutes les informations de paiement nécessaires.\nSincères salutations,\nL’équipe de Casapilot.",
    "payment_declined": "Votre paiement a été refuse",
    "payment_declined_txt": "Votre paiement a malheureusement été refusé.",
    "payment_not_possible": "Le paiement n'est actuellement pas possible",
    "payment_not_possible_txt": "Le paiement n'est malheureusement pas possible actuellement.",
    "payment_not_possible_txt2": "Veuillez réessayer plus tard ou contacter la banque émettrice de la carte de crédit.",
    "payment_successful": "Votre paiement a été réalisé avec succès.",
    "pet": "Animal",
    "pet_comment_separator": "Commentaire concernant les animaux de compagnie:",
    "pets": "Animaux",
    "pets_not_allowed": "Les animaux ne sont pas acceptés",
    "posible_host_cost": "",
    "posible_host_cost_txt": "Les coûts suivants ne sont pas inclus dans le prix de location susmentionné:",
    "possible_costs_host": "Frais d'utilisation d'équipement spécifique",
    "price_box_season_annotation": "Les prix peuvent varier en fonction des saisons.",
    "price_total": "Prix total",
    "prices_object": "Prix du logement sélectionné",
    "rental_price": "Loyer",
    "renter": {
      "birthday_format": "JJ.MM.AAAA"
    },
    "reservation": {
      "failed": "L'hébergement fut malheureusement déjà réservé. Veuillez choisir une autre période. "
    },
    "reservation_fee": "Frais de réservation inclus",
    "review": "Vérifiez vos données",
    "rotation_day": "Arrivée",
    "secure": "Vacances sécurisées avec Casapilot. Garanti. ",
    "security": {
      "h1": "Votre réservation",
      "h2": "Le paiement",
      "h3": "Notre service",
      "p1": "Vos données personnelles sont traitées de manière confidentielle.",
      "p2": "Paiement facile et sécurisé avec notre système sécurisé Casapilot. ",
      "p3": "Nous sommes à votre disposition pour toutes questions. "
    },
    "select_bookable_date": "Sélectionnez une date d'arrivée disponible",
    "select_duration": "Sélectionnez la durée de votre séjour à l'aide du menu bleu.",
    "slider": {
      "month_not_available_html": "Durant cette période, ce logement n'est pas disponible.",
      "next": "Les 4 mois prochains",
      "prev": "Les 4 mois précédents"
    },
    "sp_redirect_hl": "Redirection vers SKI-PLANET",
    "sp_redirect_txt": "Vous allez être redirigé vers notre partenaire SKI-PLANET. Veuillez patienter s'il vous plaît. ",
    "tenant_booking": "Votre réservation",
    "tenant_data": "Vos coordonnées",
    "tenant_residence": "Votre domicile",
    "terms_of_service_html": "Je confirme avoir lu, compris et accepté <a href=\"/downloads/terms-conditions/guest-fr\" target=\"_blank\">les CGV</a>.",
    "time": "heures",
    "to": "jusqu'à",
    "total": "total",
    "travel_cancelation_insurance": "Assurance voyage",
    "travel_cancelation_insurance_dash": "Assurance voyage",
    "travel_cancelation_insurance_plus": "Assurance annulation inclue",
    "travel_cancelation_insurance_plus_txt": "Assurance complète inclue",
    "travel_cancelation_insurance_txt": "Risque d'annulation ou d'interruption de séjour ? Pensez-y",
    "travel_insurance": "Assurance voyage totale",
    "travel_insurance_txt": "Assurance voyage complète",
    "traveler_options": {
      "adult": {
        "one": "%{count} Adulte",
        "other": "%{count} Adultes"
      },
      "all_children": {
        "one": "%{count} Enfant (0-17 ans)",
        "other": "%{count} Enfants (0-17 ans)"
      },
      "baby": {
        "one": "%{count} Bébé (0-1 ans)",
        "other": "%{count} Bébés (0-1 ans)"
      },
      "baby_parts": {
        "one": "Dont %{count} bébé (0-1 ans)",
        "other": "Dont %{count} bébés (0-1 ans)"
      },
      "child": {
        "one": "%{count} Enfant (2-17 ans)",
        "other": "%{count} Enfants (2-17 ans)"
      },
      "pet": {
        "one": "%{count} Animal",
        "other": "%{count} Animaux"
      }
    },
    "travelers": "Voyageurs",
    "try_again": "Veuillez réessayer",
    "week": "Semaine",
    "weeks": "Semaines"
  },
  "booking_cancel": "Annuler la réservation ",
  "booking_confirmation": "Confirmation de réservation",
  "booking_confirming": "Confirmer la réservation",
  "breakfast_offer": {
    "body": "Dans ce logement, vous avez la possibilité de <a href=\"https://specials.casapilot.com/shop/?lang=fr\" target=\"_blank\" rel=\"noreferrer\">réserver le petit-déjeuner et des repas</a> avant votre séjour. Laissez-vous gâter par de délicieux produits de la région!",
    "title": "NOUVEAU: Faites-vous livrer votre petit déjeuner ou menu!"
  },
  "buttons": {
    "availability": "Disponibilité",
    "book_now": "Réservez maintenant ",
    "cancel": "Annuler",
    "continue": "Suivant",
    "delete": "Supprimer",
    "edit": "Modifier",
    "go_to_summary": "Aller au résumé",
    "host_acct_create": "Créer un compte propriétaire",
    "login_continue": "Se connecter et poursuivre la réservation",
    "offers": "Vers les offres ",
    "pay": "Payer",
    "preview": "Aperçu",
    "price": "Prix",
    "register_continue": "S'inscrire et poursuivre la réservation",
    "register_property": "Enregistrer votre logement maintenant.",
    "renter_acct_create": "Créer un compte locataire",
    "reserve_now": "Réservez de manière payante ",
    "save": "Sauver",
    "submit": "Sauver"
  },
  "cancellation": "Stornieren",
  "chat_tool": {
    "widget_id": "1ef1742566a5116bec557ceb049992ab49fb0edcc7f110fa6a0e7125642b5446"
  },
  "confirm": "Confirmer",
  "confirmed_by_admin": "Confirmé par l'administrateur",
  "confirmed_by_host": "Confirmé par le propriétaire",
  "cookie_disclaimer": {
    "button_text": "Accepter",
    "link_text": "En savoir plus",
    "text": "<p>Ce site utilise des cookies.</p>\n<p>Ce sont de petits fichiers texte qui sont stockés sur votre appareil et permettent une analyse de l'utilisation du site.</p>\n<p>Pour plus d'informations, s'il vous plaît veuillez vous référer à notre politique de confidentialité.</p>\n<p>En continuant à utiliser le site Web avec les paramètres de navigateur appropriés, vous acceptez l'utilisation de cookies dans ce contexte.</p>"
  },
  "country_codes": {
    "at": "Autriche",
    "be": "Belgique",
    "bg": "Bulgarie",
    "ch": "Suisse",
    "cy": "Chypre",
    "cz": "République Tchèque",
    "de": "Allemagne",
    "dk": "Danemark",
    "ee": "Estonie",
    "es": "Espagne",
    "false": "Norvège",
    "fi": "Finlande",
    "fr": "France",
    "gb": "Royaume-Uni",
    "gr": "Grèce",
    "hr": "Croatie",
    "ie": "Irlande",
    "is": "Islande",
    "it": "Italie",
    "li": "Liechtenstein",
    "lt": "Lituanie",
    "lu": "Luxembourg",
    "lv": "Lettonie",
    "mt": "Malte",
    "nl": "Pays-Bas",
    "pl": "Pologne",
    "pt": "Portugal",
    "ro": "Roumanie",
    "se": "Suède",
    "si": "Slovénie",
    "sk": "Slovaquie",
    "uk": "Royaume-Uni"
  },
  "date": {
    "abbr_day_names": [
      "dim",
      "lun",
      "mar",
      "mer",
      "jeu",
      "ven",
      "sam"
    ],
    "abbr_day_names_string": {
      "friday": "ven",
      "monday": "lun",
      "saturday": "sam",
      "sunday": "dim",
      "thursday": "jeu",
      "tuesday": "mar",
      "wednesday": "mer"
    },
    "abbr_month_names": [
      null,
      "jan.",
      "fév.",
      "mar.",
      "avr.",
      "mai",
      "juin",
      "juil.",
      "août",
      "sept.",
      "oct.",
      "nov.",
      "déc."
    ],
    "day_names": [
      "dimanche",
      "lundi",
      "mardi",
      "mercredi",
      "jeudi",
      "vendredi",
      "samedi"
    ],
    "day_names_string": {
      "friday": "vendredi",
      "monday": "lundi",
      "saturday": "samedi",
      "sunday": "dimanche",
      "thursday": "jeudi",
      "tuesday": "mardi",
      "wednesday": "mercredi"
    },
    "formats": {
      "calendar_field": "%d.%m.%Y",
      "day_date_month": "dd, DD. MMM",
      "default": "%d/%m/%Y",
      "long": "%e %B %Y",
      "long_date": "%a. %d.%m.%y",
      "month_year": "MMMM YYYY",
      "only_day": "%e",
      "request_time_scope": "dd. DD/MM/YY",
      "short": "%e %b"
    },
    "month_names": [
      null,
      "janvier",
      "février",
      "mars",
      "avril",
      "mai",
      "juin",
      "juillet",
      "août",
      "septembre",
      "octobre",
      "novembre",
      "décembre"
    ],
    "order": [
      "day",
      "month",
      "year"
    ]
  },
  "datetime": {
    "distance_in_words": {
      "about_x_hours": {
        "one": "environ une heure",
        "other": "environ %{count} heures"
      },
      "about_x_months": {
        "one": "environ un mois",
        "other": "environ %{count} mois"
      },
      "about_x_years": {
        "one": "environ un an",
        "other": "environ %{count} ans"
      },
      "almost_x_years": {
        "one": "presqu'un an",
        "other": "presque %{count} ans"
      },
      "half_a_minute": "une demi-minute",
      "less_than_x_minutes": {
        "one": "moins d'une minute",
        "other": "moins de %{count} minutes",
        "zero": "moins d'une minute"
      },
      "less_than_x_seconds": {
        "one": "moins d'une seconde",
        "other": "moins de %{count} secondes",
        "zero": "moins d'une seconde"
      },
      "over_x_years": {
        "one": "plus d'un an",
        "other": "plus de %{count} ans"
      },
      "x_days": {
        "one": "1 jour",
        "other": "%{count} jours"
      },
      "x_minutes": {
        "one": "1 minute",
        "other": "%{count} minutes"
      },
      "x_months": {
        "one": "1 mois",
        "other": "%{count} mois"
      },
      "x_seconds": {
        "one": "1 seconde",
        "other": "%{count} secondes"
      }
    },
    "prompts": {
      "day": "Jour",
      "hour": "Heure",
      "minute": "Minute",
      "month": "Mois",
      "second": "Seconde",
      "year": "Année"
    }
  },
  "days_short": {
    "friday": "Ven",
    "monday": "Lun",
    "saturday": "Sam",
    "sunday": "Dim",
    "thursday": "Jeu",
    "tuesday": "Mar",
    "wednesday": "Mer"
  },
  "devise": {
    "confirmations": {
      "confirmed": "Votre compte est validé.Vous êtes enregistré(e)",
      "new": {
        "submit": "Soumettre",
        "title": "Envoyer une confirmation"
      },
      "send_instructions": "Vous recevrez dans quelques instants un e-mail permettant la réinitialisation de votre mot de passe.",
      "send_paranoid_instructions": "If your email address exists in our database, you will receive an email with instructions for how to confirm your email address in a few minutes.",
      "updated": "Votre mot de passe a été mis à jour avec succès."
    },
    "error_occured": "Une erreur s'est produite",
    "failure": {
      "already_authenticated": "Vous êtes déjà connecté. ",
      "inactive": "Votre compte n'est pas actif.",
      "invalid": "Vos coordonnées de connexion sont erronées.",
      "invalid_token": "Problème d'authentification.",
      "last_attempt": "You have one more attempt before your account is locked.",
      "locked": "Votre compte est bloqué.",
      "not_found_in_database": "Invalid %{authentication_keys} or password.",
      "timeout": "Votre session a expiré, veuillez vous reconnecter.",
      "unauthenticated": "Vous êtes prié(e) de vous identifier ou vous enregistrer avant de poursuivre.",
      "unconfirmed": "Veuillez confirmer votre compte avant de poursuivre."
    },
    "mailer": {
      "confirmation_instructions": {
        "subject": "Veuillez confirmer votre inscription en tant qu’utilisateur de www.casapilot.com"
      },
      "email_changed": {
        "subject": "Email Changed"
      },
      "password_change": {
        "subject": "Password Changed"
      },
      "reset_password_instructions": {
        "subject": "Réinitialiser votre mot de passe sur www.casapilot.com"
      },
      "unlock_instructions": {
        "subject": "Votre profil sur www.casapilot.com a été bloqué"
      }
    },
    "oauth_callbacks": {
      "failure": "Impossible de se connecter au compte %{kind}-Account car \"%{reason}\". ",
      "success": "Vous êtes connecté au compte \"%{kind}-Account\"."
    },
    "omniauth_callbacks": {
      "failure": "Could not authenticate you from %{kind} because \"%{reason}\".",
      "success": "Successfully authenticated from %{kind} account."
    },
    "passwords": {
      "edit": {
        "submit": "Sauvegarder le mot de passe",
        "title": "Modifier le mot de passe"
      },
      "new": {
        "submit": "Réinitialiser le mot de passe",
        "title": "Mot de passe oublié ?"
      },
      "no_token": "You can't access this page without coming from a password reset email. If you do come from a password reset email, please make sure you used the full URL provided.",
      "send_instructions": "Vous recevrez dans quelques instants un e-mail contenant les informations nécessaires à la réinitialisation de votre mot de passe.",
      "send_paranoid_instructions": "If your email address exists in our database, you will receive a password recovery link at your email address in a few minutes.",
      "updated": "Votre mot de passe a été modifié. Vous êtes connecté.",
      "updated_not_active": "Your password has been changed successfully."
    },
    "registrations": {
      "destroyed": "Votre compte a bien été effacé.",
      "edit": {
        "back": "Retour",
        "cancel": {
          "description": "Mécontent ?",
          "link": "Supprimer mon compte",
          "question": "Êtes-vous sûr(e) ?",
          "title": "Supprimer compte"
        },
        "current_hint": "(vous aurez besoin de votre mot de passe pour effectuer des modifications)",
        "password_hint": "(laissez la case vide si vous ne désirez pas le modifier)",
        "submit": "Enregistrer",
        "title": "Modifier le compte"
      },
      "new": {
        "newsletter_subscription": "Je souhaite recevoir la newsletter de Casapilot.",
        "submit": "Créer compte",
        "title": "Créez gratuitement votre profil en tant que propriétaire"
      },
      "signed_up": "Vous vous êtes enregistré avec succès. Vous allez maintenant recevoir un e-mail de confirmation.\nVous n'avez pas reçu notre e-mail ? Vérifiez votre boite spam.",
      "signed_up_but_inactive": "You have signed up successfully. However, we could not sign you in because your account is not yet activated.",
      "signed_up_but_locked": "You have signed up successfully. However, we could not sign you in because your account is locked.",
      "signed_up_but_unconfirmed": "A message with a confirmation link has been sent to your email address. Please follow the link to activate your account.",
      "update_needs_confirmation": "You updated your account successfully, but we need to verify your new email address. Please check your email and follow the confirmation link to confirm your new email address.",
      "updated": "Vos données ont été mises à jour avec succès.",
      "updated_but_not_signed_in": "Your account has been updated successfully, but since your password was changed, you need to sign in again."
    },
    "sessions": {
      "already_signed_out": "Signed out successfully.",
      "new": {
        "login_text": "Pour gérér vos hébergements, connectez-vous avec vos données d'accès. ",
        "submit": "Connexion",
        "title": "Vous voulez accéder à votre compte propriétaire? C'est ici. "
      },
      "signed_in": "Vous êtes connecté(e).",
      "signed_out": "Vous êtes déconnecté(e)."
    },
    "shared": {
      "links": {
        "confirmation": "Vous n'avez pas reçu l'e-mail de confirmation ?",
        "not_registered": "Vous n'êtes pas encore membre? ",
        "password": "Mot de passe oublié ?",
        "registered": "Vous êtes déjà membre? ",
        "sign_in": "Se connecter ici",
        "sign_up": "S'inscrire",
        "unlock": "Vous n'avez pas reçu les informations pour déverrouiller votre compte ?"
      }
    },
    "unlocks": {
      "new": {
        "sumbit": "Renvoyer les instructions sur la façon de déverrouiller",
        "title": "Renvoyer les instructions sur la façon de déverrouiller"
      },
      "send_instructions": "Vous recevrez dans quelques instants un e-mail contenant toutes les informations permettant de déverrouiller votre compte.",
      "send_paranoid_instructions": "If your account exists, you will receive an email with instructions for how to unlock it in a few minutes.",
      "unlocked": "Votre compte a été déverrouillé avec succès. Vous êtes maintenant enregistré(e)."
    }
  },
  "errors": {
    "format": "%{attribute} %{message}",
    "messages": {
      "accepted": "doit être accepté(e)",
      "already_confirmed": "déjà confirmé",
      "blank": "doit être rempli(e)",
      "confirmation": "ne concorde pas avec la confirmation",
      "confirmation_period_expired": "needs to be confirmed within %{period}, please request a new one",
      "empty": "doit être rempli(e)",
      "equal_to": "doit être égal à %{count}",
      "even": "doit être pair",
      "exclusion": "n'est pas disponible",
      "expired": "has expired, please request a new one",
      "greater_than": "doit être supérieur à %{count}",
      "greater_than_or_equal_to": "doit être supérieur ou égal à %{count}",
      "in": "must be in %{count}",
      "in_between": "must be in between %{min} and %{max}",
      "inclusion": "n'est pas inclus(e) dans la liste",
      "invalid": "n'est pas valide",
      "less_than": "doit être inférieur à %{count}",
      "less_than_or_equal_to": "doit être inférieur ou égal à %{count}",
      "model_invalid": "Validation failed: %{errors}",
      "not_a_number": "n'est pas un nombre",
      "not_an_integer": "doit être un nombre entier",
      "not_found": "introuvable",
      "not_locked": "non verrouillé",
      "not_saved": {
        "one": "1 error prohibited this %{resource} from being saved:",
        "other": "%{count} errors prohibited this %{resource} from being saved:"
      },
      "odd": "doit être impair",
      "other_than": "must be other than %{count}",
      "password_too_long": "is too long",
      "present": "must be blank",
      "required": "must exist",
      "spoofed_media_type": "has contents that are not what they are reported to be",
      "taken": "has already been taken",
      "too_long": "est trop long (pas plus de %{count} caractères)",
      "too_short": "est trop court (au moins %{count} caractères)",
      "wrong_length": "ne fait pas la bonne longueur (doit comporter %{count} caractères)"
    },
    "template": {
      "body": "Veuillez vérifier les champs suivants : ",
      "header": {
        "one": "Impossible d'enregistrer ce %{model} : 1 erreur",
        "other": "Impossible d'enregistrer ce %{model} : %{count} erreurs"
      }
    }
  },
  "extra_services": {
    "body": "In this accommodation you have the possibility to book <a href=\"https://specials.casapilot.com/shop/\">the Casapilot breakfast service</a> before your stay. Let us spoil you with delicious products from the region!",
    "bookable": {
      "1-night-only": "Réservation possible pour 1 nuit",
      "bikerental": "Location de vélos sur demande",
      "breakfast": "Petit-déjeuner sur demande",
      "carcharger": "Station de recharge pour voiture électrique sur demande",
      "casapilot-breakfast": "Petit-déjeuner réservable chez Casapilot",
      "champagne": "Boissons de bienvenue sur demande",
      "dinner": "Dîner sur demande",
      "dog": "Chiens autorisés",
      "flowers": "Fleurs et décoration romantique sur demande",
      "massage": "Massage sur demande",
      "pool": "Piscine",
      "sauna": "Sauna",
      "whirlpool": "Jacuzzi"
    },
    "included": {
      "1-night-only": "Réservation possible pour 1 nuit",
      "bikerental": "Location de vélo incluse",
      "breakfast": "Petit déjeuner inclus",
      "carcharger": "Station de recharge pour voiture électrique incluse",
      "casapilot-breakfast": "Petit déjeuner inclus",
      "champagne": "Boissons de bienvenue incluses",
      "dinner": "Dîner inclus",
      "dog": "Chiens autorisés",
      "flowers": "Fleurs et décoration romantique incluses",
      "massage": "Massage inclus"
    },
    "title": "NEW: Get your breakfast delivered!"
  },
  "flash": {
    "actions": {
      "create": {
        "notice": "%{resource_name} was successfully created."
      },
      "destroy": {
        "alert": "%{resource_name} could not be destroyed.",
        "notice": "%{resource_name} was successfully destroyed."
      },
      "update": {
        "notice": "%{resource_name} was successfully updated."
      }
    },
    "alert": {
      "accept_tos": "Veuillez accepter les CGV.",
      "error_too_many_insurants": "Le nombre de voyageurs est supérieur à 7 personnes, or 7 personnes au maximum peuvent être assurées. Veuillez contacter info@casapilot.com.",
      "error_try_again": "Une erreur s'est produite.\nEssayez encore une fois s'il y a eu une erreur. Si vous venez de compléter une réservation, veuillez contacter notre équipe de réservation par info@casapilot.com",
      "insert_information": "Veuillez compléter tous les champs en rouge.",
      "insert_name": "Il est nécessaire d'introduire un nom de famille.",
      "insert_names_1": "Veuillez saisir exactement %{count} noms de famille.",
      "insert_names_2": "noms de famille insérés.",
      "insurance_error_prebook_period_to_long": "Votre séjour ne peut commencer au-delà d'une année.",
      "insurance_over_tenthousand": "Le montant maximum assurable concernant les assurances voyage est de 10.000,00 € par personne.",
      "insurance_product": "Une erreur en rapport avec les assurances s'est produite. Veuillez réessayer s'il vous plait."
    }
  },
  "footer": {
    "about": "A propos de Casapilot",
    "contact_link": "info@casapilot.com?subject=www.casapilot.com ",
    "follow_us": "Suis nous sur",
    "imprint_link": "/fr/about/imprint",
    "support": "Support",
    "team_cpl": "L'équipe Casapilot",
    "team_cpl_link": "https://www.casapilot.com/fr/your_benefits",
    "vouchers": "Chèque-cadeau",
    "vouchers_link": "https://shop.casapilot.com/fr"
  },
  "header": {
    "facebook_link": "http://www.facebook.com/casapilot.fr",
    "hyves_link": "http://www.hyves-share.nl/button/tip/?tipcategoryid=12&rating=5&title=Casapilot&body=www.casapilot.com ",
    "phone_annotation_host": "Une question ? Prenez contact avec nous :",
    "phone_annotation_renter": "Réservez en direct:",
    "phone_host": "Tél. +352 20 20 34 26 30",
    "phone_renter": "+352 20 20 34 26 30",
    "twitter_link": "http://twitter.com/?status=http%3A%2F%2Fwww.casapilot.com "
  },
  "helpers": {
    "label": {
      "holiday_home": {
        "accommodation_amenities": "Equipement ",
        "accommodation_area": "Surface habitable (m²)",
        "accommodation_bond": "Caution (€)",
        "accommodation_bond_refund": "Restitution de la caution",
        "accommodation_created_at": "Créé le",
        "accommodation_description": "Description",
        "accommodation_fee": "Commission (en %)",
        "accommodation_id": "ID",
        "accommodation_kind": "Type de logement",
        "accommodation_max_persons": "Personnes (max.)",
        "accommodation_number_of_baths": "Salle de bains ",
        "accommodation_number_of_bunk_beds": "Lits superposés",
        "accommodation_number_of_daybeds": "Canapé-lit",
        "accommodation_number_of_king_size_beds": "Lits double",
        "accommodation_number_of_rooms": "Chambre à coucher",
        "accommodation_number_of_similar": "Nombre de logements du même type.",
        "accommodation_number_of_single_beds": "Lits simple",
        "accommodation_photos": "Photos",
        "accommodation_property_id": "Hébergement",
        "accommodation_title": "Titre",
        "accommodation_updated_at": "Mis à jour",
        "property_country": "Pays",
        "property_created_at": "Créé le",
        "property_description": "Description",
        "property_id": "ID",
        "property_locality": "Localité",
        "property_postal_code": "Code postal",
        "property_rating": "Etoiles",
        "property_region": "Région ",
        "property_street": "Rue",
        "property_title": "Nom de l'hébergement",
        "property_top_object": "Hébergement de niveau supérieur",
        "property_travel_region_id": "Région",
        "property_updated_at": "Mis à jour"
      },
      "subscription": {
        "country": "Localisation de l'hébergement",
        "email": "E-Mail",
        "kind": "Je possède",
        "kind_apartment": "Appartement ",
        "kind_bed_and_breakfast": "Chambre d'hôtes ",
        "kind_vacation_rental": "Maison de vacances ",
        "language": "Votre langue"
      }
    },
    "select": {
      "prompt": "Veuillez sélectionner"
    },
    "submit": {
      "create": "Créer un %{model}",
      "submit": "Enregistrer ce %{model}",
      "update": "Modifier ce %{model}"
    }
  },
  "home": {
    "teaser": {
      "text_1": "Nous réservons votre villa y compris vol et voiture.<br /> <strong>Réservez en direct: :</strong> <br /> +352 20 20 34 26 30\n",
      "text_2": "Votre partenaire du Luxembourg",
      "text_3": "Pourquoi Casapilot ?<br />Bon prix, réserver en toute sécurité, service 5 étoiles"
    }
  },
  "homepage": {
    "checks": {
      "headline_1": "Annoncez gratuitement",
      "headline_2": "Gagner de l'avance",
      "headline_3": "Déterminer eux-mêmes les prix",
      "headline_4": "Rester flexible",
      "text_1": "L'annonce de votre logement est gratuite.",
      "text_2": "En cas de location, nous vous payons deux semaines avant l'arrivée de vos clients.",
      "text_3": "Vous déterminez vous-même le prix de location de votre propriété.",
      "text_4": "Vous déterminez vous-même à quelle période votre propriété est disponible."
    },
    "counter_text": "Maisons de vacances",
    "counter_text_single": "Maison de vacances",
    "head_title": "selected homes",
    "headline": "Louer votre maison de vacances ? Rien de plus facile avec Casapilot !",
    "intro_text_1": "Casapilot est votre nouveau partenaire pour la location de votre maison de vacances ou de votre chambre d'hôtes.",
    "intro_text_2": "Inscrivez-vous dès à présent. Nous vous tiendrons informé et vous serez parmi les premiers avertis lorsque notre plateforme sera disponible.",
    "intro_text_3": "Nous vous trouvons de nouveaux clients.",
    "relax_cottage_stoerer": {
      "headline": "Suite Bien-être - Suite Nuptiale",
      "text": "Suites de détente avec jacuzzi dans une ambiance<br/>exclusive pour un séjour romantique avec votre partenaire."
    },
    "subscription_form": {
      "country": {
        "andorra": "Andorra",
        "austria": "Autriche",
        "belgium": "Belgique",
        "croatia": "Croatie",
        "danemark": "Danemark",
        "finland": "Finlande",
        "france": "France",
        "germany": "Allemagne",
        "great_britain": "Angleterre  ",
        "greece": "Grèce",
        "hungary": "Hongrie",
        "ibiza": "Ibiza",
        "island": "Islande",
        "italy": "Italie",
        "liechtenstein": "Lichtenstein",
        "luxemburg": "Luxembourg",
        "malta": "Malta",
        "monaco": "Monaco",
        "nederland": "Pays-Bas",
        "norway": "Norvège",
        "poland": "Pologne",
        "portugal": "Portugal",
        "scotland": "Écosse",
        "spain": "Espagne",
        "sweden": "Suède",
        "switzerland": "Suisse"
      },
      "email": "E-Mail",
      "email_text": "Votre adresse email est traitée de manière confidentielle.",
      "headline": "Inscrivez-vous et restez informé.",
      "language": {
        "de": "Allemand",
        "en": "Anglais",
        "es": "Espagnol ",
        "fr": "Français ",
        "nl": "Néerlandais"
      },
      "submit": "Inscrire maintenant"
    }
  },
  "homepage_customer": {
    "book_object": "Réserver",
    "country": "Destination de vacances",
    "head_title": "selected homes",
    "headline": "Maisons de vacances, villas et suites sélectionnées pour vous",
    "hosts": {
      "headline": "Les meilleures offres de Casapilot"
    },
    "intro_headline": "Pourquoi réserver votre séjour avec Casapilot ?",
    "intro_text_1": "Un système simple et une recherche facile pour des vacances tranquilles, tout simplement.",
    "intro_text_1_hl": "Simple.",
    "intro_text_2": "Chaque logement est sélectionné personnellement avec soin. Ensuite seulement il peut rejoindre l'offre Casapilot.",
    "intro_text_2_hl": "Sélectionné.",
    "intro_text_3": "A votre arrivée, tout est là. Un problème ? Nous sommes disponibles pour vous. Vous pouvez compter sur nous.",
    "intro_text_3_hl": "Fiable.",
    "landingpage": {
      "headline": "Les meilleures destinations de vacances"
    },
    "last_viewed_objects": "Logements récemment consultés",
    "objects_foot_hl": "Vous pourriez également apprécier ces logements",
    "prebook_object": "Retenir",
    "reserve": "Réserver ",
    "search_arrival": "Arrivée ",
    "search_button": "Recherche",
    "search_category_1": "En famille",
    "search_category_2": "En amoureux",
    "search_category_3": "Aventure",
    "search_category_4": "Cocoon",
    "search_category_5": "Autres suggestions",
    "search_departure": "Début",
    "search_detail": "Recherche détaillée",
    "search_headline": "Vos vacances commencent ici.",
    "see_object": "Afficher",
    "slideshow": {
      "ardennen": "Maisons de vacances en Ardennes",
      "ardennen_desc": "Bénéficiez de la tranquillité rurale et découvrez les nombreux sentiers de randonnée et pistes cyclables. Profitez des nombreuses activités de loisirs de la région. ",
      "austria": "Maisons de vacances en Autriche",
      "austria_desc": "Hiver comme été, l'Autriche vaut toujours une visite. En été, vous pourrez découvrir des sentiers de randonnée et faire des visites culturelles, et en hiver vous pourrez profiter des nombreuses pistes de ski.  ",
      "cotedazur": "Maisons de vacances à la Côte d'Azur",
      "cotedazur_desc": "Sans doute la côte la plus célèbre en Europe. Laissez-vous envoûter par de nombreuses possibilités de shopping, de la cuisine française fantastique et des belles plages.",
      "france": "Maisons de vacances en France",
      "france_desc": "Découvrez les plus belles maisons de vacances en France. Visitez les lieux les plus connus, à l’intérieur du pays comme sur la côte. Les beaux paysages invitent à passer un séjour inoubliable.",
      "ibiza": "Maisons de vacances en Ibiza",
      "ibiza_desc": "Ne manquez pas le luxe sur cette île méditerranéenne exclusive! Des belles plages et la vie nocturne vivante garantissent un séjour inoubliable sur Ibiza.",
      "luxemburg": "Luxemburg",
      "luxemburg_desc": "",
      "mallorca": "Maisons de vacances à Majorque",
      "mallorca_desc": "Découvrez les belles plages et le charme rural préservé de l’île méditerranéenne populaire. Profitez de vos vacances dans une maison de campagne confortable ou dans une belle villa. ",
      "spain": "Maisons de vacances en Espagne",
      "spain_desc": "Découvrez les plus beaux sites de l’Espagne et de sa côte avec de magnifiques plages. \nPassez des vacances inoubliables dans une maison de vacances à Malaga, sur la Costa del Sol, la Costa Blanca, la Costa Brava,… \n",
      "wellnesssuites": "Suite Bien-être - Suite Nuptiale",
      "wellnesssuites_desc": "Suites de détente avec jacuzzi dans une ambiance exclusive pour un séjour romantique avec votre partenaire. Fraîchement marié, anniversaire ou comme cadeau, nos suites nuptiales offrent pour chaque couple du luxe et du repos."
    }
  },
  "host": {
    "ab": "à partir de",
    "accept_agbs": "Veuillez accepter les Conditions générales de Vente.",
    "accommodation": "Hébergement",
    "accommodation_number_of_beds_zero": "Veuillez introduire au minimum le type et le nombre de lits.",
    "accommodation_reviews": "Reviews",
    "accommodations": {
      "prices": {
        "day_of_arrival": "Jour d'arrivée",
        "day_of_departure": "Jour de départ ",
        "friday": "Vendredi",
        "monday": "Lundi",
        "sunday": "Dimanche"
      },
      "suggestions": "Nos suggestions pour vous"
    },
    "add_image": "Ajouter une photo",
    "add_new_accommodation": "Ajouter un nouvel hébergement",
    "add_new_property": "Ajouter un nouvel hébergement",
    "add_new_room": "Ajouter une nouvelle chambre",
    "additional_costs": "Frais supplémentaires",
    "adress": "Adresse",
    "all_properties": "Tous les hébergements de",
    "amenities": "Caractéristiques",
    "amount_bathrooms": "Nombre de salles de bains à partir de",
    "amount_bedrooms": "Chambres à coucher",
    "amount_rooms": "Nombre de chambres",
    "apartment": "Appartement",
    "as": "comme",
    "attractions": "Activités",
    "avail_in": "Disponible dans",
    "avail_in_2": "jours",
    "avail_in_3": "jour",
    "availabilities": {
      "availabilities": {
        "availabilities_select": "Veuillez sélectionner l'année ici:"
      }
    },
    "availabilities_text": "Si vous souhaitez indiquer un jour comme étant indisponible, cliquez avec votre souris sur le jour en question et sélectionnez \"Marquer\". Si vous souhaitez indiquer plusieurs jours consécutifs comme indisponibles, cliquez sur le premier et le dernier jour de la période en question et ensuite sur \"Marquer\". Les jours réservés via Casapilot sont automatiquement marqués comme indisponibles par notre système.",
    "availability": "Disponibilité",
    "availability_message": "Veuillez mettre à jour la disponibilité de votre logement",
    "avatar_text": "Vous pouvez télécharger une photo de vous ici si vous le désirez. La photo sera affichée dans la case de contact de votre annonce.",
    "base_rating": "Évaluation de base",
    "basics": "Information de base",
    "baths": "Salle de bains",
    "bed_and_breakfast": "Chambre d’hôtes",
    "blocked": "Non disponible ",
    "blocked_msg": "Il n'y a pas de jour d'arrivée disponible pour la période souhaitée. Veuillez choisir une autre période.",
    "bookable": "Disponible",
    "booked": "Réservé par Casapilot",
    "bookings_count": "personnes ont réservé auprès de ce propriétaire",
    "bookings_count_zero": "Cet hébergement est nouveau dans le programme",
    "bunk_beds": "Lits superposés",
    "clearing_message": "Afin d'activer ce logement, veuillez fournir les renseignements suivants.",
    "clearing_missing": "Les données suivantes sont toujours manquantes",
    "clearing_status_popup": "Votre logement est incomplet",
    "confirm_delete": "Etes-vous sûr que cet objet doit être supprimé? Cette action ne peut pas être annulée.",
    "contact_user": "Contacter",
    "coordinates": "Coordonnées",
    "coordinates_annotation": "Insérez ici les coordonnées exactes de votre logement au cas où celui-ci serait mal localisé sur la carte dans l'aperçu.",
    "country": "Pays",
    "create": "Créer",
    "create_holiday_home": "Créer l'hébergement",
    "create_property": "Créer un hébergement",
    "cut_image": "Recadrer la photo",
    "dashboard": {
      "index": {
        "html": {
          "all_objects": "Voir tous les logements",
          "another_object": "Enregistrer un nouveau logement.",
          "another_object_content": "Au plus vous enregistrez de logements, au plus vous louerez et engrangerez des bénéfices. <br /> Prenez <strong>5 minutes</strong> et ajoutez vos autres logements.",
          "button": "Créer un logement maintenant",
          "button_another_object": "Ajouter un logement",
          "first_object": "Créez votre première maison de vacances.",
          "first_object_content": "N'hésitez plus un seul instant et faites de Casapilot votre nouveau partenaire pour la location de votre maison de vacances ou de votre appartement de vacances : vous pourrez enregistrer les principales informations en <strong>5 minutes</strong> seulement.",
          "news_more": "Plus de nouvelles.",
          "news_specialoffer_text": "Le site Web Casapilot.com sera disponible pour vos futurs clients dès le 1er juin 2011. Si vous enregistrez votre maison de vacances avant le 1er juillet 2011, vous pourrez profiter de conditions spéciales.",
          "news_specialoffer_title": "Enregistrez votre maison de vacances dès maintenant et profitez de conditions spéciales.",
          "news_title": "Nouvelles de Casapilot",
          "title": "Statistiques",
          "your_properties": "Votre logement"
        }
      }
    },
    "daybeds": "Canapé-lit",
    "del_confirm": "Êtes-vous sûr ?",
    "delete": "Supprimer",
    "description": "Description",
    "details": "Détails",
    "details_missing": "Quelles sont les informations manquantes ?",
    "distance_description": "Activez une case pour introduire la distance en kilomètres.",
    "distance_unit": "km",
    "downloads": "Téléchargements",
    "duration_of_stay": "Durée de séjour",
    "edit": "Modifier",
    "edit_accommodation": "Modifier l'hébergement",
    "edit_holiday_home": "Modifier le logement",
    "edit_image": "Modifier la photo",
    "embed_calendar_text": "Vous pouvez intégrer ce calendrier dans votre site web avec ces iFrames:",
    "extras": "Suppléments",
    "extras_annotation": "Ici vous pouvez configurer différentes fonctions.",
    "fallback_text": "Aucune donnée n'a encore été saisie.",
    "fallback_text_costs": "Aucun.",
    "fallback_text_description": "Aucune description n'a encore été saisie.",
    "feedback_message": "En cas de question, veuillez prendre contact avec notre support :",
    "filter": "Filtre",
    "following_rooms_already_created": "Les chambres suivantes ont déjà été créées :",
    "forms": "Formulaires",
    "from": "à partir de",
    "general_property_informations": "Informations générales",
    "hh_inc_fees": "Frais de réservations inclus",
    "holiday_home": "Maison de vacances",
    "holiday_homes": {
      "create": {
        "create_failed": "Votre logement n'a pas pu être créé. Veuillez compléter tous les champs marqués en rouge.",
        "create_successful": "Votre logement a bien été créé. Vous pouvez à présent télécharger des photos et ajouter des informations sur votre logement."
      },
      "description": {
        "annotations": {
          "property_description": "La description permet au client de se projeter dans son propre rêve. Ne l'interrompez pas avec un style télégraphique, une répétition des équipements ou de la surface de votre logement. Vantez son atmosphère, son confort, mettez-vous à la place du client qui ne connaît ni la région ni la maison et qui veut à la fois s'amuser et se rassurer. Insistez sur l'aspect sécurité pour les familles, l'aspect fun pour les jeunes, les aspects décontraction et découverte en général.",
          "property_description_hint_html": "La description permet au client de se projeter dans son propre rêve. Ne l'interrompez pas avec un style télégraphique, une répétition des équipements ou de la surface de votre logement. Vantez son atmosphère, son confort, mettez-vous à la place du client qui ne connaît ni la région ni la maison et qui veut à la fois s'amuser et se rassurer. Insistez sur l'aspect sécurité pour les familles, l'aspect fun pour les jeunes, les aspects décontraction et découverte en général.",
          "property_description_short": "Accroche brève (max. 88 caractères)",
          "property_description_short_remaining": "Caractères restants",
          "property_language": "Veuillez utiliser les onglets ci-dessous pour traduire votre annonce dans les autres langues.",
          "property_language_2": "Si vous ne souhaitez pas traduire vous-même, Casapilot peut s'en charger.",
          "property_rating": "Veuillez n'indiquer les données que si votre propriété dispose d'une évaluation.",
          "property_rating_forbidden": "Le classement de votre logement a été approuvé par l'équipe Casapilot. En cas de réclamation, veuillez nous contacter à l'adresse fr@casapilot.com",
          "property_title": "Votre logement apparaît sous ce nom sur le site Web."
        },
        "data_multiple_rooms": "Votre maison dispose de plusieurs chambres ou appartements à louer séparément?<br/>Dans ce cas, vous pouvez indiquer ici les données relatives à la première chambre ou au premier appartement.",
        "data_single_room": "Sinon, veuillez indiquer les valeurs valables pour l'ensemble de la maison ou de l'appartement.",
        "language_de": "Allemand",
        "language_description_1": "Votre descriptif est",
        "language_description_2": "Veuillez utiliser les onglets pour compléter les descriptions dans d'autres langues.",
        "language_en": "Anglais",
        "language_es": "Espagnol",
        "language_fr": "Français",
        "language_nl": "Néerlandais",
        "select_language": "Langue"
      },
      "form": {
        "data_multiple_rooms": "Votre maison dispose de plusieurs chambres ou appartements à louer séparément?\n<br/>Dans ce cas, vous pouvez indiquer ici les données relatives à la première chambre ou au premier appartement.",
        "data_single_room": "Sinon, veuillez indiquer les valeurs valables pour l'ensemble de la maison ou de l'appartement.",
        "language_de": "Allemand",
        "language_description_1": "Votre descriptif est",
        "language_description_2": "Veuillez utiliser les onglets pour compléter les descriptions dans d'autres langues.",
        "language_en": "Anglais",
        "language_es": "Espagnol",
        "language_fr": "Français",
        "language_nl": "Néerlandais",
        "select_language": "Langue"
      },
      "new": {
        "submit": "Créer l'hébergement",
        "title": "Créer un nouveau logement"
      }
    },
    "host": "Propriétaire ",
    "image_alt": "Aperçu du logement.",
    "image_description_text": "Décrivez brièvement la photo, par exemple Vue sur le jardin.",
    "image_gallery": "Gallerie",
    "image_legend": "Changer l'ordre des photos par glisser-déposer",
    "image_upload_description": "Sélectionnez une photo sur votre ordinateur. Nous recommandons une taille minimale de 1124 x 689 pixels (max. 950 KB) pour offrir des images de qualité aux visiteurs du site.",
    "inc_fees": "Assurance-dégâts et frais de réservation inclus",
    "included": "inclue",
    "incomplete": "incomplet",
    "info": "À propos de cet hébergement",
    "kind": "Type",
    "kind_of_property": "Type de logement",
    "kind_of_property_available": "Les pièces suivantes sont déjà créées :",
    "kind_of_property_none": "Le logement ne comporte pas d'autres pièces.",
    "king_size_beds": "Lits double",
    "languages": "Langues",
    "lat": "Latitude (exemple : 47,152370)",
    "limitation": {
      "allowed": "Oui",
      "forbidden": "non",
      "onrequest": "sur demande"
    },
    "limitations": "Restrictions",
    "limitations_annotation": "Vous pouvez spécifier certaines restrictions à l'aide du menu suivant",
    "link_edit_image": "Modifier",
    "list": "Retour",
    "locality": "Lieu",
    "long": "Longitude (exemple : 3,208140)",
    "main_image": "Image principale",
    "main_image_legend": "Placez votre photo principale ici (glissé-déposé).",
    "manage_properties": "Gestion des hébergements",
    "map": "Carte",
    "map_zoom": "Agrandir la carte",
    "max_persons": "Personnes max.",
    "messages": "Messages",
    "minimum_booking": "Nuits minimum",
    "more_images": "Plus de photos",
    "new_accommodation": "Nouvel hébergement",
    "new_room": "Nouvelle chambres",
    "no_images": "Aucune photo disponible",
    "not_published": "Non publié",
    "other_costs_text": "Ces coûts sont uniquement affichés si vous indiquez les informations.",
    "others": "autres",
    "payment": "Informations de paiement",
    "photos": "Photos",
    "platform_airbnb": "AirBnB",
    "platform_booking": "Booking.com",
    "platform_flipkey": "Flipkey",
    "platform_homeaway": "Homeaway",
    "platform_homelidays": "Homelidays",
    "platform_hometogo": "Hometogo",
    "platform_tripadvisor": "TripAdvisor",
    "platforms": "Platforms for export",
    "platforms_annotation": "You can switch off the export for specific platforms",
    "preview": "Aperçu",
    "prices": "Prix",
    "prices_availability": "Prix et disponibilité",
    "prices_overview": {
      "js_alert": "Veuillez utiliser le format 1 000,00 pour indiquer les prix, ou utilisez exclusivement des chiffres."
    },
    "properties": {
      "index": {
        "confirm_delete": "Etes-vous certain de vouloir supprimer ce logement? Cette action ne pourra pas être annulée."
      }
    },
    "property_id": "ID hébergement ",
    "property_title": "Titre hébergement",
    "published": "Publié",
    "rating": "Évaluation",
    "read_messages": "Lire les messages",
    "regilar_costs_text": "Si vous n'indiquez aucune information ici, ces coûts seront considérés comme compris.",
    "region": "Région",
    "registrations": {
      "edit": {
        "back": "arrière",
        "cancel": {
          "description": "Insatisfait",
          "link": "Supprimer mon compte",
          "question": "Etes-vous sûr",
          "title": "Supprimer compte"
        },
        "current_hint": "(Vous aurez besoin de votre mot de passe actuel de faire des changements)\n",
        "password_hint": "Si vous ne souhaitez pas modifier votre mot de passe, laissez les cases vides.",
        "submit": "Sauver",
        "title": "Modifier le compte"
      },
      "new": {
        "already_registered": "Je me suis déjà enregistré en tant que locataire sur Casapilot.",
        "host_account": "Créez gratuitement votre compte propriétaire Casapilot ici. ",
        "newsletter_subscription": "Je veux reçevoir le newsletter de Casapilot",
        "not_yet_registered": "Je ne suis pas encore locataire sur Casapilot.",
        "offers_text": "Ou voulez-vous partir en vacances et louer un hébergement chez Casapilot? Consultez nos offres. ",
        "register_account": "Vous souhaitez louer un hébergement? C'est ici. ",
        "register_pls": "Veuillez vous connecter.",
        "register_txt": "Créez gratuitement votre profil ici.",
        "submit": "Créer compte",
        "terms_of_service_html": "Je confirme que j'ai lu, compris et accepté <a href=\"/downloads/terms-conditions/host-fr\" target=\"_blank\">les Conditions générales de Vente</a>.",
        "title": "Créez gratuitement votre profil en tant que propriétaire"
      }
    },
    "registrations_addons": {
      "api_documentation": {
        "title": "Documentation API"
      },
      "edit_downloads": {
        "bank_data": "Bankverbindung",
        "bank_data_message": "Bitte geben Sie hier Ihre Bankverbindung ein damit wir Ihnen nach einer erfolgten Buchung Ihre Einnahmen überweisen können. Alle Ihre persönlichen Daten werden bei Casapilot vertraulich behandelt.",
        "bic": "BIC",
        "category_forms": "Formulaires ",
        "commercial_host": "Gewerblicher Vermieter",
        "compendium": "Guide pour les prix 2012",
        "compendium_description": "Voici des explications pour la fixation de vos prix locatifs.",
        "contact_data": "Kontaktdaten",
        "contact_data_message": "Bitte geben Sie hier ausschließlich Ihre Rechnungsadresse an und keinesfalls die Adresse Ihrer Ferienimmobilie.",
        "edit_payment": null,
        "house_rules": "Règlement d’ordre intérieur",
        "iban": "IBAN",
        "invoice_city": "Ort",
        "invoice_company": "Firma",
        "invoice_country": "Land",
        "invoice_fax": "Fax",
        "invoice_house_number": "Hausnummer",
        "invoice_mobile_phone": "Mobiltelefon",
        "invoice_name": "Name",
        "invoice_of_stay": "Décompte de fin de séjour",
        "invoice_of_stay_description": "Veuillez compléter le formulaire suivant avec les frais supplémentaires pour pouvoir les facturer au client en fin de séjour.",
        "invoice_of_stay_link": "/downloads/invoice_of_stay/Decompte_de_fin_de_sejour.pdf",
        "invoice_partner_agency": "Partneragentur",
        "invoice_phone": "Telefon",
        "invoice_postal_code": "PLZ",
        "invoice_street": "Straße / Hausnummer",
        "invoice_website": "Webseite",
        "kaution": "Formulaire de caution",
        "kaution_description": "Le locataire est tenu de vous payer la caution à l'arrivée.\nCette caution sert de garantie locative en cas d'abus par le locataire.",
        "kaution_link": "/downloads/deposit.pdf",
        "kind_of_host": "Vermieterart",
        "message": "Afin de faciliter la prise en charge de vos hôtes, nous vous proposons deux formulaires pratiques. <br/>Vous pouvez télécharger ces formulaires puis les imprimer.",
        "private_host": "Privater Vermieter",
        "title": "Formulaires",
        "vat_rate": "Umsatzsteuer-ID",
        "wellness": {
          "pool": "Jacuzzi et piscine",
          "sauna": "Sauna",
          "title": "Règles pour l’utilisation du sauna, du jacuzzi et de la piscine"
        }
      },
      "edit_payment": {
        "bank_data": "Coordonnées bancaires",
        "bank_data_message": "Vos codes IBAN et BIC/SWIFT nous permettent d'effectuer des virements bancaires vers votre compte dans le cadre du versement de vos loyers. Ces codes ne peuvent au aucun cas servir à débiter votre compte. Ils ne s'apparentent en aucune manière à une procuration ou à un numéro de carte de crédit/carte bleue. Son unique utilité est de permettre la réception de virements bancaires, comme le RIB somme toute. Ci-dessous, deux articles (relativement techniques) explicatifs sur Wikipédia.\n\nIBAN: http://fr.wikipedia.org/wiki/ISO_13616\nBIC/SWIFT: http://fr.wikipedia.org/wiki/ISO_9362",
        "bic": "BIC/SWIFT",
        "commercial_host": "Propriétaire professionnel",
        "contact_data": "Coordonnées",
        "contact_data_message": "Veuillez introduire ici votre adresse de facturation (pas l'adresse de votre/vos logement(s) de vacances).",
        "iban": "IBAN",
        "invoice_city": "Ville",
        "invoice_company": "Société",
        "invoice_country": "Pays",
        "invoice_fax": "Fax",
        "invoice_house_number": "Numéro de maison",
        "invoice_mobile_phone": "Tel. Mobile",
        "invoice_name": "Nom",
        "invoice_partner_agency": "Agence partenaire",
        "invoice_phone": "Téléphone",
        "invoice_postal_code": "CP",
        "invoice_street": "Rue / Numéro de maison",
        "invoice_website": "Site internet personnel",
        "kind_of_host": "Type de propriétaire",
        "private_host": "Propriétaire particulier",
        "title": "Coordonnées bancaires",
        "vat_rate": "ID. TVA"
      },
      "edit_tenant": {
        "key_hand_over": "Emplacement des clés",
        "key_hand_over_city": "Ville",
        "key_hand_over_country": "Pays",
        "key_hand_over_different_place": "Les clés du logement sont disponibles à une adresse différente.",
        "key_hand_over_name": "Nom",
        "key_hand_over_postal_code": "CP",
        "key_hand_over_street": "Rue",
        "more_languages": "Autres langues",
        "mother_tongue": "Langue maternelle",
        "other_language_1": "Allemand",
        "other_language_2": "Anglais",
        "other_language_3": "Français",
        "other_language_4": "Néerlandais",
        "other_language_5": "Espagnol",
        "title": "Informations pour vos locataires"
      }
    },
    "regular_costs": "Coût habituel",
    "rentable_units": "Périodes disponibles",
    "reservations": "Réservations",
    "room": "Chambre",
    "rooms": "Chambre",
    "save_description": "Enregistrer la description",
    "save_image": "Enregistrer la photo",
    "season_msg": "Pour des raisons organisationnelles, vous ne pouvez adapter les disponibilités jusqu'au 09.01.2026 inclus. Vous allez être informé dès que le traitement des disponibilités pour la saison 2026 est déverrouillé.",
    "show": "Afficher",
    "single_beds": "Lits simple",
    "size_capacity": "Taille et capacité",
    "square_meters": "Surface habitable",
    "star": "Étoile ",
    "star_rating": "Évaluation-Étoiles",
    "stars": "Étoiles",
    "status_revision": "Validation en cours",
    "status_visible": "Ce logement est validé et disponible à la réservation.",
    "suite": "Suite",
    "summer_price": "(été)",
    "tenant": "Informations pour vos clients",
    "thumb_fallback": "/images/thumb_fallback.gif ",
    "to": "Jusqu'à",
    "travel_bookings": {
      "index": {
        "availability": "Voir la disponibilité",
        "booking_period": "Période de réservation (date d'arrivée)",
        "cancelled": "Réfusé",
        "confirmed": "Confirmé",
        "date_of_receipt": "Date d'entrée",
        "details": "Détails",
        "sort": "Trier par",
        "sort_by_ref_code": "Suche nach Buchungsnummer"
      },
      "show": {
        "accommodation_id": "ID Hébergement",
        "accommodation_name": "Nom",
        "accomoodation": "Hébergement",
        "bond": "Caution",
        "booking": "Réservation",
        "booking_created_at": "Réservé le ",
        "booking_id": "Numéro de réservation",
        "booking_process": "Processus de réservation",
        "checkin": "Check-In",
        "checkout": "Check-Out",
        "costs": "Coûts",
        "extra_bring": "A apporter",
        "extra_cost": "Frais accessoires",
        "guest": "Locataire",
        "host_total": "Revenus locatifs",
        "on_request": "Sur demande",
        "optional_cost": "Coûts optionnels",
        "overview": "« Retour au sommaire",
        "stay": "Séjour",
        "tenant_information": "Informations sur le locataire",
        "tenant_name": "Nom du locataire",
        "tenant_phone_number": "Numéro de téléphone du locataire",
        "title": "Détails de la damende pour l'objet:"
      }
    },
    "update": "Mettre à jour",
    "winter_price": "(hiver)",
    "you_have_got": "Vous avez"
  },
  "host_details": {
    "included": "inclus",
    "on_request": "À la demande",
    "see_additional_costs": "Veuillez noter les informations sous « Frais supplémentaires »",
    "to_be_brought": "Doit être apporté"
  },
  "host_navigation": {
    "account": "Profil",
    "dashboard": "Cockpit",
    "messages": "Messages",
    "objects": "Objets",
    "reservations": "Réservations",
    "teaser_host": "Vous souhaitez louer votre hébergement? Inscrivez-vous maintenant."
  },
  "host_teaser": {
    "button": "Plus d’info",
    "number_of_baths": "Nombre de salles de bain",
    "number_of_persons": "Personnes (max)",
    "number_of_rooms": "Nombre de chambres"
  },
  "i18n": {
    "transliterate": {
      "rule": {
        "À": "a",
        "Á": "a",
        "Â": "a",
        "Ä": "ae",
        "Æ": "ae",
        "Ç": "c",
        "È": "e",
        "É": "e",
        "Ê": "e",
        "Ë": "e",
        "Í": "i",
        "Î": "i",
        "Ï": "i",
        "Ñ": "n",
        "Ó": "o",
        "Ô": "o",
        "Ö": "oe",
        "Ù": "u",
        "Ú": "u",
        "Û": "u",
        "Ü": "ue",
        "ß": "ss",
        "à": "a",
        "á": "a",
        "â": "a",
        "ä": "ue",
        "æ": "ae",
        "ç": "c",
        "è": "e",
        "é": "e",
        "ê": "e",
        "ë": "e",
        "í": "i",
        "î": "i",
        "ï": "i",
        "ñ": "n",
        "ó": "o",
        "ô": "o",
        "ö": "oe",
        "ù": "u",
        "ú": "u",
        "û": "u",
        "ü": "ue",
        "ÿ": "y",
        "Œ": "oe",
        "œ": "oe",
        "Ÿ": "y"
      }
    }
  },
  "icons": {
    "first": "start",
    "last": "end",
    "next": "forward",
    "previous": "back"
  },
  "inquiry_form": {
    "fail_notification": "Your enquiry wasn't transmitted successfully. Please try again later.",
    "inquiry_to": "Enquête ID Hébergement: ",
    "send_button": "Envoyer",
    "text": "N’hésitez pas à nous envoyer une demande non contractuelle ci-après.",
    "thank_you_1": "Nous vous remercions de votre demande chez Casapilot.",
    "thank_you_2": "Nous vous répondrons dès que possible."
  },
  "landing_page": {
    "ardennen": {
      "goto": "Offres spéciales Ardennes"
    },
    "austria": {
      "goto": "Offres spéciales Autriche"
    },
    "cotedazur": {
      "goto": "Offres spéciales Côte d'Azur"
    },
    "france": {
      "goto": "Offres spéciales France"
    },
    "ibiza": {
      "goto": "Offres spéciales Ibiza"
    },
    "luxemburg": {
      "goto": "Zum Luxemburg Special"
    },
    "mallorca": {
      "goto": "Offres spéciales Majorque"
    },
    "more": "Plus de maisons de vacances ",
    "more_at": "Plus de maisons sur",
    "more_objects": "Plus d'offres",
    "spain": {
      "goto": "Offres spéciales Espagne"
    },
    "wellnesssuites": {
      "goto": "Voir les suites bien-être"
    }
  },
  "landing_page_teaser": {
    "title": "Assurez-vous des coupons à prix réduits"
  },
  "mailer": {
    "attributes": {
      "approval_mailer": {
        "subject": "Validation du logement"
      },
      "invitation_mailer": {
        "subject": "Invitation chez Casapilot"
      },
      "travel_booking_mailer": {
        "confirm": {
          "subject": "Votre confirmation de réservation %{name}, %{id} "
        },
        "credit_note": {
          "subject": "Votre note de crédit %{name}, %{id}"
        },
        "payment": {
          "subject": "Votre confirmation de paiement %{name}, %{id}"
        },
        "reservation": {
          "subject": "Votre demande de réservation %{id}"
        },
        "reservation_host": {
          "subject": "Votre confirmation de réservation  %{name} (%{id}) "
        },
        "voucher": {
          "subject": "Votre ticket de séjour %{name}, %{id}"
        }
      }
    },
    "models": {
      "approval_mailer": "Validation",
      "invitation_mailer": "Invitation"
    }
  },
  "meta": {
    "description": "Louez votre maison de vacances chez Casapilot. Trouver et réserver rapidement et facilement des offres dans toute l'Europe! ",
    "keywords": "Casapilot,chambre luxe jacuzzi, villa ardennes,ardennen,maison de vacances ardennes,chambre luxe,appartement, villa, chalet, villa, vacances, vacances de ski, voyager pas cher, appartements, gîte de groupe, résidence de vacances, ski lodge, louer, hébergement, bungalow, vacances d'été, vacances d'hiver, Nouvel An, Noël , Espagne, Ardennes, Mallorca, sud de la France, réserver, Autriche, séjour pas cher.",
    "title": "casapilot | %{title}"
  },
  "not_found": {
    "back_to_homepage": "pas de résultats",
    "description": "Une erreur s'est produite.\nEssayez encore une fois s'il y a eu une erreur. Si vous venez de compléter une réservation, veuillez contacter notre équipe de réservation par info@casapilot.com.",
    "number": "+352 20 20 34 26 30",
    "title": "Une erreur s'est produite.\nEssayez encore une fois s'il y a eu une erreur. Si vous venez de compléter une réservation, veuillez contacter notre équipe de réservation par info@casapilot.com."
  },
  "notepad": {
    "add": "Ajouter",
    "full": "Vous pouvez ajouter max. 25 logements sur votre mémo",
    "headline": "Il y a ",
    "headline_part_two": "sur le mémo",
    "none": "aucun ",
    "notepad": "Mémo",
    "object": "hébergement",
    "objects": "Logements",
    "remember": "Noter",
    "remove": "Enlever ",
    "remove_full": "Enlever du mémo",
    "search": "Recherche"
  },
  "number": {
    "currency": {
      "format": {
        "delimiter": " ",
        "format": "%n %u",
        "negative_format": "-%u%n",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "€"
      }
    },
    "format": {
      "delimiter": " ",
      "precision": 3,
      "round_mode": "default",
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "human": {
      "decimal_units": {
        "format": "%n %u",
        "units": {
          "billion": "milliard",
          "million": "million",
          "quadrillion": "million de milliards",
          "thousand": "millier",
          "trillion": "billion",
          "unit": ""
        }
      },
      "format": {
        "delimiter": "",
        "precision": 2,
        "significant": true,
        "strip_insignificant_zeros": true
      },
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "octet",
            "other": "octets"
          },
          "eb": "EB",
          "gb": "Go",
          "kb": "ko",
          "mb": "Mo",
          "pb": "PB",
          "tb": "To",
          "zb": "ZB"
        }
      }
    },
    "nth": {
      "ordinalized": "#<Proc:0x000000010b979508 /Users/patrik/.rbenv/versions/3.2.2/lib/ruby/gems/3.2.0/gems/activesupport-6.1.7.6/lib/active_support/locale/en.rb:26 (lambda)>",
      "ordinals": "#<Proc:0x000000010b979530 /Users/patrik/.rbenv/versions/3.2.2/lib/ruby/gems/3.2.0/gems/activesupport-6.1.7.6/lib/active_support/locale/en.rb:7 (lambda)>"
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%"
      }
    },
    "precision": {
      "format": {
        "delimiter": ""
      }
    }
  },
  "payment_confirmation": "Confirmation de paiement",
  "previews": {
    "back_to_homepage": "Revenir sur la page d'accueil",
    "back_to_search": "Revenir à la liste",
    "submit": "Réserver"
  },
  "price": {
    "activate_standard_prices": "Activer les prix standards",
    "add_new_season_price": "Ajouter le prix d'une nouvelle saison",
    "add_new_standard_price": "Ajouter un nouveau prix standard",
    "alternatives": "Alternatives:",
    "available_dates": "Dates disponibles:",
    "check_in": "Check-in:",
    "check_in_time": "Heure d'arrivée:",
    "check_out": "Check-out:",
    "check_out_time": "Heure de départ:",
    "currency_symbol": "€",
    "current_season_prices": "Prix de la saison en cours",
    "current_season_prices_info": "Les prix sont créés pour une période déterminée",
    "current_standard_prices": "Prix standards en vigueur",
    "current_standard_prices_info": "Prix valables toute l'année",
    "customer_price": "Prix pour le client",
    "duplicate_season_price": "Dupliquer les prix de saison pour l'année prochaine",
    "edit_season_price": "Editer les prix de saisons",
    "euro_per_long_weekend": "€/long week-end",
    "euro_per_night": "€/nuit",
    "euro_per_stay": "€ par séjour",
    "euro_per_week": "€/semaine",
    "euro_per_weekend": "€/week-end",
    "from": "à partir de",
    "long_weekend_consists_of": "Un long week-end se compose des nuits de",
    "lump_long_weekend": "Long week-end",
    "lump_long_weekend_short": "Long week-end",
    "lump_week": "Semaine",
    "lump_weekend": "Week-end",
    "more_price_options": "Plus d'options de prix ? Ajoutez un nouveau groupe de prix.",
    "nightly_week": "Nuit de semaine",
    "nightly_week_season": "Nuit simple",
    "nightly_weekend": "Nuit de week-end",
    "nightly_weekend_season": "Une nuit pendant le week-end",
    "no_prices": "Aucun prix n'a encore été fixé.",
    "no_rotation_day": "Arrivée tout jour de semaine",
    "not_available": "Choisissez un autre jour d'arrivée ou adaptez le nombre de nuits.",
    "per_night": "par nuit",
    "per_stay": "Par séjour ",
    "per_week": "semaine",
    "per_weekend": "Par week-end",
    "price": "Prix",
    "price_lump_long_weekend": "Indiquer le prix pour un long week-end",
    "price_lump_week": "Indiquer le prix pour une semaine",
    "price_per_night": "Prix/nuit",
    "price_single_night": "Afficher le prix pour une nuit",
    "price_single_night_weekend": "Prix pour une nuit pendant le week-end",
    "price_stay_weekdays": "Prix pour une mi-semaine",
    "season_price_text": "Les prix de saison sont uniquement valables si vous avez indiqué une période. Il n'est pas obligatoire d'indiquer les prix de saison avant de pouvoir activer une propriété.",
    "season_prices": "Prix de saison",
    "season_title": "Nom de la saison",
    "single_night": "Prix pour une nuit de semaine",
    "single_night_weekend": "Prix pour une nuit pendant le week-end",
    "standard_price": "Prix standard",
    "standard_price_text": "Indiquez au moins un prix standard pour que votre propriété soit activée. Nous vous recommandons d'indiquer tous les prix standards, mais ce n'est pas une obligation. Les prix standard sont valables toute l'année, sauf pendant les saisons.",
    "standard_price_text_2": "Si vous souhaitez définir un prix différent pour une saison, veuillez indiquer un prix de saison dans la partie inférieure.",
    "standard_prices": "Prix standard",
    "stay_weekdays": "Prix pour une mi-semaine",
    "tooltip_lump_long_weekend": "Un long week-end est habituellement composé de trois nuitées consécutives.",
    "tooltip_nightly_week": "Une nuit de semaine est en principe comprise entre lundi et jeudi y compris.",
    "tooltip_nightly_weekend": "Une nuit de week-end est en principe comprise entre vendredi et dimanche y compris.",
    "tooltip_stay_underweek": "En principe, une mi-semaine commence lundi pour se terminer vendredi.",
    "tooltip_stay_weekdays": "Un séjour compris entre le lundi et le vendredi prend en compte le prix des nuits de semaine.",
    "under_week": "Mi-semaine",
    "week_period": "Prix pour un séjour pendant la semaine",
    "week_period_consists_of": "Ce prix est d'application pour les nuits consécutives pendant la semaine",
    "week_starts": "Une semaine de vacances commence",
    "weekend_consists_of": "Ce prix est valable pour les nuits consécutives de",
    "what_is_common": "Quelle est la constante ?",
    "what_is_common_1": "En principe une semaine de vacances commence le vendredi (Benelux) ou samedi (reste de l'Europe)",
    "what_is_common_2": "Par défaut, les prix de week-end correspondent aux nuits de vendredi et samedi",
    "whole_weekend": "Prix pour un week-end",
    "your_price": "Vous gagnez"
  },
  "processing": {
    "booking": {
      "booking_form": {
        "amex": "American Express",
        "bank_transfer": "Virement bancaire",
        "credit_card": "Mastercard, Visa, Maestro",
        "payment_charge": "Frais de traitement",
        "payment_method": "Mode de paiement",
        "payment_method_expl": "En cas de paiement avec carte de crédit, il y a des frais supplémentaires. Ceux-ci seront automatiquement ajoutés au prix total. "
      }
    }
  },
  "renter": {
    "contact": "Coordonnées",
    "terms_of_service_html": "Je confirme avoir lu, compris et accepté les <a href=\"/downloads/terms-conditions/guest-fr\" target=\"_blank\">CGV</a>."
  },
  "reserved": "Réservé",
  "reviews": {
    "accommodation": "Hébergement",
    "cancel_correct": "Revenir en arrière et corriger",
    "confirm": "Vérifier",
    "confirmation_intro": "Veuillez vérifier votre recommandation. Peut-on la publier telle quelle?",
    "intro_1": "Votre opinion compte : Votre recommandation aide les autres utilisateurs de Casapilot à choisir le bon hébergement et nous aide à mieux comprendre comment vous avez vécu votre séjour.",
    "intro_2": "Merci d’avoir pris le temps de nous faire part de vos commentaires.",
    "mailers": {
      "host_reaction_subject": "Un locataire a déposé une note",
      "invitation_reminder_subject": "Petit rappel: Comment était ton séjour?",
      "invitation_subject": "Comment était ton séjour?"
    },
    "nps_headline": "Quelle est la probabilité que vous recommandiez Casapilot à d’autres personnes?",
    "nps_unlikely": "Improbable",
    "nps_very_likely": "Très probable",
    "question_area": "Comment était l’emplacement de l’hébergement?",
    "question_cleanliness": "Le logement était-il propre?",
    "question_comfort": "Dans quelle mesure avez-vous été satisfait du confort?",
    "question_value": "Quel était le rapport qualité-prix de l’hébergement?",
    "rating_headline": "Dans quelle mesure avez-vous été satisfait de l’hébergement?",
    "rating_no_selection": "Veuillez sélectionner",
    "rating_selection_1": "1 - Non satisfait",
    "rating_selection_2": "2 - Plutôt insatisfait",
    "rating_selection_3": "3 - Neutre",
    "rating_selection_4": "4 - Plutôt satisfait",
    "rating_selection_5": "5 - Très satisfait",
    "remaining_chars": "Caractères restants",
    "review_author": "Auteur de la recommandation",
    "review_headline": "Rédigez une courte recommandation. Qu’est-ce qui était bon? Qu’est-ce qui peut être amélioré?",
    "submit": "Soumettre",
    "success_title": "Merci",
    "supbmit": "Indienen",
    "thank_you": "Merci pour votre recommandation. Comme nous venons juste de commencer à demander des recommandations à nos clients, nous attendrons un peu avant de les publier, jusqu’à ce que nous ayons rassemblé suffisamment de témoignages.",
    "title": "Faire une recommandation",
    "travel_dates": "Dates de voyage",
    "validation_error": "Veuillez remplir tous les champs obligatoires."
  },
  "salutations": {
    "female": "Madame ",
    "male": "Monsieur "
  },
  "search": {
    "additional_results": "D'autres destinations populaires en",
    "adjust_filters": "Plus de filtres",
    "adjust_request": "Modifier la demande",
    "all_cities": "Toutes les villes",
    "all_regions": "Toutes les régions",
    "arrival": "Arrivée",
    "availability": {
      "availability_for": "Disponibilité pour",
      "available": "Disponible",
      "calculate_price_and_availability": "Prix et disponibilité sont calculés...",
      "check_availability": "Vérifier disponibilité",
      "checking": "Vérification de la disponibilité",
      "choose_day_of_arrival": "Sélectionnez un jour d'arrivée:",
      "day_of_arrival": "Jour d'arrivée",
      "free": "libre",
      "no_arrivals": "Il n'y a pas de jour d'arrivée disponible pour la période sélectionnée. Veuillez choisir une autre durée de séjour.",
      "not_available": "Pas disponible",
      "occupied": "occupé",
      "on_request": "Vérifier la disponibilité",
      "update_price_and_availability": "Actualiser prix et disponibilité ..."
    },
    "back_to_search_list": "Revenir à la liste",
    "banner": {
      "contact_note": "Veuillez nous contacter par mail ou par téléphone. ",
      "headline": "Vous n'avez rien trouvé d'approprié? ",
      "headline_big_1": "Il n'y a malheureusement pas de résultats à votre recherche. ",
      "headline_big_2": "Veuillez modifier vos critères de recherche. ",
      "offer": "Nous pouvons bien sûr vous aider dans votre recherche.",
      "offer_big": "Bien sûr, nous pouvons vous aider dans votre recherche. "
    },
    "check_availability": "Vérifier disponibilité",
    "choose_city": "Toutes les destinations",
    "choose_region": "Toutes les régions",
    "close": "À proximité",
    "departure": "Départ",
    "detail": {
      "allowed_pets": "Animaux acceptés",
      "allowed_smoking": "Fumeurs acceptés",
      "allowed_youth": "Groupes de jeunes acceptés",
      "amenities_balcony": "Balcon",
      "amenities_dish": "Lave-vaisselle",
      "amenities_garage": "Emplacement de parking",
      "amenities_garden": "Jardin",
      "amenities_internet": "Internet/WiFi",
      "amenities_pool": "Piscine",
      "amenities_sauna": "Sauna",
      "amenities_terasse": "Terrasse",
      "amenities_tv": "TV",
      "amenities_wash": "Lave-linge",
      "from": "à partir de",
      "locality_calm": "Au calme",
      "locality_city": "A la campagne",
      "locality_mountains": "A la montagne",
      "locality_nature": "Dans la nature",
      "locality_sea": "A la mer"
    },
    "detail_search": "Recherche avancée",
    "exact_date": "Date exacte",
    "extended_search_result": "Nous n'avons malheureusement pas pu trouver des logements disponibles pour votre destination souhaitée. Peut-être que les hébergements suivants, qui se trouvent dans les environs, pourraient vous intéresser. ",
    "filters": {
      "activities": "Activités",
      "air_conditioning": "Climatisation",
      "any": "Tout",
      "apartment": "Appartement",
      "central_heating": "Chauffage central",
      "distance_to_beach": "Distance de la plage",
      "features": "Caractéristiques",
      "fenced_garden": "Jardin clôturé",
      "holiday_home": "Maison de vacances",
      "jacuzzi": "Jacuzzi",
      "jacuzzi_inside": "Jacuzzi intérieur",
      "jacuzzi_outside": "Jacuzzi extérieur",
      "kind_of_property": "Type de bien",
      "lake": "Lac à proximité",
      "limited_mobility": "Mobilité Réduite",
      "linen_included": "Drap inclus",
      "object_place": "Emplacement",
      "ocean_view": "Vue sur mer",
      "pets": "Animaux acceptés",
      "pool": "Piscine",
      "pool_inside": "Piscine intérieure",
      "pool_outside": "Piscine extérieure",
      "sauna": "Sauna",
      "ski": "Ski",
      "stars": "Étoiles",
      "suite": "Suite Luxe",
      "teambuilding": "Teambuilding",
      "waterfront": "Situé au bord de mer/côte",
      "wifi_internet": "Wifi - internet"
    },
    "map_zoom": "Agrandir la carte",
    "map_zoom_out": "Rétrécir la carte",
    "mark": "Noter",
    "micro_search_no_results": "Malheureusement, il n'y a pas d'objet avec l'ID souhaité.",
    "more": "plus",
    "more_objects": "Autres logements dans la région",
    "no_results": "Votre recherche n'a donné aucun résultat. Veuillez modifier vos critères de recherche.",
    "objects_for_all_arrivals": "Montrer des objets pour toutes les dates d'arrivée. ",
    "offers_found": "Proposition de séjours",
    "please_enter": "Introduisez votre destination",
    "reset_filters": "Supprimer les filtres et afficher tous les résultats",
    "results": "Résultat de la recherche",
    "search": "Recherche",
    "search_by_object_code": "Recherche par code",
    "search_list": "Nouvelle recherche",
    "show_availability": "Voir disponibilité",
    "size": "Taille",
    "to_accomondation": "Plus d'info",
    "your_destination": "Destination"
  },
  "sending_mails": "Envoi du courrier électronique",
  "service_navigation": {
    "account": "Mon compte"
  },
  "shared": {
    "footer": {
      "breakfast": "Petit-déjeuner",
      "breakfast_url": "https://specials.casapilot.com/shop/?lang=fr",
      "contact": "Contact",
      "cookie_settings": "Paramètres des cookies",
      "faq": "FAQ",
      "help": "Aide",
      "hosts": "Pour les propriétaires",
      "imprint": "Mentions légales",
      "partners": "Partenaires",
      "privacy": "Données personnelles"
    },
    "service_navigation": {
      "host_area": "Accès propriétaire",
      "locale": {
        "de": "DE",
        "en": "EN",
        "es": "ES",
        "fr": "FR",
        "nl": "NL"
      },
      "offer_flat": "Inscrivez votre logement de vacances",
      "service_navigation": {
        "account": "Account"
      },
      "user": {
        "edit": "Modifier mon compte",
        "sign_in": "Propriétaire",
        "sign_out": "Se déconnecter",
        "sign_up": "S'enregistrer"
      },
      "vouchers": "Chèque-cadeau",
      "vouchers_url": "https://shop.casapilot.com/fr"
    },
    "sub_navigation": {
      "account": "Compte",
      "bookings": "Réservations",
      "dashboard": "Dashboard",
      "objects": "Objets",
      "statistics": "Statistiques"
    }
  },
  "subscription": {
    "email_error": "Cette adresse email n'est pas valable. Veuillez vérifier votre saisie.",
    "email_text": "Votre adresse email est traitée de manière confidentielle.",
    "headline": "Inscrivez-vous maintenant et restez informé.",
    "missing_field": "Veuillez compléter tous les champs."
  },
  "support": {
    "array": {
      "last_word_connector": " et ",
      "two_words_connector": " et ",
      "words_connector": ", "
    },
    "select": {
      "prompt": "Veuillez sélectionner"
    }
  },
  "thank_you": {
    "copy_1": "Nous vous remercions pour l'intérêt que vous portez à Casapilot. Nous vous tiendrons désormais informé.",
    "copy_2": "Afin de confirmer votre inscription, vous allez bientôt recevoir un courrier électronique avec un lien de confirmation. Votre inscription ne pourra pas être définitive sans cette confirmation.",
    "copy_3": "Vous trouverez dans tous les courriers électroniques que nous vous enverrons un lien qui vous permettra d'annuler votre inscription et de supprimer vos données.",
    "copy_4": "Votre équipe Casapilot",
    "empfehlen": "Merci de nous recommander.",
    "headline": "merci beaucoup !"
  },
  "three_good_reasons": "bonnes raisons pour vos vacances avec casapilot.com",
  "time": {
    "am": "am",
    "formats": {
      "default": "%d %B %Y %H:%M:%S",
      "long": "%A %d %B %Y %H:%M",
      "moment": "H:mm",
      "only_second": "%S",
      "short": "%d/%m/%Y, %H:%M",
      "time": "%H:%M h"
    },
    "pm": "pm"
  },
  "travel_booking_price": {
    "booking_fee": "Frais de réservation",
    "costs_in_detail": "Les coûts en détail",
    "deposit": {
      "on_location": "Payable sur place",
      "refund": {
        "instantly": "Remboursement lors du départ des clients",
        "one_week": "Remboursement une semaine après le départ",
        "two_weeks": "Remboursement deux semaines après le départ"
      },
      "upfront": "Payable à Casapilot"
    },
    "extras": {
      "type_bring": "À emporter",
      "type_included": "Inclus",
      "type_on_location": "Sur site",
      "type_on_request": "À la demande",
      "type_payable": "Doit être loué",
      "type_upfront": "À l’avance"
    },
    "handling_fee": "Frais de traitement",
    "included": "inclus",
    "liability_insurance": "Assurance responsabilité civile",
    "optional_costs": "Coûts optionnels",
    "other_costs": "Other costs",
    "payable_on_location": "Payable sur place",
    "payable_on_location_colon": "Payable sur place:",
    "payable_to_casapilot": "Payable à Casapilot",
    "plus_other_costs": "(plus autres frais)",
    "price_error": "Une erreur s'est produite lors de la détermination du prix.",
    "rent_fees_included": "Loyer (incl. frais de réservation)",
    "total_amount": "Prix ​​total",
    "withheld_from_deposit": "Retenu sur le dépôt:"
  },
  "travel_bookings": {
    "ical_guest_summary": "Réservation Casapilot pour %{title}",
    "ical_host_summary": "Réservation pour « %{property} » avec Casapilot"
  },
  "universal_tag": {
    "cnv": {
      "conversion_lang": "85852"
    },
    "rmkt": {
      "container_id": "8808",
      "conversion_lang": "85857"
    }
  },
  "voucher": "Ticket de séjour",
  "we_book_your_holidayhome": "Nous réservons votre villa y compris vol et voiture.",
  "web_app_theme": {
    "accommodations": "Logements",
    "add": "Ajouter",
    "administration": "Administration",
    "agency": "call-center",
    "all": "Tout",
    "amenities": "Caractéristiques",
    "approval_status": "Statut",
    "approvals": "Validations",
    "approve": "Activer",
    "approved": "En ligne",
    "attractions": "Activités",
    "cancel": "Annuler",
    "complete": "À valider",
    "confirm": "Êtes-vous sûr(e) ?",
    "console": "Console",
    "costs": "Charges",
    "created": "Créé",
    "dashboard": "Cockpit",
    "day": "Jour",
    "days": "Jours",
    "delete": "Supprimer",
    "delete_map_clipping": "Afficher la carte",
    "edit": "Modifier",
    "editing": "Incomplet",
    "find": "Chercher",
    "fix_rating": "Sternekategorie fixieren?",
    "homepage": "Accueil",
    "invitations": "Invitation ",
    "latest_send": "Dernier envoi",
    "limitations": "Particularités",
    "list": "Liste",
    "logout": "Déconnexion",
    "new": "Nouveau",
    "new_users": "Nouvel utilisateur",
    "notapproved": "Bloqué offline",
    "ogone": {
      "timedout": "Verbindung zum Zahlungssystem konnte nicht hergestellt werden."
    },
    "or": "ou",
    "possible_extras": "Choix possibles",
    "possible_limitations": "Possibilités",
    "possible_units": "Unités possibles",
    "properties": "Propriétés",
    "save": "Enregistrer",
    "search_people": "Personnes",
    "search_person": "Personne",
    "select": {
      "prompt": "Sélectionnez"
    },
    "send": "Envoyer",
    "show": "Afficher",
    "summary": "Somme",
    "translate": "Traductions",
    "travel_bookings": "Buchungen",
    "travel_regions": "Régions",
    "unapprove": "Placer offline",
    "usable_on": "Utile à",
    "users": "Utilisateurs",
    "various_options": "Divers"
  },
  "will_paginate": {
    "container_aria_label": "Pagination",
    "next_label": "»",
    "page_aria_label": "Page %{page}",
    "page_entries_info": {
      "multi_page": "Displaying %{model} %{from} - %{to} of %{count} in total",
      "multi_page_html": "Displaying %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b> of <b>%{count}</b> in total",
      "single_page": {
        "one": "Displaying 1 %{model}",
        "other": "Displaying all %{count} %{model}",
        "zero": "No %{model} found"
      },
      "single_page_html": {
        "one": "Displaying <b>1</b> %{model}",
        "other": "Displaying <b>all&nbsp;%{count}</b> %{model}",
        "zero": "No %{model} found"
      }
    },
    "page_gap": "...",
    "previous_label": "«"
  },
  "your_benefits": {
    "contact": {
      "at": {
        "number": "+352 20 20 34 26 20",
        "text": "(Joignable d'Autriche)"
      },
      "be": {
        "number": "+32 28 80 89 83",
        "text": "(Joignable de Belgique)"
      },
      "ch": {
        "number": "+352 20 20 34 26 20",
        "text": "(Joignable de Suisse)"
      },
      "de": {
        "number": "+352 20 20 34 26 20",
        "text": "(Joignable d'Allemagne)"
      },
      "email": "E-Mail: info@casapilot.com",
      "email_link": "info@casapilot.com",
      "headline": "Vous avez des questions",
      "intro": "Contactez-nous. Nous sommes à votre disposition!",
      "lu": {
        "number": "+352 (0)20 20 34 26 20",
        "text": "(Joignable du Luxembourg)"
      },
      "opening_hours": "Vous pouvez nous joindre par téléphone au tarif local: ",
      "opening_hours_1": "Du lundi au vendredi de 9h00 à 12h30 et de 13h30 à 18h00",
      "opening_hours_2": "Le weekend de 14 à 16 heures",
      "partners": "Nos partenaires",
      "phone": "Tel. +352 20 20 34 26 30"
    },
    "h1": "Pourquoi Casapilot? ",
    "h2": "Prix tout compris",
    "h3": "Réservation sécurisée, données sécurisées, vacances sécurisées",
    "h4": "Un service excellent et une très bonne accessibilité",
    "headline_html": "L'équipe Casapilot",
    "intro": "Vos vacances de rêve, c'est notre principale préoccupation. C'est pourquoi l'accessibilité, la convivialité et le service sont nos priorités. Testez nous et vous serez agréablement surpris - nous vous promettons.",
    "list_item2_1": "Les loyers présentés pour une période de voyage sont des prix finaux",
    "list_item2_2": "Les coûts de l'assurance de dégâts et les autres frais sont inclus",
    "list_item2_3": "Les coûts éventuels de consommation sur place sont énumérés de façon claire et visible",
    "list_item3_1": "Le site web sécurisé garantit une protection des données personnelles",
    "list_item3_2": "Notre fournisseur de services de paiement certifié garantit un paiement sécurisé par virement bancaire ou carte de crédit",
    "list_item4_1": "Vous pouvez nous joindre par téléphone au tarif local, pendant la semaine et le weekend",
    "list_item4_2": "Nous sommes joignables 24 heures sur 24. Nous répondons dans les 24 heures.",
    "list_item4_3": "Vous êtes à la recherche d'un logement de vacances spécial? Nous sommes heureux de vous aider dans la recherche. ",
    "p1_1": "Il y a beaucoup de raisons pour lesquelles vous devriez réserver vos vacances de rêve sur casapilot.com.",
    "p1_2": "Les principales raisons sont précisées ci-après:",
    "p2": "Sur Casapilot.com, il n'y a pas de mauvaises surprises - notre système de tarification est clair et tranparent:",
    "p3": "Nous voulons que vous passez des vacances agréables. La sécurité que nous offrons, commence à la réservation et au paiement, et comprend tous les jours de votre séjour sur place. ",
    "p4": "Notre équipe multilingue est à votre disposition 365 jours sur 365. Un service excellent est une de nos forces. ",
    "page_title": "Avec Casapilot, la location est simple et rentable. ",
    "positions": {
      "accounting": "Comptabilité",
      "business_development": "Business Development",
      "business_development_spain": "Business Development Espagne",
      "ceo": "Direction",
      "cio": "Directeur technique",
      "design": "Interactive Design",
      "dev": "Webdevelopment",
      "it": "Administrateur IT",
      "photography": "Photographie",
      "pm": "Gestion du site",
      "service": "Service client",
      "service_marketing": "Service client et marketing",
      "teamleader": "Teamleader"
    }
  }
};
I18n.translations["nl"] = {
  "about": {
    "h1": "Eenvoudig adverteren en beheren",
    "h2": "Van Eigenaar voor eigenaars",
    "h3": "Onbeperkte service",
    "h4": "Verhuur in heel europa",
    "h5": "Veiligheid",
    "h6": "Aantrekkelijke voorwaarden",
    "link_13": "Een juiste uitleg van",
    "link_23": "Casapilot business modell",
    "link_33": "kunt u als pdf downloaden",
    "p1": "In zo weinig mogelijk stappen een advertentie creëren, dat beloven wij u. Dankzij een overzichtelijk design en vele praktische kenmerken is Casapilot heel gebruiksvriendelijk. Zo kunt u vooraf uw advertentie bekijken om er zeker van te zijn dat die aan uw eisen voldoet.",
    "p2": "Wij zijn net zoals u eigenaars van een vakantiewoning die we sinds enkele jaren zelf verhuren. Bij de verhuur via online portalen en makelaars moesten we vaak vaststellen dat externe tussenpersonen duur en weinig flexibel zijn. Dat stoorde ons en daarom hebben wij Casapilot in het leven geroepen. Wij beloven u gunstige voorwaarden, hoge flexibiliteit en een onberispelijke service.",
    "p3": "Wij staan u 24 uur per dag en 365 dagen per jaar met raad en daad bij. Wij vertalen uw advertentie zodat u klanten uit heel Europa aan kunt trekken. Daarnaast vervullen wij voor u formaliteiten zoals reclame, boeking, het afsluiten van een verzekering en betaling en wij bezorgen uw klanten alle nodige informatie over uw vakantiewoning.",
    "p4": "Wij willen dat u huurders aantrekt uit heel Europa. Daarom is Casapilot opgesteld in vijf talen: Engels, Duits, Frans, Spaans en Nederlands.",
    "p5": "Alle boekingen verlopen via een veilige, gecodeerde website en via een gecertificeerde betalingsprovider. U ontvangt het bedrag bij elke boeking direct naar de aankomst van uw gasten. Mogelijke schade wordt gedekt door de wettelijke aansprakelijkheidsverzekering die uw huurders automatisch afsluiten bij een boeking via Casapilot.",
    "p6": "Adverteren is volledig gratis voor u. U hoeft enkel een bemiddelingscommissie te betalen wanneer u een definitieve boeking ontvangt. Onze commissie bepalen wij op basis van de huurprijs. Per boeking bedraagt de commissie voor vakantiewoningen 17% en voor uw Bed & Breakfast slechts 10%."
  },
  "about_us": {
    "claim": "Dankzij Casapilot was uw vakantiewoning verhuren nog nooit zo eenvoudig en winstgevend.",
    "headline_html": "Meer verhuren. <br /> Meer verdienen. <br /> Met Casapilot.",
    "page_title": "Meer verhuren. Meer verdienen. Met Casapilot."
  },
  "accommodation_reviews": {
    "area": "Locatie",
    "cleanliness": "Netheid",
    "comfort": "Comfort",
    "hide": "Laat minder zien",
    "load_more_reviews": "Laad meer recensies…",
    "review_translated": "Recensie vertaald",
    "reviews": {
      "one": "recensie",
      "other": "recensies"
    },
    "show_more": "Laat meer zien",
    "show_original": "Toon origineel",
    "show_translation": "Vertaling bekijken",
    "value": "Prijs-kwaliteitverhouding"
  },
  "accommodations": {
    "errors": {
      "minstay": "Voor deze woning, gelieve eerst een duur van het verblijf te kiezen %{minstay} .\nGelieve probeert u het opnieuw."
    },
    "seo": {
      "in": "in",
      "kind": {
        "apartment": "appartement ",
        "bed_and_breakfast": "b&b kamer ",
        "holiday_home": "Vakantiewonig "
      }
    }
  },
  "activemodel": {
    "errors": {
      "template": {
        "body": "There were problems with the following fields:",
        "header": {
          "one": "1 error prohibited this %{model} from being saved",
          "other": "%{count} errors prohibited this %{model} from being saved"
        }
      }
    }
  },
  "activerecord": {
    "abbr_day_names": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "abbr_day_names_string": {
      "friday": "Fri",
      "monday": "Mon",
      "saturday": "Sat",
      "sunday": "Sun",
      "thursday": "Thu",
      "tuesday": "Tue",
      "wednesday": "Wed"
    },
    "abbr_month_names": [
      null,
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "attributes": {
      "accommodation": {
        "amenities": "Uitrustingseigenschappen",
        "area": "Oppervlakte (m²)",
        "bond": "Waarborg",
        "bond_refund": "Teruggave waarborg",
        "created_at": "Aangemaakt op",
        "description": "Beschrijving",
        "description_short": "Kurzbeschreibung",
        "fee": "Commissie (in %)",
        "filter_partition": {
          "all": "Alle verblijfsmogelijkheden tonen",
          "any_missing": "ontbrekende vertaling",
          "de_missing": "zonder Duitse vertaling",
          "en_missing": "zonder Engelse vertaling",
          "es_missing": "zonder Spaanse vertaling",
          "fr_missing": "zonder Franse vertaling",
          "nl_missing": "zonder Nederlandse vertaling"
        },
        "filter_partition_all": "Alle Unterkünfte anzeigen",
        "filter_partition_any_missing": "mit fehlender Übersetzung",
        "filter_partition_de_missing": "ohne deutsche Übersetzung",
        "filter_partition_en_missing": "ohne englische Übersetzung",
        "filter_partition_es_missing": "ohne spanische Übersetzung",
        "filter_partition_fr_missing": "ohne französische Übersetzung",
        "filter_partition_nl_missing": "ohne niederländische Übersetzung",
        "id": "ID",
        "kind": "Soort/Genre",
        "max_persons": "Personen (max.)",
        "number_of_baths": "Badkamers",
        "number_of_bunk_beds": "Stapelbedden",
        "number_of_daybeds": "Slaapbanken",
        "number_of_king_size_beds": "Tweepersoons bed",
        "number_of_rooms": "Slaapkamer",
        "number_of_similar": "Aantal gelijkaardige woningen",
        "number_of_single_beds": "Eénpersoons bed",
        "photos": "Foto's",
        "property_id": "Gebouw/Artikel",
        "title": "Titel",
        "updated_at": "Geupdatet op",
        "user_rating": "Basisbewertung"
      },
      "amenity": {
        "apartment": "Appartement",
        "bed_and_breakfast": "Bed & Breakfast",
        "category": "categorie",
        "created_at": "Aangemaakt op",
        "holiday_home": "Vakantiehuis",
        "id": "ID",
        "name": "Gebruikersnaam",
        "updated_at": "Geüpdatet op"
      },
      "attraction": {
        "category": "Categorie",
        "created_at": "Aangemaakt op",
        "id": "ID",
        "name": "Gebruikersnaam",
        "updated_at": "Geüpdatet op"
      },
      "attraction_distance": {
        "created_at": "Aangemaakt op",
        "distance": "Afstand",
        "id": "ID",
        "updated_at": "Geüpdatet op"
      },
      "block": {
        "accommodation": "Vakantiewoning/Kamer",
        "beginning": "Niet beschikbaar vanaf",
        "created_at": "Aangemaakt op",
        "ending": "Niet beschikbaar tot",
        "id": "ID",
        "updated_at": "Geüpdatet op"
      },
      "cost": {
        "created_at": "Aangemaakt op",
        "id": "ID",
        "inclusive": "inclusief",
        "mandatory": "Verplichte kosten",
        "name": "Gebruikersnaam",
        "per_animal": "per dier",
        "per_box": "per box",
        "per_consumption": "per verbruik en actuele marktprijs",
        "per_cubic_meter": "Per kubieke meter",
        "per_day": "per dag",
        "per_day_and_person": "per dag per persoon",
        "per_day_and_piece": "per dag per stuk",
        "per_hour": "per uur",
        "per_kwh": "per kW",
        "per_liter": "per liter",
        "per_midweek": "per midden van de week",
        "per_night": "per nacht",
        "per_night_and_animal": "per nacht en dier",
        "per_night_and_person": "per nacht per persoon",
        "per_package": "per pakket",
        "per_person": "per persoon",
        "per_piece": "per stuk",
        "per_set": "per set",
        "per_stay": "per verblijf",
        "per_week": "per week",
        "per_weekend": "per weekend",
        "updated_at": "Geüpdatet op"
      },
      "extra": {
        "breakfast": "Ontbijt",
        "bring": "Zelf meebrengen",
        "created_at": "Aangemaakt op",
        "dish_towels": "Keukenlinnen",
        "id": "ID",
        "included": "Inclusief",
        "kind": "Soort",
        "linen": "Beddengoed",
        "on_request": "Op aanvraag",
        "optional": "Kosten voor optionele uitrusting",
        "payable": "Boekbar",
        "price": "Prijs",
        "towels": "Handdoeken",
        "updated_at": "Geüpdatet op"
      },
      "inquiry_form": {
        "day_of_arrival": "Aankomst",
        "day_of_departure": "Vertrekdag",
        "email": "E-mail",
        "inquiry": "Aanvraag",
        "message": "Bericht",
        "name": "Naam",
        "object_id": "Woning Id",
        "phone": "Telefoon",
        "updated_at": "Actualizado el"
      },
      "limitation": {
        "allowed": "Toegestaan",
        "bring_with": "Selbst mitbringen",
        "can_be_rented": "Mieten möglich",
        "created_at": "Aangmaakt op",
        "forbidden": "Niet toegestaan",
        "id": "ID",
        "must_be_rented": "Mietverpflichtung",
        "name": "Naam",
        "onrequest": "op aanvraag",
        "updated_at": "Geüpdated op"
      },
      "price": {
        "accommodation": "Vakantiewoning/Kamer",
        "beginning": "Geldig vanaf",
        "created_at": "Aangemaakt op",
        "default_price": "Standaardprijs",
        "ending": "Geldig tot",
        "friday": "Vrijdag",
        "friday_abbr": "Vr",
        "id": "ID",
        "monday": "Maandag",
        "monday_abbr": "Ma",
        "payment_type": "Betalingswijze",
        "price": "Prijs",
        "rotation_day": "Beddenwissel",
        "saturday": "Zaterdag",
        "saturday_abbr": "Za",
        "sunday": "Zondag",
        "sunday_abbr": "Zo",
        "thursday": "Donderdag",
        "thursday_abbr": "Do",
        "tuesday": "Dinsdag",
        "tuesday_abbr": "Di",
        "updated_at": "Geüpdatet op",
        "wednesday": "Woensdag",
        "wednesday_abbr": "Wo"
      },
      "property": {
        "country": "Land",
        "created_at": "Aangemaakt op",
        "description": "Omschrijving",
        "description_short": "Korte beschrijving",
        "filter_partition_all": "Alle woningen tonen",
        "filter_partition_any_missing": "ontbrekende vertaling",
        "filter_partition_de_missing": "zonder duitse vertaling",
        "filter_partition_en_missing": "zonder engelse vertaling",
        "filter_partition_es_missing": "zonder spaanse vertaling",
        "filter_partition_fr_missing": "zonder franse vertaling",
        "filter_partition_nl_missing": "zonder nederlandse vertaling",
        "id": "ID",
        "internal_memo": "Intern kenmerk",
        "locality": "Plaats",
        "postal_code": "Postcode",
        "rating": "Sterren-Categorie",
        "region": "Regio",
        "street": "Straat",
        "title": "Naam van de woning",
        "top_object": "Superverblijf",
        "travel_region_id": "Vakantieregio",
        "updated_at": "Geüpdatet"
      },
      "property_photo": {
        "created_at": "Aangemaakt op",
        "description": "Omschrijving",
        "file": "Foto",
        "id": "ID",
        "updated_at": "Geüpdatet op"
      },
      "travel_booking": {
        "accommodation": "Unterkunft",
        "amount_total": "Rechnungsbetrag",
        "cancel_ins_amount": "Reiserücktrittsvericherung",
        "casualty_ins_amount": "Haftpflichtversicherung",
        "created_at": "Boeking gemaakt",
        "id": "ID",
        "number_of_adults": "Erwachsene",
        "number_of_children": "Kinder",
        "number_of_infants": "Kleinkinder",
        "number_of_pets": "Haustiere",
        "ref_code": "Rechnungsnummer",
        "renter": "Mieter",
        "state": "Status",
        "travel_ins_amount": "Umfassende Reiseversicherung",
        "travel_range": "Reisezeitraum"
      },
      "travel_region": {
        "country_code": "Land",
        "created_at": "Aangemaakt op",
        "custom_geocode": "Kaartfragment handmatig",
        "id": "ID",
        "name": "Naam in de landstaal",
        "updated_at": "Geüpdatet op"
      },
      "user": {
        "additional_emails": "Additional Emails",
        "additional_emails_csv": "Extra e-mails (gescheiden door komma's)",
        "admin": "Administrator",
        "agent": "Telefonist",
        "agent_lead": "begeleiding van agentschap",
        "api_user": "Api toegang",
        "authentication_token": "Auth Token",
        "avatar": "Uw Foto",
        "birthday": "Verjaardag",
        "cellphone": "Mobile telefoon",
        "city": "Plaats",
        "country": "Land",
        "created_at": "Geregistreerd op",
        "current_password": "Huidig paswoord",
        "description": "Omschrijving",
        "email": "E-mail",
        "first_name": "Voornaam",
        "host": "Verhuurder",
        "id": "ID",
        "invoice_city": "Plaats (Contactgegevens)",
        "invoice_company": "Bedrijf (Contactgegevens)",
        "invoice_country": "Land (Contactgegevens)",
        "invoice_mobile_phone": "Mobiele telefoon",
        "invoice_name": "Naam (Contactgegevens)",
        "invoice_phone": "Telefoon (Contactgegevens)",
        "invoice_postal_code": "Postcode (Contactgegevens)",
        "invoice_street": "Straat (Contactgegevens)",
        "key_hand_over_city": "Plaats (Adres van sleuteloverhandiging)",
        "key_hand_over_country": "Land (Adres van sleuteloverhandiging)",
        "key_hand_over_name": "Naam (Adres van sleuteloverhandiging)",
        "key_hand_over_postal_code": "Postcode (Adres van sleuteloverhandiging)",
        "key_hand_over_street": "Straat (Adres van sleuteloverhandiging)",
        "last_name": "Familienaam",
        "last_sign_in_at": "Laatst ingelogd op",
        "mother_tongue": "Moedertaal",
        "name": "Naam",
        "newsletter": "Nieuwsbrief ontvangen",
        "password": "Paswoord",
        "password_confirmation": "Paswoord herhalen",
        "phone": "Telefoon",
        "postal_code": "Postcode",
        "remember_me": "Aangemeld blijven",
        "remove_avatar": "Foto verwijderen",
        "renter": "Klant",
        "salutation": "Titel",
        "street_nr": "Straat / huisnummer",
        "terms_of_service": "Algemene Verkoopsvoorwaarden",
        "translator": "Vertaler",
        "updated_at": "Geüpdatet op",
        "vat_rate": "BTW"
      }
    },
    "day_names": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "day_names_string": {
      "friday": "Friday",
      "monday": "Monday",
      "saturday": "Saturday",
      "sunday": "Sunday",
      "thursday": "Thursday",
      "tuesday": "Tuesday",
      "wednesday": "Wednesday"
    },
    "errors": {
      "full_messages": {
        "format": "%{attribute}%{message}"
      },
      "messages": {
        "accepted": "moet worden geaccepteerd",
        "blank": "moet opgegeven zijn",
        "confirmation": "komt niet met de bevestiging overeen",
        "empty": "moet opgegeven zijn",
        "equal_to": "moet gelijk zijn aan %{count}",
        "even": "moet even zijn",
        "exclusion": "is niet beschikbaar",
        "greater_than": "moet groter zijn dan %{count}",
        "greater_than_or_equal_to": "moet groter dan of gelijk zijn aan %{count}",
        "inclusion": "is niet in de lijst opgenomen",
        "invalid": "is ongeldig",
        "less_than": "moet minder zijn dan %{count}",
        "less_than_or_equal_to": "moet minder dan of gelijk zijn aan %{count}",
        "not_a_number": "is geen getal",
        "not_an_integer": "moet een geheel getal zijn",
        "odd": "moet oneven zijn",
        "record_invalid": "Validatie mislukt: %{errors}",
        "restrict_dependent_destroy": {
          "has_many": "Cannot delete record because dependent %{record} exist",
          "has_one": "Cannot delete record because a dependent %{record} exists"
        },
        "taken": "is al in gebruik",
        "too_long": "is te lang (maximaal %{count} tekens)",
        "too_short": "is te kort (minimaal %{count} tekens)",
        "wrong_length": "heeft onjuiste lengte (moet %{count} tekens lang zijn)"
      },
      "models": {
        "amenity": {
          "attributes": {
            "name": {
              "invalid": "mag enkel letters bevatten"
            }
          }
        },
        "attraction": {
          "attributes": {
            "name": {
              "invalid": "mag enkel letters bevatten"
            }
          }
        },
        "block": {
          "attributes": {
            "ending": {
              "range_too_short": "moet minstens een dag na het begin van de periode zijn"
            }
          }
        },
        "cost": {
          "attributes": {
            "name": {
              "invalid": "mag enkel letters bevatten"
            }
          }
        },
        "extra": {
          "attributes": {
            "kind": {
              "invalid": "Aleen letters invoeren"
            }
          }
        },
        "limitation": {
          "attributes": {
            "name": {
              "invalid": "Voer enkel letters in"
            }
          }
        },
        "price": {
          "attributes": {
            "base": {
              "lump_price_exists": "Er is al een all-inprijs voor de periode",
              "nested_season": "Het is alleen mogelijk  een seizoen naar een andere achter elkaar te maken maar niet 2 tegelijk.",
              "nightly_price_exists": "Er is al een prijs voor een van de dagen",
              "no_night_selected": "Kies minstens één weekdag uit",
              "not_linked_up": "Voor all-inprijzen moeten de weekdagen aaneensluitend zijn"
            },
            "ending": {
              "range_too_short": "moet minstens één dag na begin van de geldigheidsperiode zijn"
            }
          },
          "not_blank": "is niet leeg"
        },
        "travel_region": {
          "attributes": {
            "name": {
              "invalid": "mag enkel letters bevatten"
            }
          }
        }
      },
      "template": {
        "body": "Controleer de volgende velden:",
        "header": {
          "one": "%{model} niet opgeslagen: 1 fout gevonden",
          "other": "%{model} niet opgeslagen: %{count} fouten gevonden"
        }
      }
    },
    "models": {
      "accommodation": "Vakantiewoning/Kamer",
      "amenity": "Uitrustingskenmerk",
      "attraction": "Attractie",
      "attraction_distance": "Afstand van attractie",
      "block": "Geblokkeerde periode",
      "cost": "Extra kosten",
      "extra": "Extras",
      "limitation": "Beperking / Bijzonderheden",
      "price": "Prijs",
      "property": "Woning",
      "property_photo": "Foto",
      "travel_booking": "Buchung",
      "travel_region": "Regio",
      "user": "Gebruiker"
    },
    "month_names": [
      null,
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "options": {
      "accommodation": {
        "bond_refund": {
          "instantly": "onmiddellijk bij vertrek",
          "one_week": "na een week na uw vertrek",
          "two_weeks": "na twee weken na uw vertrek"
        },
        "kind": {
          "apartment": "Appartement",
          "bed_and_breakfast": "Bed & Breakfast",
          "holiday_home": "Vakantiehuis"
        }
      },
      "amenity": {
        "category": {
          "business": "Business",
          "domestic": "Huishoudtoestellen",
          "exclusive": "Wellness en plezier",
          "exterior": "Buiten",
          "general": "Algemeen",
          "location": "Locatie",
          "multimedia": "Multimedia",
          "orientation": "Oriëntatie",
          "other": "Faciliteiten voor personen met beperkte mobiliteit",
          "view": "Uitzicht"
        }
      },
      "attraction": {
        "category": {
          "activities": "Activiteiten",
          "other": "Overig",
          "places": "Plaatsen"
        }
      },
      "extra": {
        "extra_type": {
          "bring": "Zelf meebrenngen",
          "included": "Inclusief",
          "on_request": "Op aanvraag",
          "payable": "Verplicht te huur"
        },
        "unit": {
          "per_night": "per nacht",
          "per_night_and_person": "per nacht per persoon",
          "per_person": "per persoon",
          "per_piece": "per stuk",
          "per_set": "set",
          "per_stay": "per verblijf"
        }
      },
      "limitation": {
        "name": {
          "allowed": "Permited",
          "forbidden": "Not allowed",
          "onrequest": "on request"
        }
      },
      "price": {
        "payment_type": {
          "lump": "all-in",
          "nightly": "per nacht"
        },
        "rotation_day": {
          "friday": "Vrijdag",
          "monday": "Maandag",
          "saturday": "Zaterdag",
          "sunday": "Zondag",
          "thursday": "Donderdag",
          "tuesday": "Dinsdag",
          "wednesday": "Woensdag"
        }
      },
      "travel_region": {
        "country_code": {
          "AD": "Andorra",
          "AE": "Verenigde Arabische Emiraten",
          "AF": "Afghanistan",
          "AG": "Antigua and Barbuda",
          "AI": "Anguilla",
          "AL": "Albanië",
          "AM": "Amermenië",
          "AN": "Nederlandse Antillen",
          "AO": "Angola",
          "AP": "Aziatisch-pacifische regio",
          "AQ": "Antarctica",
          "AR": "Argentinië",
          "AS": "Amerikaans-Samoa",
          "AT": "Oostenrijk",
          "AU": "Australië",
          "AW": "Aruba",
          "AX": "Aland",
          "AZ": "Azerbeidzjan",
          "BA": "Bosnië en Herzegovina",
          "BB": "Barbados",
          "BD": "Bangladesh",
          "BE": "België",
          "BF": "Burkina Faso",
          "BG": "Bulgarije",
          "BH": "Bahrein",
          "BI": "Burundi",
          "BJ": "Benin",
          "BL": "Sint-Bartholomeus",
          "BM": "Bermuda",
          "BN": "Brunei",
          "BO": "Bolivia",
          "BR": "Brazilië",
          "BS": "Bahamas",
          "BT": "Bhutan",
          "BV": "Bouvet",
          "BW": "Botswana",
          "BY": "Wit-Rusland",
          "BZ": "Belize",
          "CA": "Canada",
          "CC": "Cocoseilanden",
          "CD": "Congo, de Democratische Rubliek",
          "CF": "Centaal-Afrikaanse Republiek",
          "CG": "Congo",
          "CH": "Zwitserland",
          "CI": "Ivoorkust",
          "CK": "Cookeilanden",
          "CL": "Chili",
          "CM": "Kameroen",
          "CN": "China",
          "CO": "Colombia",
          "CR": "Costa Rica",
          "CU": "Cuba",
          "CV": "Kaap Verde",
          "CX": "Christmaseiland",
          "CY": "Cyprus",
          "CZ": "Tsjechische Republiek",
          "DE": "Duitsland",
          "DJ": "Djibouti",
          "DK": "Denemarken",
          "DM": "Dominica",
          "DO": "Dominicaanse Republiek",
          "DZ": "Algerije",
          "EC": "Ecuador",
          "EE": "Estland",
          "EG": "Egypte",
          "EH": "Westelijke Sahara",
          "ER": "Eritrea",
          "ES": "Spanje",
          "ET": "Ethiopië",
          "EU": "Europa",
          "FI": "Finland",
          "FJ": "Fiji",
          "FK": "Falklandeilanden (Malvinas)",
          "FM": "Micronesia",
          "FO": "Faeröer eilanden",
          "FR": "Frankrijk",
          "FX": "Frankrijk, Continentaal",
          "GA": "Gabon",
          "GB": "Verenigd Koninkrijk",
          "GD": "Grenada",
          "GE": "Georgië",
          "GF": "Frans-Guyana",
          "GG": "Guernsey",
          "GH": "Ghana",
          "GI": "Gibraltar",
          "GL": "Groenland",
          "GM": "Gambia",
          "GN": "Guinea",
          "GP": "Guadeloupe",
          "GQ": "Equatoriaal-Guinea",
          "GR": "Griekenland",
          "GS": "Zuid-Georgië en de Zuidelijke Sandwicheilanden",
          "GT": "Guatemala",
          "GU": "Guam",
          "GW": "Guinea-Bissau",
          "GY": "Guyana",
          "HK": "Hong Kong",
          "HM": "Heardeiland en McDonaldeilanden",
          "HN": "Honduras",
          "HR": "Croatië",
          "HT": "Haïti",
          "HU": "Hongarije",
          "ID": "Indonesië",
          "IE": "Ierland",
          "IL": "Israël",
          "IM": "Man",
          "IN": "India",
          "IO": "Brits Indische Oceaanterritorium",
          "IQ": "Irak",
          "IR": "Iran, Islamitische Republiek",
          "IS": "IJsland",
          "IT": "Italië",
          "JE": "Jersey",
          "JM": "Jamaica",
          "JO": "Jordanië",
          "JP": "Japan",
          "KE": "Kenia",
          "KG": "Kirgizië",
          "KH": "Cambodja",
          "KI": "Kiribati",
          "KM": "Comoren",
          "KN": "Saint Kitts en Nevis",
          "KP": "Korea, Democratische Volksrepubliek",
          "KR": "Korea, Republiek",
          "KW": "Koeweit",
          "KY": "Kaaimaneilanden",
          "KZ": "Kazachstan",
          "LA": "Laos, Democratische Volksrepubliek",
          "LB": "Libanon",
          "LC": "Saint Lucia",
          "LI": "Liechtenstein",
          "LK": "Sri Lanka",
          "LR": "Liberia",
          "LS": "Lesotho",
          "LT": "Litouwen",
          "LU": "Luxemburg",
          "LV": "Letland",
          "LY": "Libisch-Arabische Jamahiriyah ",
          "MA": "Marokko",
          "MC": "Monaco",
          "MD": "Moldavië, Republiek",
          "ME": "Montenegro",
          "MF": "Sint Maarten",
          "MG": "Madagascar",
          "MH": "Marshalleilanden",
          "MK": "Macedonië",
          "ML": "Mali",
          "MM": "Myanmar",
          "MN": "Mongolië",
          "MO": "Macau",
          "MP": "Noordelijke Marianen",
          "MQ": "Martinique",
          "MR": "Mauretanië",
          "MS": "Montserrat",
          "MT": "Malta",
          "MU": "Mauritius",
          "MV": "Maldiven",
          "MW": "Malawi",
          "MX": "Mexico",
          "MY": "Maleisië",
          "MZ": "Mozambique",
          "NA": "Namibië",
          "NC": "Nieuw-Caledonië",
          "NE": "Niger",
          "NF": "Norfolk",
          "NG": "Nigeria",
          "NI": "Nicaragua",
          "NL": "Nederland",
          "NO": "Noorwegen",
          "NP": "Nepal",
          "NR": "Nauru",
          "NU": "Niue",
          "NZ": "Nieuw-Zeeland",
          "OM": "Oman",
          "PA": "Panama",
          "PE": "Peru",
          "PF": "Frans-Polynesië",
          "PG": "Papua-Nieuw-Guinea",
          "PH": "Filipijnen",
          "PK": "Pakistan",
          "PL": "Polen",
          "PM": "Saint-Pierre en Miquelon",
          "PN": "Pitcairn",
          "PR": "Puerto Rico",
          "PS": "Palestijnse Gebieden",
          "PT": "Portugal",
          "PW": "Palau",
          "PY": "Paraguay",
          "QA": "Qatar",
          "RE": "Réunion",
          "RO": "Roemenië",
          "RS": "Servië",
          "RU": "Russische Federatie",
          "RW": "Rwanda",
          "SA": "Saudi-Arabië",
          "SB": "Solomoneilanden",
          "SC": "Seychellen",
          "SD": "Sudan",
          "SE": "Zweden",
          "SG": "Singapore",
          "SH": "Sint-Helena",
          "SI": "Slovenië",
          "SJ": "Spitsbergen en Jan Mayen",
          "SK": "Slovakije",
          "SL": "Sierra Leone",
          "SM": "San Marino",
          "SN": "Senegal",
          "SO": "Somalië",
          "SR": "Suriname",
          "ST": "Sao Tomé en Principe",
          "SV": "El salvador",
          "SY": "Syrische Arabische Republiek",
          "SZ": "Swaziland",
          "TC": "Turks- en Caicoseilanden",
          "TD": "Chad",
          "TF": "French Southern Territories",
          "TG": "Togo",
          "TH": "Thailand",
          "TJ": "Tajikistan",
          "TK": "Tokelau",
          "TL": "Timor-Leste",
          "TM": "Turkmenistan",
          "TN": "Tunesië",
          "TO": "Tonga",
          "TR": "Turkije",
          "TT": "Trinidad en Tobago",
          "TV": "Tuvalu",
          "TW": "Taiwan",
          "TZ": "Tanzania, Verenigd Republiek van",
          "UA": "Oekraïne",
          "UG": "Oeganda",
          "UM": "De Kleine Afgelegen Eilanden van de Verenigde Staten",
          "US": "Verenigde Staten",
          "UY": "Uruguay",
          "UZ": "Uzbekistan",
          "VA": "Heilige stoel (Vaticaanstad)",
          "VC": "Sint Vincent en de Grenadines",
          "VE": "Venezuela",
          "VG": "Maagdeneilanden, Britse",
          "VI": "Maagdeneilanden, V.S.",
          "VN": "Vietnam",
          "VU": "Vanuatu",
          "WF": "Wallis and Futuna",
          "WS": "Samoa",
          "YE": "Yemen",
          "YT": "Mayotte",
          "ZA": "Zuid-Afrika",
          "ZM": "Zambia",
          "ZW": "Zimbabwe",
          "all": "Alle landen"
        }
      }
    },
    "order": [
      "year",
      "month",
      "day"
    ],
    "status_codes": {
      "accommodation": {
        "create_failed": "Vakantiewoning/Kamer kan niet worden bevestigd",
        "destroyed": "Ferienwohnung/Zimmer werd verwijderd.",
        "successfully_created": "Vakantiewoning/Kamer succesvol gereserveerd",
        "successfully_updated": "Vakantiewoning/Kamer succesvol gewijzigd",
        "update_failed": "Vakantiewoning/Kamer kan niet worden gewijzigd"
      },
      "amenity": {
        "create_failed": "Functie/Eigenschap kan niet bevestigd worden",
        "destroyed": "Uitrustingskenmerk werd verwijderd.",
        "successfully_created": "Functie/Eigenschap succesvol bevestigd",
        "successfully_updated": "Functie/Eigenschap succesvol gewijzigd",
        "update_failed": "Functie/Eigenschap kan niet veranderd worden"
      },
      "approval": {
        "successfully_updated": "Freigabe erfolgreich geändert"
      },
      "attraction": {
        "create_failed": "Attractie kan niet bevestigd worden",
        "destroyed": "Attractie werd verwijderd.",
        "successfully_created": "Attractie succesvol bevestigd",
        "successfully_updated": "Attractie succesvol gewijzigd",
        "update_failed": "Attractie kan niet gewijzigd worden"
      },
      "attraction_distance": {
        "create_failed": "Afstand tot attractie kan niet bevestigd worden",
        "destroyed": "Afstand tot attractie werd verwijderd.",
        "successfully_created": "Afstand tot attractie werd succesvol bevestigd",
        "successfully_updated": "Afstand tot attractie werd succesvol gewijzigd",
        "update_failed": "Afstand tot attractie kan niet gewijzigd worden"
      },
      "block": {
        "create_failed": "Periode kan niet bevestigd worden",
        "destroyed": "Periode werd verwijderd.",
        "successfully_created": "Periode succesvol bevestigd",
        "successfully_unblocked": "Periode succesvol ter beschikking gemaakt",
        "successfully_updated": "Periode succesvol gewijzigd",
        "unblocking_failed": "Periode kon niet ter beschikking worden gemaakt",
        "update_failed": "Periode kan niet gewijzigd worden"
      },
      "cost": {
        "create_failed": "Extra kosten kunnen niet niet aangemaakt worden.",
        "destroyed": "Extra kosten werden verwijderd.",
        "successfully_created": "Extra kosten met succes aangemaakt.",
        "successfully_updated": "Extra kosten met succes besvestigt.",
        "update_failed": "Extra kosten kunnen niet gewijzigd worden."
      },
      "extra": {
        "create_failed": "Extra is niet aangemaakt",
        "destroyed": "Extra is geschrapt",
        "successfully_created": "Extra met succes aangemaakt",
        "successfully_updated": "Extra succesvoll gewijzigt",
        "update_failed": "Extra is niet verandert"
      },
      "invitation": {
        "create_failed": "Uitnodiging kon niet aangemaakt worden",
        "successfully_created": "Uitnodiging succesvol aangemaakt"
      },
      "limitation": {
        "create_failed": "Beperking / Bijzonderheden kon niet aangemaakt worden",
        "destroyed": "Beperking / Bijzonderheden verwijderd",
        "successfully_created": "Beperking / Bijzonderheden succesvol aangemaakt",
        "successfully_updated": "Beperking / Bijzonderheden succesvol verandert",
        "update_failed": "Beperking / Bijzonderheden"
      },
      "price": {
        "create_failed": "Prijs kan niet aangemaakt worden.",
        "destroyed": "Prijs werd verwijderd.",
        "nested_season": "Het is alleen mogelijk  een seizoen naar een andere achter elkaar te maken maar niet 2 tegelijk.",
        "successfully_created": "Prijs met succes aangemaakt.",
        "successfully_updated": "Prijs met succes gewijzigd.",
        "update_failed": "Prijs kan niet gewijzigd worden."
      },
      "property": {
        "create_failed": "Woning kan niet aangemaakt worden.",
        "destroyed": "Woning werd verwijderd.",
        "successfully_created": "Woning met succes aangemaakt.",
        "successfully_updated": "Woning met succes gewijzigd.",
        "update_failed": "Woning kan niet gewijzigd worden."
      },
      "property_photo": {
        "create_failed": "Foto kan niet aangemaakt worden.",
        "destroyed": "Foto werd verwijderd.",
        "successfully_created": "Foto met succes aangemaakt.",
        "successfully_updated": "Foto met succes gewijzigd.",
        "update_failed": "Foto kan niet gewijzigd worden."
      },
      "travel_booking": {
        "cancel_failed": "Buchung wurde nicht storniert.",
        "confirmation_failed": "Buchung wurde nicht bestätigt.",
        "create_failed": "Buchung konnte nicht angelegt werden.",
        "destroyed": "Buchung wurde gelöscht.",
        "successfully_cancelled": "Buchung wurde storniert.",
        "successfully_confirmed": "Buchung wurde bestätigt.",
        "successfully_created": "Buchung erfolgreich angelegt.",
        "successfully_updated": "Buchung erfolgreich geändert.",
        "update_failed": "Buchung konnte nicht geändert werden."
      },
      "travel_region": {
        "create_failed": "Regio kan niet aangemaakt worden.",
        "destroyed": "Regio werd verwijderd.",
        "successfully_created": "Regio met succes aangemaakt.",
        "successfully_updated": "Regio met succes gewijzigd.",
        "update_failed": "Regio kan niet gewijzigd worden."
      },
      "user": {
        "create_failed": "Gebruiker kan niet aangemaakt worden.",
        "destroyed": "Gebruiker werd verwijderd.",
        "must_be_host": "Gelieve verhuurder te worden (vb. AGB accepteren..)",
        "must_be_renter": "Gelieve wordt een klant. Om dit te doen, kunt u zich inschrijven met een ander e-mailadres.",
        "successfully_created": "Gebruiker met succes aangemaakt.",
        "successfully_updated": "Gebruiker met succes gewijzigd.",
        "update_failed": "Gebruiker gegevens kon niet gewijzigd worden.",
        "wrong_date_format": "De datum formaat is verkeerd."
      }
    }
  },
  "administration": {
    "accommodations": {
      "price_change_end_date_label": "Einde: Seizoensprijzen die beginnen op of voor deze datum (niet invullen om prijswijzigingen te voorkomen)",
      "price_change_label": "Prijswijziging (in %, niet invullen om prijzen niet te wijzigen)",
      "price_change_start_date_label": "Start: Seizoensprijzen die starten op of na deze datum (niet invullen om prijzen niet te wijzigen)"
    },
    "city_name_for_filter": "Namer der Stadt für Suchfilter",
    "landing_pages": {
      "accids": "Woning ID's",
      "country_code": "Länderkürzel",
      "desc": "Beschrijving",
      "edit": "Landing Page wijzigen",
      "header": "Header",
      "img": "Teaser",
      "locale": "Taalversie",
      "mailer": "Email link tekst",
      "mailer_subject": "Email onderwerp",
      "meta_desc": "Beschrijving SEO",
      "meta_keyword": "Trefwoorden SEO",
      "search_meta": "Regio",
      "slug": "Naam",
      "title": "Regio"
    },
    "properties": {
      "form": {
        "api_blocked": "Uit Api"
      }
    },
    "travel_bookings": {
      "no_data": "Geen gegevens beschikbaar"
    }
  },
  "already_cancelled": "Bereits storniert",
  "already_confirmed": "Al bevestigd",
  "ancestry": {
    "cannot_delete_descendants": "Cannot delete record because it has descendants.",
    "cannot_rebuild_depth_cache": "Cannot rebuild depth cache for model without depth caching.",
    "conflicting_parent_id": "Conflicting parent id found in node %{node_id}: %{parent_id} for node %{node_id} while expecting %{expected}",
    "exclude_self": "%{class_name} cannot be a descendant of itself.",
    "invalid_ancestry_column": "Invalid format for ancestry column of node %{node_id}: %{ancestry_column}.",
    "invalid_orphan_strategy": "Invalid orphan strategy, valid ones are :rootify, :adopt, :restrict and :destroy.",
    "named_scope_depth_cache": "Named scope '%{scope_name}' is only available when depth caching is enabled.",
    "no_child_for_new_record": "No child ancestry for new record. Save record before performing tree operations.",
    "option_must_be_hash": "Options for has_ancestry must be in a hash.",
    "reference_nonexistent_node": "Reference to nonexistent node in node %{node_id}: %{ancestor_id}.",
    "unknown_depth_option": "Unknown depth option: %{scope_name}.",
    "unknown_option": "Unknown option for has_ancestry: %{key} => %{value}."
  },
  "attributes": {
    "created_at": "Créé le",
    "translations": {
      "description": "Omschrijving",
      "description_de": "Omschrijving (Duits)",
      "description_en": "Omschrijving (Engels)",
      "description_es": "Beschrijving (Spaans)",
      "description_fr": "Omschrijving (Frans)",
      "description_nl": "Omschrijving (Nederlands)",
      "description_short": "Kurzbeschreibung",
      "description_short_de": "Kurzbeschreibung (deutsch)",
      "description_short_en": "Kurzbeschreibung (englisch)",
      "description_short_es": "Kurzbeschreibung (spanisch)",
      "description_short_fr": "Kurzbeschreibung (französisch)",
      "description_short_nl": "Kurzbeschreibung (niederländisch)",
      "kind": "Art",
      "kind_de": "Art (deutsch)",
      "kind_en": "Art (englisch)",
      "kind_es": "Art (spanisch)",
      "kind_fr": "Art (französisch)",
      "kind_nl": "Art (niederländisch)",
      "title": "Titel",
      "title_de": "Titel (Duits)",
      "title_en": "Titel (Engels)",
      "title_es": "Titel (Spaans)",
      "title_fr": "Titel (Frans)",
      "title_nl": "Titel (Nederlands)"
    },
    "updated_at": "Modifié le"
  },
  "booking": {
    "additional_costs_host": "Extrakosten/verbruik ter plaatse",
    "additional_information": "Meer gegevens",
    "additional_information_annotation": "Selecteer het aantal personen en kies uw vakantiewoning voor het gewenste datum.",
    "adult": "Volwassen",
    "adults": "Volwassenen",
    "arrival_date": "Aankomst datum ",
    "arrival_date_annotation": "Kies hier het aankomstdatum",
    "availability_check": "Beschikbaarheid van de woning",
    "availability_txt": "Kies de gewenste periode direct in de kalender.",
    "available_arrival_date": "Beschikbaar aankomst datum",
    "available_arrival_date_annotation": "Voor het wijzigen van een reeds gekozen datum, klik op een alternatieve datum ",
    "booking_headline": "Boek „%{object_name}“ in 2 stappen",
    "booking_info": "Boekingsinformatie",
    "booking_overview": "Uw boekingsoverzicht",
    "booking_period": "periode",
    "booking_possible_timespace": "Beschikbare periodes",
    "booking_process": "Boekingsafloop",
    "booking_process_confirmation": "Na het invoeren van uw boeking, ontvangt u een bevestiging per email.",
    "booking_process_payment_details": "Na bevestiging van de verhuurder, ontvangt u dan de benodigde betalingsinformatie.",
    "booking_summary": "Samenvatting van uw boeking",
    "booking_timespace": "Boekingsperiode",
    "calendar_annotation": "Een ogenblik geduld aub. De beschikbaarheid van uw woning wordt geladen.",
    "cancellation": {
      "accept_conditions": "Met het boeken van de reisannuleringsverzekering accepteer ik hun <a href=\"/downloads/terms-conditions/cancellation-insurance-nl\" target=\"_blank\" rel=\"noopener noreferrer\">verzekeringsvoorwaarden</a>.",
      "amount": "Slechts %{amount}",
      "opt_in": "Ik wil graag een reisannuleringsverzekering afsluiten voor deze boeking."
    },
    "casualty_insurance": "incl. Schadeverzekering:",
    "casualty_insurance_txt": "Nuttig in geval van schade - zonder een eigen risico",
    "change": "boekingsperiode wijzigen",
    "check_payment_info": "Controleer uw betalingsgegevens of neem contact op met uw credit card provider",
    "chid_age_full": "Kind (0-17 jaren)",
    "chidren_age_full": "Kinderen (0-17 jaren)",
    "child_age17": "Kind (2-17 jaar)",
    "child_age2": "Kind (van 0 tot 1)",
    "child_part_age2": "Baby (0-1 jaren)",
    "child_part_age2_cost": "Daarvan baby's (0-1 jaren)",
    "children_age17": "Kinderen (2-17 jaar)",
    "children_age2": "Kinderen (van 0 tot 1)",
    "children_part_age2": "Baby (0-1 jaren)",
    "comment": "Opmerking - Kortingsbon",
    "comment_label_info": "Gelieve uw Opmerking of kortingscode in te vullen zo ontvangt u naar de boeking de korting.",
    "comment_note": "Hier kunt u commentaren / opmerkingen / voucher code ingeven. ",
    "confirmation_mail": "Binnen de komende paar minuten ontvangt u een bevestigings e-mail naar het volgende adres",
    "confirmation_spam_notice": "Geen e-mail ontvangen? Controleer uw spam folder.",
    "confirmation_wrong_mail": "Voor vragen over uw reservering gelieve contact opnemen met",
    "contact_host": "Contactgegevens",
    "dateselect": "Om het wijzigen van een eerder geselecteerde periode, klikt u op de begin-of einddatum en selecteer vervolgens een nieuwe datum.",
    "deposit": "Waarborg",
    "deposit_handling": "Teruggave waarborg",
    "duration": "Verblijfsduur",
    "duration_of_stay": {
      "one": "%{count} Nacht",
      "other": "%{count} Nachten"
    },
    "duration_of_stay_annotation": "Kies een van de mogelijke verblijfsduren aan de rechterkant vermeld.",
    "europeene_explanation": "Axa is de partner van casapilot",
    "from": "van",
    "group": "Uw Groep",
    "group_comment": "Samenstelling van de groep",
    "group_max": "Max. leeftijd",
    "group_min": "Min leeftijd",
    "group_years": "Groep leeftijd",
    "group_years_sum": "%{min} – %{max} Leeftijd",
    "hh_additional": "Extrakosten",
    "hh_additional_tax": "Toeristenbelasting",
    "hh_agb": "Algemene Verkoopsvoorwaarden",
    "hh_agb_annotation": "Ik bevestig dat ik de Algemene Verkoopsvoorwaarden gelezen, begrepen en geaccepteerd heb",
    "hh_conditions_and_prices": "Huurvoorwaarden en prijzen",
    "hh_inc_fees": "Inclusive reserverings- en administratiekosten",
    "hh_redirect_annotation_pt1": "Indien de automatische doorverwijzing niet werkt, klik ",
    "hh_redirect_annotation_pt2": "Hier",
    "hh_redirect_hl": "Verbinding naar onze Partner Holiday Home",
    "hh_redirect_txt": "U wordt doorgestuurd naar onze partner Holiday Home. Gelieve een moment geduld.",
    "host_contact": "De contactgegevens van de eigenaar, ontvangt u 3 weken voor begin van de vakantie samen met het verblijfsticket. ",
    "host_cost": "Plus de extra kosten ter plaatse",
    "inc_fees": "Inclusive reserverings- en administratiekosten",
    "inc_fees_cancellation": "Inclusive reisannuleringsverzekering, reserverings- en administratiekosten",
    "info_message_redirect": "U wordt automatisch naar de homepage doorgestuurd.",
    "insurance_names_txt": "Gelieve de namen van de medereizigers in te vullen die verzekert moeten worden. Deze namen worden voor het verzekeringsbiljet gebruikt.",
    "insurance_names_txt_2": "Schrijf elke naam op een aparte lijn of scheid ze met komma's. De specificatie van de achternaam is voldoende.",
    "insurance_tos": "Verzekerings voorwaarden",
    "insurance_tos_html": "Ik bevestig dat ik de Algemene Voorwaarden gelezen, begrepen en geaccepteerd heb",
    "insurances": "Verzekering",
    "journey": "Uw reis ",
    "limitations": "Bijzonderheden",
    "mail_confirmation": "Bedankt voor het bevestigen van deze reservatie.",
    "mail_confirmation_annotation": "Hebt u vragen betrekkelijk het boekingsproces? Neem dan contact met ons op. ",
    "me_redirect_hl": "Verbinding naar onze Partner MER-EVASION",
    "me_redirect_txt": "U wordt doorgestuurd naar onze partner MER-EVASION. Gelieve een moment geduld.",
    "mv_redirect_hl": "Verbinding naar onze Partner MONTAGNE-VACANCES",
    "mv_redirect_txt": "U wordt doorgestuurd naar onze partner MONTAGNE-VACANCES. Gelieve een moment geduld.",
    "navigation": {
      "availability": "Data",
      "booking_info": "Kosten",
      "payment": "Betaling",
      "payment_feedback": "Bevestiging",
      "payment_info": "Overzicht"
    },
    "newsletter_subscription": "Ik zou graag de Casapilot nieuwsbrief ontvangen. ",
    "night": "Nacht",
    "nights": "Nachten",
    "no_costs": "Geen",
    "number_of_persons": "Aantal personen",
    "payment": "Betaling.",
    "payment_accepted": "Hartelijk dank voor uw boeking. \nNa de bevestiging door de verhuurder ontvangt u een e-mail met alle benodigde betalingsgegevens .\nMet vriendelijke groeten,\nhet Team van Casapilot",
    "payment_declined": "Uw betaling is geweigerd",
    "payment_declined_txt": "Uw betaling werd helaas afgewezen.",
    "payment_not_possible": "De betaling is op dit moment niet mogelijk",
    "payment_not_possible_txt": "De betaling is op dit moment niet mogelijk",
    "payment_not_possible_txt2": "Probeer het later opnieuw of neem contact met u  credit card provider",
    "payment_successful": "Uw betaling is gelukt.",
    "pet": "Huisdier",
    "pet_comment_separator": "Opmerking over huisdieren:",
    "pets": "Huisdieren",
    "pets_not_allowed": "Huisdieren zijn niet toegestaan",
    "posible_host_cost": "",
    "posible_host_cost_txt": "De volgende kosten zijn niet inbegrepen in de bovenstaande huurprijs:",
    "possible_costs_host": "Kosten voor optionele uitrusting",
    "price_box_season_annotation": "Prijzen kunnen veranderen afhankelijk van het seizoen.",
    "price_total": "Totale huurprijs",
    "prices_object": "Prijs van uw gekozen woning",
    "rental_price": "Huurprijs",
    "renter": {
      "birthday_format": "DD.MM.JJJJ"
    },
    "reservation": {
      "failed": "Helaas is de woning al geboekt. Gelieve een andere periode te selecteren. "
    },
    "reservation_fee": "incl. Reserveringskosten",
    "review": "Controleer uw gegevens",
    "rotation_day": "Aankomst",
    "secure": "Veilig op vakantie met Casapilot. Gegarandeerd. ",
    "security": {
      "h1": "Uw boeking",
      "h2": "De betaling",
      "h3": "Onze diensten",
      "p1": "Uw persoonlijke gegevens worden vertrouwelijk behandeld.",
      "p2": "Veilige en gemakkelijke betaling over het versleutelde systeem van Casapilot.",
      "p3": "Als u vragen hebt, zijn we tot uw beschikking."
    },
    "select_bookable_date": "Selecteer een beschikbaar datum voor uw verblijf",
    "select_duration": "Kies uw verblijfsperiode in het blauwe keuzevakje.",
    "slider": {
      "month_not_available_html": "In deze periode is deze woning niet beschikbaar",
      "next": "De opvolgende 4 maanden",
      "prev": "De vorige 4 maanden"
    },
    "sp_redirect_hl": "Verbinding naar onze Partner SKI-PLANET",
    "sp_redirect_txt": "U wordt doorgestuurd naar onze partner SKI-PLANET. Gelieve een moment geduld.",
    "tenant_booking": "Uw boeking",
    "tenant_data": "Uw gegevens",
    "tenant_residence": "Uw Woonplaats",
    "terms_of_service_html": "Ik bevestig dat ik de <a href=\"/downloads/terms-conditions/guest-nl\" target=\"_blank\">AV</a> van Casapilot gelezen, begrepen en geaccepteerd heb. ",
    "time": "Uur",
    "to": "tot",
    "total": "Totaal",
    "travel_cancelation_insurance": "Reisverzekering",
    "travel_cancelation_insurance_dash": "Reisverzekering",
    "travel_cancelation_insurance_plus": "Inclusief reis-annuleringsverzekering",
    "travel_cancelation_insurance_plus_txt": "Compleet verzekeringen \n",
    "travel_cancelation_insurance_txt": "Bestaat er een risico voor een annulatie van uw verblijf?",
    "travel_insurance": "Uitgebreide reisverzekering",
    "travel_insurance_txt": "Uitgebreide verzekering",
    "traveler_options": {
      "adult": {
        "one": "%{count} Volwassen",
        "other": "%{count} Volwassenen"
      },
      "all_children": {
        "one": "%{count} Kind (0-17 jaren)",
        "other": "%{count} Kinderen (0-17 jaren)"
      },
      "baby": {
        "one": "%{count} Baby (0-1 jaren)",
        "other": "%{count} Baby (0-1 jaren)"
      },
      "baby_parts": {
        "one": "Daarvan %{count} baby's (0-1 jaren)",
        "other": "Daarvan %{count} baby's (0-1 jaren)"
      },
      "child": {
        "one": "%{count} Kind (2-17 jaar)",
        "other": "%{count} Kinderen (2-17 jaar)"
      },
      "pet": {
        "one": "%{count} Huisdier",
        "other": "%{count} Huisdieren"
      }
    },
    "travelers": "Medereizigers ",
    "try_again": "Probeer het opnieuw",
    "week": "Week",
    "weeks": "Weken"
  },
  "booking_cancel": "Boeking annuleren",
  "booking_confirmation": "Boekingsbevestiging",
  "booking_confirming": "Boeking bevestigen",
  "breakfast_offer": {
    "body": "In deze accommodatie heeft u de <a href=\"https://specials.casapilot.com/shop/?lang=nl\" target=\"_blank\" rel=\"noreferrer\">mogelijkheid om een maaltijd of ontbijt</a> voor uw verblijf te reserveren. Laat ons u verwennen met heerlijke producten uit de streek!",
    "title": "NIEUW: Laat een ontbijt ofwel menu bezorgen!"
  },
  "buttons": {
    "availability": "Beschikbaarheid",
    "book_now": "Nu boeken",
    "cancel": "afbreken",
    "continue": "Verder",
    "delete": "verwijderen",
    "edit": "Wijzigen",
    "go_to_summary": "Samenvatting",
    "host_acct_create": "Verhuurder profiel creëren ",
    "login_continue": "Inloggen en verder met uw boeking",
    "offers": "Ons aanbod",
    "pay": "Betalen",
    "preview": "Vooraanzicht",
    "price": "Prijs",
    "register_continue": "Inschrijven en verder met de boeking",
    "register_property": "Nu uw huis registreren",
    "renter_acct_create": "Huurder toegang creëren",
    "reserve_now": "Reservering met betaalverplichting",
    "save": "opslaan",
    "submit": "Opslaan"
  },
  "cancellation": "Stornieren",
  "chat_tool": {
    "widget_id": "4becb0cb07b2c85b577bfbce4b889c4781bc6cbca290d2d78bda03ae30220bb2"
  },
  "confirm": "Bevestigen",
  "confirmed_by_admin": "Bevestigd door administrator",
  "confirmed_by_host": "Bevestigd door eigenaar",
  "cookie_disclaimer": {
    "button_text": "Aanvaarden",
    "link_text": "Meer info",
    "text": "<p>Deze website maakt net zoals de meeste websites gebruik van cookies.</p>\n<p>Via deze cookies verzamelen wij informatie over uw bezoek en interesses.</p>\n<p>Centraal in ons cookiebeleid staat respect voor uw privacy.</P>\n<p>Lees dit gerust na via de link “Meer informatie” onderaan.</p>\n<p>Bedankt voor uw vertrouwen en veel plezier</p>"
  },
  "country_codes": {
    "at": "Oostenrijk",
    "be": "België",
    "bg": "Bulgarije",
    "ch": "Zwitserland",
    "cy": "Cyprus",
    "cz": "Tsjechië",
    "de": "Duitsland",
    "dk": "Denemarken",
    "ee": "Estland",
    "es": "Spanje",
    "false": "Noorwegen",
    "fi": "Finland",
    "fr": "Frankrijk",
    "gb": "Verenigd Koninkrijk",
    "gr": "Griekenland",
    "hr": "Kroatië",
    "ie": "Ierland",
    "is": "IJsland",
    "it": "Italië",
    "li": "Liechtenstein",
    "lt": "Litouwen",
    "lu": "Luxemburg",
    "lv": "Letland",
    "mt": "Malta",
    "nl": "Nederland",
    "pl": "Polen",
    "pt": "Portugal",
    "ro": "Roemenië",
    "se": "Zweden",
    "si": "Slovenië",
    "sk": "Slowakije",
    "uk": "Verenigd Koninkrijk"
  },
  "date": {
    "abbr_day_names": [
      "zon",
      "maa",
      "din",
      "woe",
      "don",
      "vri",
      "zat"
    ],
    "abbr_day_names_string": {
      "friday": "vri",
      "monday": "maa",
      "saturday": "zat",
      "sunday": "zon",
      "thursday": "don",
      "tuesday": "din",
      "wednesday": "woe"
    },
    "abbr_month_names": [
      null,
      "jan",
      "feb",
      "mar",
      "apr",
      "mei",
      "jun",
      "jul",
      "aug",
      "sep",
      "okt",
      "nov",
      "dec"
    ],
    "day_names": [
      "zondag",
      "maandag",
      "dinsdag",
      "woensdag",
      "donderdag",
      "vrijdag",
      "zaterdag"
    ],
    "day_names_string": {
      "friday": "vrijdag",
      "monday": "maandag",
      "saturday": "zaterdag",
      "sunday": "zondag",
      "thursday": "donderdag",
      "tuesday": "dinsdag",
      "wednesday": "woensdag"
    },
    "formats": {
      "calendar_field": "%d.%m.%Y",
      "day_date_month": "dd, DD. MMM",
      "default": "%d/%m/%Y",
      "long": "%e %B %Y",
      "long_date": "%a. %d.%m.%y",
      "month_year": "MMMM YYYY",
      "only_day": "%e",
      "request_time_scope": "dd. DD-MM-YY",
      "short": "%e %b"
    },
    "month_names": [
      null,
      "januari",
      "februari",
      "maart",
      "april",
      "mei",
      "juni",
      "juli",
      "augustus",
      "september",
      "oktober",
      "november",
      "december"
    ],
    "order": [
      "day",
      "month",
      "year"
    ]
  },
  "datetime": {
    "distance_in_words": {
      "about_x_hours": {
        "one": "ongeveer Ã©Ã©n uur",
        "other": "ongeveer %{count} uur"
      },
      "about_x_months": {
        "one": "ongeveer Ã©Ã©n maand",
        "other": "ongeveer %{count} maanden"
      },
      "about_x_years": {
        "one": "ongeveer Ã©Ã©n jaar",
        "other": "ongeveer %{count} jaar"
      },
      "almost_x_years": {
        "one": "bijna Ã©Ã©n jaar",
        "other": "bijna %{count} jaar"
      },
      "half_a_minute": "een halve minuut",
      "less_than_x_minutes": {
        "one": "minder dan Ã©Ã©n minuut",
        "other": "minder dan %{count} minuten"
      },
      "less_than_x_seconds": {
        "one": "minder dan Ã©Ã©n seconde",
        "other": "minder dan %{count} seconden"
      },
      "over_x_years": {
        "one": "meer dan Ã©Ã©n jaar",
        "other": "meer dan %{count} jaar"
      },
      "x_days": {
        "one": "1 dag",
        "other": "%{count} dagen"
      },
      "x_minutes": {
        "one": "1 minuut",
        "other": "%{count} minuten"
      },
      "x_months": {
        "one": "1 maand",
        "other": "%{count} maanden"
      },
      "x_seconds": {
        "one": "1 seconde",
        "other": "%{count} seconden"
      }
    },
    "prompts": {
      "day": "dag",
      "hour": "uur",
      "minute": "minuut",
      "month": "maand",
      "second": "seconde",
      "year": "jaar"
    }
  },
  "days_short": {
    "friday": "Vr",
    "monday": "Ma",
    "saturday": "Za",
    "sunday": "Zo",
    "thursday": "Do",
    "tuesday": "Di",
    "wednesday": "Wo"
  },
  "devise": {
    "confirmations": {
      "confirmed": "Uw gegevens zijn succesvol bevestigd. U bent nu ingelogd.",
      "new": {
        "submit": "Bestellen",
        "title": "Bevestigingsgegevens opnieuw versturen"
      },
      "send_instructions": "Over enkele minuten krijgt u een e-mail met de instructies hoe u uw paswoord opnieuw kunt instellen.",
      "send_paranoid_instructions": "If your email address exists in our database, you will receive an email with instructions for how to confirm your email address in a few minutes.",
      "updated": "Uw paswoord werd gewijzigd. U bent aangemeld."
    },
    "error_occured": "Er is een fout opgetreden.",
    "failure": {
      "already_authenticated": "U bent al registreerd",
      "inactive": "Uw gegevens zijn niet actief.",
      "invalid": "Ongeldige aanmeldgegevens.",
      "invalid_token": "Invalid authentication token.",
      "last_attempt": "You have one more attempt before your account is locked.",
      "locked": "Uw gegevens zijn geblokkeerd.",
      "not_found_in_database": "Invalid %{authentication_keys} or password.",
      "timeout": "Uw sessie is verstreken. Meld u opnieuw aan a.u.b.",
      "unauthenticated": "U dient zich aan te melden of te registreren voordat u kunt verder surfen.",
      "unconfirmed": "U dient uw gegevens te bevestigen, voordat u kunt verder surfen."
    },
    "mailer": {
      "confirmation_instructions": {
        "subject": "Gelieve uw registratie als gebruiker van www.casapilot.com te bevestigen."
      },
      "email_changed": {
        "subject": "Email Changed"
      },
      "password_change": {
        "subject": "Password Changed"
      },
      "reset_password_instructions": {
        "subject": "Uw paswoord voor www.casapilot.com resetten"
      },
      "unlock_instructions": {
        "subject": "Uw profiel op www.casapilot.com werd geblokkeerd"
      }
    },
    "oauth_callbacks": {
      "failure": "U kan niet met de %{kind}-gegevens aangemeld worden, omdat \"%{reason}\".",
      "success": "Succesvol aangemeld met de %{kind}-gegevens."
    },
    "omniauth_callbacks": {
      "failure": "Could not authenticate you from %{kind} because \"%{reason}\".",
      "success": "Successfully authenticated from %{kind} account."
    },
    "passwords": {
      "edit": {
        "submit": "Wachtwoord opslaan",
        "title": "Wachtwoord wijzigen"
      },
      "new": {
        "submit": "Wachtwoord opnieuw instellen",
        "title": "Wachtwoord vergeten?"
      },
      "no_token": "You can't access this page without coming from a password reset email. If you do come from a password reset email, please make sure you used the full URL provided.",
      "send_instructions": "Over enkele minuten krijgt u een e-mail met de instructies hoe u uw paswoord opnieuw kunt instellen.",
      "send_paranoid_instructions": "If your email address exists in our database, you will receive a password recovery link at your email address in a few minutes.",
      "updated": "Uw paswoord werd gewijzigd. U ben aangemeld.",
      "updated_not_active": "Your password has been changed successfully."
    },
    "registrations": {
      "destroyed": "Uw gegevens zijn met succes verwijderd.",
      "edit": {
        "back": "Terug",
        "cancel": {
          "description": "Niet tevreden?",
          "link": "Mijn profiel verwijderen",
          "question": "Bent u zeker?",
          "title": "Profiel verwijderen"
        },
        "current_hint": "(Uw heeft uw huidige paswoord nodig om wijzigingen aan te brengen)",
        "password_hint": "(Leeg laten indien u niets wilt wijzigen)",
        "submit": "Opslaan",
        "title": "Profiel wijzigen"
      },
      "new": {
        "newsletter_subscription": "Ik zou graag de Casapilot nieuwsletter ontvangen",
        "submit": "Profiel aanmaken",
        "title": "Maak gratis een profiel als verhuurder"
      },
      "signed_up": "U heeft zich met succes geregistreerd. U ontvangt nu een activerings e-mail voor U account te bevestigen .\nGeen e-mail ontvangen? Contorleer uw spam folder.\n",
      "signed_up_but_inactive": "You have signed up successfully. However, we could not sign you in because your account is not yet activated.",
      "signed_up_but_locked": "You have signed up successfully. However, we could not sign you in because your account is locked.",
      "signed_up_but_unconfirmed": "A message with a confirmation link has been sent to your email address. Please follow the link to activate your account.",
      "update_needs_confirmation": "You updated your account successfully, but we need to verify your new email address. Please check your email and follow the confirmation link to confirm your new email address.",
      "updated": "De gegevens werden met succes gewijzigd.",
      "updated_but_not_signed_in": "Your account has been updated successfully, but since your password was changed, you need to sign in again."
    },
    "sessions": {
      "already_signed_out": "Signed out successfully.",
      "new": {
        "login_text": "Registreert U hier om U woning te wijzigen. ",
        "submit": "Login",
        "title": "Wilt U op uw huurder account inloggen? Dan bent U hier goed. "
      },
      "signed_in": "Met succes aangemeld.",
      "signed_out": "Met succes afgemeld."
    },
    "shared": {
      "links": {
        "confirmation": "Heeft u de bevestigingsemail ontvangen?",
        "not_registered": "U bent nog geen lid?",
        "password": "Bent u uw paswoord vergeten?",
        "registered": "U bent al lid?",
        "sign_in": "Hier inloggen. ",
        "sign_up": "Registreren",
        "unlock": "Heeft u de informatie i.v.m. de deblokkering van uw gegevens niet ontvangen?"
      }
    },
    "unlocks": {
      "new": {
        "sumbit": "Instructies voor deblokkeren opnieuw versturen",
        "title": "Instructies voor deblokkeren opnieuw versturen"
      },
      "send_instructions": "Over enkele minuten, ontvangt u een e-mail met de instructies hoe u uw gegevens kunt deblokkeren.",
      "send_paranoid_instructions": "If your account exists, you will receive an email with instructions for how to unlock it in a few minutes.",
      "unlocked": "Uw gegevens zijn gedeblokkeerd. U bent aangemeld."
    }
  },
  "errors": {
    "format": "%{attribute} %{message}",
    "messages": {
      "accepted": "moet worden geaccepteerd",
      "already_confirmed": "werd al bevestigd",
      "blank": "moet opgegeven zijn",
      "confirmation": "komt niet met de bevestiging overeen",
      "confirmation_period_expired": "needs to be confirmed within %{period}, please request a new one",
      "empty": "moet opgegeven zijn",
      "equal_to": "moet gelijk zijn aan %{count}",
      "even": "moet even zijn",
      "exclusion": "is niet beschikbaar",
      "expired": "has expired, please request a new one",
      "greater_than": "moet groter zijn dan %{count}",
      "greater_than_or_equal_to": "moet groter dan of gelijk zijn aan %{count}",
      "in": "must be in %{count}",
      "in_between": "must be in between %{min} and %{max}",
      "inclusion": "is niet in de lijst opgenomen",
      "invalid": "is ongeldig",
      "less_than": "moet minder zijn dan %{count}",
      "less_than_or_equal_to": "moet minder dan of gelijk zijn aan %{count}",
      "model_invalid": "Validation failed: %{errors}",
      "not_a_number": "is geen getal",
      "not_an_integer": "moet een geheel getal zijn",
      "not_found": "niet gevonden",
      "not_locked": "is niet geblokkeerd",
      "not_saved": {
        "one": "1 error prohibited this %{resource} from being saved:",
        "other": "%{count} errors prohibited this %{resource} from being saved:"
      },
      "odd": "moet oneven zijn",
      "other_than": "must be other than %{count}",
      "password_too_long": "is too long",
      "present": "must be blank",
      "required": "must exist",
      "spoofed_media_type": "has contents that are not what they are reported to be",
      "taken": "has already been taken",
      "too_long": "is te lang (maximaal %{count} tekens)",
      "too_short": "is te kort (minimaal %{count} tekens)",
      "wrong_length": "heeft onjuiste lengte (moet %{count} tekens lang zijn)"
    },
    "template": {
      "body": "Veuillez vérifier les champs suivants : ",
      "header": {
        "one": "Impossible d'enregistrer ce %{model} : 1 erreur",
        "other": "Impossible d'enregistrer ce %{model} : %{count} erreurs"
      }
    }
  },
  "extra_services": {
    "body": "In this accommodation you have the possibility to book <a href=\"https://specials.casapilot.com/shop/\">the Casapilot breakfast service</a> before your stay. Let us spoil you with delicious products from the region!",
    "bookable": {
      "1-night-only": "Boeking mogelijk voor 1 nacht",
      "bikerental": "Fietsverhuur op aanvraag",
      "breakfast": "Ontbijt op aanvraag",
      "carcharger": "E-auto oplaadstation op aanvraag",
      "casapilot-breakfast": "Ontbijt te boeken bij Casapilot",
      "champagne": "Welkomstdrankjes op aanvraag",
      "dinner": "Diner op aanvraag",
      "dog": "Honden toegestaan",
      "flowers": "Bloemen en romantische decoratie op aanvraag",
      "massage": "Massage op aanvraag",
      "pool": "Zwembad",
      "sauna": "Sauna",
      "whirlpool": "Whirlpool"
    },
    "included": {
      "1-night-only": "Boeking mogelijk voor 1 nacht",
      "bikerental": "Fietsverhuur inbegrepen",
      "breakfast": "Ontbijt inbegrepen",
      "carcharger": "E-auto oplaadstation inbegrepen",
      "casapilot-breakfast": "Ontbijt inbegrepen",
      "champagne": "Welkomstdrankjes inbegrepen",
      "dinner": "Diner inbegrepen",
      "dog": "Honden toegestaan",
      "flowers": "Bloemen en romantische decoratie inbegrepen",
      "massage": "Massage inbegrepen"
    },
    "title": "NEW: Get your breakfast delivered!"
  },
  "flash": {
    "actions": {
      "create": {
        "notice": "%{resource_name} was successfully created."
      },
      "destroy": {
        "alert": "%{resource_name} could not be destroyed.",
        "notice": "%{resource_name} was successfully destroyed."
      },
      "update": {
        "notice": "%{resource_name} was successfully updated."
      }
    },
    "alert": {
      "accept_tos": "Gelieve nog de algemene voorwaarden accepteren.",
      "error_too_many_insurants": "Het aantal reizigers is meer dan 7 mensen, maar 7 personen maximum kunnen gewaarborgd worden. Gelieve info@casapilot.com contacteren.",
      "error_try_again": "Excuses, er is een fout gebeurd, probeer het opnieuw. Indien het nog niet lukt, gelieve ons een mailtje te sturen naar info@casapilot.com. Als U juist een reservering gedaan hebt, neem dan contact op met onze klantenservice.",
      "insert_information": "Gelieve alle velden in rood invullen.",
      "insert_name": "Er moet precies 1 naam ingevoerd worden.",
      "insert_names_1": "Gelieve precies %{count} achternamen invoeren.",
      "insert_names_2": "Achternamen ingevoerd worden.",
      "insurance_error_prebook_period_to_long": "Uw verblijf moet uiterlijk binnen een jaar beginnen.",
      "insurance_over_tenthousand": "De maximaal verzekerbare reiskosten per persoon is € 10.000,00",
      "insurance_product": "Fout bij het ​​verkrijgen van de verzekeringen. Probeer het opnieuw"
    }
  },
  "footer": {
    "about": "Over Casapilot",
    "contact_link": "info@casapilot.com?subject=www.casapilot.com",
    "follow_us": "Volg ons op",
    "imprint_link": "/nl/about/imprint",
    "support": "Support",
    "team_cpl": "Het Casapilot team",
    "team_cpl_link": "https://www.casapilot.com/nl/your_benefits",
    "vouchers": "Voucher",
    "vouchers_link": "https://shop.casapilot.com/nl"
  },
  "header": {
    "facebook_link": "http://www.facebook.com/casapilot.nl",
    "hyves_link": "http://www.hyves-share.nl/button/tip/?tipcategoryid=12&rating=5&title=Casapilot&body=www.casapilot.com",
    "phone_annotation_host": "Heb je vragen? Neem contact met ons op:",
    "phone_annotation_renter": "Telefonisch boeken:",
    "phone_host": "Tel. +32 28 80 89 83",
    "phone_renter": "Tel. +32 28 80 89 83",
    "twitter_link": "http://twitter.com/?status=http%3A%2F%2Fwww.casapilot.com"
  },
  "helpers": {
    "label": {
      "holiday_home": {
        "accommodation_amenities": "Uitrustingskenmerk",
        "accommodation_area": "Bewoonbare oppervlakte (m²)",
        "accommodation_bond": "Waarborg (€)",
        "accommodation_bond_refund": "Teruggave waarborg",
        "accommodation_created_at": "aangemaakt op",
        "accommodation_description": "beschrijving",
        "accommodation_fee": "commissie (in %)",
        "accommodation_id": "ID",
        "accommodation_kind": "Aard van de woning",
        "accommodation_max_persons": "personen (max.)",
        "accommodation_number_of_baths": "Badkamer",
        "accommodation_number_of_bunk_beds": "Stapelbedden",
        "accommodation_number_of_daybeds": "Zetel-bed",
        "accommodation_number_of_king_size_beds": "Tweepersoons bed",
        "accommodation_number_of_rooms": "Slaapkamer",
        "accommodation_number_of_similar": "Aantal gelijkaardige woningen",
        "accommodation_number_of_single_beds": "Eénpersoons bed",
        "accommodation_photos": "foto's",
        "accommodation_property_id": "gebouw/artikel",
        "accommodation_title": "Titel",
        "accommodation_updated_at": "Geüpdated op",
        "property_country": "Land",
        "property_created_at": "aangemaakt op",
        "property_description": "beschrijving",
        "property_id": "ID",
        "property_locality": "Plaats",
        "property_postal_code": "Postcode",
        "property_rating": "Sterren-categorie",
        "property_region": "Streek",
        "property_street": "Straat",
        "property_title": "Naam van de woning",
        "property_top_object": "Super verblijf",
        "property_travel_region_id": "Vakantie regio",
        "property_updated_at": "Geüpdated op"
      },
      "subscription": {
        "country": "Ligging van de woning",
        "email": "e-mail",
        "kind": "ik beschik over",
        "kind_apartment": "appartement ",
        "kind_bed_and_breakfast": "Bed & Breakfast ",
        "kind_vacation_rental": "Vakantiewoning ",
        "language": "Uw taal"
      }
    },
    "select": {
      "prompt": "Selecteer"
    },
    "submit": {
      "create": "%{model} toevoegen",
      "submit": "%{model} opslaan",
      "update": "%{model} bewaren"
    }
  },
  "home": {
    "teaser": {
      "text_1": "Wij boeken uw vakantiehuis inkl. vlucht.<br /> <strong>Telefonisch boeken:</strong> <br /> +32 28 80 89 83",
      "text_2": "Uw Partner uit Luxemburg",
      "text_3": "Waarom Casapilot?<br />Goede prijzen, veilig boeken, 5-sterrenservice"
    }
  },
  "homepage": {
    "checks": {
      "headline_1": "Kosteloos inschrijven",
      "headline_2": "Op voorhand verdienen",
      "headline_3": "Prijs zelf bepalen",
      "headline_4": "Flexibel blijven",
      "text_1": "Het inschrijven van de woning is kosteloos voor u.",
      "text_2": "Bij verhuring schrijven wij u het bedrag over, twee weken voor aankomst",
      "text_3": "Enkel uzelf bepaalt het tarief voor het verhuren van uw woning",
      "text_4": "U bepaalt de periode waarin uw woning ter beschikking is."
    },
    "counter_text": "Vakantiehuizen",
    "counter_text_single": "Vakantiehuis",
    "head_title": "selected homes",
    "headline": "Verhuur uw vakantiewoning. Uiterst eenvoudig met Casapilot.",
    "intro_text_1": "Casapilot is uw nieuwe partner voor het verhuren van uw vakantiewoning en de ideale tussenpersoon voor uw Bed & Breakfast aanbiedingen.",
    "intro_text_2": "Registreer u nu - zo blijft u op de hoogte en hoort u als eerste de wanneer de website ter beschikking staat.",
    "intro_text_3": "Wij werven nieuwe klanten voor u aan.",
    "relax_cottage_stoerer": {
      "headline": "Wellness Suites - Bruidssuites",
      "text": "Wellness Suites met jacuzzi in een exclusieve ambiance<br/>voor een romantisch verblijf met uw partner."
    },
    "subscription_form": {
      "country": {
        "andorra": "Andorra",
        "austria": "Oostenrijk",
        "belgium": "België",
        "croatia": "Kroatië",
        "danemark": "Denemarken",
        "finland": "Finland",
        "france": "Frankrijk",
        "germany": "Duitsland",
        "great_britain": "Engeland",
        "greece": "Griekenland",
        "hungary": "Hongarije",
        "ibiza": "Ibiza",
        "island": "Ijsland",
        "italy": "Italië",
        "liechtenstein": "Lichtenstein ",
        "luxemburg": "Luxemburg",
        "malta": "Malta",
        "monaco": "Monaco",
        "nederland": "Nederland",
        "norway": "Noorwegen",
        "poland": "Polen",
        "portugal": "Portugal",
        "scotland": "Schotland",
        "spain": "Spanje",
        "sweden": "Zweden",
        "switzerland": "Zwitserland"
      },
      "email": "E-mail",
      "email_text": "Uw e-mail wordt vertrouwelijk behandeld.",
      "headline": "Nu registreren en op de hoogte blijven",
      "language": {
        "de": "Duits ",
        "en": "Engels",
        "es": "Spaans",
        "fr": "Frans",
        "nl": "Nederlands"
      },
      "submit": "Nu onthouden"
    }
  },
  "homepage_customer": {
    "book_object": "Boeken",
    "country": "Vakantie-bestemming",
    "head_title": "Selected homes",
    "headline": "Persoonlijk geselecteerde vakantiehuizen, villas en suites ",
    "hosts": {
      "headline": "Bekijk de mooiste vakantiehuizen in onze populairste bestemmingen"
    },
    "intro_headline": "Waarom bij Casapilot boeken ?",
    "intro_text_1": "Ons principe is eenvoud. Een gemakkelijke zoektocht voor een aangename vakantie, wat heb je nog meer nodig ?",
    "intro_text_1_hl": "Gemakkelijk",
    "intro_text_2": "We controleren al onze woningen met veel zorg en worden persoonlijk geselecteerd. Alleen dan wordt het een Casapilot woning.",
    "intro_text_2_hl": "Geselecteerd",
    "intro_text_3": "Bij aankomst is de sleutel paraat en uw welverdiende vakantie begint zodra u de deur opent.",
    "intro_text_3_hl": "Betrouwbaar",
    "landingpage": {
      "headline": "Topbestemmingen\n\n\n"
    },
    "last_viewed_objects": "Laatst bekeken vakantiewoningen",
    "objects_foot_hl": "Ook dit kan u bevallen.",
    "prebook_object": "Houden",
    "reserve": "Boeken",
    "search_arrival": "Aankomst",
    "search_button": "Zoeken",
    "search_category_1": "Familie vakantie",
    "search_category_2": "Paar vakantie",
    "search_category_3": "Avontuur Vakantie",
    "search_category_4": "Spa & Relax Vakantie",
    "search_category_5": "Meer vakantie suggesties",
    "search_departure": "Vertrek",
    "search_detail": "Uitgebreid zoeken",
    "search_headline": "Zoek in ons aanbod van vakantiehuizen",
    "see_object": "Tonen",
    "slideshow": {
      "ardennen": "Vakantiehuizen in de Ardennen",
      "ardennen_desc": "Geniet van de landelijke rust en ontdek de vele wandel- en fietspaden. Profiteer van de talrijke ontspanningsmogelijkheden die de regio te bieden heeft.",
      "austria": "Vakantiehuizen in Oosternrijk",
      "austria_desc": "Winter of zomer, Oostenrijk altijd een bezoek waard. In de zomer kunnen gasten verkennen wandeling, Culturele en in de winter kunt u genieten van de skipistes.",
      "cotedazur": "Vakantiehuizen aan de Côte d'Azur",
      "cotedazur_desc": "De meest bekende kust van Europa. Laat u betoveren door talrijke mogelijkheden om te winkelen, een fantastische Franse keuken en prachtige stranden.",
      "france": "Vakantiehuizen in Frankrijk",
      "france_desc": "Ontdek de mooiste vakantiehuizen in Frankrijk, aan de bekendste plaatsen, in het binnenland en aan de kust. Vakantiehuizen in Frankrijk nodigen u uit voor en leuke en ontspannende vakantie. ",
      "ibiza": "Vakantiehuizen in Ibiza",
      "ibiza_desc": "Het populaire vakantie-eiland Ibiza is bekend door zijn prachtige zonsondergangen. Tijdens de dag ontspannen op het strand een s’avonds genieten van het nachtleven.",
      "luxemburg": "Luxemburg",
      "luxemburg_desc": "",
      "mallorca": "Vakantiehuizen op Mallorca",
      "mallorca_desc": "Ontdek de prachtige stranden en de ongerepte landelijke charme van de populaire mediterrane eiland. Geniet van uw vakantie in een sfeervol landhuis of een prachtige villa.",
      "spain": "Vakantiehuizen in Spanje",
      "spain_desc": "Ontdek de mooiste plekjes van het Spaanse vasteland, en de charme van de kust met mooie stranden. Geniet van een heerlijke vakantie in een vakantiehuis in Malaga, aan de Costa del Sol, de Costa Blanca, de Costa Brava,… ",
      "wellnesssuites": "Wellness Suites - Bruidssuites",
      "wellnesssuites_desc": "Wellness Suites met jacuzzi in een exclusieve ambiance voor een romantisch verblijf met uw partner. Net getrouwd, jaarlijkse feestdag of als geschenk, bieden onze bruidssuites elk paar luxe en ontspanning."
    }
  },
  "host": {
    "ab": "van",
    "accept_agbs": "Gelieve de Algemene Verkoopsvoorwaarden te accepteren.",
    "accommodation": "Apartement",
    "accommodation_number_of_beds_zero": "Voer ten minste een type en aantal bedden in.",
    "accommodation_reviews": "Reviews",
    "accommodations": {
      "prices": {
        "day_of_arrival": "Aankomst",
        "day_of_departure": "Vertrekdag",
        "friday": "Vrijdag",
        "monday": "Maandag",
        "sunday": "zondag"
      },
      "suggestions": "Onze suggesties voor u "
    },
    "add_image": "Foto toevoegen",
    "add_new_accommodation": "Nieuwe appartement aanmelden",
    "add_new_property": "Nieuwe woning aanmelden",
    "add_new_room": "Voeg een nieuwe kamer in",
    "additional_costs": "Extra kosten",
    "adress": "Adres",
    "all_properties": "Alle woningen van",
    "amenities": "Uitrustingskenmerken",
    "amount_bathrooms": "Aantal badkamer vanaf",
    "amount_bedrooms": "Aantal slaapkamers",
    "amount_rooms": "Aantal kamers",
    "apartment": "Appartement",
    "as": "als, wanneer",
    "attractions": "Omgeving",
    "avail_in": "Boekbaar in",
    "avail_in_2": "dagen",
    "avail_in_3": "dag",
    "availabilities": {
      "availabilities": {
        "availabilities_select": "Gelieve het jaar kiezen"
      }
    },
    "availabilities_text": "Wanneer u een dag wil instellen als \"niet beschikbaar\", gelieve dan de dag aan te vinken en vervolgens op \"markeren\" te klikken. Wanneer u meerdere dagen wenst aan te duiden als \"niet beschikbaar\", klik dan op de eerste en laatste dag van de gewenste periode en vervolgens op \" markeren\". Dagen die via Casapilot werden geboekt, worden automatisch in ons systeem aangepast en als \"niet beschikbaar\" gemarkeerd.",
    "availability": "Beschikbaarheid",
    "availability_message": "Wijzig ook de beschikbaarheid van uw woning",
    "avatar_text": "Als u dat wenst, kan u hier een foto uploaden. De foto verschijnt in de contactbox van uw advertentie",
    "base_rating": "Basic beoordeling",
    "basics": "Basis informatie",
    "baths": "Badkamers",
    "bed_and_breakfast": "Bed & Breakfast",
    "blocked": "Niet beschikbaar",
    "blocked_msg": "Er is geen beschikbare aankomstdag voor het gewenste tijdstip. Gelieve een andere periode te kiezen.",
    "bookable": "Beschikbaar",
    "booked": "Geboekt door Casapilot",
    "bookings_count": "personen hebben bij deze verhuurder geboekt",
    "bookings_count_zero": "Deze vakantiewoning is nieuw in het programma",
    "bunk_beds": "Stapelbedden",
    "clearing_message": "Om de woning vrij te schakelen  , moet u de volgende informatie invullen.",
    "clearing_missing": "Volgende informaties zijn nog niet ingevult",
    "clearing_status_popup": "U woning is niet volledig",
    "confirm_delete": " Bent u zeker dat u dit artikel wilt verwijderen. Deze handeling kan niet worden teruggeroepen.",
    "contact_user": "Contacteren",
    "coordinates": "Coördinaten",
    "coordinates_annotation": "Hier kunt u de exacte coördinaten van uw vakantiewoning plaatsen.",
    "country": "Land",
    "create": "Plaatsen",
    "create_holiday_home": "Woning opmaken",
    "create_property": "Woning plaatsen",
    "cut_image": "Foto bijknippen",
    "dashboard": {
      "index": {
        "html": {
          "all_objects": "Alle woningen bevestigen",
          "another_object": "Plaats een volgende woning",
          "another_object_content": "Als U meer woningen opzet, hoe meer U kunt verhuren en verdienen. <br /> Neem <strong> 5 minuten </ strong> tijd en plaats nu een volgende woning",
          "button": "Nu woning instellen",
          "button_another_object": "Volgende woning plaatsen",
          "first_object": "Plaats uw eerste vakantiewoning",
          "first_object_content": "Indien u graag uw vakantiehuis of uw vakantiewoning via Casapilot wil verhuren, ga dan naar stap 1: Dit neemt enkel 5 minuten van uw tijd in beslag om  de nodige gegevens in te vullen.",
          "news_more": "verder nieuws",
          "news_specialoffer_text": "Voor uw toekomstige huurder start Casapilot.com officieel in Juni 2011. Als dank voor uw publicatie vóór deze datum, ontvangt u van ons uitzonderlijke aantrekkelijke kortingen.",
          "news_specialoffer_title": "Indien u nu uw artikel plaatst, geniet u van uitzonderlijke aantrekkelijk kortingen.",
          "news_title": "Casapilot nieuws",
          "title": "Statistiek",
          "your_properties": "uw woning"
        }
      }
    },
    "daybeds": "Zetel-bed",
    "del_confirm": "Bent U zeker?\n",
    "delete": "Verwijderen",
    "description": "Omschrijving",
    "details": "details",
    "details_missing": "Welke informatie mist er nog ??",
    "distance_description": "Activeer een checkbox om de afstand in kilometers aan te geven",
    "distance_unit": "km",
    "downloads": "Downloads",
    "duration_of_stay": "Duur van het verblijf",
    "edit": "Profiel wijzigen ",
    "edit_accommodation": "Woning wijzigen",
    "edit_holiday_home": "Woning wijzigen",
    "edit_image": "Foto wijzigen",
    "embed_calendar_text": "U kunt deze kalender aan de hand van deze iFrames op uw website integreren:",
    "extras": "Optionele uitrustingskenmerken",
    "extras_annotation": "Hier kunt u speciale voorwaarden voor bepaalde uitrustingskenmerken invoeren.",
    "fallback_text": "Er worden nog geen gegevens weergegeven.",
    "fallback_text_costs": "Geen",
    "fallback_text_description": "Er wordt nog geen beschrijving weergegeven",
    "feedback_message": "Als u vragen hebt, gelieve met ons kontakt opnemen",
    "filter": "Filter",
    "following_rooms_already_created": "De volgende kamers zijn gemaakt:",
    "forms": "Formulieren",
    "from": "Van",
    "general_property_informations": "Algemene woninginformatie",
    "hh_inc_fees": "Inclusive reserveringskosten",
    "holiday_home": "Vakantiehuis",
    "holiday_homes": {
      "create": {
        "create_failed": "Uw woning kan niet aangemaakt worden. Gelieve alle velden in het rood in te vullen.",
        "create_successful": "Uw woning werd succesvol aangemaakt. Hier kan u nog zowel foto's uploaden, als verdere informatie van uw woning instellen."
      },
      "description": {
        "annotations": {
          "property_description": "Beschrijf kort wat uw woning voor uw klanten bepaalt.",
          "property_description_hint_html": "Uw omschrijvende tekst is een informatie voor uw gasten om het eerste gevoel van een leuke vakantie te kunnen geven. Beschrijf de sfeer , de attracties en toeristische bestemmingen die nabij uw vakantiewoning aanwezig zijn.Besrijv niet de accomodatie ofwel aantal kamers .\\n",
          "property_description_short": "Samenvatting beschrijvingstekst van uw vakantiewoning (max. 88 tekens)",
          "property_description_short_remaining": "Gemisde tekens",
          "property_language": "Gebruik de tabbladen om uw beschrijving in anderen talen te voltoien.",
          "property_language_2": "Wanneer u geen andere talen spreekt, dan maakt Casapilot de vertalingen voor u.",
          "property_rating": "Gelieve enkel in te vullen, wanneer uw woning over een schatting beschikt.",
          "property_rating_forbidden": "Het aantal sterren van uw woning zijn veranderd door administratoren. Bij vragen  e-mail : nl@casapilot.com",
          "property_title": "Onder deze naam zal uw woning op de website verschijnen"
        },
        "data_multiple_rooms": "Heeft uw artikel meerdere appart te verhuren kamers of woningen? Dan kan u hier de gegevens voor de eerste kamer of woning ingeven.",
        "data_single_room": "Of wel gelieve de waarde toe te voegen, die voor het gehele huis of appartement geldt.",
        "language_de": "Duits",
        "language_description_1": "Uw beschrijving",
        "language_description_2": "Gebruik de tabbladen om uw beschrijving in anderen talen te voltooien.",
        "language_en": "Engels",
        "language_es": "Spaans",
        "language_fr": "Frans",
        "language_nl": "Nederlands",
        "select_language": "Taal"
      },
      "form": {
        "data_multiple_rooms": "Heeft uw artikel meerdere appart te verhuren kamers of woningen? Dan kan u hier de gegevens voor de eerste kamer of woning ingeven.",
        "data_single_room": "Of wel gelieve de waarde toe te voegen, die voor het gehele huis of appartement geldt. ",
        "language_de": "Duits",
        "language_description_1": "Uw beschrijving",
        "language_description_2": "Gebruik de tabbladen om uw beschrijving in anderen talen te voltooien.",
        "language_en": "Engels",
        "language_es": "Spaans",
        "language_fr": "Frans",
        "language_nl": "Nederlands",
        "select_language": "Taal"
      },
      "new": {
        "submit": "Woning opmaken",
        "title": "Nieuwe woning opmaken"
      }
    },
    "host": "Verhuurder",
    "image_alt": "Vooraanzicht van de woning",
    "image_description_text": "Beschrijf kort de foto, vb. Zicht op de tuin.",
    "image_gallery": "Fotogalerij",
    "image_legend": "Volgorde foto's via Drag & Drop wijzigen",
    "image_upload_description": "Kies een foto uit uw bestand met een minimale grootte van 1124 x 689 pixels of groter (max. 950 KB), zodat de foto een totaalbeeld van uw object weergeeft.",
    "inc_fees": "inkl. schadensverzekering en reserveringskosten",
    "included": "inbegrepen",
    "incomplete": "niet volledig ingevuld",
    "info": "Over de woning",
    "kind": "categorie",
    "kind_of_property": "Type accommodatie",
    "kind_of_property_available": "Volgend kamers zijn reeds gemaakt",
    "kind_of_property_none": "Het artikel heeft nog geen kamer",
    "king_size_beds": "Tweepersoons bed",
    "languages": "Talen",
    "lat": "Breedtegraad",
    "limitation": {
      "allowed": "Ja",
      "forbidden": "nee",
      "onrequest": "op aanvraag"
    },
    "limitations": "Bijzonderheden",
    "limitations_annotation": "Hier kunt u extra bijzonderheden invullen",
    "link_edit_image": "Wijzigen",
    "list": "Terug",
    "locality": "Ligging",
    "long": "Meridiaan",
    "main_image": "Hoofdfoto",
    "main_image_legend": "Sleep het gewenste thema hierheen",
    "manage_properties": "Woning beheren",
    "map": "Kaart",
    "map_zoom": "Kaart vergroten",
    "max_persons": "Max personen",
    "messages": "Berichten",
    "minimum_booking": "Minimum nachten",
    "more_images": "overige foto's",
    "new_accommodation": "Nieuwe woning",
    "new_room": "Nieuw kamer",
    "no_images": "Nog geen foto beschikbaar",
    "not_published": "niet vrijgesteld",
    "other_costs_text": "Deze kosten worden enkel getoond wanneer u gegevens toont.",
    "others": "overige",
    "payment": "Betalings informatie",
    "photos": "Foto's",
    "platform_airbnb": "AirBnB",
    "platform_booking": "Booking.com",
    "platform_flipkey": "Flipkey",
    "platform_homeaway": "Homeaway",
    "platform_homelidays": "Homelidays",
    "platform_hometogo": "Hometogo",
    "platform_tripadvisor": "TripAdvisor",
    "platforms": "Platforms for export",
    "platforms_annotation": "You can switch off the export for specific platforms",
    "preview": "vooraanzicht",
    "prices": "Prijzen",
    "prices_availability": "Prijzen en beschikbaarheid",
    "prices_overview": {
      "js_alert": "Gelieve het hetvolgende formaat te gebruiken voor uw prijzen 1.000,00 of geef alleen maar cijfers in. "
    },
    "properties": {
      "index": {
        "confirm_delete": "Bent u zeker dat u de woning wil verwijderen. Deze actie kan niet worden teruggeroepen."
      }
    },
    "property_id": "ID woning",
    "property_title": "Titel woning",
    "published": "vrijgesteld",
    "rating": "Sterren",
    "read_messages": "Berichten lezen",
    "regilar_costs_text": " Wanneer u hier geen gegevens toont, dan gelden de kosten als inbegrepen.",
    "region": "Vakantieregio",
    "registrations": {
      "edit": {
        "back": "Terug",
        "cancel": {
          "description": "Niet tevreden?",
          "link": "Mijn gegevens verwijderen",
          "question": "Bent u zeker?",
          "title": "Profiel verwijderen"
        },
        "current_hint": "(Uw heeft uw huidige paswoord nodig om wijzigingen aan te brengen)",
        "password_hint": "(Leeg laten indien u niets wilt wijzigen)",
        "submit": "Opslaan",
        "title": "Profiel wijzigen"
      },
      "new": {
        "already_registered": "Ik ben al geregistreerd als huurder bij Casapilot.",
        "host_account": "Creer hier uw gratis login voor Casapilot. ",
        "newsletter_subscription": "Ik zou graag de Casapilot nieuwsletter ontvangen",
        "not_yet_registered": "Ik ben nog geen Casapilot huurder.",
        "offers_text": "Of wilt u naar vakantie en een woning van Casapilot huren? Kijk naar ons aanbod. ",
        "register_account": "Wilt U een woning verhuren? ",
        "register_pls": "Gelieve inloggen",
        "register_txt": "Maak hier een gratis profiel als huurder.",
        "submit": "Profiel aanmaken",
        "terms_of_service_html": "Ik heb gelezen, begrepen en ga akkoord met de <a href=\"/downloads/terms-conditions/host-nl\" target=\"_blank\">Algemene Verkoopsvoorwaarden</a>.",
        "title": "Maak gratis een profiel als verhuurder"
      }
    },
    "registrations_addons": {
      "api_documentation": {
        "title": "Api dokumentatie"
      },
      "edit_downloads": {
        "bank_data": "Bankverbindung",
        "bank_data_message": "Bitte geben Sie hier Ihre Bankverbindung ein damit wir Ihnen nach einer erfolgten Buchung Ihre Einnahmen überweisen können. Alle Ihre persönlichen Daten werden bei Casapilot vertraulich behandelt.",
        "bic": "BIC",
        "category_forms": "Formulier",
        "commercial_host": "Gewerblicher Vermieter",
        "compendium": "Hulp voor de prijzen 2012 in te vullen",
        "compendium_description": "Hier vindt u een handige instructie voor uw huurprijzen in te vullen.",
        "contact_data": "Kontaktdaten",
        "contact_data_message": "Bitte geben Sie hier ausschließlich Ihre Rechnungsadresse an und keinesfalls die Adresse Ihrer Ferienimmobilie.",
        "edit_payment": null,
        "house_rules": "Huishoudelijk reglement",
        "iban": "IBAN",
        "invoice_city": "Ort",
        "invoice_company": "Firma",
        "invoice_country": "Land",
        "invoice_fax": "Fax",
        "invoice_house_number": "Hausnummer",
        "invoice_mobile_phone": "Mobiltelefon",
        "invoice_name": "Name",
        "invoice_of_stay": "Eindafrekening",
        "invoice_of_stay_description": "Via dit formulier, worden alle extra kosten gefactureerd aan het eind van het verblijf.",
        "invoice_of_stay_link": "/downloads/invoice_of_stay/Eindafrekening_van_verblijf.pdf",
        "invoice_partner_agency": "Partneragentur",
        "invoice_phone": "Telefon",
        "invoice_postal_code": "PLZ",
        "invoice_street": "Straße / Hausnummer",
        "invoice_website": "Webseite",
        "kaution": "Borgsom",
        "kaution_description": "De huurder verplicht zich de borg bij aankomst te betalen.\n De borg dient als beveiliging tegen mogelijke vandalisme door de huurders.",
        "kaution_link": "/downloads/deposit.pdf",
        "kind_of_host": "Vermieterart",
        "message": "Ter vergemakkelijking van de verzorging van uw gasten, bieden wij hier twee praktische formulieren ter beschikking. <br/> de documenten kunnen gedownload worden om vervolgens te printen en te gebruiken.",
        "private_host": "Privater Vermieter",
        "title": "Formulieren",
        "vat_rate": "Umsatzsteuer-ID",
        "wellness": {
          "pool": "Jacuzzi en zwembadgebruik",
          "sauna": "Saunagebruik",
          "title": "Veiligheidsregels voor saunagebruik, jacuzzi en zwembadgebruik"
        }
      },
      "edit_payment": {
        "bank_data": "Bankgegevens",
        "bank_data_message": "Vul gelieve uw bankgegevens in dat wij u na een successvolle boeking ,het geld kunnen overmaken.\nUw persoonlijke gegevens worden vertrouwelijk behandeld bij Casapilot.",
        "bic": "BIC",
        "commercial_host": "Commerciële verhuurder",
        "contact_data": "Contactgegevens",
        "contact_data_message": "Gelieve Uw facturatie adres in te vullen en niet het adres van Uw woning.",
        "iban": "IBAN",
        "invoice_city": "Plaats",
        "invoice_company": "Bedrijf",
        "invoice_country": "Land",
        "invoice_fax": "Fax",
        "invoice_house_number": "Huisnummer",
        "invoice_mobile_phone": "GSM",
        "invoice_name": "Naam",
        "invoice_partner_agency": "Partner Agentschap",
        "invoice_phone": "Telefoon",
        "invoice_postal_code": "Postcode",
        "invoice_street": "Straat / Huisnummer",
        "invoice_website": "Webpagina",
        "kind_of_host": " Type van de verhuurder",
        "private_host": "Privé verhuurder",
        "title": "Betalingsinformatie",
        "vat_rate": "BTW-nummer"
      },
      "edit_tenant": {
        "key_hand_over": "Adres van sleuteloverhandiging",
        "key_hand_over_city": "Plaats",
        "key_hand_over_country": "Land",
        "key_hand_over_different_place": "Plaats van sleuteloverhandiging is niet gelijk aan plaats van huurwoning.",
        "key_hand_over_name": "Naam",
        "key_hand_over_postal_code": "Postcode",
        "key_hand_over_street": "Straat",
        "more_languages": " Andere talenkennis",
        "mother_tongue": "Moedertaal",
        "other_language_1": "Duits",
        "other_language_2": "Engels",
        "other_language_3": "Frans",
        "other_language_4": "Nederlands",
        "other_language_5": "Spaans",
        "title": "Informatie voor uw huurder"
      }
    },
    "regular_costs": "Overige kosten",
    "rentable_units": "verhuurbare eenheden",
    "reservations": "Boekingen",
    "room": "Kamer",
    "rooms": "kamer",
    "save_description": "beschrijving opslaan",
    "save_image": "Foto opslaan",
    "season_msg": "Wegens organisatorische redenen kunt u de beschikbaarheid alleen maar tot en met 09.01.2026 bewerken. U wordt geïnformeerd zodra de verwerking van de beschikbaarheid voor het seizoen 2026 vrijgegeven is. ",
    "show": "Tonen",
    "single_beds": "Eénpersoons bed",
    "size_capacity": "Grootte en capaciteit",
    "square_meters": "Oppervlakte woning",
    "star": "Sterren",
    "star_rating": "Sterren beoordeling",
    "stars": "Sterren",
    "status_revision": "Lopende validatie",
    "status_visible": "Uw vakantiewoning is nu zichtbaar.",
    "suite": "Suite",
    "summer_price": "(zomer)",
    "tenant": "Informatie voor Uw klant",
    "thumb_fallback": "/images/thumb_fallback.gif ",
    "to": "tot",
    "travel_bookings": {
      "index": {
        "availability": "Beschikbaarheid bekijken",
        "booking_period": "Boekingsperiode (aankomstdatum)",
        "cancelled": "geannuleerd",
        "confirmed": "bevestigd",
        "date_of_receipt": "Datum van ontvangst",
        "details": "Details",
        "sort": "Sorteren naar",
        "sort_by_ref_code": "Suche nach Buchungsnummer"
      },
      "show": {
        "accommodation_id": "woning Id",
        "accommodation_name": "Naam",
        "accomoodation": "Woning",
        "bond": "Borgsom",
        "booking": "Boeking",
        "booking_created_at": "Geboekt de ",
        "booking_id": "Boekingsnummer",
        "booking_process": "Boekingsverrichting",
        "checkin": "Annkomsttijd",
        "checkout": "Vertrektijd",
        "costs": "Kosten",
        "extra_bring": "Mee te brengen",
        "extra_cost": "Extra kosten",
        "guest": "Huurder",
        "host_total": "Huurinkomsten",
        "on_request": "Op aanvraag",
        "optional_cost": "Optionele kosten",
        "overview": "Terug naar de overzicht",
        "stay": "Verblijf",
        "tenant_information": "Informatie over de huurder",
        "tenant_name": "Informatie over de huurder",
        "tenant_phone_number": "Telefoonnummer van de huurder",
        "title": "Boekingsinformatie van de woning"
      }
    },
    "update": "Verder",
    "winter_price": "(winter)",
    "you_have_got": "U heeft"
  },
  "host_details": {
    "included": "inbegrepen",
    "on_request": "Op aanvraag",
    "see_additional_costs": "Let op de informatie onder “Extra kosten”",
    "to_be_brought": "Moet meegebracht worden"
  },
  "host_navigation": {
    "account": "Profiel",
    "dashboard": "Cockpit",
    "messages": "Berichten",
    "objects": "Woningen",
    "reservations": "Boekingen",
    "teaser_host": "Hebt u een  vakantiewoning te huur?Registreer nu en verdien meer!"
  },
  "host_teaser": {
    "button": "Meer info",
    "number_of_baths": "Aantal badkamers",
    "number_of_persons": "Personen (max.)",
    "number_of_rooms": "Aantal slaapkamers"
  },
  "i18n": {
    "transliterate": {
      "rule": {
        "À": "a",
        "Á": "a",
        "Â": "a",
        "Ä": "ae",
        "Æ": "ae",
        "Ç": "c",
        "È": "e",
        "É": "e",
        "Ê": "e",
        "Ë": "e",
        "Í": "i",
        "Î": "i",
        "Ï": "i",
        "Ñ": "n",
        "Ó": "o",
        "Ô": "o",
        "Ö": "oe",
        "Ù": "u",
        "Ú": "u",
        "Û": "u",
        "Ü": "ue",
        "ß": "ss",
        "à": "a",
        "á": "a",
        "â": "a",
        "ä": "ue",
        "æ": "ae",
        "ç": "c",
        "è": "e",
        "é": "e",
        "ê": "e",
        "ë": "e",
        "í": "i",
        "î": "i",
        "ï": "i",
        "ñ": "n",
        "ó": "o",
        "ô": "o",
        "ö": "oe",
        "ù": "u",
        "ú": "u",
        "û": "u",
        "ü": "ue",
        "ÿ": "y",
        "Œ": "oe",
        "œ": "oe",
        "Ÿ": "y"
      }
    }
  },
  "icons": {
    "first": "start",
    "last": "end",
    "next": "forward",
    "previous": "back"
  },
  "inquiry_form": {
    "fail_notification": "Your enquiry wasn't transmitted successfully. Please try again later.",
    "inquiry_to": "Aanvraag Woning Id: ",
    "send_button": "Aanvraag verzenden",
    "text": "U bent welkom om ons hier onder een onverbindend aanvraag te sturen.",
    "thank_you_1": "Hartelijk dank voor uw aanvraag bij Casapilot.",
    "thank_you_2": "Wij zullen u deze zo spoedig mogelijk beantwoorden."
  },
  "landing_page": {
    "ardennen": {
      "goto": "Naar Ardennen special"
    },
    "austria": {
      "goto": "Naar Oostenrijk special"
    },
    "cotedazur": {
      "goto": "Naar Côte d'Azur special"
    },
    "france": {
      "goto": "Naar Frankrijk special"
    },
    "ibiza": {
      "goto": "Naar Ibiza Special"
    },
    "luxemburg": {
      "goto": "Naar Luxemburg Special"
    },
    "mallorca": {
      "goto": "Naar Mallorca special"
    },
    "more": "Meer vakantiehuizen ",
    "more_at": "Meer vakantiehuizen op",
    "more_objects": "Bekijk alle huizen",
    "spain": {
      "goto": "Naar Spanje special"
    },
    "wellnesssuites": {
      "goto": "Alle Luxe Wellness Suites"
    }
  },
  "landing_page_teaser": {
    "title": "Vouchers tegen gereduceerde prijzen"
  },
  "mailer": {
    "attributes": {
      "approval_mailer": {
        "subject": "Activering voor uw woning"
      },
      "invitation_mailer": {
        "subject": "Uitnodiging naar Casapilot"
      },
      "travel_booking_mailer": {
        "confirm": {
          "subject": "Uw boekingsbevestiging van %{name}, %{id}"
        },
        "credit_note": {
          "subject": "Uw Creditnota %{name}, %{id}"
        },
        "payment": {
          "subject": "Uw betalingsbevestiging van %{name}, %{id}"
        },
        "reservation": {
          "subject": "Uw boekingsopdracht van %{id}"
        },
        "reservation_host": {
          "subject": "Uw boekingsbevestiging van %{name} (%{id}) "
        },
        "voucher": {
          "subject": "Uw verblijfsticket  %{name}, %{id}"
        }
      }
    },
    "models": {
      "approval_mailer": "Geactiveert",
      "invitation_mailer": "uitnodiging"
    }
  },
  "meta": {
    "description": "Huur uw vakantiehuis bij Casapilot. Snel en gemakkelijk vinden goedkope aanbiedingen uit heel Europa en!",
    "keywords": "Vakantiehuis Ardennen, vakantiehuis met zwembad ardennen,villa Ardennen,Appartement, vakantiehuis ,luxe villa, huisje met zwembad, Villa, Appartement,Chalet, Villa, last minute, vakantie, skivakantie,appartementen, B & B, groepsaccommodatie, vakantiewoning, ski lodge, huur, reizen, accommodatie, bungalow, zomervakantie, wintervakantie, Nieuwjaar, Kerstmis , Spanje, Ardennen, Mallorca, Zuid-Frankrijk,luxe kamer, luxe suites,goedkope vakantie.\n",
    "title": "casapilot | %{title}"
  },
  "not_found": {
    "back_to_homepage": "geen resultaat",
    "description": "Excuses, er is een fout gebeurd, probeer het opnieuw. Indien het nog niet lukt, gelieve ons een mailtje te sturen naar info@casapilot.com. Als U juist een reservering gedaan hebt, neem dan contact op met onze klantenservice.",
    "number": "+32 28 80 89 83",
    "title": "Excuses, er is een fout gebeurd, probeer het opnieuw. Indien het nog niet lukt, gelieve ons een mailtje te sturen naar info@casapilot.com. Als U juist een reservering gedaan hebt, neem dan contact op met onze klantenservice."
  },
  "notepad": {
    "add": "Toevoegen",
    "full": "U kunt max. 25 woningen in de merklijst toevoegen.",
    "headline": "Er zijn",
    "headline_part_two": "op u merklijst",
    "none": "geen",
    "notepad": "Merklijst",
    "object": "Woning",
    "objects": "Woningen",
    "remember": "Noteren",
    "remove": "Verwijderen",
    "remove_full": "Van de merklijst verwijderen",
    "search": "Zoek"
  },
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%u%n",
        "negative_format": "-%u%n",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "€"
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 2,
      "round_mode": "default",
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "human": {
      "decimal_units": {
        "format": "%n %u",
        "units": {
          "billion": "miljard",
          "million": "miljoen",
          "quadrillion": "biljard",
          "thousand": "duizend",
          "trillion": "biljoen",
          "unit": ""
        }
      },
      "format": {
        "delimiter": "",
        "precision": 3,
        "significant": true,
        "strip_insignificant_zeros": true
      },
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "eb": "EB",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "pb": "PB",
          "tb": "TB",
          "zb": "ZB"
        }
      }
    },
    "nth": {
      "ordinalized": "#<Proc:0x000000010b979508 /Users/patrik/.rbenv/versions/3.2.2/lib/ruby/gems/3.2.0/gems/activesupport-6.1.7.6/lib/active_support/locale/en.rb:26 (lambda)>",
      "ordinals": "#<Proc:0x000000010b979530 /Users/patrik/.rbenv/versions/3.2.2/lib/ruby/gems/3.2.0/gems/activesupport-6.1.7.6/lib/active_support/locale/en.rb:7 (lambda)>"
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%"
      }
    },
    "precision": {
      "format": {
        "delimiter": ""
      }
    }
  },
  "payment_confirmation": "Betalingsbevestiging",
  "previews": {
    "back_to_homepage": "Terug naar de homepage",
    "back_to_search": "Terug naar zoekresultaten",
    "submit": "boeken"
  },
  "price": {
    "activate_standard_prices": "Standaardprijzen activeren",
    "add_new_season_price": "Nieuwe seizoensprijs toevoegen",
    "add_new_standard_price": "Nieuwe standaardprijs toevoegen",
    "alternatives": "Alternatieven:",
    "available_dates": "Beschikbare data:",
    "check_in": "Check-in:",
    "check_in_time": "Tijd van aankomst:",
    "check_out": "Check-out:",
    "check_out_time": "Tijd van vertrek:",
    "currency_symbol": "€",
    "current_season_prices": "Actuele seizoensprijs",
    "current_season_prices_info": "Prijs wordt vastgelegd voor aangegeven periode",
    "current_standard_prices": "Actuele standaardprijs",
    "current_standard_prices_info": "Prijzen gelden het hele jaar door",
    "customer_price": "Prijs zichtbaar voor klanten",
    "duplicate_season_price": "Seizoen prijzen dupliceren voor volgend jaar",
    "edit_season_price": "Seizoensprijzen wijzigen ",
    "euro_per_long_weekend": "€ per lang weekend",
    "euro_per_night": "€ per nacht",
    "euro_per_stay": "€ per verblijf",
    "euro_per_week": "€ per week",
    "euro_per_weekend": "€ per weekend",
    "from": "vanaf",
    "long_weekend_consists_of": "lang weekend bestaat uit",
    "lump_long_weekend": "Lang weekend",
    "lump_long_weekend_short": "Lang weekend",
    "lump_week": "Week",
    "lump_weekend": "Weekend",
    "more_price_options": "Meer prijsopties? Maak een nieuwe prijsklasse aan",
    "nightly_week": "Één nacht (weekdagen)",
    "nightly_week_season": "Enkele nacht",
    "nightly_weekend": "Één nacht (weekend)",
    "nightly_weekend_season": "Één enkele nacht in het weekend",
    "no_prices": "er worden nog geen prijzen vastgelegd",
    "no_rotation_day": "Aankomst op elke dag van de week",
    "not_available": "Kies een andere aankomstdag of pas het aantal nachten aan.",
    "per_night": "per nacht",
    "per_stay": "Per verblijf ",
    "per_week": "per week",
    "per_weekend": "per weekend",
    "price": "Prijs",
    "price_lump_long_weekend": "prijs voor een lang weekend ",
    "price_lump_week": "Prijs voor een week ",
    "price_per_night": "prijs per nacht",
    "price_single_night": "Prijs voor één enkele nacht ",
    "price_single_night_weekend": "Prijs voor één nacht gedurende het weekend",
    "price_stay_weekdays": "Prijs voor een midweek",
    "season_price_text": "Hier kan u individuele prijzen voor een bepaald seizoen omschrijven, vb.“ Pasen“. Seizoensprijzen zijn alleen geldig, wanneer u een periode bepaald heeft. U bent nog niet verplicht om de seizoen-prijzen in te vullen , U kunt dit indien u dat wenst, later doen.",
    "season_prices": "Seizoen prijs",
    "season_title": "Seizoensomschrijving",
    "single_night": "Prijs voor één enkele nacht",
    "single_night_weekend": "Prijs voor één nacht gedurende het weekend",
    "standard_price": "Standaardprijs",
    "standard_price_text": "Bevestig minstens één standaardprijs,  waarmee u uw immobiliën kan vrijstellen van inschrijving. Wij raden u aan, dat u alle standaardprijzen bevestigt, wat echter geen dwingende gevolgen brengt.Standaardprijzen zijn gedurende het hele boekjaar geldig.",
    "standard_price_text_2": "Wanneer u voor een bepaald seizoen een ander prijs wenst vast te leggen, gelieve onderaan de seizoensprijs te bevestigen.",
    "standard_prices": "Standaardprijs",
    "stay_weekdays": "Prijs voor een midweek",
    "tooltip_lump_long_weekend": "Een volledig lang weekend bestaat uit drie opeenvolgende overnachtingen.",
    "tooltip_nightly_week": "Een enkele nacht bestaat uit één overnachting tijdens de week, aldus tussen maandag en donderdag.",
    "tooltip_nightly_weekend": "Een enkele nacht tijdens het weekend bestaat uit één overnachting tijdens het weekend, aldus tussen vrijdag en zondag.",
    "tooltip_stay_underweek": "Een verblijf tijdens de week begint op maandag en eindigt vrijdag.",
    "tooltip_stay_weekdays": "Een verblijf tijdens de week verwijst naar een overnachting tussen maandag en vrijdag.",
    "under_week": "Midweek",
    "week_period": "Prijs voor een verblijf tijdens de week",
    "week_period_consists_of": "Deze prijs is geldig voor opvolgende nachten tijdens de week",
    "week_starts": "Een week begint vanaf",
    "weekend_consists_of": "Dit prijs is geldig voor de volgende nachten",
    "what_is_common": "Wat is gebruikelijk?",
    "what_is_common_1": "Normaal begint een vakantieweek op vrijdag (Benelux) of zaterdag (in de rest van Europa)",
    "what_is_common_2": "Normaal worden de weekendprijzen voor vrijdag- en zaterdagnacht samen geplaatst",
    "whole_weekend": "Prijs voor een weekend",
    "your_price": "Uw prijs"
  },
  "processing": {
    "booking": {
      "booking_form": {
        "amex": "American Express",
        "bank_transfer": "Bankoverschrijving",
        "credit_card": "Mastercard, Visa, Maestro",
        "payment_charge": "Boekinsgkosten",
        "payment_method": "Betaalwijze",
        "payment_method_expl": "Als u per creditcard betaalt extra verwerking van vergoedingen. Deze worden automatisch toegevoegd aan de totale prijs."
      }
    }
  },
  "renter": {
    "contact": "Contact Informatie",
    "terms_of_service_html": "Ik bevestig dat ik de <a href=\"/downloads/renter_tos/casapilot_tos_renter_NL.pdf\" target=\"_blank\">Algemene Verkoopsvoorwaarden</a> gelesen, begrepen en accepteert heb."
  },
  "reserved": "Geboekt",
  "reviews": {
    "accommodation": "Vakantiewoning",
    "cancel_correct": "Ga terug en corrigeer",
    "confirm": "Controleren",
    "confirmation_intro": "Herzie a.u.b. uw aanbeveling. Kan het zo gepubliceerd worden?",
    "intro_1": "Uw mening telt: Uw aanbeveling helpt andere Casapilot gebruikers om de juiste accommodatie te kiezen en helpt ons om beter te begrijpen hoe u uw verblijf heeft beleefd.",
    "intro_2": "Dank u dat u de tijd heeft genomen om ons uw feedback te geven.",
    "mailers": {
      "host_reaction_subject": "Een gast heeft een recensie geplaatst",
      "invitation_reminder_subject": "Vriendelijke herinnering: Hoe was je verblijf?",
      "invitation_subject": "Hoe was je verblijf?"
    },
    "nps_headline": "Hoe waarschijnlijk is het dat u Casapilot aan anderen aanbeveelt?",
    "nps_unlikely": "Onwaarschijnlijk",
    "nps_very_likely": "Zeer waarschijnlijk",
    "question_area": "Hoe was de locatie van de accommodatie?",
    "question_cleanliness": "Hoe schoon was de accommodatie?",
    "question_comfort": "Hoe tevreden was u met het comfort?",
    "question_value": "Hoe was de prijs kwaliteits verhouding van de accommodatie?",
    "rating_headline": "Hoe tevreden was u met de accommodatie?",
    "rating_no_selection": "Gelieve te kiezen",
    "rating_selection_1": "1 - Niet tevreden",
    "rating_selection_2": "2 - Nogal ontevreden",
    "rating_selection_3": "3 - Neutraal",
    "rating_selection_4": "4 - Eerder tevreden",
    "rating_selection_5": "5 - Zeer tevreden",
    "remaining_chars": "Overblijvende karakters",
    "review_author": "Auteur van de aanbeveling",
    "review_headline": "Schrijf een korte aanbeveling. Wat was goed? Wat kan er verbeterd worden?",
    "submit": "Submit",
    "success_title": "Bedankt",
    "supbmit": "Indienen",
    "thank_you": "Dank u voor uw aanbeveling. Aangezien we net begonnen zijn onze klanten om aanbevelingen te vragen, wachten we nog even met de publicatie tot we genoeg recensies bij elkaar hebben.",
    "title": "Maak een aanbeveling",
    "travel_dates": "Reisdata",
    "validation_error": "Gelieve alle verplichte velden in te vullen."
  },
  "salutations": {
    "female": "Mevrouw ",
    "male": "Mijnheer"
  },
  "search": {
    "additional_results": "Andere populaire vakantiebestemmingen in",
    "adjust_filters": " Filter hier",
    "adjust_request": "Aanvraag wijzigen",
    "all_cities": "Alle steden",
    "all_regions": "Alle regio's",
    "arrival": "Aankomst",
    "availability": {
      "availability_for": "Beschikbaarheid voor",
      "available": "Beschikbaar",
      "calculate_price_and_availability": "Prijzen en beschikbaarheid worden gecontroleerd...",
      "check_availability": "Beschikbaarheid tonen",
      "checking": "Beschikbaarheid wordt gecontroleerd\n",
      "choose_day_of_arrival": "Selecteer hier een aankomstdatum",
      "day_of_arrival": "Aankomstdatum",
      "free": "Beschikbaar",
      "no_arrivals": "Voor de geselecteerde periode van uw verblijf ,is geen aankomstdag beschikbaar , kies dan een andere lengte van uw verblijf.",
      "not_available": "Niet beschikbaar",
      "occupied": "bezet",
      "on_request": "Bekijk beschikbarheid ",
      "update_price_and_availability": "Prijzen en beschikbaarheid bekijken"
    },
    "back_to_search_list": "Terug naar zoekresultaten",
    "banner": {
      "contact_note": "Gelieve met ons kontakt opnemen per e-mail of per telefoon ",
      "headline": "Hebt u niets gevonden?",
      "headline_big_1": "Uw zoekopdracht heeft geen resultat gevonden.",
      "headline_big_2": "Gelieve uw zoekcriteria te wijzigen",
      "offer": "Wij helpen u graag persoonlijk een woning te vinden.",
      "offer_big": "Wij helpen u ook graag persoonlijk een woning te vinden"
    },
    "check_availability": "Beschikbaarheid controleren ",
    "choose_city": "Alle regio’s",
    "choose_region": "Alle plaatsen",
    "close": "Sluiten",
    "departure": "Vertrek",
    "detail": {
      "allowed_pets": "Huisdieren toegestaan",
      "allowed_smoking": "Roken toegestaan",
      "allowed_youth": "Jeugdgroepen",
      "amenities_balcony": "Balkon",
      "amenities_dish": "Afwasmachine",
      "amenities_garage": "Parking",
      "amenities_garden": "Tuin",
      "amenities_internet": "Internet / Wifi",
      "amenities_pool": "Zwembad",
      "amenities_sauna": "Sauna",
      "amenities_terasse": "Terras",
      "amenities_tv": "Tv",
      "amenities_wash": "Wasmachine",
      "from": "van",
      "locality_calm": "Rustig gelegen",
      "locality_city": "Landelijk gelegen",
      "locality_mountains": "In de bergen ",
      "locality_nature": "In de natuut",
      "locality_sea": "Ann zee"
    },
    "detail_search": "Meer zoekopties",
    "exact_date": "Precieze Datum",
    "extended_search_result": "Voor uw bestemming, konden we geen beschikbare woning vinden. Misschien zijn de  volgende resultaten een goede alternatief.",
    "filters": {
      "activities": "Activiteiten",
      "air_conditioning": "Airconditioning",
      "any": "Elk",
      "apartment": "Appartement",
      "central_heating": "Centrale verwarming",
      "distance_to_beach": "Afstand naar het strand",
      "features": "Kenmerken",
      "fenced_garden": "Tuin (omheind)",
      "holiday_home": "Vakantiehuis",
      "jacuzzi": "Jacuzzi",
      "jacuzzi_inside": "Jacuzzi binnen",
      "jacuzzi_outside": "Jacuzzi buiten",
      "kind_of_property": "Type accommodatie",
      "lake": "Meer dichtbij",
      "limited_mobility": "Beperkte mobiliteit",
      "linen_included": "Beddengoed inbegrepen",
      "object_place": "Locatie",
      "ocean_view": "Uitzicht op zee",
      "pets": "Huisdieren toegestaan",
      "pool": "Zwembad",
      "pool_inside": "Zwembad binnen",
      "pool_outside": "Zwembad buiten",
      "sauna": "Sauna",
      "ski": "Ski",
      "stars": "Sterren",
      "suite": "Luxe Suite",
      "teambuilding": "Teambuilding",
      "waterfront": "Gelegen aan de zee/kust",
      "wifi_internet": "Wifi - internet"
    },
    "map_zoom": "Vergroot de kaart",
    "map_zoom_out": "Verkleiner de kaart",
    "mark": "aangeven waarvoor iets gebruikt moet worden/\naanduiden?",
    "micro_search_no_results": "Helaas is er geen object met de gewenste ID.",
    "more": "meer",
    "more_objects": "Andere woningen in de regio",
    "no_results": "Uw zoekopdracht heeft helaas geen resultaten voorzien. Gelieve uw zoekopdracht te veranderen.",
    "objects_for_all_arrivals": "Alle woningen tonen",
    "offers_found": "Aanbiedingen gevonden",
    "please_enter": "Hier uw bestemming invullen",
    "reset_filters": "Verwijder filters en toon alle resultaten",
    "results": "Zoekresultaten",
    "search": "Zoeken",
    "search_by_object_code": "Zoeken met huiscode",
    "search_list": "Nieuwe zoekopdracht",
    "show_availability": "Beschikbaarheid tonen",
    "size": "Grootte",
    "to_accomondation": "Meer info",
    "your_destination": "Uw bestemming"
  },
  "sending_mails": "Mailverzending",
  "service_navigation": {
    "account": "Mijn profiel"
  },
  "shared": {
    "footer": {
      "breakfast": "Ontbijt",
      "breakfast_url": "https://specials.casapilot.com/shop/?lang=nl",
      "contact": "Contact",
      "cookie_settings": "Cookie instellingen",
      "faq": "FAQ",
      "help": "Hulp",
      "hosts": "Voor eigenaars",
      "imprint": "Disclaimer",
      "partners": "Partners",
      "privacy": "Privacy"
    },
    "service_navigation": {
      "host_area": "Verhuurder-login",
      "locale": {
        "de": "DE",
        "en": "EN",
        "es": "ES",
        "fr": "FR",
        "nl": "NL"
      },
      "offer_flat": "Bijzondere/speciale vakantievastgoed aanbieden",
      "service_navigation": {
        "account": "Account"
      },
      "user": {
        "edit": "Conto wijzigen",
        "sign_in": "Verhuurder",
        "sign_out": "Logout",
        "sign_up": "Registreren"
      },
      "vouchers": "Voucher",
      "vouchers_url": "https://shop.casapilot.com/nl"
    },
    "sub_navigation": {
      "account": "Account",
      "bookings": "Boekingen",
      "dashboard": "Menu",
      "objects": "Woningen",
      "statistics": "Statistiek"
    }
  },
  "subscription": {
    "email_error": "Het e-mail adres is ongeldig. Gelieve opnieuw in te vullen.",
    "email_text": "Uw e-mailadres wordt in vertrouwen behandeld.",
    "headline": "Nu registreren en op de hoogte blijven.",
    "missing_field": "Gelieve alle velden in te vullen."
  },
  "support": {
    "array": {
      "last_word_connector": " en ",
      "two_words_connector": " en ",
      "words_connector": ", "
    },
    "select": {
      "prompt": "Selecteer"
    }
  },
  "thank_you": {
    "copy_1": "Wij stellen uw interesse in Casapilot ten zeerste op prijs en houden u vanaf heden op de hoogte.",
    "copy_2": "Om u definitief uit te schrijven, zal u binnenkort een e-mail met een bevestigingslink ontvangen. Zonder deze bevestiging kan u niet worden uitgeschreven.",
    "copy_3": "In alle e-mails die u van ons zal ontvangen, kunt u een link terugvinden, waarmee u zich kunt aanmelden en uw gegevens opnieuw kunt wissen.",
    "copy_4": "Uw Casapilot-Team",
    "empfehlen": "Raadt ons verder aan aub.",
    "headline": "Hartelijk bedankt!"
  },
  "three_good_reasons": "goede redenen voor uw vakantie met casapilot.com",
  "time": {
    "am": "'s ochtends",
    "formats": {
      "default": "%a %d %b %Y %H:%M:%S %Z",
      "long": "%d %B %Y %H:%M",
      "moment": "H:mm",
      "only_second": "%S",
      "short": "%d/%m/%Y, %H:%M",
      "time": "%H:%M h"
    },
    "pm": "'s middags"
  },
  "travel_booking_price": {
    "booking_fee": "Reserveringskosten",
    "costs_in_detail": "Kosten in detail",
    "deposit": {
      "on_location": "Ter plaatse te betalen",
      "refund": {
        "instantly": "Terugbetaling onmiddellijk bij vertrek",
        "one_week": "Terugbetaling na een week na uw vertrek",
        "two_weeks": "Terugbetaling na twee weken na uw vertrek"
      },
      "upfront": "Te betalen aan Casapilot"
    },
    "extras": {
      "type_bring": "Zelf meenemen",
      "type_included": "Inbegrepen",
      "type_on_location": "Ter plekke",
      "type_on_request": "Op verzoek",
      "type_payable": "Moet gehuurd worden",
      "type_upfront": "Van tevoren"
    },
    "handling_fee": "Verwerkingskosten",
    "included": "inbegrepen",
    "liability_insurance": "Aansprakelijkheids&shy;verzekering",
    "optional_costs": "Optionele kosten",
    "other_costs": "Andere kosten",
    "payable_on_location": "Ter plaatse te betalen",
    "payable_on_location_colon": "Ter plaatse te betalen:",
    "payable_to_casapilot": "Te betalen aan Casapilot",
    "plus_other_costs": "(plus andere kosten)",
    "price_error": "Er is een fout opgetreden bij het bepalen van de prijs.",
    "rent_fees_included": "Huur (incl. reserveringskosten)",
    "total_amount": "Totale prijs",
    "withheld_from_deposit": "Ingehouden op borg:"
  },
  "travel_bookings": {
    "ical_guest_summary": "Casapilot boeking voor %{title}",
    "ical_host_summary": "Boeking voor “%{property}” bij Casapilot"
  },
  "universal_tag": {
    "cnv": {
      "conversion_lang": "85853"
    },
    "rmkt": {
      "container_id": "8809",
      "conversion_lang": "85858"
    }
  },
  "voucher": "Verblijfsticket",
  "we_book_your_holidayhome": "Wij boeken uw vakantiehuis incl. vlucht en huurauto.",
  "web_app_theme": {
    "accommodations": "Woningen",
    "add": "Toevoegen",
    "administration": "Administratie",
    "agency": "Call-center",
    "all": "Alle/Alles",
    "amenities": "Uitrustingskenmerken",
    "approval_status": "Status",
    "approvals": "Vrij gesteld",
    "approve": "Online zetten",
    "approved": "Online",
    "attractions": "Attracties",
    "cancel": "annuleren",
    "complete": "Te controleren",
    "confirm": "Bent U zeker?",
    "console": "Console",
    "costs": "Extra kosten",
    "created": "Gemaakt",
    "dashboard": "Cockpit",
    "day": "Dag",
    "days": "Dagen",
    "delete": "wissen",
    "delete_map_clipping": "Reset map",
    "edit": "Wijzigen",
    "editing": "Niet volledig",
    "find": "Zoeken",
    "fix_rating": "Sternekategorie fixieren?",
    "homepage": "Startpagina",
    "invitations": "uitnodiging",
    "latest_send": "Ten laatste verzonden",
    "limitations": "Beperkingen / Bijzonderheden",
    "list": "lijst",
    "logout": "Uitloggen",
    "new": "Nieuw",
    "new_users": "Nieuwe gebruiker",
    "notapproved": "Offline gezet",
    "ogone": {
      "timedout": "Verbindung zum Zahlungssystem konnte nicht hergestellt werden."
    },
    "or": "of",
    "possible_extras": "Mogelijkheden",
    "possible_limitations": "Mogelijkheden",
    "possible_units": "Mogelijke eenheden",
    "properties": "Uw woningen",
    "save": "opslaan/bewerken",
    "search_people": "Personen",
    "search_person": "Persoon",
    "select": {
      "prompt": "Selecteer aub"
    },
    "send": "versturen",
    "show": "bevestigen",
    "summary": "Alle",
    "translate": "Vertalingen",
    "travel_bookings": "Buchungen",
    "travel_regions": "Streken",
    "unapprove": "Offline zetten",
    "usable_on": "Te gebruiken bij..",
    "users": "Gebruiker",
    "various_options": "Verschillende.."
  },
  "will_paginate": {
    "container_aria_label": "Pagination",
    "next_label": "»",
    "page_aria_label": "Page %{page}",
    "page_entries_info": {
      "multi_page": "Displaying %{model} %{from} - %{to} of %{count} in total",
      "multi_page_html": "Displaying %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b> of <b>%{count}</b> in total",
      "single_page": {
        "one": "Displaying 1 %{model}",
        "other": "Displaying all %{count} %{model}",
        "zero": "No %{model} found"
      },
      "single_page_html": {
        "one": "Displaying <b>1</b> %{model}",
        "other": "Displaying <b>all&nbsp;%{count}</b> %{model}",
        "zero": "No %{model} found"
      }
    },
    "page_gap": "...",
    "previous_label": "«"
  },
  "your_benefits": {
    "contact": {
      "at": {
        "number": "+352 20 20 34 26 20",
        "text": "(Bereikbaar uit Oostenrijk)"
      },
      "be": {
        "number": "+32 28 80 89 83",
        "text": "(Bereikbaar uit België)"
      },
      "ch": {
        "number": "+352 20 20 34 26 20",
        "text": "(Bereikbaar uit Zwitserland)"
      },
      "de": {
        "number": "+352 20 20 34 26 20",
        "text": "(Bereikbaar uit Duitsland)"
      },
      "email": "E-Mail: info@casapilot.com",
      "email_link": "info@casapilot.com",
      "headline": "U hebt vragen",
      "intro": "Neem contact met ons op. Wij helpen u graag!",
      "lu": {
        "number": "+352 (0)20 20 34 26 20",
        "text": "(Bereikbaar uit Luxemburg)"
      },
      "opening_hours": "U kunt ons telefonisch bereiken tegen lokaal tarief:",
      "opening_hours_1": "vrijdag van 9:00u–12:30u en 13:30u–18:00u",
      "opening_hours_2": "Het weekend van 14-16 uur",
      "partners": "Onze partners",
      "phone": "Tel. +32 (0)28 80 89 83"
    },
    "h1": "Waarom Casapilot?",
    "h2": "Inclusive prijzen",
    "h3": "Veilig boeken, betrouwbare gegevens, veilig op vakantie. ",
    "h4": "Goede service en zeer goede bereikbaarheid",
    "headline_html": "Het Casapilot team",
    "intro": "Uw droom vakantie is onze preoccupatie. Bereikbaarheid, vriendelijkheid en service zijn onze prioriteit. Probeer het uit en u zult aangenaam verrast zijn - dat garanderen wij!",
    "list_item2_1": "Die voor een specifieke reisperiode weergegeven huurprijzen zijn eindprijzen",
    "list_item2_2": "De kosten van de schadensverzekering en andere kosten zijn inbegrepen",
    "list_item2_3": "Eventuele kosten voor uw gebruik ter plaatse worden goed zichtbaar vermeld",
    "list_item3_1": "De gecodeerde website zorgt ervoor dat uw persoonlijke gegevens beschermd worden",
    "list_item3_2": "Onze gecertificeerde betalingsprovider garandeert veilige betalingen via een overschrijving of creditcard",
    "list_item4_1": "U kunt ons tijdens de week en in het weekend tegen lokaal tarief telefonisch bereiken",
    "list_item4_2": "Wij zijn altijd per e-mail bereikbaar. Wij reageren binnen 24 uren",
    "list_item4_3": "Op zoek naar een bijzondere vakantie woning? Wij helpen u graag persoonlijk ",
    "p1_1": "Er zijn veel goede redenen om uw droomvakantie te boeken op casapilot.com.",
    "p1_2": "De belangrijkste redenen hebben wij voor u in detail toegelicht:",
    "p2": "Op Casapilot.com zijn er geen onaangename verrassingen, als onze prijsstructuur is duidelijk en transparent:",
    "p3": "Wij willen dat u van een zorgeloze vakantie kunt genieten. De zekerheid die wij bieden, begint bij de boeking en de betaling en omvat alle dagen van uw verblijf ter plaatse. ",
    "p4": "Ons 5-talig service team staat tot uw beschikking, 365 dagen per jaar. Een goede service is onze kracht. ",
    "page_title": "Meer verhuren. Meer verdienen. Met Casapilot.",
    "positions": {
      "accounting": "Accounting",
      "business_development": "Business Development",
      "business_development_spain": "Business Development Spanje",
      "ceo": "Directie",
      "cio": "Technisch directeur",
      "design": "Interactive Design",
      "dev": "Webdevelopment",
      "it": "IT Administrator",
      "photography": "Fotografie",
      "pm": "Web Coordinator",
      "service": "Klantenservice",
      "service_marketing": "Klantenservice en marketing",
      "teamleader": "Teamleader"
    }
  }
};
